(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2kzMM"));

});
parcelRegister("2kzMM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1b2935584d52f656$export$ffb0004e005737fa, (v) => $1b2935584d52f656$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1b2935584d52f656$export$34b9dba7ce09269b, (v) => $1b2935584d52f656$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1b2935584d52f656$export$25062201e9e25d76, (v) => $1b2935584d52f656$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1b2935584d52f656$export$ffb0004e005737fa;
var $1b2935584d52f656$export$34b9dba7ce09269b;
var $1b2935584d52f656$export$25062201e9e25d76;
"use strict";
var $1b2935584d52f656$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1b2935584d52f656$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $1b2935584d52f656$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $1b2935584d52f656$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$1b2935584d52f656$export$ffb0004e005737fa = $1b2935584d52f656$var$REACT_FRAGMENT_TYPE;
$1b2935584d52f656$export$34b9dba7ce09269b = $1b2935584d52f656$var$jsxProd;
$1b2935584d52f656$export$25062201e9e25d76 = $1b2935584d52f656$var$jsxProd;

});


parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jMs9J"));

});
parcelRegister("jMs9J", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $e668572f1c95467d$export$9c16c1426311996d, (v) => $e668572f1c95467d$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $e668572f1c95467d$export$dca3b0875bd9a954, (v) => $e668572f1c95467d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e668572f1c95467d$export$16fa2f45be04daa8, (v) => $e668572f1c95467d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e668572f1c95467d$export$ffb0004e005737fa, (v) => $e668572f1c95467d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e668572f1c95467d$export$e2c29f18771995cb, (v) => $e668572f1c95467d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e668572f1c95467d$export$221d75b3f55bb0bd, (v) => $e668572f1c95467d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e668572f1c95467d$export$5f8d39834fd61797, (v) => $e668572f1c95467d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e668572f1c95467d$export$74bf444e3cd11ea5, (v) => $e668572f1c95467d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e668572f1c95467d$export$1ced07cd6b1985ce, (v) => $e668572f1c95467d$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $e668572f1c95467d$export$abd8e32b826d7ea7, (v) => $e668572f1c95467d$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $e668572f1c95467d$export$69a3209f1a06c04d, (v) => $e668572f1c95467d$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $e668572f1c95467d$export$8c538325882c7eec, (v) => $e668572f1c95467d$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $e668572f1c95467d$export$e530037191fcd5d7, (v) => $e668572f1c95467d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e668572f1c95467d$export$fd42f52fd3ae1109, (v) => $e668572f1c95467d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e668572f1c95467d$export$c8a8987d4410bf2d, (v) => $e668572f1c95467d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $e668572f1c95467d$export$7d1e3a5e95ceca43, (v) => $e668572f1c95467d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e668572f1c95467d$export$257a8862b851cb5b, (v) => $e668572f1c95467d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e668572f1c95467d$export$a8257692ac88316c, (v) => $e668572f1c95467d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e668572f1c95467d$export$488013bae63b21da, (v) => $e668572f1c95467d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e668572f1c95467d$export$7c73462e0d25e514, (v) => $e668572f1c95467d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e668572f1c95467d$export$7568632d0d33d16d, (v) => $e668572f1c95467d$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $e668572f1c95467d$export$f93f40ac0ca7e3a8, (v) => $e668572f1c95467d$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $e668572f1c95467d$export$1f96ae73734a86cc, (v) => $e668572f1c95467d$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $e668572f1c95467d$export$9a47ced3238df325, (v) => $e668572f1c95467d$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $e668572f1c95467d$export$35808ee640e87ca7, (v) => $e668572f1c95467d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e668572f1c95467d$export$fae74005e78b1a27, (v) => $e668572f1c95467d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e668572f1c95467d$export$dc8fbce3eb94dc1e, (v) => $e668572f1c95467d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e668572f1c95467d$export$6a7bc4e911dc01cf, (v) => $e668572f1c95467d$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e668572f1c95467d$export$6d9c69b0de29b591, (v) => $e668572f1c95467d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $e668572f1c95467d$export$7f54fc3180508a52, (v) => $e668572f1c95467d$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $e668572f1c95467d$export$f680877a34711e37, (v) => $e668572f1c95467d$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e668572f1c95467d$export$d5a552a76deda3c2, (v) => $e668572f1c95467d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e668572f1c95467d$export$aaabe4eda9ed9969, (v) => $e668572f1c95467d$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e668572f1c95467d$export$e5c5a5f917a5871c, (v) => $e668572f1c95467d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e668572f1c95467d$export$1538c33de8887b59, (v) => $e668572f1c95467d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $e668572f1c95467d$export$fca7f784ae7a249a, (v) => $e668572f1c95467d$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $e668572f1c95467d$export$13e3392192263954, (v) => $e668572f1c95467d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e668572f1c95467d$export$b8f5890fc79d6aca, (v) => $e668572f1c95467d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e668572f1c95467d$export$60241385465d0a34, (v) => $e668572f1c95467d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e668572f1c95467d$export$306c0aa65ff9ec16, (v) => $e668572f1c95467d$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e668572f1c95467d$export$7b286972b8d8ccbf, (v) => $e668572f1c95467d$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e668572f1c95467d$export$83d89fbfd8236492, (v) => $e668572f1c95467d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e668572f1c95467d$export$9c16c1426311996d;
var $e668572f1c95467d$export$dca3b0875bd9a954;
var $e668572f1c95467d$export$16fa2f45be04daa8;
var $e668572f1c95467d$export$ffb0004e005737fa;
var $e668572f1c95467d$export$e2c29f18771995cb;
var $e668572f1c95467d$export$221d75b3f55bb0bd;
var $e668572f1c95467d$export$5f8d39834fd61797;
var $e668572f1c95467d$export$74bf444e3cd11ea5;
var $e668572f1c95467d$export$1ced07cd6b1985ce;
var $e668572f1c95467d$export$abd8e32b826d7ea7;
var $e668572f1c95467d$export$69a3209f1a06c04d;
var $e668572f1c95467d$export$8c538325882c7eec;
var $e668572f1c95467d$export$e530037191fcd5d7;
var $e668572f1c95467d$export$fd42f52fd3ae1109;
var $e668572f1c95467d$export$c8a8987d4410bf2d;
var $e668572f1c95467d$export$7d1e3a5e95ceca43;
var $e668572f1c95467d$export$257a8862b851cb5b;
var $e668572f1c95467d$export$a8257692ac88316c;
var $e668572f1c95467d$export$488013bae63b21da;
var $e668572f1c95467d$export$7c73462e0d25e514;
var $e668572f1c95467d$export$7568632d0d33d16d;
var $e668572f1c95467d$export$f93f40ac0ca7e3a8;
var $e668572f1c95467d$export$1f96ae73734a86cc;
var $e668572f1c95467d$export$9a47ced3238df325;
var $e668572f1c95467d$export$35808ee640e87ca7;
var $e668572f1c95467d$export$fae74005e78b1a27;
var $e668572f1c95467d$export$dc8fbce3eb94dc1e;
var $e668572f1c95467d$export$6a7bc4e911dc01cf;
var $e668572f1c95467d$export$6d9c69b0de29b591;
var $e668572f1c95467d$export$7f54fc3180508a52;
var $e668572f1c95467d$export$f680877a34711e37;
var $e668572f1c95467d$export$d5a552a76deda3c2;
var $e668572f1c95467d$export$aaabe4eda9ed9969;
var $e668572f1c95467d$export$e5c5a5f917a5871c;
var $e668572f1c95467d$export$1538c33de8887b59;
var $e668572f1c95467d$export$fca7f784ae7a249a;
var $e668572f1c95467d$export$13e3392192263954;
var $e668572f1c95467d$export$b8f5890fc79d6aca;
var $e668572f1c95467d$export$60241385465d0a34;
var $e668572f1c95467d$export$306c0aa65ff9ec16;
var $e668572f1c95467d$export$7b286972b8d8ccbf;
var $e668572f1c95467d$export$83d89fbfd8236492;
"use strict";
var $e668572f1c95467d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e668572f1c95467d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e668572f1c95467d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e668572f1c95467d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e668572f1c95467d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e668572f1c95467d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e668572f1c95467d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e668572f1c95467d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e668572f1c95467d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e668572f1c95467d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e668572f1c95467d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $e668572f1c95467d$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e668572f1c95467d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e668572f1c95467d$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e668572f1c95467d$var$assign = Object.assign, $e668572f1c95467d$var$emptyObject = {};
function $e668572f1c95467d$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e668572f1c95467d$var$emptyObject;
    this.updater = updater || $e668572f1c95467d$var$ReactNoopUpdateQueue;
}
$e668572f1c95467d$var$Component.prototype.isReactComponent = {};
$e668572f1c95467d$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$e668572f1c95467d$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $e668572f1c95467d$var$ComponentDummy() {}
$e668572f1c95467d$var$ComponentDummy.prototype = $e668572f1c95467d$var$Component.prototype;
function $e668572f1c95467d$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e668572f1c95467d$var$emptyObject;
    this.updater = updater || $e668572f1c95467d$var$ReactNoopUpdateQueue;
}
var $e668572f1c95467d$var$pureComponentPrototype = $e668572f1c95467d$var$PureComponent.prototype = new $e668572f1c95467d$var$ComponentDummy();
$e668572f1c95467d$var$pureComponentPrototype.constructor = $e668572f1c95467d$var$PureComponent;
$e668572f1c95467d$var$assign($e668572f1c95467d$var$pureComponentPrototype, $e668572f1c95467d$var$Component.prototype);
$e668572f1c95467d$var$pureComponentPrototype.isPureReactComponent = !0;
var $e668572f1c95467d$var$isArrayImpl = Array.isArray;
function $e668572f1c95467d$var$noop() {}
var $e668572f1c95467d$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $e668572f1c95467d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e668572f1c95467d$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $e668572f1c95467d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $e668572f1c95467d$var$cloneAndReplaceKey(oldElement, newKey) {
    return $e668572f1c95467d$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $e668572f1c95467d$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $e668572f1c95467d$var$REACT_ELEMENT_TYPE;
}
function $e668572f1c95467d$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $e668572f1c95467d$var$userProvidedKeyEscapeRegex = /\/+/g;
function $e668572f1c95467d$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $e668572f1c95467d$var$escape("" + element.key) : index.toString(36);
}
function $e668572f1c95467d$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($e668572f1c95467d$var$noop, $e668572f1c95467d$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $e668572f1c95467d$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $e668572f1c95467d$var$REACT_ELEMENT_TYPE:
                case $e668572f1c95467d$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $e668572f1c95467d$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $e668572f1c95467d$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $e668572f1c95467d$var$getElementKey(children, 0) : nameSoFar, $e668572f1c95467d$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($e668572f1c95467d$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $e668572f1c95467d$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($e668572f1c95467d$var$isValidElement(callback) && (callback = $e668572f1c95467d$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($e668572f1c95467d$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($e668572f1c95467d$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $e668572f1c95467d$var$getElementKey(nameSoFar, i), invokeCallback += $e668572f1c95467d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $e668572f1c95467d$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $e668572f1c95467d$var$getElementKey(nameSoFar, i++), invokeCallback += $e668572f1c95467d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $e668572f1c95467d$var$mapIntoArray($e668572f1c95467d$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $e668572f1c95467d$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $e668572f1c95467d$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $e668572f1c95467d$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $e668572f1c95467d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $e668572f1c95467d$var$Children = {
    map: $e668572f1c95467d$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $e668572f1c95467d$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $e668572f1c95467d$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $e668572f1c95467d$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$e668572f1c95467d$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$e668572f1c95467d$export$9c16c1426311996d = $e668572f1c95467d$var$REACT_ACTIVITY_TYPE;
$e668572f1c95467d$export$dca3b0875bd9a954 = $e668572f1c95467d$var$Children;
$e668572f1c95467d$export$16fa2f45be04daa8 = $e668572f1c95467d$var$Component;
$e668572f1c95467d$export$ffb0004e005737fa = $e668572f1c95467d$var$REACT_FRAGMENT_TYPE;
$e668572f1c95467d$export$e2c29f18771995cb = $e668572f1c95467d$var$REACT_PROFILER_TYPE;
$e668572f1c95467d$export$221d75b3f55bb0bd = $e668572f1c95467d$var$PureComponent;
$e668572f1c95467d$export$5f8d39834fd61797 = $e668572f1c95467d$var$REACT_STRICT_MODE_TYPE;
$e668572f1c95467d$export$74bf444e3cd11ea5 = $e668572f1c95467d$var$REACT_SUSPENSE_TYPE;
$e668572f1c95467d$export$1ced07cd6b1985ce = $e668572f1c95467d$var$ReactSharedInternals;
$e668572f1c95467d$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $e668572f1c95467d$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$e668572f1c95467d$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$e668572f1c95467d$export$8c538325882c7eec = function() {
    return null;
};
$e668572f1c95467d$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $e668572f1c95467d$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$e668572f1c95467d$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $e668572f1c95467d$var$ReactElement(element.type, key, props);
};
$e668572f1c95467d$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $e668572f1c95467d$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $e668572f1c95467d$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$e668572f1c95467d$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$e668572f1c95467d$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $e668572f1c95467d$var$ReactElement(type, key, props);
};
$e668572f1c95467d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e668572f1c95467d$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$e668572f1c95467d$export$a8257692ac88316c = $e668572f1c95467d$var$isValidElement;
$e668572f1c95467d$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $e668572f1c95467d$var$lazyInitializer
    };
};
$e668572f1c95467d$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$e668572f1c95467d$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $e668572f1c95467d$var$ReactSharedInternals.T, currentTransition = {};
    $e668572f1c95467d$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $e668572f1c95467d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($e668572f1c95467d$var$noop, $e668572f1c95467d$var$reportGlobalError);
    } catch (error) {
        $e668572f1c95467d$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e668572f1c95467d$var$ReactSharedInternals.T = prevTransition;
    }
};
$e668572f1c95467d$export$f93f40ac0ca7e3a8 = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useCacheRefresh();
};
$e668572f1c95467d$export$1f96ae73734a86cc = function(usable) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.use(usable);
};
$e668572f1c95467d$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$e668572f1c95467d$export$35808ee640e87ca7 = function(callback, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$e668572f1c95467d$export$fae74005e78b1a27 = function(Context) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useContext(Context);
};
$e668572f1c95467d$export$dc8fbce3eb94dc1e = function() {};
$e668572f1c95467d$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$e668572f1c95467d$export$6d9c69b0de29b591 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useEffect(create, deps);
};
$e668572f1c95467d$export$7f54fc3180508a52 = function(callback) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$e668572f1c95467d$export$f680877a34711e37 = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useId();
};
$e668572f1c95467d$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$e668572f1c95467d$export$aaabe4eda9ed9969 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$e668572f1c95467d$export$e5c5a5f917a5871c = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$e668572f1c95467d$export$1538c33de8887b59 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useMemo(create, deps);
};
$e668572f1c95467d$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$e668572f1c95467d$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$e668572f1c95467d$export$b8f5890fc79d6aca = function(initialValue) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useRef(initialValue);
};
$e668572f1c95467d$export$60241385465d0a34 = function(initialState) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useState(initialState);
};
$e668572f1c95467d$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$e668572f1c95467d$export$7b286972b8d8ccbf = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useTransition();
};
$e668572f1c95467d$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("6T1J1", function(module, exports) {
'use strict';
function $503937b663c395c4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($503937b663c395c4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$503937b663c395c4$var$checkDCE();

module.exports = (parcelRequire("gNTjK"));

});
parcelRegister("gNTjK", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $c3bc21db9fc66909$export$882461b6382ed46c, (v) => $c3bc21db9fc66909$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $c3bc21db9fc66909$export$757ceba2d55c277e, (v) => $c3bc21db9fc66909$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $c3bc21db9fc66909$export$83d89fbfd8236492, (v) => $c3bc21db9fc66909$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c3bc21db9fc66909$export$882461b6382ed46c;
var $c3bc21db9fc66909$export$757ceba2d55c277e;
var $c3bc21db9fc66909$export$83d89fbfd8236492;
"use strict";

var $clk2u = parcelRequire("clk2u");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $c3bc21db9fc66909$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c3bc21db9fc66909$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $c3bc21db9fc66909$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c3bc21db9fc66909$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $c3bc21db9fc66909$var$assertIsMounted(fiber) {
    if ($c3bc21db9fc66909$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
}
function $c3bc21db9fc66909$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c3bc21db9fc66909$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c3bc21db9fc66909$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c3bc21db9fc66909$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c3bc21db9fc66909$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c3bc21db9fc66909$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c3bc21db9fc66909$var$assign = Object.assign, $c3bc21db9fc66909$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c3bc21db9fc66909$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c3bc21db9fc66909$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c3bc21db9fc66909$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c3bc21db9fc66909$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c3bc21db9fc66909$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c3bc21db9fc66909$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c3bc21db9fc66909$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c3bc21db9fc66909$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c3bc21db9fc66909$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c3bc21db9fc66909$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c3bc21db9fc66909$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c3bc21db9fc66909$var$getComponentNameFromType(type.type) || "Memo";
        case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c3bc21db9fc66909$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c3bc21db9fc66909$var$isArrayImpl = Array.isArray, $c3bc21db9fc66909$var$ReactSharedInternals = $8NFma.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c3bc21db9fc66909$var$ReactDOMSharedInternals = $2pmb0.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c3bc21db9fc66909$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c3bc21db9fc66909$var$valueStack = [], $c3bc21db9fc66909$var$index = -1;
function $c3bc21db9fc66909$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c3bc21db9fc66909$var$pop(cursor) {
    0 > $c3bc21db9fc66909$var$index || (cursor.current = $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index], $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index] = null, $c3bc21db9fc66909$var$index--);
}
function $c3bc21db9fc66909$var$push(cursor, value) {
    $c3bc21db9fc66909$var$index++;
    $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index] = cursor.current;
    cursor.current = value;
}
var $c3bc21db9fc66909$var$contextStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$contextFiberStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$rootInstanceStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$hostTransitionProviderCursor = $c3bc21db9fc66909$var$createCursor(null);
function $c3bc21db9fc66909$var$pushHostContainer(fiber, nextRootInstance) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$rootInstanceStackCursor, nextRootInstance);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextFiberStackCursor, fiber);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $c3bc21db9fc66909$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $c3bc21db9fc66909$var$getOwnHostContext(nextRootInstance), fiber = $c3bc21db9fc66909$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, fiber);
}
function $c3bc21db9fc66909$var$popHostContainer() {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextFiberStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$rootInstanceStackCursor);
}
function $c3bc21db9fc66909$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$hostTransitionProviderCursor, fiber);
    var context = $c3bc21db9fc66909$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c3bc21db9fc66909$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextFiberStackCursor, fiber), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, JSCompiler_inline_result));
}
function $c3bc21db9fc66909$var$popHostContext(fiber) {
    $c3bc21db9fc66909$var$contextFiberStackCursor.current === fiber && ($c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor), $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextFiberStackCursor));
    $c3bc21db9fc66909$var$hostTransitionProviderCursor.current === fiber && ($c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$hostTransitionProviderCursor), $c3bc21db9fc66909$var$HostTransitionContext._currentValue = $c3bc21db9fc66909$var$sharedNotPendingObject);
}
var $c3bc21db9fc66909$var$prefix, $c3bc21db9fc66909$var$suffix;
function $c3bc21db9fc66909$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c3bc21db9fc66909$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c3bc21db9fc66909$var$prefix = match && match[1] || "";
        $c3bc21db9fc66909$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c3bc21db9fc66909$var$prefix + name + $c3bc21db9fc66909$var$suffix;
}
var $c3bc21db9fc66909$var$reentry = !1;
function $c3bc21db9fc66909$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c3bc21db9fc66909$var$reentry) return "";
    $c3bc21db9fc66909$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c3bc21db9fc66909$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c3bc21db9fc66909$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c3bc21db9fc66909$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Suspense Fallback") : $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $c3bc21db9fc66909$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $c3bc21db9fc66909$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c3bc21db9fc66909$var$scheduleCallback$3 = $clk2u.unstable_scheduleCallback, $c3bc21db9fc66909$var$cancelCallback$1 = $clk2u.unstable_cancelCallback, $c3bc21db9fc66909$var$shouldYield = $clk2u.unstable_shouldYield, $c3bc21db9fc66909$var$requestPaint = $clk2u.unstable_requestPaint, $c3bc21db9fc66909$var$now = $clk2u.unstable_now, $c3bc21db9fc66909$var$getCurrentPriorityLevel = $clk2u.unstable_getCurrentPriorityLevel, $c3bc21db9fc66909$var$ImmediatePriority = $clk2u.unstable_ImmediatePriority, $c3bc21db9fc66909$var$UserBlockingPriority = $clk2u.unstable_UserBlockingPriority, $c3bc21db9fc66909$var$NormalPriority$1 = $clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$LowPriority = $clk2u.unstable_LowPriority, $c3bc21db9fc66909$var$IdlePriority = $clk2u.unstable_IdlePriority, $c3bc21db9fc66909$var$log$1 = $clk2u.log, $c3bc21db9fc66909$var$unstable_setDisableYieldValue = $clk2u.unstable_setDisableYieldValue, $c3bc21db9fc66909$var$rendererID = null, $c3bc21db9fc66909$var$injectedHook = null;
function $c3bc21db9fc66909$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c3bc21db9fc66909$var$log$1 && $c3bc21db9fc66909$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.setStrictMode) try {
        $c3bc21db9fc66909$var$injectedHook.setStrictMode($c3bc21db9fc66909$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c3bc21db9fc66909$var$clz32 = Math.clz32 ? Math.clz32 : $c3bc21db9fc66909$var$clz32Fallback, $c3bc21db9fc66909$var$log = Math.log, $c3bc21db9fc66909$var$LN2 = Math.LN2;
function $c3bc21db9fc66909$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c3bc21db9fc66909$var$log(x) / $c3bc21db9fc66909$var$LN2 | 0) | 0;
}
var $c3bc21db9fc66909$var$nextTransitionUpdateLane = 256, $c3bc21db9fc66909$var$nextTransitionDeferredLane = 262144, $c3bc21db9fc66909$var$nextRetryLane = 4194304;
function $c3bc21db9fc66909$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c3bc21db9fc66909$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c3bc21db9fc66909$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c3bc21db9fc66909$var$claimNextRetryLane() {
    var lane = $c3bc21db9fc66909$var$nextRetryLane;
    $c3bc21db9fc66909$var$nextRetryLane <<= 1;
    0 === ($c3bc21db9fc66909$var$nextRetryLane & 62914560) && ($c3bc21db9fc66909$var$nextRetryLane = 4194304);
    return lane;
}
function $c3bc21db9fc66909$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c3bc21db9fc66909$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c3bc21db9fc66909$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $c3bc21db9fc66909$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c3bc21db9fc66909$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $c3bc21db9fc66909$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $c3bc21db9fc66909$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c3bc21db9fc66909$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $c3bc21db9fc66909$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c3bc21db9fc66909$var$resolveUpdatePriority() {
    var updatePriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c3bc21db9fc66909$var$getEventPriority(updatePriority.type);
}
function $c3bc21db9fc66909$var$runWithPriority(priority, fn) {
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        return $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c3bc21db9fc66909$var$randomKey = Math.random().toString(36).slice(2), $c3bc21db9fc66909$var$internalInstanceKey = "__reactFiber$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalPropsKey = "__reactProps$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalContainerInstanceKey = "__reactContainer$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlersKey = "__reactEvents$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlerListenersKey = "__reactListeners$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlesSetKey = "__reactHandles$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalRootNodeResourcesKey = "__reactResources$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalHoistableMarker = "__reactMarker$" + $c3bc21db9fc66909$var$randomKey;
function $c3bc21db9fc66909$var$detachDeletedInstance(node) {
    delete node[$c3bc21db9fc66909$var$internalInstanceKey];
    delete node[$c3bc21db9fc66909$var$internalPropsKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlersKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlerListenersKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlesSetKey];
}
function $c3bc21db9fc66909$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c3bc21db9fc66909$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c3bc21db9fc66909$var$internalContainerInstanceKey] || parentNode[$c3bc21db9fc66909$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c3bc21db9fc66909$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c3bc21db9fc66909$var$internalInstanceKey]) return parentNode;
                targetNode = $c3bc21db9fc66909$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c3bc21db9fc66909$var$getInstanceFromNode(node) {
    if (node = node[$c3bc21db9fc66909$var$internalInstanceKey] || node[$c3bc21db9fc66909$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c3bc21db9fc66909$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(33));
}
function $c3bc21db9fc66909$var$getResourcesFromRoot(root) {
    var resources = root[$c3bc21db9fc66909$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c3bc21db9fc66909$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c3bc21db9fc66909$var$markNodeAsHoistable(node) {
    node[$c3bc21db9fc66909$var$internalHoistableMarker] = !0;
}
var $c3bc21db9fc66909$var$allNativeEvents = new Set(), $c3bc21db9fc66909$var$registrationNameDependencies = {};
function $c3bc21db9fc66909$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c3bc21db9fc66909$var$registerDirectEvent(registrationName, dependencies);
    $c3bc21db9fc66909$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c3bc21db9fc66909$var$registerDirectEvent(registrationName, dependencies) {
    $c3bc21db9fc66909$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c3bc21db9fc66909$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c3bc21db9fc66909$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c3bc21db9fc66909$var$illegalAttributeNameCache = {}, $c3bc21db9fc66909$var$validatedAttributeNameCache = {};
function $c3bc21db9fc66909$var$isAttributeNameSafe(attributeName) {
    if ($c3bc21db9fc66909$var$hasOwnProperty.call($c3bc21db9fc66909$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c3bc21db9fc66909$var$hasOwnProperty.call($c3bc21db9fc66909$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c3bc21db9fc66909$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c3bc21db9fc66909$var$validatedAttributeNameCache[attributeName] = !0;
    $c3bc21db9fc66909$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c3bc21db9fc66909$var$setValueForAttribute(node, name, value) {
    if ($c3bc21db9fc66909$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c3bc21db9fc66909$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c3bc21db9fc66909$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $c3bc21db9fc66909$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c3bc21db9fc66909$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c3bc21db9fc66909$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c3bc21db9fc66909$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $c3bc21db9fc66909$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $c3bc21db9fc66909$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $c3bc21db9fc66909$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c3bc21db9fc66909$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c3bc21db9fc66909$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c3bc21db9fc66909$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c3bc21db9fc66909$var$getToStringValue(value);
        } else element.value !== "" + $c3bc21db9fc66909$var$getToStringValue(value) && (element.value = "" + $c3bc21db9fc66909$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c3bc21db9fc66909$var$setDefaultValue(element, type, $c3bc21db9fc66909$var$getToStringValue(value)) : null != defaultValue ? $c3bc21db9fc66909$var$setDefaultValue(element, type, $c3bc21db9fc66909$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $c3bc21db9fc66909$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c3bc21db9fc66909$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $c3bc21db9fc66909$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $c3bc21db9fc66909$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c3bc21db9fc66909$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $c3bc21db9fc66909$var$track(element);
}
function $c3bc21db9fc66909$var$setDefaultValue(node, type, value) {
    "number" === type && $c3bc21db9fc66909$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c3bc21db9fc66909$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c3bc21db9fc66909$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c3bc21db9fc66909$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c3bc21db9fc66909$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c3bc21db9fc66909$var$getToStringValue(defaultValue) : "";
}
function $c3bc21db9fc66909$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(92));
            if ($c3bc21db9fc66909$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c3bc21db9fc66909$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $c3bc21db9fc66909$var$track(element);
}
function $c3bc21db9fc66909$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c3bc21db9fc66909$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c3bc21db9fc66909$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c3bc21db9fc66909$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c3bc21db9fc66909$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c3bc21db9fc66909$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c3bc21db9fc66909$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c3bc21db9fc66909$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c3bc21db9fc66909$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c3bc21db9fc66909$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c3bc21db9fc66909$var$sanitizeURL(url) {
    return $c3bc21db9fc66909$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $c3bc21db9fc66909$var$noop$1() {}
var $c3bc21db9fc66909$var$currentReplayingEvent = null;
function $c3bc21db9fc66909$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c3bc21db9fc66909$var$restoreTarget = null, $c3bc21db9fc66909$var$restoreQueue = null;
function $c3bc21db9fc66909$var$restoreStateOfTarget(target) {
    var internalInstance = $c3bc21db9fc66909$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c3bc21db9fc66909$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c3bc21db9fc66909$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c3bc21db9fc66909$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(90));
                            $c3bc21db9fc66909$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c3bc21db9fc66909$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c3bc21db9fc66909$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c3bc21db9fc66909$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c3bc21db9fc66909$var$isInsideEventHandler = !1;
function $c3bc21db9fc66909$var$batchedUpdates$1(fn, a, b) {
    if ($c3bc21db9fc66909$var$isInsideEventHandler) return fn(a, b);
    $c3bc21db9fc66909$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c3bc21db9fc66909$var$isInsideEventHandler = !1, null !== $c3bc21db9fc66909$var$restoreTarget || null !== $c3bc21db9fc66909$var$restoreQueue) {
            if ($c3bc21db9fc66909$var$flushSyncWork$1(), $c3bc21db9fc66909$var$restoreTarget && (a = $c3bc21db9fc66909$var$restoreTarget, fn = $c3bc21db9fc66909$var$restoreQueue, $c3bc21db9fc66909$var$restoreQueue = $c3bc21db9fc66909$var$restoreTarget = null, $c3bc21db9fc66909$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c3bc21db9fc66909$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c3bc21db9fc66909$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c3bc21db9fc66909$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $c3bc21db9fc66909$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !1;
if ($c3bc21db9fc66909$var$canUseDOM) try {
    var $c3bc21db9fc66909$var$options = {};
    Object.defineProperty($c3bc21db9fc66909$var$options, "passive", {
        get: function() {
            $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c3bc21db9fc66909$var$options, $c3bc21db9fc66909$var$options);
    window.removeEventListener("test", $c3bc21db9fc66909$var$options, $c3bc21db9fc66909$var$options);
} catch (e) {
    $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !1;
}
var $c3bc21db9fc66909$var$root = null, $c3bc21db9fc66909$var$startText = null, $c3bc21db9fc66909$var$fallbackText = null;
function $c3bc21db9fc66909$var$getData() {
    if ($c3bc21db9fc66909$var$fallbackText) return $c3bc21db9fc66909$var$fallbackText;
    var start, startValue = $c3bc21db9fc66909$var$startText, startLength = startValue.length, end, endValue = "value" in $c3bc21db9fc66909$var$root ? $c3bc21db9fc66909$var$root.value : $c3bc21db9fc66909$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c3bc21db9fc66909$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c3bc21db9fc66909$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c3bc21db9fc66909$var$functionThatReturnsTrue() {
    return !0;
}
function $c3bc21db9fc66909$var$functionThatReturnsFalse() {
    return !1;
}
function $c3bc21db9fc66909$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c3bc21db9fc66909$var$functionThatReturnsTrue : $c3bc21db9fc66909$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c3bc21db9fc66909$var$functionThatReturnsFalse;
        return this;
    }
    $c3bc21db9fc66909$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $c3bc21db9fc66909$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $c3bc21db9fc66909$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $c3bc21db9fc66909$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c3bc21db9fc66909$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c3bc21db9fc66909$var$SyntheticEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$EventInterface), $c3bc21db9fc66909$var$UIEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    view: 0,
    detail: 0
}), $c3bc21db9fc66909$var$SyntheticUIEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$UIEventInterface), $c3bc21db9fc66909$var$lastMovementX, $c3bc21db9fc66909$var$lastMovementY, $c3bc21db9fc66909$var$lastMouseEvent, $c3bc21db9fc66909$var$MouseEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c3bc21db9fc66909$var$lastMouseEvent && ($c3bc21db9fc66909$var$lastMouseEvent && "mousemove" === event.type ? ($c3bc21db9fc66909$var$lastMovementX = event.screenX - $c3bc21db9fc66909$var$lastMouseEvent.screenX, $c3bc21db9fc66909$var$lastMovementY = event.screenY - $c3bc21db9fc66909$var$lastMouseEvent.screenY) : $c3bc21db9fc66909$var$lastMovementY = $c3bc21db9fc66909$var$lastMovementX = 0, $c3bc21db9fc66909$var$lastMouseEvent = event);
        return $c3bc21db9fc66909$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $c3bc21db9fc66909$var$lastMovementY;
    }
}), $c3bc21db9fc66909$var$SyntheticMouseEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$MouseEventInterface), $c3bc21db9fc66909$var$DragEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    dataTransfer: 0
}), $c3bc21db9fc66909$var$SyntheticDragEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$DragEventInterface), $c3bc21db9fc66909$var$FocusEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    relatedTarget: 0
}), $c3bc21db9fc66909$var$SyntheticFocusEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$FocusEventInterface), $c3bc21db9fc66909$var$AnimationEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c3bc21db9fc66909$var$SyntheticAnimationEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$AnimationEventInterface), $c3bc21db9fc66909$var$ClipboardEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c3bc21db9fc66909$var$SyntheticClipboardEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$ClipboardEventInterface), $c3bc21db9fc66909$var$CompositionEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    data: 0
}), $c3bc21db9fc66909$var$SyntheticCompositionEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$CompositionEventInterface), $c3bc21db9fc66909$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c3bc21db9fc66909$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c3bc21db9fc66909$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c3bc21db9fc66909$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c3bc21db9fc66909$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c3bc21db9fc66909$var$getEventModifierState() {
    return $c3bc21db9fc66909$var$modifierStateGetter;
}
var $c3bc21db9fc66909$var$KeyboardEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c3bc21db9fc66909$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c3bc21db9fc66909$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c3bc21db9fc66909$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $c3bc21db9fc66909$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $c3bc21db9fc66909$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c3bc21db9fc66909$var$SyntheticKeyboardEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$KeyboardEventInterface), $c3bc21db9fc66909$var$PointerEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c3bc21db9fc66909$var$SyntheticPointerEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$PointerEventInterface), $c3bc21db9fc66909$var$TouchEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState
}), $c3bc21db9fc66909$var$SyntheticTouchEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$TouchEventInterface), $c3bc21db9fc66909$var$TransitionEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c3bc21db9fc66909$var$SyntheticTransitionEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$TransitionEventInterface), $c3bc21db9fc66909$var$WheelEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c3bc21db9fc66909$var$SyntheticWheelEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$WheelEventInterface), $c3bc21db9fc66909$var$ToggleEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c3bc21db9fc66909$var$SyntheticToggleEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$ToggleEventInterface), $c3bc21db9fc66909$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c3bc21db9fc66909$var$canUseCompositionEvent = $c3bc21db9fc66909$var$canUseDOM && "CompositionEvent" in window, $c3bc21db9fc66909$var$documentMode = null;
$c3bc21db9fc66909$var$canUseDOM && "documentMode" in document && ($c3bc21db9fc66909$var$documentMode = document.documentMode);
var $c3bc21db9fc66909$var$canUseTextInputEvent = $c3bc21db9fc66909$var$canUseDOM && "TextEvent" in window && !$c3bc21db9fc66909$var$documentMode, $c3bc21db9fc66909$var$useFallbackCompositionData = $c3bc21db9fc66909$var$canUseDOM && (!$c3bc21db9fc66909$var$canUseCompositionEvent || $c3bc21db9fc66909$var$documentMode && 8 < $c3bc21db9fc66909$var$documentMode && 11 >= $c3bc21db9fc66909$var$documentMode), $c3bc21db9fc66909$var$SPACEBAR_CHAR = String.fromCharCode(32), $c3bc21db9fc66909$var$hasSpaceKeypress = !1;
function $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c3bc21db9fc66909$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c3bc21db9fc66909$var$isComposing = !1;
function $c3bc21db9fc66909$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c3bc21db9fc66909$var$hasSpaceKeypress = !0;
            return $c3bc21db9fc66909$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c3bc21db9fc66909$var$SPACEBAR_CHAR && $c3bc21db9fc66909$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c3bc21db9fc66909$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c3bc21db9fc66909$var$isComposing) return "compositionend" === domEventName || !$c3bc21db9fc66909$var$canUseCompositionEvent && $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c3bc21db9fc66909$var$getData(), $c3bc21db9fc66909$var$fallbackText = $c3bc21db9fc66909$var$startText = $c3bc21db9fc66909$var$root = null, $c3bc21db9fc66909$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c3bc21db9fc66909$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c3bc21db9fc66909$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c3bc21db9fc66909$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c3bc21db9fc66909$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c3bc21db9fc66909$var$restoreTarget ? $c3bc21db9fc66909$var$restoreQueue ? $c3bc21db9fc66909$var$restoreQueue.push(target) : $c3bc21db9fc66909$var$restoreQueue = [
        target
    ] : $c3bc21db9fc66909$var$restoreTarget = target;
    inst = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c3bc21db9fc66909$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c3bc21db9fc66909$var$activeElement$1 = null, $c3bc21db9fc66909$var$activeElementInst$1 = null;
function $c3bc21db9fc66909$var$runEventInBatch(dispatchQueue) {
    $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, 0);
}
function $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c3bc21db9fc66909$var$getNodeFromInstance(targetInst);
    if ($c3bc21db9fc66909$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c3bc21db9fc66909$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c3bc21db9fc66909$var$isInputEventSupported = !1;
if ($c3bc21db9fc66909$var$canUseDOM) {
    var $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$286;
    if ($c3bc21db9fc66909$var$canUseDOM) {
        var $c3bc21db9fc66909$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$c3bc21db9fc66909$var$isSupported$jscomp$inline_427) {
            var $c3bc21db9fc66909$var$element$jscomp$inline_428 = document.createElement("div");
            $c3bc21db9fc66909$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $c3bc21db9fc66909$var$isSupported$jscomp$inline_427 = "function" === typeof $c3bc21db9fc66909$var$element$jscomp$inline_428.oninput;
        }
        $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$286 = $c3bc21db9fc66909$var$isSupported$jscomp$inline_427;
    } else $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$286 = !1;
    $c3bc21db9fc66909$var$isInputEventSupported = $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $c3bc21db9fc66909$var$stopWatchingForValueChange() {
    $c3bc21db9fc66909$var$activeElement$1 && ($c3bc21db9fc66909$var$activeElement$1.detachEvent("onpropertychange", $c3bc21db9fc66909$var$handlePropertyChange), $c3bc21db9fc66909$var$activeElementInst$1 = $c3bc21db9fc66909$var$activeElement$1 = null);
}
function $c3bc21db9fc66909$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c3bc21db9fc66909$var$getInstIfValueChanged($c3bc21db9fc66909$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, $c3bc21db9fc66909$var$activeElementInst$1, nativeEvent, $c3bc21db9fc66909$var$getEventTarget(nativeEvent));
        $c3bc21db9fc66909$var$batchedUpdates$1($c3bc21db9fc66909$var$runEventInBatch, dispatchQueue);
    }
}
function $c3bc21db9fc66909$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c3bc21db9fc66909$var$stopWatchingForValueChange(), $c3bc21db9fc66909$var$activeElement$1 = target, $c3bc21db9fc66909$var$activeElementInst$1 = targetInst, $c3bc21db9fc66909$var$activeElement$1.attachEvent("onpropertychange", $c3bc21db9fc66909$var$handlePropertyChange)) : "focusout" === domEventName && $c3bc21db9fc66909$var$stopWatchingForValueChange();
}
function $c3bc21db9fc66909$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged($c3bc21db9fc66909$var$activeElementInst$1);
}
function $c3bc21db9fc66909$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst);
}
function $c3bc21db9fc66909$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst);
}
function $c3bc21db9fc66909$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c3bc21db9fc66909$var$objectIs = "function" === typeof Object.is ? Object.is : $c3bc21db9fc66909$var$is;
function $c3bc21db9fc66909$var$shallowEqual(objA, objB) {
    if ($c3bc21db9fc66909$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c3bc21db9fc66909$var$hasOwnProperty.call(objB, currentKey) || !$c3bc21db9fc66909$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c3bc21db9fc66909$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c3bc21db9fc66909$var$getNodeForCharacterOffset(root, offset) {
    var node = $c3bc21db9fc66909$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c3bc21db9fc66909$var$getLeafNode(node);
    }
}
function $c3bc21db9fc66909$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c3bc21db9fc66909$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c3bc21db9fc66909$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c3bc21db9fc66909$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c3bc21db9fc66909$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c3bc21db9fc66909$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $c3bc21db9fc66909$var$skipSelectionChangeEvent = $c3bc21db9fc66909$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c3bc21db9fc66909$var$activeElement = null, $c3bc21db9fc66909$var$activeElementInst = null, $c3bc21db9fc66909$var$lastSelection = null, $c3bc21db9fc66909$var$mouseDown = !1;
function $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c3bc21db9fc66909$var$mouseDown || null == $c3bc21db9fc66909$var$activeElement || $c3bc21db9fc66909$var$activeElement !== $c3bc21db9fc66909$var$getActiveElement(doc) || (doc = $c3bc21db9fc66909$var$activeElement, "selectionStart" in doc && $c3bc21db9fc66909$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c3bc21db9fc66909$var$lastSelection && $c3bc21db9fc66909$var$shallowEqual($c3bc21db9fc66909$var$lastSelection, doc) || ($c3bc21db9fc66909$var$lastSelection = doc, doc = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners($c3bc21db9fc66909$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c3bc21db9fc66909$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c3bc21db9fc66909$var$activeElement)));
}
function $c3bc21db9fc66909$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c3bc21db9fc66909$var$vendorPrefixes = {
    animationend: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionEnd")
}, $c3bc21db9fc66909$var$prefixedEventNames = {}, $c3bc21db9fc66909$var$style = {};
$c3bc21db9fc66909$var$canUseDOM && ($c3bc21db9fc66909$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c3bc21db9fc66909$var$vendorPrefixes.animationend.animation, delete $c3bc21db9fc66909$var$vendorPrefixes.animationiteration.animation, delete $c3bc21db9fc66909$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c3bc21db9fc66909$var$vendorPrefixes.transitionend.transition);
function $c3bc21db9fc66909$var$getVendorPrefixedEventName(eventName) {
    if ($c3bc21db9fc66909$var$prefixedEventNames[eventName]) return $c3bc21db9fc66909$var$prefixedEventNames[eventName];
    if (!$c3bc21db9fc66909$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c3bc21db9fc66909$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c3bc21db9fc66909$var$style) return $c3bc21db9fc66909$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c3bc21db9fc66909$var$ANIMATION_END = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationend"), $c3bc21db9fc66909$var$ANIMATION_ITERATION = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationiteration"), $c3bc21db9fc66909$var$ANIMATION_START = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationstart"), $c3bc21db9fc66909$var$TRANSITION_RUN = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionrun"), $c3bc21db9fc66909$var$TRANSITION_START = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionstart"), $c3bc21db9fc66909$var$TRANSITION_CANCEL = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitioncancel"), $c3bc21db9fc66909$var$TRANSITION_END = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionend"), $c3bc21db9fc66909$var$topLevelEventsToReactNames = new Map(), $c3bc21db9fc66909$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$c3bc21db9fc66909$var$simpleEventPluginEvents.push("scrollEnd");
function $c3bc21db9fc66909$var$registerSimpleEvent(domEventName, reactName) {
    $c3bc21db9fc66909$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c3bc21db9fc66909$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c3bc21db9fc66909$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $c3bc21db9fc66909$var$concurrentQueues = [], $c3bc21db9fc66909$var$concurrentQueuesIndex = 0, $c3bc21db9fc66909$var$concurrentlyUpdatedLanes = 0;
function $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c3bc21db9fc66909$var$concurrentQueuesIndex, i = $c3bc21db9fc66909$var$concurrentlyUpdatedLanes = $c3bc21db9fc66909$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var queue = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var update = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var lane = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = fiber;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = queue;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = update;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = lane;
    $c3bc21db9fc66909$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $c3bc21db9fc66909$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $c3bc21db9fc66909$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c3bc21db9fc66909$var$nestedUpdateCount) throw $c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null, Error($c3bc21db9fc66909$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c3bc21db9fc66909$var$emptyContextObject = {};
function $c3bc21db9fc66909$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c3bc21db9fc66909$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c3bc21db9fc66909$var$FiberNode(tag, pendingProps, key, mode);
}
function $c3bc21db9fc66909$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c3bc21db9fc66909$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c3bc21db9fc66909$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c3bc21db9fc66909$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c3bc21db9fc66909$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c3bc21db9fc66909$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c3bc21db9fc66909$var$isHostHoistableType(type, pendingProps, $c3bc21db9fc66909$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE:
            return $c3bc21db9fc66909$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c3bc21db9fc66909$var$REACT_PROFILER_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c3bc21db9fc66909$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c3bc21db9fc66909$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c3bc21db9fc66909$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $c3bc21db9fc66909$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c3bc21db9fc66909$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c3bc21db9fc66909$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c3bc21db9fc66909$var$createFiberFromText(content, mode, lanes) {
    content = $c3bc21db9fc66909$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c3bc21db9fc66909$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $c3bc21db9fc66909$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $c3bc21db9fc66909$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c3bc21db9fc66909$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $c3bc21db9fc66909$var$CapturedStacks = new WeakMap();
function $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $c3bc21db9fc66909$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(source)
        };
        $c3bc21db9fc66909$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(source)
    };
}
var $c3bc21db9fc66909$var$forkStack = [], $c3bc21db9fc66909$var$forkStackIndex = 0, $c3bc21db9fc66909$var$treeForkProvider = null, $c3bc21db9fc66909$var$treeForkCount = 0, $c3bc21db9fc66909$var$idStack = [], $c3bc21db9fc66909$var$idStackIndex = 0, $c3bc21db9fc66909$var$treeContextProvider = null, $c3bc21db9fc66909$var$treeContextId = 1, $c3bc21db9fc66909$var$treeContextOverflow = "";
function $c3bc21db9fc66909$var$pushTreeFork(workInProgress, totalChildren) {
    $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex++] = $c3bc21db9fc66909$var$treeForkCount;
    $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex++] = $c3bc21db9fc66909$var$treeForkProvider;
    $c3bc21db9fc66909$var$treeForkProvider = workInProgress;
    $c3bc21db9fc66909$var$treeForkCount = totalChildren;
}
function $c3bc21db9fc66909$var$pushTreeId(workInProgress, totalChildren, index) {
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextId;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextOverflow;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextProvider;
    $c3bc21db9fc66909$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c3bc21db9fc66909$var$treeContextId;
    workInProgress = $c3bc21db9fc66909$var$treeContextOverflow;
    var baseLength = 32 - $c3bc21db9fc66909$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c3bc21db9fc66909$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c3bc21db9fc66909$var$treeContextId = 1 << 32 - $c3bc21db9fc66909$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c3bc21db9fc66909$var$treeContextOverflow = length + workInProgress;
    } else $c3bc21db9fc66909$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c3bc21db9fc66909$var$treeContextOverflow = workInProgress;
}
function $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c3bc21db9fc66909$var$pushTreeFork(workInProgress, 1), $c3bc21db9fc66909$var$pushTreeId(workInProgress, 1, 0));
}
function $c3bc21db9fc66909$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c3bc21db9fc66909$var$treeForkProvider;)$c3bc21db9fc66909$var$treeForkProvider = $c3bc21db9fc66909$var$forkStack[--$c3bc21db9fc66909$var$forkStackIndex], $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex] = null, $c3bc21db9fc66909$var$treeForkCount = $c3bc21db9fc66909$var$forkStack[--$c3bc21db9fc66909$var$forkStackIndex], $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex] = null;
    for(; workInProgress === $c3bc21db9fc66909$var$treeContextProvider;)$c3bc21db9fc66909$var$treeContextProvider = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null, $c3bc21db9fc66909$var$treeContextOverflow = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null, $c3bc21db9fc66909$var$treeContextId = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null;
}
function $c3bc21db9fc66909$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextId;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextOverflow;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextProvider;
    $c3bc21db9fc66909$var$treeContextId = suspendedContext.id;
    $c3bc21db9fc66909$var$treeContextOverflow = suspendedContext.overflow;
    $c3bc21db9fc66909$var$treeContextProvider = workInProgress;
}
var $c3bc21db9fc66909$var$hydrationParentFiber = null, $c3bc21db9fc66909$var$nextHydratableInstance = null, $c3bc21db9fc66909$var$isHydrating = !1, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, $c3bc21db9fc66909$var$HydrationMismatchException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(519));
function $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c3bc21db9fc66909$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(error, fiber));
    throw $c3bc21db9fc66909$var$HydrationMismatchException;
}
function $c3bc21db9fc66909$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c3bc21db9fc66909$var$internalInstanceKey] = fiber;
    instance[$c3bc21db9fc66909$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("cancel", instance);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c3bc21db9fc66909$var$mediaEventTypes.length; type++)$c3bc21db9fc66909$var$listenToNonDelegatedEvent($c3bc21db9fc66909$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", instance);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance);
            $c3bc21db9fc66909$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance), $c3bc21db9fc66909$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c3bc21db9fc66909$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", instance), $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c3bc21db9fc66909$var$noop$1), instance = !0) : instance = !1;
    instance || $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber, !0);
}
function $c3bc21db9fc66909$var$popToNextHostParent(fiber) {
    for($c3bc21db9fc66909$var$hydrationParentFiber = fiber.return; $c3bc21db9fc66909$var$hydrationParentFiber;)switch($c3bc21db9fc66909$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $c3bc21db9fc66909$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $c3bc21db9fc66909$var$rootOrSingletonContext = !0;
            return;
        default:
            $c3bc21db9fc66909$var$hydrationParentFiber = $c3bc21db9fc66909$var$hydrationParentFiber.return;
    }
}
function $c3bc21db9fc66909$var$popHydrationState(fiber) {
    if (fiber !== $c3bc21db9fc66909$var$hydrationParentFiber) return !1;
    if (!$c3bc21db9fc66909$var$isHydrating) return $c3bc21db9fc66909$var$popToNextHostParent(fiber), $c3bc21db9fc66909$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c3bc21db9fc66909$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $c3bc21db9fc66909$var$nextHydratableInstance && $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber);
    $c3bc21db9fc66909$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $c3bc21db9fc66909$var$nextHydratableInstance, $c3bc21db9fc66909$var$isSingletonScope(fiber.type) ? (fiber = $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton, $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = null, $c3bc21db9fc66909$var$nextHydratableInstance = fiber) : $c3bc21db9fc66909$var$nextHydratableInstance = tag) : $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$hydrationParentFiber ? $c3bc21db9fc66909$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c3bc21db9fc66909$var$resetHydrationState() {
    $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$hydrationParentFiber = null;
    $c3bc21db9fc66909$var$isHydrating = !1;
}
function $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $c3bc21db9fc66909$var$hydrationErrors;
    null !== queuedErrors && (null === $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors ? $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = queuedErrors : $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors.push.apply($c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, queuedErrors), $c3bc21db9fc66909$var$hydrationErrors = null);
    return queuedErrors;
}
function $c3bc21db9fc66909$var$queueHydrationError(error) {
    null === $c3bc21db9fc66909$var$hydrationErrors ? $c3bc21db9fc66909$var$hydrationErrors = [
        error
    ] : $c3bc21db9fc66909$var$hydrationErrors.push(error);
}
var $c3bc21db9fc66909$var$valueCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null, $c3bc21db9fc66909$var$lastContextDependency = null;
function $c3bc21db9fc66909$var$pushProvider(providerFiber, context, nextValue) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c3bc21db9fc66909$var$popProvider(context) {
    context._currentValue = $c3bc21db9fc66909$var$valueCursor.current;
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$valueCursor);
}
function $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c3bc21db9fc66909$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c3bc21db9fc66909$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c3bc21db9fc66909$var$HostTransitionContext) : current = [
                $c3bc21db9fc66909$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c3bc21db9fc66909$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c3bc21db9fc66909$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c3bc21db9fc66909$var$prepareToReadContext(workInProgress) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = workInProgress;
    $c3bc21db9fc66909$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c3bc21db9fc66909$var$readContext(context) {
    return $c3bc21db9fc66909$var$readContextForConsumer($c3bc21db9fc66909$var$currentlyRenderingFiber$1, context);
}
function $c3bc21db9fc66909$var$readContextDuringReconciliation(consumer, context) {
    null === $c3bc21db9fc66909$var$currentlyRenderingFiber$1 && $c3bc21db9fc66909$var$prepareToReadContext(consumer);
    return $c3bc21db9fc66909$var$readContextForConsumer(consumer, context);
}
function $c3bc21db9fc66909$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c3bc21db9fc66909$var$lastContextDependency) {
        if (null === consumer) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(308));
        $c3bc21db9fc66909$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$lastContextDependency.next = context;
    return value;
}
var $c3bc21db9fc66909$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c3bc21db9fc66909$var$scheduleCallback$2 = $clk2u.unstable_scheduleCallback, $c3bc21db9fc66909$var$NormalPriority = $clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$CacheContext = {
    $$typeof: $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c3bc21db9fc66909$var$createCache() {
    return {
        controller: new $c3bc21db9fc66909$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c3bc21db9fc66909$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c3bc21db9fc66909$var$scheduleCallback$2($c3bc21db9fc66909$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c3bc21db9fc66909$var$currentEntangledListeners = null, $c3bc21db9fc66909$var$currentEntangledPendingCount = 0, $c3bc21db9fc66909$var$currentEntangledLane = 0, $c3bc21db9fc66909$var$currentEntangledActionThenable = null;
function $c3bc21db9fc66909$var$entangleAsyncAction(transition, thenable) {
    if (null === $c3bc21db9fc66909$var$currentEntangledListeners) {
        var entangledListeners = $c3bc21db9fc66909$var$currentEntangledListeners = [];
        $c3bc21db9fc66909$var$currentEntangledPendingCount = 0;
        $c3bc21db9fc66909$var$currentEntangledLane = $c3bc21db9fc66909$var$requestTransitionLane();
        $c3bc21db9fc66909$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c3bc21db9fc66909$var$currentEntangledPendingCount++;
    thenable.then($c3bc21db9fc66909$var$pingEngtangledActionScope, $c3bc21db9fc66909$var$pingEngtangledActionScope);
    return thenable;
}
function $c3bc21db9fc66909$var$pingEngtangledActionScope() {
    if (0 === --$c3bc21db9fc66909$var$currentEntangledPendingCount && null !== $c3bc21db9fc66909$var$currentEntangledListeners) {
        null !== $c3bc21db9fc66909$var$currentEntangledActionThenable && ($c3bc21db9fc66909$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c3bc21db9fc66909$var$currentEntangledListeners;
        $c3bc21db9fc66909$var$currentEntangledListeners = null;
        $c3bc21db9fc66909$var$currentEntangledLane = 0;
        $c3bc21db9fc66909$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c3bc21db9fc66909$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c3bc21db9fc66909$var$prevOnStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
$c3bc21db9fc66909$var$ReactSharedInternals.S = function(transition, returnValue) {
    $c3bc21db9fc66909$var$globalMostRecentTransitionTime = $c3bc21db9fc66909$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $c3bc21db9fc66909$var$entangleAsyncAction(transition, returnValue);
    null !== $c3bc21db9fc66909$var$prevOnStartTransitionFinish && $c3bc21db9fc66909$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c3bc21db9fc66909$var$resumedCache = $c3bc21db9fc66909$var$createCursor(null);
function $c3bc21db9fc66909$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c3bc21db9fc66909$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c3bc21db9fc66909$var$workInProgressRoot.pooledCache;
}
function $c3bc21db9fc66909$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$resumedCache, $c3bc21db9fc66909$var$resumedCache.current) : $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$resumedCache, prevCachePool.pool);
}
function $c3bc21db9fc66909$var$getSuspendedCache() {
    var cacheFromPool = $c3bc21db9fc66909$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c3bc21db9fc66909$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c3bc21db9fc66909$var$SuspenseException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(460)), $c3bc21db9fc66909$var$SuspenseyCommitException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(474)), $c3bc21db9fc66909$var$SuspenseActionException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(542)), $c3bc21db9fc66909$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $c3bc21db9fc66909$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c3bc21db9fc66909$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c3bc21db9fc66909$var$noop$1, $c3bc21db9fc66909$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c3bc21db9fc66909$var$noop$1, $c3bc21db9fc66909$var$noop$1);
            else {
                thenableState = $c3bc21db9fc66909$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $c3bc21db9fc66909$var$suspendedThenable = thenable;
            throw $c3bc21db9fc66909$var$SuspenseException;
    }
}
function $c3bc21db9fc66909$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $c3bc21db9fc66909$var$suspendedThenable = x, $c3bc21db9fc66909$var$SuspenseException;
        throw x;
    }
}
var $c3bc21db9fc66909$var$suspendedThenable = null;
function $c3bc21db9fc66909$var$getSuspendedThenable() {
    if (null === $c3bc21db9fc66909$var$suspendedThenable) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(459));
    var thenable = $c3bc21db9fc66909$var$suspendedThenable;
    $c3bc21db9fc66909$var$suspendedThenable = null;
    return thenable;
}
function $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $c3bc21db9fc66909$var$SuspenseException || rejectedReason === $c3bc21db9fc66909$var$SuspenseActionException) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(483));
}
var $c3bc21db9fc66909$var$thenableState$1 = null, $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
function $c3bc21db9fc66909$var$unwrapThenable(thenable) {
    var index = $c3bc21db9fc66909$var$thenableIndexCounter$1;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 += 1;
    null === $c3bc21db9fc66909$var$thenableState$1 && ($c3bc21db9fc66909$var$thenableState$1 = []);
    return $c3bc21db9fc66909$var$trackUsedThenable($c3bc21db9fc66909$var$thenableState$1, thenable, index);
}
function $c3bc21db9fc66909$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c3bc21db9fc66909$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c3bc21db9fc66909$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c3bc21db9fc66909$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $c3bc21db9fc66909$var$REACT_LAZY_TYPE && $c3bc21db9fc66909$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c3bc21db9fc66909$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c3bc21db9fc66909$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c3bc21db9fc66909$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c3bc21db9fc66909$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $c3bc21db9fc66909$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return lanes = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return newChild = $c3bc21db9fc66909$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return newChild = $c3bc21db9fc66909$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $c3bc21db9fc66909$var$REACT_LAZY_TYPE && $c3bc21db9fc66909$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c3bc21db9fc66909$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE ? (lanes = $c3bc21db9fc66909$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c3bc21db9fc66909$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return newChild = $c3bc21db9fc66909$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c3bc21db9fc66909$var$getIteratorFn(newChild)) {
                key = $c3bc21db9fc66909$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c3bc21db9fc66909$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c3bc21db9fc66909$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c3bc21db9fc66909$var$SuspenseException || x === $c3bc21db9fc66909$var$SuspenseActionException) throw x;
            var fiber = $c3bc21db9fc66909$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c3bc21db9fc66909$var$reconcileChildFibers = $c3bc21db9fc66909$var$createChildReconciler(!0), $c3bc21db9fc66909$var$mountChildFibers = $c3bc21db9fc66909$var$createChildReconciler(!1), $c3bc21db9fc66909$var$hasForceUpdate = !1;
function $c3bc21db9fc66909$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c3bc21db9fc66909$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c3bc21db9fc66909$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
        $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c3bc21db9fc66909$var$markRootEntangled(root, lane);
    }
}
function $c3bc21db9fc66909$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !1;
function $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c3bc21db9fc66909$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c3bc21db9fc66909$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c3bc21db9fc66909$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c3bc21db9fc66909$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c3bc21db9fc66909$var$currentEntangledLane && ($c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c3bc21db9fc66909$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c3bc21db9fc66909$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c3bc21db9fc66909$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c3bc21db9fc66909$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c3bc21db9fc66909$var$callCallback(callbacks[updateQueue], context);
}
var $c3bc21db9fc66909$var$currentTreeHiddenStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$prevEntangledRenderLanesCursor = $c3bc21db9fc66909$var$createCursor(0);
function $c3bc21db9fc66909$var$pushHiddenContext(fiber, context) {
    fiber = $c3bc21db9fc66909$var$entangledRenderLanes;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor, fiber);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$currentTreeHiddenStackCursor, context);
    $c3bc21db9fc66909$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c3bc21db9fc66909$var$reuseHiddenContextOnStack() {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor, $c3bc21db9fc66909$var$entangledRenderLanes);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$currentTreeHiddenStackCursor, $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current);
}
function $c3bc21db9fc66909$var$popHiddenContext() {
    $c3bc21db9fc66909$var$entangledRenderLanes = $c3bc21db9fc66909$var$prevEntangledRenderLanesCursor.current;
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$currentTreeHiddenStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor);
}
var $c3bc21db9fc66909$var$suspenseHandlerStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$shellBoundary = null;
function $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current & 1);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, handler);
    null === $c3bc21db9fc66909$var$shellBoundary && (null === current || null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current ? $c3bc21db9fc66909$var$shellBoundary = handler : null !== current.memoizedState && ($c3bc21db9fc66909$var$shellBoundary = handler));
}
function $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, fiber);
    null === $c3bc21db9fc66909$var$shellBoundary && ($c3bc21db9fc66909$var$shellBoundary = fiber);
}
function $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, fiber), null === $c3bc21db9fc66909$var$shellBoundary && ($c3bc21db9fc66909$var$shellBoundary = fiber)) : $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack() {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current);
}
function $c3bc21db9fc66909$var$popSuspenseHandler(fiber) {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseHandlerStackCursor);
    $c3bc21db9fc66909$var$shellBoundary === fiber && ($c3bc21db9fc66909$var$shellBoundary = null);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
}
var $c3bc21db9fc66909$var$suspenseStackCursor = $c3bc21db9fc66909$var$createCursor(0);
function $c3bc21db9fc66909$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $c3bc21db9fc66909$var$isSuspenseInstancePending(state) || $c3bc21db9fc66909$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $c3bc21db9fc66909$var$renderLanes = 0, $c3bc21db9fc66909$var$currentlyRenderingFiber = null, $c3bc21db9fc66909$var$currentHook = null, $c3bc21db9fc66909$var$workInProgressHook = null, $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1, $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c3bc21db9fc66909$var$localIdCounter = 0, $c3bc21db9fc66909$var$thenableIndexCounter = 0, $c3bc21db9fc66909$var$thenableState = null, $c3bc21db9fc66909$var$globalClientIdCounter = 0;
function $c3bc21db9fc66909$var$throwInvalidHookError() {
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(321));
}
function $c3bc21db9fc66909$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c3bc21db9fc66909$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c3bc21db9fc66909$var$renderLanes = nextRenderLanes;
    $c3bc21db9fc66909$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c3bc21db9fc66909$var$HooksDispatcherOnMount : $c3bc21db9fc66909$var$HooksDispatcherOnUpdate;
    $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c3bc21db9fc66909$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c3bc21db9fc66909$var$finishRenderingHooks(current) {
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c3bc21db9fc66909$var$currentHook && null !== $c3bc21db9fc66909$var$currentHook.next;
    $c3bc21db9fc66909$var$renderLanes = 0;
    $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1;
    $c3bc21db9fc66909$var$thenableIndexCounter = 0;
    $c3bc21db9fc66909$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(300));
    null === current || $c3bc21db9fc66909$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c3bc21db9fc66909$var$checkIfContextChanged(current) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0));
}
function $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c3bc21db9fc66909$var$thenableState = null);
        $c3bc21db9fc66909$var$thenableIndexCounter = 0;
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c3bc21db9fc66909$var$TransitionAwareHostComponent() {
    var dispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c3bc21db9fc66909$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c3bc21db9fc66909$var$currentHook ? $c3bc21db9fc66909$var$currentHook.memoizedState : null) !== dispatcher && ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $c3bc21db9fc66909$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c3bc21db9fc66909$var$localIdCounter;
    $c3bc21db9fc66909$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c3bc21db9fc66909$var$resetHooksOnUnwind(workInProgress) {
    if ($c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c3bc21db9fc66909$var$renderLanes = 0;
    $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c3bc21db9fc66909$var$thenableIndexCounter = $c3bc21db9fc66909$var$localIdCounter = 0;
    $c3bc21db9fc66909$var$thenableState = null;
}
function $c3bc21db9fc66909$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState = $c3bc21db9fc66909$var$workInProgressHook = hook : $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$workInProgressHook.next = hook;
    return $c3bc21db9fc66909$var$workInProgressHook;
}
function $c3bc21db9fc66909$var$updateWorkInProgressHook() {
    if (null === $c3bc21db9fc66909$var$currentHook) {
        var nextCurrentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c3bc21db9fc66909$var$currentHook.next;
    var nextWorkInProgressHook = null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState : $c3bc21db9fc66909$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c3bc21db9fc66909$var$workInProgressHook = nextWorkInProgressHook, $c3bc21db9fc66909$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(467));
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(310));
        }
        $c3bc21db9fc66909$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c3bc21db9fc66909$var$currentHook.memoizedState,
            baseState: $c3bc21db9fc66909$var$currentHook.baseState,
            baseQueue: $c3bc21db9fc66909$var$currentHook.baseQueue,
            queue: $c3bc21db9fc66909$var$currentHook.queue,
            next: null
        };
        null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState = $c3bc21db9fc66909$var$workInProgressHook = nextCurrentHook : $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c3bc21db9fc66909$var$workInProgressHook;
}
function $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $c3bc21db9fc66909$var$useThenable(thenable) {
    var index = $c3bc21db9fc66909$var$thenableIndexCounter;
    $c3bc21db9fc66909$var$thenableIndexCounter += 1;
    null === $c3bc21db9fc66909$var$thenableState && ($c3bc21db9fc66909$var$thenableState = []);
    thenable = $c3bc21db9fc66909$var$trackUsedThenable($c3bc21db9fc66909$var$thenableState, thenable, index);
    index = $c3bc21db9fc66909$var$currentlyRenderingFiber;
    null === (null === $c3bc21db9fc66909$var$workInProgressHook ? index.memoizedState : $c3bc21db9fc66909$var$workInProgressHook.next) && (index = index.alternate, $c3bc21db9fc66909$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c3bc21db9fc66909$var$HooksDispatcherOnMount : $c3bc21db9fc66909$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c3bc21db9fc66909$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $c3bc21db9fc66909$var$useThenable(usable);
        if (usable.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return $c3bc21db9fc66909$var$readContext(usable);
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(438, String(usable)));
}
function $c3bc21db9fc66909$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c3bc21db9fc66909$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c3bc21db9fc66909$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c3bc21db9fc66909$var$updateReducer(reducer) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    return $c3bc21db9fc66909$var$updateReducerImpl(hook, $c3bc21db9fc66909$var$currentHook, reducer);
}
function $c3bc21db9fc66909$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c3bc21db9fc66909$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c3bc21db9fc66909$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($c3bc21db9fc66909$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c3bc21db9fc66909$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= revertLane, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= updateLane, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c3bc21db9fc66909$var$objectIs(pendingQueue, hook.memoizedState) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $c3bc21db9fc66909$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c3bc21db9fc66909$var$rerenderReducer(reducer) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c3bc21db9fc66909$var$objectIs(newState, hook.memoizedState) || ($c3bc21db9fc66909$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c3bc21db9fc66909$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c3bc21db9fc66909$var$currentlyRenderingFiber, hook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c3bc21db9fc66909$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c3bc21db9fc66909$var$objectIs(($c3bc21db9fc66909$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c3bc21db9fc66909$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $c3bc21db9fc66909$var$updateEffect($c3bc21db9fc66909$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c3bc21db9fc66909$var$workInProgressHook && $c3bc21db9fc66909$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c3bc21db9fc66909$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c3bc21db9fc66909$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $c3bc21db9fc66909$var$workInProgressRoot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c3bc21db9fc66909$var$renderLanes & 127) || $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c3bc21db9fc66909$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) && $c3bc21db9fc66909$var$forceStoreRerender(fiber);
}
function $c3bc21db9fc66909$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) && $c3bc21db9fc66909$var$forceStoreRerender(fiber);
    });
}
function $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c3bc21db9fc66909$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c3bc21db9fc66909$var$forceStoreRerender(fiber) {
    var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c3bc21db9fc66909$var$mountStateImpl(initialState) {
    var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c3bc21db9fc66909$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c3bc21db9fc66909$var$updateReducerImpl(hook, $c3bc21db9fc66909$var$currentHook, "function" === typeof reducer ? reducer : $c3bc21db9fc66909$var$basicStateReducer);
}
function $c3bc21db9fc66909$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c3bc21db9fc66909$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c3bc21db9fc66909$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c3bc21db9fc66909$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, currentTransition = {};
        $c3bc21db9fc66909$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c3bc21db9fc66909$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $c3bc21db9fc66909$var$onActionError(actionQueue, node, error$66);
    }
}
function $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c3bc21db9fc66909$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c3bc21db9fc66909$var$onActionError(actionQueue, node, error);
    }) : $c3bc21db9fc66909$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c3bc21db9fc66909$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c3bc21db9fc66909$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c3bc21db9fc66909$var$runActionStateAction(actionQueue, nextState)));
}
function $c3bc21db9fc66909$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c3bc21db9fc66909$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c3bc21db9fc66909$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c3bc21db9fc66909$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c3bc21db9fc66909$var$mountActionState(action, initialStateProp) {
    if ($c3bc21db9fc66909$var$isHydrating) {
        var ssrFormState = $c3bc21db9fc66909$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c3bc21db9fc66909$var$currentlyRenderingFiber;
                if ($c3bc21db9fc66909$var$isHydrating) {
                    if ($c3bc21db9fc66909$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c3bc21db9fc66909$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c3bc21db9fc66909$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c3bc21db9fc66909$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c3bc21db9fc66909$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c3bc21db9fc66909$var$dispatchSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c3bc21db9fc66909$var$mountStateImpl(!1);
    inRootOrSingleton = $c3bc21db9fc66909$var$dispatchOptimisticSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c3bc21db9fc66909$var$dispatchActionState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c3bc21db9fc66909$var$updateActionState(action) {
    var stateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    return $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, $c3bc21db9fc66909$var$currentHook, action);
}
function $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c3bc21db9fc66909$var$updateReducerImpl(stateHook, currentStateHook, $c3bc21db9fc66909$var$actionStateReducer)[0];
    stateHook = $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $c3bc21db9fc66909$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $c3bc21db9fc66909$var$SuspenseException) throw $c3bc21db9fc66909$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 2048, $c3bc21db9fc66909$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $c3bc21db9fc66909$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $c3bc21db9fc66909$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c3bc21db9fc66909$var$rerenderActionState(action) {
    var stateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), currentStateHook = $c3bc21db9fc66909$var$currentHook;
    if (null !== currentStateHook) return $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c3bc21db9fc66909$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c3bc21db9fc66909$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $c3bc21db9fc66909$var$updateRef() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $c3bc21db9fc66909$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c3bc21db9fc66909$var$currentHook && null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, $c3bc21db9fc66909$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $c3bc21db9fc66909$var$mountEffect(create, deps) {
    $c3bc21db9fc66909$var$mountEffectImpl(8390656, 8, create, deps);
}
function $c3bc21db9fc66909$var$updateEffect(create, deps) {
    $c3bc21db9fc66909$var$updateEffectImpl(2048, 8, create, deps);
}
function $c3bc21db9fc66909$var$useEffectEventImpl(payload) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $c3bc21db9fc66909$var$updateEvent(callback) {
    var ref = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
    $c3bc21db9fc66909$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $c3bc21db9fc66909$var$updateInsertionEffect(create, deps) {
    return $c3bc21db9fc66909$var$updateEffectImpl(4, 2, create, deps);
}
function $c3bc21db9fc66909$var$updateLayoutEffect(create, deps) {
    return $c3bc21db9fc66909$var$updateEffectImpl(4, 4, create, deps);
}
function $c3bc21db9fc66909$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c3bc21db9fc66909$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c3bc21db9fc66909$var$updateEffectImpl(4, 4, $c3bc21db9fc66909$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c3bc21db9fc66909$var$mountDebugValue() {}
function $c3bc21db9fc66909$var$updateCallback(callback, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c3bc21db9fc66909$var$updateMemo(nextCreate, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c3bc21db9fc66909$var$renderLanes & 1073741824) && 0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c3bc21db9fc66909$var$requestDeferredLane();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= hook;
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c3bc21db9fc66909$var$objectIs(value, prevValue)) return value;
    if (null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current) return hook = $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue), $c3bc21db9fc66909$var$objectIs(hook, prevValue) || ($c3bc21db9fc66909$var$didReceiveUpdate = !0), hook;
    if (0 === ($c3bc21db9fc66909$var$renderLanes & 42) || 0 !== ($c3bc21db9fc66909$var$renderLanes & 1073741824) && 0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 261930)) return $c3bc21db9fc66909$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c3bc21db9fc66909$var$requestDeferredLane();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= hook;
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c3bc21db9fc66909$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, currentTransition = {};
    $c3bc21db9fc66909$var$ReactSharedInternals.T = currentTransition;
    $c3bc21db9fc66909$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c3bc21db9fc66909$var$chainThenableValue(returnValue, finishedState);
            $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c3bc21db9fc66909$var$requestUpdateLane(fiber));
        } else $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, finishedState, $c3bc21db9fc66909$var$requestUpdateLane(fiber));
    } catch (error) {
        $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $c3bc21db9fc66909$var$requestUpdateLane());
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$noop() {}
function $c3bc21db9fc66909$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(476));
    var queue = $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber).queue;
    $c3bc21db9fc66909$var$startTransition(formFiber, queue, pendingState, $c3bc21db9fc66909$var$sharedNotPendingObject, null === action ? $c3bc21db9fc66909$var$noop : function() {
        $c3bc21db9fc66909$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c3bc21db9fc66909$var$sharedNotPendingObject,
        baseState: $c3bc21db9fc66909$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
            lastRenderedState: $c3bc21db9fc66909$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c3bc21db9fc66909$var$requestFormReset$1(formFiber) {
    var stateHook = $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $c3bc21db9fc66909$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $c3bc21db9fc66909$var$requestUpdateLane());
}
function $c3bc21db9fc66909$var$useHostTransitionStatus() {
    return $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$HostTransitionContext);
}
function $c3bc21db9fc66909$var$updateId() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$updateRefresh() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c3bc21db9fc66909$var$requestUpdateLane();
                fiber = $c3bc21db9fc66909$var$createUpdate(lane);
                var root$69 = $c3bc21db9fc66909$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(root$69, provider, lane), $c3bc21db9fc66909$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $c3bc21db9fc66909$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c3bc21db9fc66909$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c3bc21db9fc66909$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber) ? $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(action, fiber, lane), $c3bc21db9fc66909$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c3bc21db9fc66909$var$dispatchSetState(fiber, queue, action) {
    var lane = $c3bc21db9fc66909$var$requestUpdateLane();
    $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c3bc21db9fc66909$var$objectIs(eagerState, currentState)) return $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c3bc21db9fc66909$var$workInProgressRoot && $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c3bc21db9fc66909$var$scheduleUpdateOnFiber(action, fiber, lane), $c3bc21db9fc66909$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c3bc21db9fc66909$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c3bc21db9fc66909$var$currentlyRenderingFiber || null !== alternate && alternate === $c3bc21db9fc66909$var$currentlyRenderingFiber;
}
function $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, update) {
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c3bc21db9fc66909$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c3bc21db9fc66909$var$markRootEntangled(root, lane);
    }
}
var $c3bc21db9fc66909$var$ContextOnlyDispatcher = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$throwInvalidHookError,
    useContext: $c3bc21db9fc66909$var$throwInvalidHookError,
    useEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useImperativeHandle: $c3bc21db9fc66909$var$throwInvalidHookError,
    useLayoutEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useInsertionEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useMemo: $c3bc21db9fc66909$var$throwInvalidHookError,
    useReducer: $c3bc21db9fc66909$var$throwInvalidHookError,
    useRef: $c3bc21db9fc66909$var$throwInvalidHookError,
    useState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useDebugValue: $c3bc21db9fc66909$var$throwInvalidHookError,
    useDeferredValue: $c3bc21db9fc66909$var$throwInvalidHookError,
    useTransition: $c3bc21db9fc66909$var$throwInvalidHookError,
    useSyncExternalStore: $c3bc21db9fc66909$var$throwInvalidHookError,
    useId: $c3bc21db9fc66909$var$throwInvalidHookError,
    useHostTransitionStatus: $c3bc21db9fc66909$var$throwInvalidHookError,
    useFormState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useActionState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useOptimistic: $c3bc21db9fc66909$var$throwInvalidHookError,
    useMemoCache: $c3bc21db9fc66909$var$throwInvalidHookError,
    useCacheRefresh: $c3bc21db9fc66909$var$throwInvalidHookError
};
$c3bc21db9fc66909$var$ContextOnlyDispatcher.useEffectEvent = $c3bc21db9fc66909$var$throwInvalidHookError;
var $c3bc21db9fc66909$var$HooksDispatcherOnMount = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: function(callback, deps) {
        $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c3bc21db9fc66909$var$mountEffectImpl(4194308, 4, $c3bc21db9fc66909$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $c3bc21db9fc66909$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $c3bc21db9fc66909$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c3bc21db9fc66909$var$dispatchReducerAction.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $c3bc21db9fc66909$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c3bc21db9fc66909$var$dispatchSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        return $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $c3bc21db9fc66909$var$mountStateImpl(!1);
        stateHook = $c3bc21db9fc66909$var$startTransition.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c3bc21db9fc66909$var$currentlyRenderingFiber, hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        if ($c3bc21db9fc66909$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c3bc21db9fc66909$var$workInProgressRoot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(349));
            0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 127) || $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c3bc21db9fc66909$var$mountEffect($c3bc21db9fc66909$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c3bc21db9fc66909$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c3bc21db9fc66909$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook(), identifierPrefix = $c3bc21db9fc66909$var$workInProgressRoot.identifierPrefix;
        if ($c3bc21db9fc66909$var$isHydrating) {
            var JSCompiler_inline_result = $c3bc21db9fc66909$var$treeContextOverflow;
            var idWithLeadingBit = $c3bc21db9fc66909$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c3bc21db9fc66909$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c3bc21db9fc66909$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $c3bc21db9fc66909$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$mountActionState,
    useActionState: $c3bc21db9fc66909$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $c3bc21db9fc66909$var$dispatchOptimisticSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: function() {
        return $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = $c3bc21db9fc66909$var$refreshCache.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $c3bc21db9fc66909$var$HooksDispatcherOnUpdate = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$updateCallback,
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$updateEffect,
    useImperativeHandle: $c3bc21db9fc66909$var$updateImperativeHandle,
    useInsertionEffect: $c3bc21db9fc66909$var$updateInsertionEffect,
    useLayoutEffect: $c3bc21db9fc66909$var$updateLayoutEffect,
    useMemo: $c3bc21db9fc66909$var$updateMemo,
    useReducer: $c3bc21db9fc66909$var$updateReducer,
    useRef: $c3bc21db9fc66909$var$updateRef,
    useState: function() {
        return $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer);
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, $c3bc21db9fc66909$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer)[0], start = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c3bc21db9fc66909$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c3bc21db9fc66909$var$updateSyncExternalStore,
    useId: $c3bc21db9fc66909$var$updateId,
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$updateActionState,
    useActionState: $c3bc21db9fc66909$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return $c3bc21db9fc66909$var$updateOptimisticImpl(hook, $c3bc21db9fc66909$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: $c3bc21db9fc66909$var$updateRefresh
};
$c3bc21db9fc66909$var$HooksDispatcherOnUpdate.useEffectEvent = $c3bc21db9fc66909$var$updateEvent;
var $c3bc21db9fc66909$var$HooksDispatcherOnRerender = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$updateCallback,
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$updateEffect,
    useImperativeHandle: $c3bc21db9fc66909$var$updateImperativeHandle,
    useInsertionEffect: $c3bc21db9fc66909$var$updateInsertionEffect,
    useLayoutEffect: $c3bc21db9fc66909$var$updateLayoutEffect,
    useMemo: $c3bc21db9fc66909$var$updateMemo,
    useReducer: $c3bc21db9fc66909$var$rerenderReducer,
    useRef: $c3bc21db9fc66909$var$updateRef,
    useState: function() {
        return $c3bc21db9fc66909$var$rerenderReducer($c3bc21db9fc66909$var$basicStateReducer);
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return null === $c3bc21db9fc66909$var$currentHook ? $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue) : $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, $c3bc21db9fc66909$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c3bc21db9fc66909$var$rerenderReducer($c3bc21db9fc66909$var$basicStateReducer)[0], start = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c3bc21db9fc66909$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c3bc21db9fc66909$var$updateSyncExternalStore,
    useId: $c3bc21db9fc66909$var$updateId,
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$rerenderActionState,
    useActionState: $c3bc21db9fc66909$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        if (null !== $c3bc21db9fc66909$var$currentHook) return $c3bc21db9fc66909$var$updateOptimisticImpl(hook, $c3bc21db9fc66909$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: $c3bc21db9fc66909$var$updateRefresh
};
$c3bc21db9fc66909$var$HooksDispatcherOnRerender.useEffectEvent = $c3bc21db9fc66909$var$updateEvent;
function $c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c3bc21db9fc66909$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c3bc21db9fc66909$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(payload, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(payload, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(callback, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(callback, inst, lane));
    }
};
function $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c3bc21db9fc66909$var$shallowEqual(oldProps, newProps) || !$c3bc21db9fc66909$var$shallowEqual(oldState, newState) : !0;
}
function $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c3bc21db9fc66909$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c3bc21db9fc66909$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c3bc21db9fc66909$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $c3bc21db9fc66909$var$defaultOnUncaughtError(error) {
    $c3bc21db9fc66909$var$reportGlobalError(error);
}
function $c3bc21db9fc66909$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c3bc21db9fc66909$var$defaultOnRecoverableError(error) {
    $c3bc21db9fc66909$var$reportGlobalError(error);
}
function $c3bc21db9fc66909$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $c3bc21db9fc66909$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $c3bc21db9fc66909$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c3bc21db9fc66909$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c3bc21db9fc66909$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c3bc21db9fc66909$var$createClassErrorUpdate(lane) {
    lane = $c3bc21db9fc66909$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c3bc21db9fc66909$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c3bc21db9fc66909$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c3bc21db9fc66909$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed ? $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c3bc21db9fc66909$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c3bc21db9fc66909$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $c3bc21db9fc66909$var$shellBoundary ? $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c3bc21db9fc66909$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c3bc21db9fc66909$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes);
        $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c3bc21db9fc66909$var$isHydrating) return returnFiber = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c3bc21db9fc66909$var$HydrationMismatchException && (root = Error($c3bc21db9fc66909$var$formatProdErrorMessage(422), {
        cause: value
    }), $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c3bc21db9fc66909$var$HydrationMismatchException && (returnFiber = Error($c3bc21db9fc66909$var$formatProdErrorMessage(423), {
        cause: value
    }), $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c3bc21db9fc66909$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c3bc21db9fc66909$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c3bc21db9fc66909$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c3bc21db9fc66909$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors ? $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c3bc21db9fc66909$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c3bc21db9fc66909$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed || !$c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c3bc21db9fc66909$var$createClassErrorUpdate(rootRenderLanes), $c3bc21db9fc66909$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c3bc21db9fc66909$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c3bc21db9fc66909$var$SelectiveHydrationException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(461)), $c3bc21db9fc66909$var$didReceiveUpdate = !1;
function $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c3bc21db9fc66909$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c3bc21db9fc66909$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    nextProps = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && key && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c3bc21db9fc66909$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c3bc21db9fc66909$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c3bc21db9fc66909$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c3bc21db9fc66909$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c3bc21db9fc66909$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c3bc21db9fc66909$var$pushHiddenContext(workInProgress, prevState) : $c3bc21db9fc66909$var$reuseHiddenContextOnStack(), $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($c3bc21db9fc66909$var$pushTransition(workInProgress, prevState.cachePool), $c3bc21db9fc66909$var$pushHiddenContext(workInProgress, prevState), $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null), $c3bc21db9fc66909$var$reuseHiddenContextOnStack(), $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $c3bc21db9fc66909$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c3bc21db9fc66909$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null);
    $c3bc21db9fc66909$var$reuseHiddenContextOnStack();
    $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $c3bc21db9fc66909$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $c3bc21db9fc66909$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($c3bc21db9fc66909$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, current);
            $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $c3bc21db9fc66909$var$nextHydratableInstance) ? (current = $c3bc21db9fc66909$var$canHydrateHydrationBoundary(current, $c3bc21db9fc66909$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c3bc21db9fc66909$var$treeContextProvider ? {
                    id: $c3bc21db9fc66909$var$treeContextId,
                    overflow: $c3bc21db9fc66909$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c3bc21db9fc66909$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $c3bc21db9fc66909$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(558));
        } else if ($c3bc21db9fc66909$var$didReceiveUpdate || $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $c3bc21db9fc66909$var$didReceiveUpdate || didSuspend) {
            nextProps = $c3bc21db9fc66909$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $c3bc21db9fc66909$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(current, dehydrated), $c3bc21db9fc66909$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $c3bc21db9fc66909$var$SelectiveHydrationException;
            $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c3bc21db9fc66909$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(dehydrated.nextSibling), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$isHydrating = !0, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, null !== current && $c3bc21db9fc66909$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c3bc21db9fc66909$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $c3bc21db9fc66909$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $c3bc21db9fc66909$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    Component = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && nextProps && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c3bc21db9fc66909$var$finishRenderingHooks(current);
    Component = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && Component && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c3bc21db9fc66909$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $c3bc21db9fc66909$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c3bc21db9fc66909$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c3bc21db9fc66909$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $c3bc21db9fc66909$var$readContext(contextType) : $c3bc21db9fc66909$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c3bc21db9fc66909$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c3bc21db9fc66909$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c3bc21db9fc66909$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $c3bc21db9fc66909$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c3bc21db9fc66909$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c3bc21db9fc66909$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c3bc21db9fc66909$var$hasForceUpdate || $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c3bc21db9fc66909$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c3bc21db9fc66909$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $c3bc21db9fc66909$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c3bc21db9fc66909$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c3bc21db9fc66909$var$hasForceUpdate || null !== current && null !== current.dependencies && $c3bc21db9fc66909$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c3bc21db9fc66909$var$hasForceUpdate || $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c3bc21db9fc66909$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c3bc21db9fc66909$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c3bc21db9fc66909$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c3bc21db9fc66909$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c3bc21db9fc66909$var$getSuspendedCache()
    };
}
function $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c3bc21db9fc66909$var$workInProgressDeferredLane);
    return current;
}
function $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c3bc21db9fc66909$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c3bc21db9fc66909$var$isHydrating) {
            showFallback ? $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $c3bc21db9fc66909$var$nextHydratableInstance) ? (current = $c3bc21db9fc66909$var$canHydrateHydrationBoundary(current, $c3bc21db9fc66909$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c3bc21db9fc66909$var$treeContextProvider ? {
                    id: $c3bc21db9fc66909$var$treeContextId,
                    overflow: $c3bc21db9fc66909$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c3bc21db9fc66909$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            $c3bc21db9fc66909$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $c3bc21db9fc66909$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, nextProps);
        $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $c3bc21db9fc66909$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, workInProgress = $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, nextProps));
        else if ($c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c3bc21db9fc66909$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c3bc21db9fc66909$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c3bc21db9fc66909$var$didReceiveUpdate || $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c3bc21db9fc66909$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c3bc21db9fc66909$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $c3bc21db9fc66909$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(current, nextProps), $c3bc21db9fc66909$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c3bc21db9fc66909$var$SelectiveHydrationException;
            $c3bc21db9fc66909$var$isSuspenseInstancePending(nextPrimaryChildren) || $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $c3bc21db9fc66909$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(nextPrimaryChildren.nextSibling), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$isHydrating = !0, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, null !== current && $c3bc21db9fc66909$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $c3bc21db9fc66909$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $c3bc21db9fc66909$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $c3bc21db9fc66909$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $c3bc21db9fc66909$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $c3bc21db9fc66909$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $c3bc21db9fc66909$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, $c3bc21db9fc66909$var$bailoutOffscreenComponent(current.child, nextProps);
    $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $c3bc21db9fc66909$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $c3bc21db9fc66909$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, suspenseContext);
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $c3bc21db9fc66909$var$isHydrating ? $c3bc21db9fc66909$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c3bc21db9fc66909$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c3bc21db9fc66909$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c3bc21db9fc66909$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c3bc21db9fc66909$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c3bc21db9fc66909$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, current.memoizedState.cache);
            $c3bc21db9fc66909$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c3bc21db9fc66909$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c3bc21db9fc66909$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $c3bc21db9fc66909$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, current.memoizedState.cache);
    }
    return $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c3bc21db9fc66909$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c3bc21db9fc66909$var$didReceiveUpdate = !0;
        else {
            if (!$c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c3bc21db9fc66909$var$didReceiveUpdate = !1, $c3bc21db9fc66909$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c3bc21db9fc66909$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c3bc21db9fc66909$var$didReceiveUpdate = !1, $c3bc21db9fc66909$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c3bc21db9fc66909$var$pushTreeId(workInProgress, $c3bc21db9fc66909$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $c3bc21db9fc66909$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $c3bc21db9fc66909$var$shouldConstruct(current) ? (props = $c3bc21db9fc66909$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $c3bc21db9fc66909$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c3bc21db9fc66909$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c3bc21db9fc66909$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $c3bc21db9fc66909$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c3bc21db9fc66909$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c3bc21db9fc66909$var$getComponentNameFromType(current) || current;
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $c3bc21db9fc66909$var$resolveClassComponentProps(props, workInProgress.pendingProps), $c3bc21db9fc66909$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress);
                $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, props);
                props !== prevState.cache && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, [
                    $c3bc21db9fc66909$var$CacheContext
                ], renderLanes, !0);
                $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $c3bc21db9fc66909$var$createCapturedValueAtFiber(Error($c3bc21db9fc66909$var$formatProdErrorMessage(424)), workInProgress);
                        $c3bc21db9fc66909$var$queueHydrationError($$typeof);
                        workInProgress = $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(current.firstChild);
                        $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress;
                        $c3bc21db9fc66909$var$isHydrating = !0;
                        $c3bc21db9fc66909$var$hydrationErrors = null;
                        $c3bc21db9fc66909$var$rootOrSingletonContext = !0;
                        renderLanes = $c3bc21db9fc66909$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $c3bc21db9fc66909$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c3bc21db9fc66909$var$markRef(current, workInProgress), null === current ? (renderLanes = $c3bc21db9fc66909$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c3bc21db9fc66909$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer($c3bc21db9fc66909$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress, props[$c3bc21db9fc66909$var$internalPropsKey] = current, $c3bc21db9fc66909$var$setInitialProperties(props, renderLanes, current), $c3bc21db9fc66909$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $c3bc21db9fc66909$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c3bc21db9fc66909$var$pushHostContext(workInProgress), null === current && $c3bc21db9fc66909$var$isHydrating && (props = workInProgress.stateNode = $c3bc21db9fc66909$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootInstanceStackCursor.current), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$rootOrSingletonContext = !0, $$typeof = $c3bc21db9fc66909$var$nextHydratableInstance, $c3bc21db9fc66909$var$isSingletonScope(workInProgress.type) ? ($c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(props.firstChild)) : $c3bc21db9fc66909$var$nextHydratableInstance = $$typeof), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $c3bc21db9fc66909$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $c3bc21db9fc66909$var$isHydrating) {
                if ($$typeof = props = $c3bc21db9fc66909$var$nextHydratableInstance) props = $c3bc21db9fc66909$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(props.firstChild), $c3bc21db9fc66909$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            $c3bc21db9fc66909$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $c3bc21db9fc66909$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $c3bc21db9fc66909$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, $c3bc21db9fc66909$var$TransitionAwareHostComponent, null, null, renderLanes), $c3bc21db9fc66909$var$HostTransitionContext._currentValue = $$typeof);
            $c3bc21db9fc66909$var$markRef(current, workInProgress);
            $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c3bc21db9fc66909$var$isHydrating) {
                if (current = renderLanes = $c3bc21db9fc66909$var$nextHydratableInstance) renderLanes = $c3bc21db9fc66909$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $c3bc21db9fc66909$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $c3bc21db9fc66909$var$pushProvider(workInProgress, workInProgress.type, props.value), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $c3bc21db9fc66909$var$prepareToReadContext(workInProgress), $$typeof = $c3bc21db9fc66909$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $c3bc21db9fc66909$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $c3bc21db9fc66909$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $c3bc21db9fc66909$var$prepareToReadContext(workInProgress), props = $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext), null === current ? ($$typeof = $c3bc21db9fc66909$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $c3bc21db9fc66909$var$workInProgressRoot, prevState = $c3bc21db9fc66909$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $c3bc21db9fc66909$var$initializeUpdateQueue(workInProgress), $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress), $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, props)) : (props = prevState.cache, $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, props), props !== $$typeof.cache && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, [
                $c3bc21db9fc66909$var$CacheContext
            ], renderLanes, !0))), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c3bc21db9fc66909$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($c3bc21db9fc66909$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $c3bc21db9fc66909$var$suspendedThenable = $c3bc21db9fc66909$var$noopSuspenseyCommitThenable, $c3bc21db9fc66909$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c3bc21db9fc66909$var$preloadResource(resource)) {
        if ($c3bc21db9fc66909$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $c3bc21db9fc66909$var$suspendedThenable = $c3bc21db9fc66909$var$noopSuspenseyCommitThenable, $c3bc21db9fc66909$var$SuspenseyCommitException;
    }
}
function $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c3bc21db9fc66909$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c3bc21db9fc66909$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c3bc21db9fc66909$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $c3bc21db9fc66909$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c3bc21db9fc66909$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c3bc21db9fc66909$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
            $c3bc21db9fc66909$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c3bc21db9fc66909$var$popHydrationState(workInProgress) ? $c3bc21db9fc66909$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable());
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($c3bc21db9fc66909$var$markUpdate(workInProgress), null !== nextResource ? ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($c3bc21db9fc66909$var$markUpdate(workInProgress), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $c3bc21db9fc66909$var$popHostContext(workInProgress);
            renderLanes = $c3bc21db9fc66909$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c3bc21db9fc66909$var$contextStackCursor.current;
                $c3bc21db9fc66909$var$popHydrationState(workInProgress) ? $c3bc21db9fc66909$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c3bc21db9fc66909$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c3bc21db9fc66909$var$markUpdate(workInProgress));
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c3bc21db9fc66909$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $c3bc21db9fc66909$var$contextStackCursor.current;
                if ($c3bc21db9fc66909$var$popHydrationState(workInProgress)) $c3bc21db9fc66909$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer($c3bc21db9fc66909$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    nextResource[$c3bc21db9fc66909$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($c3bc21db9fc66909$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
                }
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            $c3bc21db9fc66909$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                current = $c3bc21db9fc66909$var$rootInstanceStackCursor.current;
                if ($c3bc21db9fc66909$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c3bc21db9fc66909$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c3bc21db9fc66909$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $c3bc21db9fc66909$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(557));
                        current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    } else $c3bc21db9fc66909$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(558));
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c3bc21db9fc66909$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
                        type[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    } else $c3bc21db9fc66909$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c3bc21db9fc66909$var$popHostContainer(), null === current && $c3bc21db9fc66909$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c3bc21db9fc66909$var$popProvider(workInProgress.type), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 19:
            $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $c3bc21db9fc66909$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c3bc21db9fc66909$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current & 1 | 2);
                            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $c3bc21db9fc66909$var$now() > $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $c3bc21db9fc66909$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, current), $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$c3bc21db9fc66909$var$isHydrating) return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c3bc21db9fc66909$var$now() - newProps.renderingStartTime > $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $c3bc21db9fc66909$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $c3bc21db9fc66909$var$now(), current.sibling = null, renderLanes = $c3bc21db9fc66909$var$suspenseStackCursor.current, $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c3bc21db9fc66909$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c3bc21db9fc66909$var$unwindWork(current, workInProgress) {
    $c3bc21db9fc66909$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), $c3bc21db9fc66909$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c3bc21db9fc66909$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(340));
                $c3bc21db9fc66909$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(340));
                $c3bc21db9fc66909$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor), null;
        case 4:
            return $c3bc21db9fc66909$var$popHostContainer(), null;
        case 10:
            return $c3bc21db9fc66909$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$popHiddenContext(), null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c3bc21db9fc66909$var$unwindInterruptedWork(current, interruptedWork) {
    $c3bc21db9fc66909$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
            $c3bc21db9fc66909$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c3bc21db9fc66909$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c3bc21db9fc66909$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
            break;
        case 10:
            $c3bc21db9fc66909$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            $c3bc21db9fc66909$var$popHiddenContext();
            null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache);
            break;
        case 24:
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
    }
}
function $c3bc21db9fc66909$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c3bc21db9fc66909$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c3bc21db9fc66909$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c3bc21db9fc66909$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c3bc21db9fc66909$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $c3bc21db9fc66909$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c3bc21db9fc66909$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c3bc21db9fc66909$var$internalPropsKey] = newProps;
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $c3bc21db9fc66909$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $c3bc21db9fc66909$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c3bc21db9fc66909$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $c3bc21db9fc66909$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c3bc21db9fc66909$var$noop$1));
    else if (4 !== tag && (27 === tag && $c3bc21db9fc66909$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $c3bc21db9fc66909$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $c3bc21db9fc66909$var$setInitialProperties(singleton, type, props);
        singleton[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
        singleton[$c3bc21db9fc66909$var$internalPropsKey] = props;
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = !1, $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = !1, $c3bc21db9fc66909$var$needsFormReset = !1, $c3bc21db9fc66909$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c3bc21db9fc66909$var$nextEffect = null;
function $c3bc21db9fc66909$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c3bc21db9fc66909$var$eventsEnabled = $c3bc21db9fc66909$var$_enabled;
    root = $c3bc21db9fc66909$var$getActiveElementDeep(root);
    if ($c3bc21db9fc66909$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c3bc21db9fc66909$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c3bc21db9fc66909$var$_enabled = !1;
    for($c3bc21db9fc66909$var$nextEffect = firstChild; null !== $c3bc21db9fc66909$var$nextEffect;)if (firstChild = $c3bc21db9fc66909$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $c3bc21db9fc66909$var$nextEffect = root;
    else for(; null !== $c3bc21db9fc66909$var$nextEffect;){
        firstChild = $c3bc21db9fc66909$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c3bc21db9fc66909$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c3bc21db9fc66909$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c3bc21db9fc66909$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c3bc21db9fc66909$var$nextEffect = root;
            break;
        }
        $c3bc21db9fc66909$var$nextEffect = firstChild.return;
    }
}
function $c3bc21db9fc66909$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c3bc21db9fc66909$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $c3bc21db9fc66909$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $c3bc21db9fc66909$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $c3bc21db9fc66909$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
                prevProps = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
                $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = flags;
                ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevProps;
                $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c3bc21db9fc66909$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c3bc21db9fc66909$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c3bc21db9fc66909$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c3bc21db9fc66909$var$hostParent = null, $c3bc21db9fc66909$var$hostParentIsContainer = !1;
function $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onCommitFiberUnmount) try {
        $c3bc21db9fc66909$var$injectedHook.onCommitFiberUnmount($c3bc21db9fc66909$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c3bc21db9fc66909$var$hostParent, prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$isSingletonScope(deletedFiber.type) && ($c3bc21db9fc66909$var$hostParent = deletedFiber.stateNode, $c3bc21db9fc66909$var$hostParentIsContainer = !1);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$releaseSingletonInstance(deletedFiber.stateNode);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $c3bc21db9fc66909$var$hostParent;
            prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$hostParent = null;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $c3bc21db9fc66909$var$hostParent) {
                if ($c3bc21db9fc66909$var$hostParentIsContainer) try {
                    (9 === $c3bc21db9fc66909$var$hostParent.nodeType ? $c3bc21db9fc66909$var$hostParent.body : "HTML" === $c3bc21db9fc66909$var$hostParent.nodeName ? $c3bc21db9fc66909$var$hostParent.ownerDocument.body : $c3bc21db9fc66909$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c3bc21db9fc66909$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c3bc21db9fc66909$var$hostParent && ($c3bc21db9fc66909$var$hostParentIsContainer ? (finishedRoot = $c3bc21db9fc66909$var$hostParent, $c3bc21db9fc66909$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot)) : $c3bc21db9fc66909$var$clearHydrationBoundary($c3bc21db9fc66909$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c3bc21db9fc66909$var$hostParent;
            prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c3bc21db9fc66909$var$hostParentIsContainer = !0;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c3bc21db9fc66909$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || ($c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = (prevHostParent = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c3bc21db9fc66909$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c3bc21db9fc66909$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c3bc21db9fc66909$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c3bc21db9fc66909$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $c3bc21db9fc66909$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($c3bc21db9fc66909$var$isSingletonScope(parent.type)) {
                        $c3bc21db9fc66909$var$hostParent = parent.stateNode;
                        $c3bc21db9fc66909$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $c3bc21db9fc66909$var$hostParent = parent.stateNode;
                    $c3bc21db9fc66909$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $c3bc21db9fc66909$var$hostParent = parent.stateNode.containerInfo;
                    $c3bc21db9fc66909$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c3bc21db9fc66909$var$hostParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(160));
        $c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c3bc21db9fc66909$var$hostParent = null;
        $c3bc21db9fc66909$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c3bc21db9fc66909$var$currentHoistableRoot = null;
function $c3bc21db9fc66909$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c3bc21db9fc66909$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c3bc21db9fc66909$var$commitHookEffectListMount(3, finishedWork), $c3bc21db9fc66909$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            flags & 64 && $c3bc21db9fc66909$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c3bc21db9fc66909$var$internalHoistableMarker] || currentResource[$c3bc21db9fc66909$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c3bc21db9fc66909$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
                                        $c3bc21db9fc66909$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c3bc21db9fc66909$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c3bc21db9fc66909$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c3bc21db9fc66909$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c3bc21db9fc66909$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
                                $c3bc21db9fc66909$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c3bc21db9fc66909$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c3bc21db9fc66909$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c3bc21db9fc66909$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c3bc21db9fc66909$var$needsFormReset = !0);
            break;
        case 6:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c3bc21db9fc66909$var$tagCaches = null;
            hoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(root.containerInfo);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$currentHoistableRoot = hoistableRoot;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c3bc21db9fc66909$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c3bc21db9fc66909$var$needsFormReset && ($c3bc21db9fc66909$var$needsFormReset = !1, $c3bc21db9fc66909$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            $c3bc21db9fc66909$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c3bc21db9fc66909$var$globalMostRecentFallbackTime = $c3bc21db9fc66909$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
            $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $c3bc21db9fc66909$var$hideOrUnhideDehydratedBoundary(instance, !0) : $c3bc21db9fc66909$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork), $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
    }
}
function $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($c3bc21db9fc66909$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($c3bc21db9fc66909$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c3bc21db9fc66909$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c3bc21db9fc66909$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $c3bc21db9fc66909$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c3bc21db9fc66909$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c3bc21db9fc66909$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c3bc21db9fc66909$var$releaseCache(previousCache));
}
function $c3bc21db9fc66909$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c3bc21db9fc66909$var$releaseCache(current));
}
function $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c3bc21db9fc66909$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c3bc21db9fc66909$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c3bc21db9fc66909$var$suspenseyCommitFlag = 8192;
function $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $c3bc21db9fc66909$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $c3bc21db9fc66909$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c3bc21db9fc66909$var$suspendResource(suspendedState, $c3bc21db9fc66909$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $c3bc21db9fc66909$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c3bc21db9fc66909$var$suspenseyCommitFlag, $c3bc21db9fc66909$var$suspenseyCommitFlag = 16777216, $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $c3bc21db9fc66909$var$suspenseyCommitFlag = previousHoistableRoot) : $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c3bc21db9fc66909$var$nextEffect = childToDelete;
            $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c3bc21db9fc66909$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c3bc21db9fc66909$var$nextEffect = childToDelete;
            $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c3bc21db9fc66909$var$nextEffect;){
        var fiber = $c3bc21db9fc66909$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c3bc21db9fc66909$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c3bc21db9fc66909$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c3bc21db9fc66909$var$nextEffect;){
            cache = $c3bc21db9fc66909$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c3bc21db9fc66909$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c3bc21db9fc66909$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c3bc21db9fc66909$var$nextEffect = sibling;
                break a;
            }
            $c3bc21db9fc66909$var$nextEffect = returnFiber;
        }
    }
}
var $c3bc21db9fc66909$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext).controller.signal;
    }
}, $c3bc21db9fc66909$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c3bc21db9fc66909$var$executionContext = 0, $c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgress = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0, $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = !1, $c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !1, $c3bc21db9fc66909$var$entangledRenderLanes = 0, $c3bc21db9fc66909$var$workInProgressRootExitStatus = 0, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes = 0, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes = 0, $c3bc21db9fc66909$var$workInProgressRootPingedLanes = 0, $c3bc21db9fc66909$var$workInProgressDeferredLane = 0, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = 0, $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = null, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = null, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c3bc21db9fc66909$var$globalMostRecentFallbackTime = 0, $c3bc21db9fc66909$var$globalMostRecentTransitionTime = 0, $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = Infinity, $c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = null, $c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$pendingEffectsRoot = null, $c3bc21db9fc66909$var$pendingFinishedWork = null, $c3bc21db9fc66909$var$pendingEffectsLanes = 0, $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = 0, $c3bc21db9fc66909$var$pendingPassiveTransitions = null, $c3bc21db9fc66909$var$pendingRecoverableErrors = null, $c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null;
function $c3bc21db9fc66909$var$requestUpdateLane() {
    return 0 !== ($c3bc21db9fc66909$var$executionContext & 2) && 0 !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes ? $c3bc21db9fc66909$var$workInProgressRootRenderLanes & -$c3bc21db9fc66909$var$workInProgressRootRenderLanes : null !== $c3bc21db9fc66909$var$ReactSharedInternals.T ? $c3bc21db9fc66909$var$requestTransitionLane() : $c3bc21db9fc66909$var$resolveUpdatePriority();
}
function $c3bc21db9fc66909$var$requestDeferredLane() {
    if (0 === $c3bc21db9fc66909$var$workInProgressDeferredLane) {
        if (0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912) || $c3bc21db9fc66909$var$isHydrating) {
            var lane = $c3bc21db9fc66909$var$nextTransitionDeferredLane;
            $c3bc21db9fc66909$var$nextTransitionDeferredLane <<= 1;
            0 === ($c3bc21db9fc66909$var$nextTransitionDeferredLane & 3932160) && ($c3bc21db9fc66909$var$nextTransitionDeferredLane = 262144);
            $c3bc21db9fc66909$var$workInProgressDeferredLane = lane;
        } else $c3bc21db9fc66909$var$workInProgressDeferredLane = 536870912;
    }
    lane = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $c3bc21db9fc66909$var$workInProgressDeferredLane;
}
function $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c3bc21db9fc66909$var$workInProgressRoot && (2 === $c3bc21db9fc66909$var$workInProgressSuspendedReason || 9 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $c3bc21db9fc66909$var$prepareFreshStack(root, 0), $c3bc21db9fc66909$var$markRootSuspended(root, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1);
    $c3bc21db9fc66909$var$markRootUpdated$1(root, lane);
    if (0 === ($c3bc21db9fc66909$var$executionContext & 2) || root !== $c3bc21db9fc66909$var$workInProgressRoot) root === $c3bc21db9fc66909$var$workInProgressRoot && (0 === ($c3bc21db9fc66909$var$executionContext & 2) && ($c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && $c3bc21db9fc66909$var$markRootSuspended(root, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1)), $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
}
function $c3bc21db9fc66909$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c3bc21db9fc66909$var$renderRootConcurrent(root$jscomp$0, lanes) : $c3bc21db9fc66909$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c3bc21db9fc66909$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c3bc21db9fc66909$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c3bc21db9fc66909$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c3bc21db9fc66909$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c3bc21db9fc66909$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c3bc21db9fc66909$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors;
                            $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors ? $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors.push.apply($c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c3bc21db9fc66909$var$prepareFreshStack(root$jscomp$0, 0);
                $c3bc21db9fc66909$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $c3bc21db9fc66909$var$markRootSuspended(shouldTimeSlice, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !$c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $c3bc21db9fc66909$var$globalMostRecentFallbackTime + 300 - $c3bc21db9fc66909$var$now(), 10 < exitStatus)) {
                    $c3bc21db9fc66909$var$markRootSuspended(shouldTimeSlice, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !$c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c3bc21db9fc66909$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $c3bc21db9fc66909$var$scheduleTimeout($c3bc21db9fc66909$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, $c3bc21db9fc66909$var$workInProgressTransitions, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $c3bc21db9fc66909$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, $c3bc21db9fc66909$var$workInProgressTransitions, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $c3bc21db9fc66909$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c3bc21db9fc66909$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $c3bc21db9fc66909$var$noop$1
        };
        $c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $c3bc21db9fc66909$var$globalMostRecentFallbackTime - $c3bc21db9fc66909$var$now() : (lanes & 4194048) === lanes ? $c3bc21db9fc66909$var$globalMostRecentTransitionTime - $c3bc21db9fc66909$var$now() : 0;
        timeoutOffset = $c3bc21db9fc66909$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($c3bc21db9fc66909$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $c3bc21db9fc66909$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c3bc21db9fc66909$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $c3bc21db9fc66909$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c3bc21db9fc66909$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c3bc21db9fc66909$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c3bc21db9fc66909$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $c3bc21db9fc66909$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c3bc21db9fc66909$var$flushSyncWork$1() {
    return 0 === ($c3bc21db9fc66909$var$executionContext & 6) ? ($c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c3bc21db9fc66909$var$resetWorkInProgressStack() {
    if (null !== $c3bc21db9fc66909$var$workInProgress) {
        if (0 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) var interruptedWork = $c3bc21db9fc66909$var$workInProgress.return;
        else interruptedWork = $c3bc21db9fc66909$var$workInProgress, $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null, $c3bc21db9fc66909$var$resetHooksOnUnwind(interruptedWork), $c3bc21db9fc66909$var$thenableState$1 = null, $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0, interruptedWork = $c3bc21db9fc66909$var$workInProgress;
        for(; null !== interruptedWork;)$c3bc21db9fc66909$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c3bc21db9fc66909$var$workInProgress = null;
    }
}
function $c3bc21db9fc66909$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c3bc21db9fc66909$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c3bc21db9fc66909$var$pendingEffectsLanes = 0;
    $c3bc21db9fc66909$var$resetWorkInProgressStack();
    $c3bc21db9fc66909$var$workInProgressRoot = root;
    $c3bc21db9fc66909$var$workInProgress = timeoutHandle = $c3bc21db9fc66909$var$createWorkInProgress(root.current, null);
    $c3bc21db9fc66909$var$workInProgressRootRenderLanes = lanes;
    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
    $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, lanes);
    $c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !1;
    $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = $c3bc21db9fc66909$var$workInProgressDeferredLane = $c3bc21db9fc66909$var$workInProgressRootPingedLanes = $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes = $c3bc21db9fc66909$var$workInProgressRootSkippedLanes = $c3bc21db9fc66909$var$workInProgressRootExitStatus = 0;
    $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = null;
    $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $c3bc21db9fc66909$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $c3bc21db9fc66909$var$entangledRenderLanes = lanes;
    $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c3bc21db9fc66909$var$handleThrow(root, thrownValue) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    thrownValue === $c3bc21db9fc66909$var$SuspenseException || thrownValue === $c3bc21db9fc66909$var$SuspenseActionException ? (thrownValue = $c3bc21db9fc66909$var$getSuspendedThenable(), $c3bc21db9fc66909$var$workInProgressSuspendedReason = 3) : thrownValue === $c3bc21db9fc66909$var$SuspenseyCommitException ? (thrownValue = $c3bc21db9fc66909$var$getSuspendedThenable(), $c3bc21db9fc66909$var$workInProgressSuspendedReason = 4) : $c3bc21db9fc66909$var$workInProgressSuspendedReason = thrownValue === $c3bc21db9fc66909$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $c3bc21db9fc66909$var$workInProgressThrownValue = thrownValue;
    null === $c3bc21db9fc66909$var$workInProgress && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 1, $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c3bc21db9fc66909$var$shouldRemainOnPreviousScreen() {
    var handler = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 4194048) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes ? null === $c3bc21db9fc66909$var$shellBoundary ? !0 : !1 : ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 62914560) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes || 0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912) ? handler === $c3bc21db9fc66909$var$shellBoundary : !1;
}
function $c3bc21db9fc66909$var$pushDispatcher() {
    var prevDispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.H;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c3bc21db9fc66909$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c3bc21db9fc66909$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.A;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = $c3bc21db9fc66909$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible() {
    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 4;
    $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings || ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 4194048) !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes && null !== $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current || ($c3bc21db9fc66909$var$workInProgressRootIsPrerendering = !0);
    0 === ($c3bc21db9fc66909$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c3bc21db9fc66909$var$workInProgressRoot || $c3bc21db9fc66909$var$markRootSuspended($c3bc21db9fc66909$var$workInProgressRoot, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1);
}
function $c3bc21db9fc66909$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
    $c3bc21db9fc66909$var$executionContext |= 2;
    var prevDispatcher = $c3bc21db9fc66909$var$pushDispatcher(), prevAsyncDispatcher = $c3bc21db9fc66909$var$pushAsyncDispatcher();
    if ($c3bc21db9fc66909$var$workInProgressRoot !== root || $c3bc21db9fc66909$var$workInProgressRootRenderLanes !== lanes) $c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c3bc21db9fc66909$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && null !== $c3bc21db9fc66909$var$workInProgress) {
            var unitOfWork = $c3bc21db9fc66909$var$workInProgress, thrownValue = $c3bc21db9fc66909$var$workInProgressThrownValue;
            switch($c3bc21db9fc66909$var$workInProgressSuspendedReason){
                case 8:
                    $c3bc21db9fc66909$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c3bc21db9fc66909$var$workInProgressSuspendedReason;
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c3bc21db9fc66909$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c3bc21db9fc66909$var$workInProgressSuspendedReason, $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c3bc21db9fc66909$var$workLoopSync();
        exitStatus = $c3bc21db9fc66909$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $c3bc21db9fc66909$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = prevDispatcher;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c3bc21db9fc66909$var$workInProgress && ($c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0, $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c3bc21db9fc66909$var$workLoopSync() {
    for(; null !== $c3bc21db9fc66909$var$workInProgress;)$c3bc21db9fc66909$var$performUnitOfWork($c3bc21db9fc66909$var$workInProgress);
}
function $c3bc21db9fc66909$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
    $c3bc21db9fc66909$var$executionContext |= 2;
    var prevDispatcher = $c3bc21db9fc66909$var$pushDispatcher(), prevAsyncDispatcher = $c3bc21db9fc66909$var$pushAsyncDispatcher();
    $c3bc21db9fc66909$var$workInProgressRoot !== root || $c3bc21db9fc66909$var$workInProgressRootRenderLanes !== lanes ? ($c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = $c3bc21db9fc66909$var$now() + 500, $c3bc21db9fc66909$var$prepareFreshStack(root, lanes)) : $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && null !== $c3bc21db9fc66909$var$workInProgress) {
            lanes = $c3bc21db9fc66909$var$workInProgress;
            var thrownValue = $c3bc21db9fc66909$var$workInProgressThrownValue;
            b: switch($c3bc21db9fc66909$var$workInProgressSuspendedReason){
                case 1:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($c3bc21db9fc66909$var$isThenableResolved(thrownValue)) {
                        $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                        $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                        $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && 9 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason || $c3bc21db9fc66909$var$workInProgressRoot !== root || ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 7);
                        $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c3bc21db9fc66909$var$isThenableResolved(thrownValue) ? ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(lanes)) : ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c3bc21db9fc66909$var$workInProgress.tag){
                        case 26:
                            resource = $c3bc21db9fc66909$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c3bc21db9fc66909$var$workInProgress;
                            if (resource ? $c3bc21db9fc66909$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                                $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c3bc21db9fc66909$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c3bc21db9fc66909$var$workInProgress = returnFiber, $c3bc21db9fc66909$var$completeUnitOfWork(returnFiber)) : $c3bc21db9fc66909$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c3bc21db9fc66909$var$resetWorkInProgressStack();
                    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(462));
            }
        }
        $c3bc21db9fc66909$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $c3bc21db9fc66909$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = prevDispatcher;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
    if (null !== $c3bc21db9fc66909$var$workInProgress) return 0;
    $c3bc21db9fc66909$var$workInProgressRoot = null;
    $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0;
    $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates();
    return $c3bc21db9fc66909$var$workInProgressRootExitStatus;
}
function $c3bc21db9fc66909$var$workLoopConcurrentByScheduler() {
    for(; null !== $c3bc21db9fc66909$var$workInProgress && !$c3bc21db9fc66909$var$shouldYield();)$c3bc21db9fc66909$var$performUnitOfWork($c3bc21db9fc66909$var$workInProgress);
}
function $c3bc21db9fc66909$var$performUnitOfWork(unitOfWork) {
    var next = $c3bc21db9fc66909$var$beginWork(unitOfWork.alternate, unitOfWork, $c3bc21db9fc66909$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) : $c3bc21db9fc66909$var$workInProgress = next;
}
function $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c3bc21db9fc66909$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c3bc21db9fc66909$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c3bc21db9fc66909$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c3bc21db9fc66909$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c3bc21db9fc66909$var$resetHooksOnUnwind(next);
        default:
            $c3bc21db9fc66909$var$unwindInterruptedWork(current, next), next = $c3bc21db9fc66909$var$workInProgress = $c3bc21db9fc66909$var$resetWorkInProgress(next, $c3bc21db9fc66909$var$entangledRenderLanes), next = $c3bc21db9fc66909$var$beginWork(current, next, $c3bc21db9fc66909$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) : $c3bc21db9fc66909$var$workInProgress = next;
}
function $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$resetHooksOnUnwind(unitOfWork);
    $c3bc21db9fc66909$var$thenableState$1 = null;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c3bc21db9fc66909$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c3bc21db9fc66909$var$workInProgressRootRenderLanes)) {
            $c3bc21db9fc66909$var$workInProgressRootExitStatus = 1;
            $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c3bc21db9fc66909$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c3bc21db9fc66909$var$workInProgress = returnFiber, error;
        $c3bc21db9fc66909$var$workInProgressRootExitStatus = 1;
        $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c3bc21db9fc66909$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c3bc21db9fc66909$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c3bc21db9fc66909$var$workInProgressRootIsPrerendering || 0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c3bc21db9fc66909$var$unwindUnitOfWork(unitOfWork, root);
    } else $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork);
}
function $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c3bc21db9fc66909$var$unwindUnitOfWork(completedWork, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c3bc21db9fc66909$var$completeWork(completedWork.alternate, completedWork, $c3bc21db9fc66909$var$entangledRenderLanes);
        if (null !== next) {
            $c3bc21db9fc66909$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c3bc21db9fc66909$var$workInProgress = completedWork;
            return;
        }
        $c3bc21db9fc66909$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 5);
}
function $c3bc21db9fc66909$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c3bc21db9fc66909$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c3bc21db9fc66909$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c3bc21db9fc66909$var$workInProgress = unitOfWork;
            return;
        }
        $c3bc21db9fc66909$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 6;
    $c3bc21db9fc66909$var$workInProgress = null;
}
function $c3bc21db9fc66909$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $c3bc21db9fc66909$var$flushPendingEffects();
    while (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus);
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $c3bc21db9fc66909$var$concurrentlyUpdatedLanes;
        $c3bc21db9fc66909$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $c3bc21db9fc66909$var$workInProgressRoot && ($c3bc21db9fc66909$var$workInProgress = $c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0);
        $c3bc21db9fc66909$var$pendingFinishedWork = finishedWork;
        $c3bc21db9fc66909$var$pendingEffectsRoot = root;
        $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
        $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $c3bc21db9fc66909$var$pendingPassiveTransitions = transitions;
        $c3bc21db9fc66909$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $c3bc21db9fc66909$var$scheduleCallback$1($c3bc21db9fc66909$var$NormalPriority$1, function() {
            $c3bc21db9fc66909$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            transitions = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $c3bc21db9fc66909$var$executionContext = spawnedLane, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = transitions, $c3bc21db9fc66909$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $c3bc21db9fc66909$var$pendingEffectsStatus = 1;
        $c3bc21db9fc66909$var$flushMutationEffects();
        $c3bc21db9fc66909$var$flushLayoutEffects();
        $c3bc21db9fc66909$var$flushSpawnedWork();
    }
}
function $c3bc21db9fc66909$var$flushMutationEffects() {
    if (1 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $c3bc21db9fc66909$var$selectionInformation, curFocusedElem = $c3bc21db9fc66909$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $c3bc21db9fc66909$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $c3bc21db9fc66909$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $c3bc21db9fc66909$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $c3bc21db9fc66909$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $c3bc21db9fc66909$var$_enabled = !!$c3bc21db9fc66909$var$eventsEnabled;
                $c3bc21db9fc66909$var$selectionInformation = $c3bc21db9fc66909$var$eventsEnabled = null;
            } finally{
                $c3bc21db9fc66909$var$executionContext = prevExecutionContext, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $c3bc21db9fc66909$var$pendingEffectsStatus = 2;
    }
}
function $c3bc21db9fc66909$var$flushLayoutEffects() {
    if (2 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $c3bc21db9fc66909$var$executionContext = prevExecutionContext, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $c3bc21db9fc66909$var$pendingEffectsStatus = 3;
    }
}
function $c3bc21db9fc66909$var$flushSpawnedWork() {
    if (4 === $c3bc21db9fc66909$var$pendingEffectsStatus || 3 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        $c3bc21db9fc66909$var$requestPaint();
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes, recoverableErrors = $c3bc21db9fc66909$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $c3bc21db9fc66909$var$pendingEffectsStatus = 5 : ($c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$pendingFinishedWork = $c3bc21db9fc66909$var$pendingEffectsRoot = null, $c3bc21db9fc66909$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $c3bc21db9fc66909$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onCommitFiberRoot) try {
            $c3bc21db9fc66909$var$injectedHook.onCommitFiberRoot($c3bc21db9fc66909$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            remainingLanes = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $c3bc21db9fc66909$var$ReactSharedInternals.T = finishedWork, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($c3bc21db9fc66909$var$pendingEffectsLanes & 3) && $c3bc21db9fc66909$var$flushPendingEffects();
        $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $c3bc21db9fc66909$var$rootWithNestedUpdates ? $c3bc21db9fc66909$var$nestedUpdateCount++ : ($c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = root) : $c3bc21db9fc66909$var$nestedUpdateCount = 0;
        $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $c3bc21db9fc66909$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c3bc21db9fc66909$var$releaseCache(remainingLanes)));
}
function $c3bc21db9fc66909$var$flushPendingEffects() {
    $c3bc21db9fc66909$var$flushMutationEffects();
    $c3bc21db9fc66909$var$flushLayoutEffects();
    $c3bc21db9fc66909$var$flushSpawnedWork();
    return $c3bc21db9fc66909$var$flushPassiveEffects();
}
function $c3bc21db9fc66909$var$flushPassiveEffects() {
    if (5 !== $c3bc21db9fc66909$var$pendingEffectsStatus) return !1;
    var root = $c3bc21db9fc66909$var$pendingEffectsRoot, remainingLanes = $c3bc21db9fc66909$var$pendingEffectsRemainingLanes;
    $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $c3bc21db9fc66909$var$lanesToEventPriority($c3bc21db9fc66909$var$pendingEffectsLanes), prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
        renderPriority = $c3bc21db9fc66909$var$pendingPassiveTransitions;
        $c3bc21db9fc66909$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $c3bc21db9fc66909$var$pendingEffectsRoot, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes;
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        $c3bc21db9fc66909$var$pendingFinishedWork = $c3bc21db9fc66909$var$pendingEffectsRoot = null;
        $c3bc21db9fc66909$var$pendingEffectsLanes = 0;
        if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(331));
        var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
        $c3bc21db9fc66909$var$executionContext |= 4;
        $c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $c3bc21db9fc66909$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
        $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onPostCommitFiberRoot) try {
            $c3bc21db9fc66909$var$injectedHook.onPostCommitFiberRoot($c3bc21db9fc66909$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition, $c3bc21db9fc66909$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c3bc21db9fc66909$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c3bc21db9fc66909$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c3bc21db9fc66909$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c3bc21db9fc66909$var$markRootUpdated$1(rootFiber, 2), $c3bc21db9fc66909$var$ensureRootIsScheduled(rootFiber));
}
function $c3bc21db9fc66909$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed || !$c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c3bc21db9fc66909$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c3bc21db9fc66909$var$createClassErrorUpdate(2);
                instance = $c3bc21db9fc66909$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c3bc21db9fc66909$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c3bc21db9fc66909$var$markRootUpdated$1(instance, 2), $c3bc21db9fc66909$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c3bc21db9fc66909$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c3bc21db9fc66909$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c3bc21db9fc66909$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c3bc21db9fc66909$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c3bc21db9fc66909$var$workInProgressRoot === root && ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c3bc21db9fc66909$var$workInProgressRootExitStatus || 3 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 62914560) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes && 300 > $c3bc21db9fc66909$var$now() - $c3bc21db9fc66909$var$globalMostRecentFallbackTime ? 0 === ($c3bc21db9fc66909$var$executionContext & 2) && $c3bc21db9fc66909$var$prepareFreshStack(root, 0) : $c3bc21db9fc66909$var$workInProgressRootPingedLanes |= pingedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes === $c3bc21db9fc66909$var$workInProgressRootRenderLanes && ($c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = 0));
    $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
}
function $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c3bc21db9fc66909$var$claimNextRetryLane());
    boundaryFiber = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c3bc21db9fc66909$var$markRootUpdated$1(boundaryFiber, retryLane), $c3bc21db9fc66909$var$ensureRootIsScheduled(boundaryFiber));
}
function $c3bc21db9fc66909$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c3bc21db9fc66909$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c3bc21db9fc66909$var$scheduleCallback$1(priorityLevel, callback) {
    return $c3bc21db9fc66909$var$scheduleCallback$3(priorityLevel, callback);
}
var $c3bc21db9fc66909$var$firstScheduledRoot = null, $c3bc21db9fc66909$var$lastScheduledRoot = null, $c3bc21db9fc66909$var$didScheduleMicrotask = !1, $c3bc21db9fc66909$var$mightHavePendingSyncWork = !1, $c3bc21db9fc66909$var$isFlushingWork = !1, $c3bc21db9fc66909$var$currentEventTransitionLane = 0;
function $c3bc21db9fc66909$var$ensureRootIsScheduled(root) {
    root !== $c3bc21db9fc66909$var$lastScheduledRoot && null === root.next && (null === $c3bc21db9fc66909$var$lastScheduledRoot ? $c3bc21db9fc66909$var$firstScheduledRoot = $c3bc21db9fc66909$var$lastScheduledRoot = root : $c3bc21db9fc66909$var$lastScheduledRoot = $c3bc21db9fc66909$var$lastScheduledRoot.next = root);
    $c3bc21db9fc66909$var$mightHavePendingSyncWork = !0;
    $c3bc21db9fc66909$var$didScheduleMicrotask || ($c3bc21db9fc66909$var$didScheduleMicrotask = !0, $c3bc21db9fc66909$var$scheduleImmediateRootScheduleTask());
}
function $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c3bc21db9fc66909$var$isFlushingWork && $c3bc21db9fc66909$var$mightHavePendingSyncWork) {
        $c3bc21db9fc66909$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c3bc21db9fc66909$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c3bc21db9fc66909$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c3bc21db9fc66909$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c3bc21db9fc66909$var$getNextLanes(root$170, root$170 === $c3bc21db9fc66909$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c3bc21db9fc66909$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $c3bc21db9fc66909$var$isFlushingWork = !1;
    }
}
function $c3bc21db9fc66909$var$processRootScheduleInImmediateTask() {
    $c3bc21db9fc66909$var$processRootScheduleInMicrotask();
}
function $c3bc21db9fc66909$var$processRootScheduleInMicrotask() {
    $c3bc21db9fc66909$var$mightHavePendingSyncWork = $c3bc21db9fc66909$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c3bc21db9fc66909$var$currentEventTransitionLane && $c3bc21db9fc66909$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c3bc21db9fc66909$var$currentEventTransitionLane);
    for(var currentTime = $c3bc21db9fc66909$var$now(), prev = null, root = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c3bc21db9fc66909$var$firstScheduledRoot = next : prev.next = next, null === next && ($c3bc21db9fc66909$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c3bc21db9fc66909$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $c3bc21db9fc66909$var$pendingEffectsStatus && 5 !== $c3bc21db9fc66909$var$pendingEffectsStatus || $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $c3bc21db9fc66909$var$currentEventTransitionLane && ($c3bc21db9fc66909$var$currentEventTransitionLane = 0);
}
function $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $c3bc21db9fc66909$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $c3bc21db9fc66909$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c3bc21db9fc66909$var$workInProgressRoot;
    suspendedLanes = $c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    suspendedLanes = $c3bc21db9fc66909$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $c3bc21db9fc66909$var$workInProgressSuspendedReason || 9 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes);
        switch($c3bc21db9fc66909$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c3bc21db9fc66909$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c3bc21db9fc66909$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c3bc21db9fc66909$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c3bc21db9fc66909$var$NormalPriority$1;
        }
        pingedLanes = $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c3bc21db9fc66909$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus && 5 !== $c3bc21db9fc66909$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($c3bc21db9fc66909$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c3bc21db9fc66909$var$getNextLanes(root, root === $c3bc21db9fc66909$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c3bc21db9fc66909$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, $c3bc21db9fc66909$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c3bc21db9fc66909$var$performSyncWorkOnRoot(root, lanes) {
    if ($c3bc21db9fc66909$var$flushPendingEffects()) return null;
    $c3bc21db9fc66909$var$performWorkOnRoot(root, lanes, !0);
}
function $c3bc21db9fc66909$var$scheduleImmediateRootScheduleTask() {
    $c3bc21db9fc66909$var$scheduleMicrotask(function() {
        0 !== ($c3bc21db9fc66909$var$executionContext & 6) ? $c3bc21db9fc66909$var$scheduleCallback$3($c3bc21db9fc66909$var$ImmediatePriority, $c3bc21db9fc66909$var$processRootScheduleInImmediateTask) : $c3bc21db9fc66909$var$processRootScheduleInMicrotask();
    });
}
function $c3bc21db9fc66909$var$requestTransitionLane() {
    if (0 === $c3bc21db9fc66909$var$currentEventTransitionLane) {
        var actionScopeLane = $c3bc21db9fc66909$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $c3bc21db9fc66909$var$nextTransitionUpdateLane, $c3bc21db9fc66909$var$nextTransitionUpdateLane <<= 1, 0 === ($c3bc21db9fc66909$var$nextTransitionUpdateLane & 261888) && ($c3bc21db9fc66909$var$nextTransitionUpdateLane = 256));
        $c3bc21db9fc66909$var$currentEventTransitionLane = actionScopeLane;
    }
    return $c3bc21db9fc66909$var$currentEventTransitionLane;
}
function $c3bc21db9fc66909$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c3bc21db9fc66909$var$sanitizeURL("" + actionProp);
}
function $c3bc21db9fc66909$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c3bc21db9fc66909$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c3bc21db9fc66909$var$coerceFormActionProp((nativeEventTarget[$c3bc21db9fc66909$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c3bc21db9fc66909$var$internalPropsKey] || null) ? $c3bc21db9fc66909$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c3bc21db9fc66909$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c3bc21db9fc66909$var$currentEventTransitionLane) {
                                var formData = submitter ? $c3bc21db9fc66909$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c3bc21db9fc66909$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c3bc21db9fc66909$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c3bc21db9fc66909$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c3bc21db9fc66909$var$i$jscomp$inline_1577 = 0; $c3bc21db9fc66909$var$i$jscomp$inline_1577 < $c3bc21db9fc66909$var$simpleEventPluginEvents.length; $c3bc21db9fc66909$var$i$jscomp$inline_1577++){
    var $c3bc21db9fc66909$var$eventName$jscomp$inline_1578 = $c3bc21db9fc66909$var$simpleEventPluginEvents[$c3bc21db9fc66909$var$i$jscomp$inline_1577], $c3bc21db9fc66909$var$domEventName$jscomp$inline_1579 = $c3bc21db9fc66909$var$eventName$jscomp$inline_1578.toLowerCase(), $c3bc21db9fc66909$var$capitalizedEvent$jscomp$inline_1580 = $c3bc21db9fc66909$var$eventName$jscomp$inline_1578[0].toUpperCase() + $c3bc21db9fc66909$var$eventName$jscomp$inline_1578.slice(1);
    $c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$domEventName$jscomp$inline_1579, "on" + $c3bc21db9fc66909$var$capitalizedEvent$jscomp$inline_1580);
}
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_END, "onAnimationEnd");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_ITERATION, "onAnimationIteration");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_START, "onAnimationStart");
$c3bc21db9fc66909$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c3bc21db9fc66909$var$registerSimpleEvent("focusin", "onFocus");
$c3bc21db9fc66909$var$registerSimpleEvent("focusout", "onBlur");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_RUN, "onTransitionRun");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_START, "onTransitionStart");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_CANCEL, "onTransitionCancel");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_END, "onTransitionEnd");
$c3bc21db9fc66909$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c3bc21db9fc66909$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c3bc21db9fc66909$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c3bc21db9fc66909$var$mediaEventTypes));
function $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c3bc21db9fc66909$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c3bc21db9fc66909$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c3bc21db9fc66909$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c3bc21db9fc66909$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c3bc21db9fc66909$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c3bc21db9fc66909$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c3bc21db9fc66909$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c3bc21db9fc66909$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c3bc21db9fc66909$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c3bc21db9fc66909$var$listeningMarker]) {
        rootContainerElement[$c3bc21db9fc66909$var$listeningMarker] = !0;
        $c3bc21db9fc66909$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c3bc21db9fc66909$var$nonDelegatedEvents.has(domEventName) || $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c3bc21db9fc66909$var$listeningMarker] || (ownerDocument[$c3bc21db9fc66909$var$listeningMarker] = !0, $c3bc21db9fc66909$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c3bc21db9fc66909$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c3bc21db9fc66909$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c3bc21db9fc66909$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c3bc21db9fc66909$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c3bc21db9fc66909$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c3bc21db9fc66909$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c3bc21db9fc66909$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c3bc21db9fc66909$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c3bc21db9fc66909$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c3bc21db9fc66909$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c3bc21db9fc66909$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticTouchEvent;
                        break;
                    case $c3bc21db9fc66909$var$ANIMATION_END:
                    case $c3bc21db9fc66909$var$ANIMATION_ITERATION:
                    case $c3bc21db9fc66909$var$ANIMATION_START:
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticAnimationEvent;
                        break;
                    case $c3bc21db9fc66909$var$TRANSITION_END:
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c3bc21db9fc66909$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c3bc21db9fc66909$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c3bc21db9fc66909$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c3bc21db9fc66909$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c3bc21db9fc66909$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c3bc21db9fc66909$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c3bc21db9fc66909$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c3bc21db9fc66909$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c3bc21db9fc66909$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c3bc21db9fc66909$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c3bc21db9fc66909$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c3bc21db9fc66909$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $c3bc21db9fc66909$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c3bc21db9fc66909$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForChangeEvent;
                else if ($c3bc21db9fc66909$var$isTextInputElement(reactName)) {
                    if ($c3bc21db9fc66909$var$isInputEventSupported) getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c3bc21db9fc66909$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c3bc21db9fc66909$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c3bc21db9fc66909$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c3bc21db9fc66909$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c3bc21db9fc66909$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c3bc21db9fc66909$var$activeElement = handleEventFunc, $c3bc21db9fc66909$var$activeElementInst = targetInst, $c3bc21db9fc66909$var$lastSelection = null;
                    break;
                case "focusout":
                    $c3bc21db9fc66909$var$lastSelection = $c3bc21db9fc66909$var$activeElementInst = $c3bc21db9fc66909$var$activeElement = null;
                    break;
                case "mousedown":
                    $c3bc21db9fc66909$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c3bc21db9fc66909$var$mouseDown = !1;
                    $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c3bc21db9fc66909$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c3bc21db9fc66909$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c3bc21db9fc66909$var$isComposing ? $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c3bc21db9fc66909$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c3bc21db9fc66909$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c3bc21db9fc66909$var$isComposing && (fallbackData = $c3bc21db9fc66909$var$getData()) : ($c3bc21db9fc66909$var$root = nativeEventTarget, $c3bc21db9fc66909$var$startText = "value" in $c3bc21db9fc66909$var$root ? $c3bc21db9fc66909$var$root.value : $c3bc21db9fc66909$var$root.textContent, $c3bc21db9fc66909$var$isComposing = !0)), handleEventFunc = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c3bc21db9fc66909$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c3bc21db9fc66909$var$canUseTextInputEvent ? $c3bc21db9fc66909$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c3bc21db9fc66909$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c3bc21db9fc66909$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c3bc21db9fc66909$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c3bc21db9fc66909$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c3bc21db9fc66909$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c3bc21db9fc66909$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c3bc21db9fc66909$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c3bc21db9fc66909$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $c3bc21db9fc66909$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c3bc21db9fc66909$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c3bc21db9fc66909$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c3bc21db9fc66909$var$getListener(target, registrationName), null != stateNode && listeners.push($c3bc21db9fc66909$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c3bc21db9fc66909$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c3bc21db9fc66909$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c3bc21db9fc66909$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c3bc21db9fc66909$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c3bc21db9fc66909$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c3bc21db9fc66909$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c3bc21db9fc66909$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $c3bc21db9fc66909$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c3bc21db9fc66909$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c3bc21db9fc66909$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c3bc21db9fc66909$var$setProp(domElement, tag, "name", props.name, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c3bc21db9fc66909$var$setProp(domElement, tag, "encType", props.encType, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "method", props.method, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c3bc21db9fc66909$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c3bc21db9fc66909$var$noop$1);
            break;
        case "onScroll":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c3bc21db9fc66909$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            $c3bc21db9fc66909$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c3bc21db9fc66909$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c3bc21db9fc66909$var$aliases.get(key) || key, $c3bc21db9fc66909$var$setValueForAttribute(domElement, key, value);
    }
}
function $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c3bc21db9fc66909$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c3bc21db9fc66909$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $c3bc21db9fc66909$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c3bc21db9fc66909$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c3bc21db9fc66909$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c3bc21db9fc66909$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c3bc21db9fc66909$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c3bc21db9fc66909$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                    default:
                        $c3bc21db9fc66909$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c3bc21db9fc66909$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c3bc21db9fc66909$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c3bc21db9fc66909$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $c3bc21db9fc66909$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c3bc21db9fc66909$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c3bc21db9fc66909$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c3bc21db9fc66909$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("cancel", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c3bc21db9fc66909$var$mediaEventTypes.length; hasSrc++)$c3bc21db9fc66909$var$listenToNonDelegatedEvent($c3bc21db9fc66909$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement), $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c3bc21db9fc66909$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c3bc21db9fc66909$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c3bc21db9fc66909$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c3bc21db9fc66909$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $c3bc21db9fc66909$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c3bc21db9fc66909$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c3bc21db9fc66909$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, tag, !0) : $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c3bc21db9fc66909$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c3bc21db9fc66909$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($c3bc21db9fc66909$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $c3bc21db9fc66909$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $c3bc21db9fc66909$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $c3bc21db9fc66909$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $c3bc21db9fc66909$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $c3bc21db9fc66909$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $c3bc21db9fc66909$var$eventsEnabled = null, $c3bc21db9fc66909$var$selectionInformation = null;
function $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c3bc21db9fc66909$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c3bc21db9fc66909$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c3bc21db9fc66909$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c3bc21db9fc66909$var$currentPopstateTransitionEvent = null;
function $c3bc21db9fc66909$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c3bc21db9fc66909$var$currentPopstateTransitionEvent) return !1;
        $c3bc21db9fc66909$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c3bc21db9fc66909$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c3bc21db9fc66909$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c3bc21db9fc66909$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c3bc21db9fc66909$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c3bc21db9fc66909$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c3bc21db9fc66909$var$localPromise ? function(callback) {
    return $c3bc21db9fc66909$var$localPromise.resolve(null).then(callback).catch($c3bc21db9fc66909$var$handleErrorInNextTick);
} : $c3bc21db9fc66909$var$scheduleTimeout;
function $c3bc21db9fc66909$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c3bc21db9fc66909$var$isSingletonScope(type) {
    return "head" === type;
}
function $c3bc21db9fc66909$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c3bc21db9fc66909$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $c3bc21db9fc66909$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $c3bc21db9fc66909$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$c3bc21db9fc66909$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $c3bc21db9fc66909$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $c3bc21db9fc66909$var$retryIfBlockedOn(hydrationInstance);
}
function $c3bc21db9fc66909$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $c3bc21db9fc66909$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c3bc21db9fc66909$var$clearContainerSparingly(node);
                $c3bc21db9fc66909$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c3bc21db9fc66909$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c3bc21db9fc66909$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c3bc21db9fc66909$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c3bc21db9fc66909$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c3bc21db9fc66909$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $c3bc21db9fc66909$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $c3bc21db9fc66909$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $c3bc21db9fc66909$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = null;
function $c3bc21db9fc66909$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $c3bc21db9fc66909$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(451));
    }
}
function $c3bc21db9fc66909$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $c3bc21db9fc66909$var$detachDeletedInstance(instance);
}
var $c3bc21db9fc66909$var$preloadPropsMap = new Map(), $c3bc21db9fc66909$var$preconnectsSet = new Set();
function $c3bc21db9fc66909$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $c3bc21db9fc66909$var$previousDispatcher = $c3bc21db9fc66909$var$ReactDOMSharedInternals.d;
$c3bc21db9fc66909$var$ReactDOMSharedInternals.d = {
    f: $c3bc21db9fc66909$var$flushSyncWork,
    r: $c3bc21db9fc66909$var$requestFormReset,
    D: $c3bc21db9fc66909$var$prefetchDNS,
    C: $c3bc21db9fc66909$var$preconnect,
    L: $c3bc21db9fc66909$var$preload,
    m: $c3bc21db9fc66909$var$preloadModule,
    X: $c3bc21db9fc66909$var$preinitScript,
    S: $c3bc21db9fc66909$var$preinitStyle,
    M: $c3bc21db9fc66909$var$preinitModuleScript
};
function $c3bc21db9fc66909$var$flushSyncWork() {
    var previousWasRendering = $c3bc21db9fc66909$var$previousDispatcher.f(), wasRendering = $c3bc21db9fc66909$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c3bc21db9fc66909$var$requestFormReset(form) {
    var formInst = $c3bc21db9fc66909$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c3bc21db9fc66909$var$requestFormReset$1(formInst) : $c3bc21db9fc66909$var$previousDispatcher.r(form);
}
var $c3bc21db9fc66909$var$globalDocument = "undefined" === typeof document ? null : document;
function $c3bc21db9fc66909$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c3bc21db9fc66909$var$preconnectsSet.has(limitedEscapedHref) || ($c3bc21db9fc66909$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c3bc21db9fc66909$var$setInitialProperties(href, "link", rel), $c3bc21db9fc66909$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c3bc21db9fc66909$var$prefetchDNS(href) {
    $c3bc21db9fc66909$var$previousDispatcher.D(href);
    $c3bc21db9fc66909$var$preconnectAs("dns-prefetch", href, null);
}
function $c3bc21db9fc66909$var$preconnect(href, crossOrigin) {
    $c3bc21db9fc66909$var$previousDispatcher.C(href, crossOrigin);
    $c3bc21db9fc66909$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c3bc21db9fc66909$var$preload(href, as, options) {
    $c3bc21db9fc66909$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c3bc21db9fc66909$var$getStyleKey(href);
                break;
            case "script":
                key = $c3bc21db9fc66909$var$getScriptKey(href);
        }
        $c3bc21db9fc66909$var$preloadPropsMap.has(key) || (href = $c3bc21db9fc66909$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c3bc21db9fc66909$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c3bc21db9fc66909$var$setInitialProperties(as, "link", href), $c3bc21db9fc66909$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c3bc21db9fc66909$var$preloadModule(href, options) {
    $c3bc21db9fc66909$var$previousDispatcher.m(href, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c3bc21db9fc66909$var$getScriptKey(href);
        }
        if (!$c3bc21db9fc66909$var$preloadPropsMap.has(key) && (href = $c3bc21db9fc66909$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c3bc21db9fc66909$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c3bc21db9fc66909$var$setInitialProperties(as, "link", href);
            $c3bc21db9fc66909$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c3bc21db9fc66909$var$preinitStyle(href, precedence, options) {
    $c3bc21db9fc66909$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c3bc21db9fc66909$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c3bc21db9fc66909$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c3bc21db9fc66909$var$markNodeAsHoistable(link);
                $c3bc21db9fc66909$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c3bc21db9fc66909$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c3bc21db9fc66909$var$preinitScript(src, options) {
    $c3bc21db9fc66909$var$previousDispatcher.X(src, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c3bc21db9fc66909$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)), resource || (src = $c3bc21db9fc66909$var$assign({
            src: src,
            async: !0
        }, options), (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c3bc21db9fc66909$var$markNodeAsHoistable(resource), $c3bc21db9fc66909$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c3bc21db9fc66909$var$preinitModuleScript(src, options) {
    $c3bc21db9fc66909$var$previousDispatcher.M(src, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c3bc21db9fc66909$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)), resource || (src = $c3bc21db9fc66909$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c3bc21db9fc66909$var$markNodeAsHoistable(resource), $c3bc21db9fc66909$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c3bc21db9fc66909$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c3bc21db9fc66909$var$rootInstanceStackCursor.current) ? $c3bc21db9fc66909$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c3bc21db9fc66909$var$getStyleKey(pendingProps.href), pendingProps = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c3bc21db9fc66909$var$getStyleKey(pendingProps.href);
                var styles$243 = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $c3bc21db9fc66909$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c3bc21db9fc66909$var$preloadPropsMap.set(type, pendingProps), styles$243 || $c3bc21db9fc66909$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $c3bc21db9fc66909$var$getScriptKey(pendingProps), pendingProps = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(444, type));
    }
}
function $c3bc21db9fc66909$var$getStyleKey(href) {
    return 'href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(rawProps) {
    return $c3bc21db9fc66909$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c3bc21db9fc66909$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c3bc21db9fc66909$var$setInitialProperties(key, "link", preloadProps), $c3bc21db9fc66909$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c3bc21db9fc66909$var$getScriptKey(src) {
    return '[src="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c3bc21db9fc66909$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c3bc21db9fc66909$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c3bc21db9fc66909$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c3bc21db9fc66909$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            $c3bc21db9fc66909$var$setInitialProperties(instance, "style", styleProps);
            $c3bc21db9fc66909$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c3bc21db9fc66909$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $c3bc21db9fc66909$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c3bc21db9fc66909$var$preloadPropsMap.get(styleProps)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c3bc21db9fc66909$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $c3bc21db9fc66909$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $c3bc21db9fc66909$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $c3bc21db9fc66909$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c3bc21db9fc66909$var$preloadPropsMap.get(instance$249)) instance = $c3bc21db9fc66909$var$assign({}, props), $c3bc21db9fc66909$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c3bc21db9fc66909$var$markNodeAsHoistable(styleProps);
            $c3bc21db9fc66909$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c3bc21db9fc66909$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c3bc21db9fc66909$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c3bc21db9fc66909$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c3bc21db9fc66909$var$tagCaches = null;
function $c3bc21db9fc66909$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c3bc21db9fc66909$var$tagCaches) {
        var cache = new Map();
        var caches = $c3bc21db9fc66909$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c3bc21db9fc66909$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c3bc21db9fc66909$var$internalHoistableMarker] || node[$c3bc21db9fc66909$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c3bc21db9fc66909$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $c3bc21db9fc66909$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c3bc21db9fc66909$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $c3bc21db9fc66909$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(props);
            (key = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c3bc21db9fc66909$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c3bc21db9fc66909$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $c3bc21db9fc66909$var$estimatedBytesWithinLimit = 0;
function $c3bc21db9fc66909$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $c3bc21db9fc66909$var$estimatedBytesWithinLimit && ($c3bc21db9fc66909$var$estimatedBytesWithinLimit = 62500 * $c3bc21db9fc66909$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $c3bc21db9fc66909$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $c3bc21db9fc66909$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $c3bc21db9fc66909$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c3bc21db9fc66909$var$precedencesByRoot = null;
function $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c3bc21db9fc66909$var$precedencesByRoot = new Map(), resources.forEach($c3bc21db9fc66909$var$insertStylesheetIntoRoot, state), $c3bc21db9fc66909$var$precedencesByRoot = null, $c3bc21db9fc66909$var$onUnsuspend.call(state));
}
function $c3bc21db9fc66909$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c3bc21db9fc66909$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c3bc21db9fc66909$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c3bc21db9fc66909$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c3bc21db9fc66909$var$HostTransitionContext = {
    $$typeof: $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c3bc21db9fc66909$var$sharedNotPendingObject,
    _currentValue2: $c3bc21db9fc66909$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c3bc21db9fc66909$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c3bc21db9fc66909$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c3bc21db9fc66909$var$createLaneMap(0);
    this.hiddenUpdates = $c3bc21db9fc66909$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c3bc21db9fc66909$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $c3bc21db9fc66909$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c3bc21db9fc66909$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c3bc21db9fc66909$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c3bc21db9fc66909$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c3bc21db9fc66909$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c3bc21db9fc66909$var$emptyContextObject;
    parentComponent = $c3bc21db9fc66909$var$emptyContextObject;
    return parentComponent;
}
function $c3bc21db9fc66909$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c3bc21db9fc66909$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c3bc21db9fc66909$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c3bc21db9fc66909$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c3bc21db9fc66909$var$entangleTransitions(element, rootFiber, lane));
}
function $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane);
}
function $c3bc21db9fc66909$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $c3bc21db9fc66909$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $c3bc21db9fc66909$var$requestUpdateLane();
        lane = $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(lane);
        var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, lane);
        $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $c3bc21db9fc66909$var$_enabled = !0;
function $c3bc21db9fc66909$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2, $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 8, $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c3bc21db9fc66909$var$_enabled) {
        var blockedOn = $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c3bc21db9fc66909$var$return_targetInst, targetContainer), $c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c3bc21db9fc66909$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c3bc21db9fc66909$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c3bc21db9fc66909$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c3bc21db9fc66909$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c3bc21db9fc66909$var$ensureRootIsScheduled(fiber);
                                0 === ($c3bc21db9fc66909$var$executionContext & 6) && ($c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = $c3bc21db9fc66909$var$now() + 500, $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 2), $c3bc21db9fc66909$var$flushSyncWork$1(), $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c3bc21db9fc66909$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c3bc21db9fc66909$var$getEventTarget(nativeEvent);
    return $c3bc21db9fc66909$var$findInstanceBlockingTarget(nativeEvent);
}
var $c3bc21db9fc66909$var$return_targetInst = null;
function $c3bc21db9fc66909$var$findInstanceBlockingTarget(targetNode) {
    $c3bc21db9fc66909$var$return_targetInst = null;
    targetNode = $c3bc21db9fc66909$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c3bc21db9fc66909$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $c3bc21db9fc66909$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c3bc21db9fc66909$var$return_targetInst = targetNode;
    return null;
}
function $c3bc21db9fc66909$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c3bc21db9fc66909$var$getCurrentPriorityLevel()){
                case $c3bc21db9fc66909$var$ImmediatePriority:
                    return 2;
                case $c3bc21db9fc66909$var$UserBlockingPriority:
                    return 8;
                case $c3bc21db9fc66909$var$NormalPriority$1:
                case $c3bc21db9fc66909$var$LowPriority:
                    return 32;
                case $c3bc21db9fc66909$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c3bc21db9fc66909$var$hasScheduledReplayAttempt = !1, $c3bc21db9fc66909$var$queuedFocus = null, $c3bc21db9fc66909$var$queuedDrag = null, $c3bc21db9fc66909$var$queuedMouse = null, $c3bc21db9fc66909$var$queuedPointers = new Map(), $c3bc21db9fc66909$var$queuedPointerCaptures = new Map(), $c3bc21db9fc66909$var$queuedExplicitHydrationTargets = [], $c3bc21db9fc66909$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c3bc21db9fc66909$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c3bc21db9fc66909$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c3bc21db9fc66909$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c3bc21db9fc66909$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c3bc21db9fc66909$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c3bc21db9fc66909$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c3bc21db9fc66909$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c3bc21db9fc66909$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c3bc21db9fc66909$var$queuedFocus = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c3bc21db9fc66909$var$queuedDrag = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c3bc21db9fc66909$var$queuedMouse = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c3bc21db9fc66909$var$queuedPointers.set(pointerId, $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c3bc21db9fc66909$var$queuedPointerCaptures.set(pointerId, $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c3bc21db9fc66909$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c3bc21db9fc66909$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c3bc21db9fc66909$var$runWithPriority(queuedTarget.priority, function() {
                        $c3bc21db9fc66909$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $c3bc21db9fc66909$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c3bc21db9fc66909$var$runWithPriority(queuedTarget.priority, function() {
                        $c3bc21db9fc66909$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c3bc21db9fc66909$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c3bc21db9fc66909$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c3bc21db9fc66909$var$currentReplayingEvent = null;
        } else return targetContainers = $c3bc21db9fc66909$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c3bc21db9fc66909$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c3bc21db9fc66909$var$replayUnblockedEvents() {
    $c3bc21db9fc66909$var$hasScheduledReplayAttempt = !1;
    null !== $c3bc21db9fc66909$var$queuedFocus && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedFocus) && ($c3bc21db9fc66909$var$queuedFocus = null);
    null !== $c3bc21db9fc66909$var$queuedDrag && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedDrag) && ($c3bc21db9fc66909$var$queuedDrag = null);
    null !== $c3bc21db9fc66909$var$queuedMouse && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedMouse) && ($c3bc21db9fc66909$var$queuedMouse = null);
    $c3bc21db9fc66909$var$queuedPointers.forEach($c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap);
    $c3bc21db9fc66909$var$queuedPointerCaptures.forEach($c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap);
}
function $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c3bc21db9fc66909$var$hasScheduledReplayAttempt || ($c3bc21db9fc66909$var$hasScheduledReplayAttempt = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$replayUnblockedEvents)));
}
var $c3bc21db9fc66909$var$lastScheduledReplayQueue = null;
function $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c3bc21db9fc66909$var$lastScheduledReplayQueue !== formReplayingQueue && ($c3bc21db9fc66909$var$lastScheduledReplayQueue = formReplayingQueue, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, function() {
        $c3bc21db9fc66909$var$lastScheduledReplayQueue === formReplayingQueue && ($c3bc21db9fc66909$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c3bc21db9fc66909$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c3bc21db9fc66909$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c3bc21db9fc66909$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c3bc21db9fc66909$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c3bc21db9fc66909$var$queuedFocus && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedFocus, unblocked);
    null !== $c3bc21db9fc66909$var$queuedDrag && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedDrag, unblocked);
    null !== $c3bc21db9fc66909$var$queuedMouse && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedMouse, unblocked);
    $c3bc21db9fc66909$var$queuedPointers.forEach(unblock);
    $c3bc21db9fc66909$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length && (i = $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c3bc21db9fc66909$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c3bc21db9fc66909$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c3bc21db9fc66909$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c3bc21db9fc66909$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c3bc21db9fc66909$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $c3bc21db9fc66909$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.render = $c3bc21db9fc66909$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c3bc21db9fc66909$var$requestUpdateLane();
    $c3bc21db9fc66909$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.unmount = $c3bc21db9fc66909$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $c3bc21db9fc66909$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c3bc21db9fc66909$var$flushSyncWork$1();
        container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = null;
    }
};
function $c3bc21db9fc66909$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c3bc21db9fc66909$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c3bc21db9fc66909$var$attemptExplicitHydrationTarget(target);
    }
};
var $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $8NFma.version;
if ("19.2.4" !== $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(527, $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$c3bc21db9fc66909$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c3bc21db9fc66909$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c3bc21db9fc66909$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c3bc21db9fc66909$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c3bc21db9fc66909$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c3bc21db9fc66909$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c3bc21db9fc66909$var$hook$jscomp$inline_2348.isDisabled && $c3bc21db9fc66909$var$hook$jscomp$inline_2348.supportsFiber) try {
        $c3bc21db9fc66909$var$rendererID = $c3bc21db9fc66909$var$hook$jscomp$inline_2348.inject($c3bc21db9fc66909$var$internals$jscomp$inline_2347), $c3bc21db9fc66909$var$injectedHook = $c3bc21db9fc66909$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$c3bc21db9fc66909$export$882461b6382ed46c = function(container, options) {
    if (!$c3bc21db9fc66909$var$isValidContainer(container)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c3bc21db9fc66909$var$defaultOnUncaughtError, onCaughtError = $c3bc21db9fc66909$var$defaultOnCaughtError, onRecoverableError = $c3bc21db9fc66909$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $c3bc21db9fc66909$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $c3bc21db9fc66909$var$defaultOnDefaultTransitionIndicator);
    container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = options.current;
    $c3bc21db9fc66909$var$listenToAllSupportedEvents(container);
    return new $c3bc21db9fc66909$var$ReactDOMRoot(options);
};
$c3bc21db9fc66909$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c3bc21db9fc66909$var$isValidContainer(container)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c3bc21db9fc66909$var$defaultOnUncaughtError, onCaughtError = $c3bc21db9fc66909$var$defaultOnCaughtError, onRecoverableError = $c3bc21db9fc66909$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c3bc21db9fc66909$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $c3bc21db9fc66909$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $c3bc21db9fc66909$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c3bc21db9fc66909$var$requestUpdateLane();
    isStrictMode = $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $c3bc21db9fc66909$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c3bc21db9fc66909$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $c3bc21db9fc66909$var$markRootUpdated$1(initialChildren, options);
    $c3bc21db9fc66909$var$ensureRootIsScheduled(initialChildren);
    container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = initialChildren.current;
    $c3bc21db9fc66909$var$listenToAllSupportedEvents(container);
    return new $c3bc21db9fc66909$var$ReactDOMHydrationRoot(initialChildren);
};
$c3bc21db9fc66909$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("epnUP"));

});
parcelRegister("epnUP", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a7d5f39a74a2399f$export$c4744153514ff05d, (v) => $a7d5f39a74a2399f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7, (v) => $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a7d5f39a74a2399f$export$e26fe2ed2fa76875, (v) => $a7d5f39a74a2399f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a7d5f39a74a2399f$export$502329bbf4b505b1, (v) => $a7d5f39a74a2399f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a7d5f39a74a2399f$export$6e3807111c4874c4, (v) => $a7d5f39a74a2399f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a7d5f39a74a2399f$export$c27134553091fb3a, (v) => $a7d5f39a74a2399f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a7d5f39a74a2399f$export$33ee1acdc04fd2a2, (v) => $a7d5f39a74a2399f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a7d5f39a74a2399f$export$b00a404bbd5edef2, (v) => $a7d5f39a74a2399f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a7d5f39a74a2399f$export$d66a1c1c77bd778b, (v) => $a7d5f39a74a2399f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a7d5f39a74a2399f$export$d3dfb8e4810cb555, (v) => $a7d5f39a74a2399f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $a7d5f39a74a2399f$export$72fdf0e06517287b, (v) => $a7d5f39a74a2399f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a7d5f39a74a2399f$export$816d2913ae6b83b1, (v) => $a7d5f39a74a2399f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a7d5f39a74a2399f$export$61bcfe829111a1d0, (v) => $a7d5f39a74a2399f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a7d5f39a74a2399f$export$7ee8c9beb337bc3f, (v) => $a7d5f39a74a2399f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a7d5f39a74a2399f$export$b5836b71941fa3ed, (v) => $a7d5f39a74a2399f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a7d5f39a74a2399f$export$cf845f2c119da08a, (v) => $a7d5f39a74a2399f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a7d5f39a74a2399f$export$c4744153514ff05d;
var $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7;
var $a7d5f39a74a2399f$export$e26fe2ed2fa76875;
var $a7d5f39a74a2399f$export$502329bbf4b505b1;
var $a7d5f39a74a2399f$export$6e3807111c4874c4;
var $a7d5f39a74a2399f$export$c27134553091fb3a;
var $a7d5f39a74a2399f$export$33ee1acdc04fd2a2;
var $a7d5f39a74a2399f$export$b00a404bbd5edef2;
var $a7d5f39a74a2399f$export$d66a1c1c77bd778b;
var $a7d5f39a74a2399f$export$d3dfb8e4810cb555;
var $a7d5f39a74a2399f$export$72fdf0e06517287b;
var $a7d5f39a74a2399f$export$816d2913ae6b83b1;
var $a7d5f39a74a2399f$export$61bcfe829111a1d0;
var $a7d5f39a74a2399f$export$7ee8c9beb337bc3f;
var $a7d5f39a74a2399f$export$b5836b71941fa3ed;
var $a7d5f39a74a2399f$export$cf845f2c119da08a;
"use strict";
function $a7d5f39a74a2399f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $a7d5f39a74a2399f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $a7d5f39a74a2399f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $a7d5f39a74a2399f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $a7d5f39a74a2399f$var$compare(left, last)) rightIndex < length && 0 > $a7d5f39a74a2399f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $a7d5f39a74a2399f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $a7d5f39a74a2399f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$a7d5f39a74a2399f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a7d5f39a74a2399f$var$localPerformance = performance;
    $a7d5f39a74a2399f$export$c4744153514ff05d = function() {
        return $a7d5f39a74a2399f$var$localPerformance.now();
    };
} else {
    var $a7d5f39a74a2399f$var$localDate = Date, $a7d5f39a74a2399f$var$initialTime = $a7d5f39a74a2399f$var$localDate.now();
    $a7d5f39a74a2399f$export$c4744153514ff05d = function() {
        return $a7d5f39a74a2399f$var$localDate.now() - $a7d5f39a74a2399f$var$initialTime;
    };
}
var $a7d5f39a74a2399f$var$taskQueue = [], $a7d5f39a74a2399f$var$timerQueue = [], $a7d5f39a74a2399f$var$taskIdCounter = 1, $a7d5f39a74a2399f$var$currentTask = null, $a7d5f39a74a2399f$var$currentPriorityLevel = 3, $a7d5f39a74a2399f$var$isPerformingWork = !1, $a7d5f39a74a2399f$var$isHostCallbackScheduled = !1, $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1, $a7d5f39a74a2399f$var$needsPaint = !1, $a7d5f39a74a2399f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $a7d5f39a74a2399f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $a7d5f39a74a2399f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $a7d5f39a74a2399f$var$advanceTimers(currentTime) {
    for(var timer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$timerQueue);
        else if (timer.startTime <= currentTime) $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$timerQueue), timer.sortIndex = timer.expirationTime, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$taskQueue, timer);
        else break;
        timer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
    }
}
function $a7d5f39a74a2399f$var$handleTimeout(currentTime) {
    $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1;
    $a7d5f39a74a2399f$var$advanceTimers(currentTime);
    if (!$a7d5f39a74a2399f$var$isHostCallbackScheduled) {
        if (null !== $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue)) $a7d5f39a74a2399f$var$isHostCallbackScheduled = !0, $a7d5f39a74a2399f$var$isMessageLoopRunning || ($a7d5f39a74a2399f$var$isMessageLoopRunning = !0, $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
            null !== firstTimer && $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $a7d5f39a74a2399f$var$isMessageLoopRunning = !1, $a7d5f39a74a2399f$var$taskTimeoutID = -1, $a7d5f39a74a2399f$var$frameInterval = 5, $a7d5f39a74a2399f$var$startTime = -1;
function $a7d5f39a74a2399f$var$shouldYieldToHost() {
    return $a7d5f39a74a2399f$var$needsPaint ? !0 : $a7d5f39a74a2399f$export$c4744153514ff05d() - $a7d5f39a74a2399f$var$startTime < $a7d5f39a74a2399f$var$frameInterval ? !1 : !0;
}
function $a7d5f39a74a2399f$var$performWorkUntilDeadline() {
    $a7d5f39a74a2399f$var$needsPaint = !1;
    if ($a7d5f39a74a2399f$var$isMessageLoopRunning) {
        var currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
        $a7d5f39a74a2399f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $a7d5f39a74a2399f$var$isHostCallbackScheduled = !1;
                $a7d5f39a74a2399f$var$isHostTimeoutScheduled && ($a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1, $a7d5f39a74a2399f$var$localClearTimeout($a7d5f39a74a2399f$var$taskTimeoutID), $a7d5f39a74a2399f$var$taskTimeoutID = -1);
                $a7d5f39a74a2399f$var$isPerformingWork = !0;
                var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
                try {
                    b: {
                        $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                        for($a7d5f39a74a2399f$var$currentTask = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue); null !== $a7d5f39a74a2399f$var$currentTask && !($a7d5f39a74a2399f$var$currentTask.expirationTime > currentTime && $a7d5f39a74a2399f$var$shouldYieldToHost());){
                            var callback = $a7d5f39a74a2399f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $a7d5f39a74a2399f$var$currentTask.callback = null;
                                $a7d5f39a74a2399f$var$currentPriorityLevel = $a7d5f39a74a2399f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($a7d5f39a74a2399f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $a7d5f39a74a2399f$var$currentTask.callback = continuationCallback;
                                    $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $a7d5f39a74a2399f$var$currentTask === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue) && $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$taskQueue);
                                $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                            } else $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$taskQueue);
                            $a7d5f39a74a2399f$var$currentTask = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue);
                        }
                        if (null !== $a7d5f39a74a2399f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
                            null !== firstTimer && $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $a7d5f39a74a2399f$var$currentTask = null, $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel, $a7d5f39a74a2399f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline() : $a7d5f39a74a2399f$var$isMessageLoopRunning = !1;
        }
    }
}
var $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $a7d5f39a74a2399f$var$localSetImmediate) $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
    $a7d5f39a74a2399f$var$localSetImmediate($a7d5f39a74a2399f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a7d5f39a74a2399f$var$channel = new MessageChannel(), $a7d5f39a74a2399f$var$port = $a7d5f39a74a2399f$var$channel.port2;
    $a7d5f39a74a2399f$var$channel.port1.onmessage = $a7d5f39a74a2399f$var$performWorkUntilDeadline;
    $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
        $a7d5f39a74a2399f$var$port.postMessage(null);
    };
} else $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
    $a7d5f39a74a2399f$var$localSetTimeout($a7d5f39a74a2399f$var$performWorkUntilDeadline, 0);
};
function $a7d5f39a74a2399f$var$requestHostTimeout(callback, ms) {
    $a7d5f39a74a2399f$var$taskTimeoutID = $a7d5f39a74a2399f$var$localSetTimeout(function() {
        callback($a7d5f39a74a2399f$export$c4744153514ff05d());
    }, ms);
}
$a7d5f39a74a2399f$export$3e506c1ccc9cc1a7 = 5;
$a7d5f39a74a2399f$export$e26fe2ed2fa76875 = 1;
$a7d5f39a74a2399f$export$502329bbf4b505b1 = 4;
$a7d5f39a74a2399f$export$6e3807111c4874c4 = 3;
$a7d5f39a74a2399f$export$c27134553091fb3a = null;
$a7d5f39a74a2399f$export$33ee1acdc04fd2a2 = 2;
$a7d5f39a74a2399f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$a7d5f39a74a2399f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a7d5f39a74a2399f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$a7d5f39a74a2399f$export$d3dfb8e4810cb555 = function() {
    return $a7d5f39a74a2399f$var$currentPriorityLevel;
};
$a7d5f39a74a2399f$export$72fdf0e06517287b = function(eventHandler) {
    switch($a7d5f39a74a2399f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    $a7d5f39a74a2399f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a7d5f39a74a2399f$export$816d2913ae6b83b1 = function() {
    $a7d5f39a74a2399f$var$needsPaint = !0;
};
$a7d5f39a74a2399f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    $a7d5f39a74a2399f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a7d5f39a74a2399f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $a7d5f39a74a2399f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$timerQueue, priorityLevel), null === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue) && priorityLevel === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue) && ($a7d5f39a74a2399f$var$isHostTimeoutScheduled ? ($a7d5f39a74a2399f$var$localClearTimeout($a7d5f39a74a2399f$var$taskTimeoutID), $a7d5f39a74a2399f$var$taskTimeoutID = -1) : $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !0, $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$taskQueue, priorityLevel), $a7d5f39a74a2399f$var$isHostCallbackScheduled || $a7d5f39a74a2399f$var$isPerformingWork || ($a7d5f39a74a2399f$var$isHostCallbackScheduled = !0, $a7d5f39a74a2399f$var$isMessageLoopRunning || ($a7d5f39a74a2399f$var$isMessageLoopRunning = !0, $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$a7d5f39a74a2399f$export$b5836b71941fa3ed = $a7d5f39a74a2399f$var$shouldYieldToHost;
$a7d5f39a74a2399f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
        $a7d5f39a74a2399f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("jRYbO"));

});
parcelRegister("jRYbO", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0, (v) => $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $e771a7f3a12c9e1c$export$d39a5bbd09211389, (v) => $e771a7f3a12c9e1c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4, (v) => $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $e771a7f3a12c9e1c$export$a0816fa17a9e79be, (v) => $e771a7f3a12c9e1c$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $e771a7f3a12c9e1c$export$7292efcadded39f3, (v) => $e771a7f3a12c9e1c$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $e771a7f3a12c9e1c$export$da407abadb9b8f86, (v) => $e771a7f3a12c9e1c$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $e771a7f3a12c9e1c$export$314cfea32580671c, (v) => $e771a7f3a12c9e1c$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $e771a7f3a12c9e1c$export$513ccb98c53b8039, (v) => $e771a7f3a12c9e1c$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $e771a7f3a12c9e1c$export$dbca993bc2d264a, (v) => $e771a7f3a12c9e1c$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $e771a7f3a12c9e1c$export$4797a8006f0655d0, (v) => $e771a7f3a12c9e1c$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e771a7f3a12c9e1c$export$c78a37762a8d58e1, (v) => $e771a7f3a12c9e1c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $e771a7f3a12c9e1c$export$606f11b2eb45ecc6, (v) => $e771a7f3a12c9e1c$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e, (v) => $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $e771a7f3a12c9e1c$export$83d89fbfd8236492, (v) => $e771a7f3a12c9e1c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0;
var $e771a7f3a12c9e1c$export$d39a5bbd09211389;
var $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4;
var $e771a7f3a12c9e1c$export$a0816fa17a9e79be;
var $e771a7f3a12c9e1c$export$7292efcadded39f3;
var $e771a7f3a12c9e1c$export$da407abadb9b8f86;
var $e771a7f3a12c9e1c$export$314cfea32580671c;
var $e771a7f3a12c9e1c$export$513ccb98c53b8039;
var $e771a7f3a12c9e1c$export$dbca993bc2d264a;
var $e771a7f3a12c9e1c$export$4797a8006f0655d0;
var $e771a7f3a12c9e1c$export$c78a37762a8d58e1;
var $e771a7f3a12c9e1c$export$606f11b2eb45ecc6;
var $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e;
var $e771a7f3a12c9e1c$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $e771a7f3a12c9e1c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e771a7f3a12c9e1c$var$noop() {}
var $e771a7f3a12c9e1c$var$Internals = {
    d: {
        f: $e771a7f3a12c9e1c$var$noop,
        r: function() {
            throw Error($e771a7f3a12c9e1c$var$formatProdErrorMessage(522));
        },
        D: $e771a7f3a12c9e1c$var$noop,
        C: $e771a7f3a12c9e1c$var$noop,
        L: $e771a7f3a12c9e1c$var$noop,
        m: $e771a7f3a12c9e1c$var$noop,
        X: $e771a7f3a12c9e1c$var$noop,
        S: $e771a7f3a12c9e1c$var$noop,
        M: $e771a7f3a12c9e1c$var$noop
    },
    p: 0,
    findDOMNode: null
}, $e771a7f3a12c9e1c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $e771a7f3a12c9e1c$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e771a7f3a12c9e1c$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $e771a7f3a12c9e1c$var$ReactSharedInternals = $8NFma.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$e771a7f3a12c9e1c$export$69ce8ef3fe5cead0 = $e771a7f3a12c9e1c$var$Internals;
$e771a7f3a12c9e1c$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($e771a7f3a12c9e1c$var$formatProdErrorMessage(299));
    return $e771a7f3a12c9e1c$var$createPortal$1(children, container, null, key);
};
$e771a7f3a12c9e1c$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $e771a7f3a12c9e1c$var$ReactSharedInternals.T, previousUpdatePriority = $e771a7f3a12c9e1c$var$Internals.p;
    try {
        if ($e771a7f3a12c9e1c$var$ReactSharedInternals.T = null, $e771a7f3a12c9e1c$var$Internals.p = 2, fn) return fn();
    } finally{
        $e771a7f3a12c9e1c$var$ReactSharedInternals.T = previousTransition, $e771a7f3a12c9e1c$var$Internals.p = previousUpdatePriority, $e771a7f3a12c9e1c$var$Internals.d.f();
    }
};
$e771a7f3a12c9e1c$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $e771a7f3a12c9e1c$var$Internals.d.C(href, options));
};
$e771a7f3a12c9e1c$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $e771a7f3a12c9e1c$var$Internals.d.D(href);
};
$e771a7f3a12c9e1c$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $e771a7f3a12c9e1c$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $e771a7f3a12c9e1c$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$e771a7f3a12c9e1c$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $e771a7f3a12c9e1c$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $e771a7f3a12c9e1c$var$Internals.d.M(href);
    }
};
$e771a7f3a12c9e1c$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, options.crossOrigin);
        $e771a7f3a12c9e1c$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$e771a7f3a12c9e1c$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $e771a7f3a12c9e1c$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $e771a7f3a12c9e1c$var$Internals.d.m(href);
    }
};
$e771a7f3a12c9e1c$export$4797a8006f0655d0 = function(form) {
    $e771a7f3a12c9e1c$var$Internals.d.r(form);
};
$e771a7f3a12c9e1c$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$e771a7f3a12c9e1c$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $e771a7f3a12c9e1c$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$e771a7f3a12c9e1c$export$f7e8a0bf92324b1e = function() {
    return $e771a7f3a12c9e1c$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$e771a7f3a12c9e1c$export$83d89fbfd8236492 = "19.2.4";

});




parcelRegister("bfBMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6fcc99ecac7252$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $4hwI2 = parcelRequire("4hwI2");
var $hcjAO = parcelRequire("hcjAO");
var $jsUR6 = parcelRequire("jsUR6");

var $lmhZG = parcelRequire("lmhZG");

var $3hUXe = parcelRequire("3hUXe");

var $1DKzi = parcelRequire("1DKzi");
function $fe6fcc99ecac7252$export$2e2bcd8739ae039({ grid: grid, setGrid: setGrid, displayActions: displayActions = false, ref: ref = null }) {
    const { setItem: setItem } = (0, $3hUXe.useVideoModal)();
    const clearCell = (index)=>{
        setGrid(grid.map((c, i)=>{
            if (i === index) return null;
            return c;
        }));
    };
    const moveCellLeft = (index)=>{
        if (index === 0) {
            console.error('First cell can noy be moved further left!');
            return;
        }
        changeCellPosition(index, -1);
    };
    const moveCellRight = (index)=>{
        if (index === grid.length - 1) {
            console.error('Last cell can noy be moved further right!');
            return;
        }
        changeCellPosition(index, 1);
    };
    const changeCellPosition = (index, step)=>{
        setGrid(grid.map((c, i)=>{
            if (i === index) return grid[index + step];
            else if (i === index + step) return grid[index];
            else return c;
        }));
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            ref: ref,
            className: `token-grid token-grid-${grid.length} grid gap-2 ${(0, $1DKzi.gridColumnVariants)[grid.length]}`,
            children: grid.map((item, index)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "token-grid-item border border-dashed p-4 rounded bg-white shadow hover:shadow/30",
                    children: [
                        !item && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "token-grid-item__empty w-full h-full flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                className: "text-gray-400 text-center",
                                children: Drupal.t('No content')
                            })
                        }),
                        item && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "token-grid-item__body w-full h-full flex flex-col",
                            children: [
                                item.illustration && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "token-grid-item__illustration grow flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                                        src: item.illustration.src,
                                        alt: "",
                                        className: "max-w-full h-auto cursor-pointer",
                                        onClick: ()=>setItem(item)
                                    })
                                }),
                                item.title && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "token-grid-item__title",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        className: "font-semibold text-center",
                                        children: item.title
                                    })
                                }),
                                displayActions && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                    className: "token-grid-item__controls grid grid-cols-3 gap-4 place-items-center mt-2 max-w-20 mx-auto",
                                    children: [
                                        index !== 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                            className: "cursor-pointer",
                                            title: Drupal.t('Move left'),
                                            onClick: ()=>moveCellLeft(index),
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4hwI2.default), {
                                                className: "size-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))('cursor-pointer', {
                                                'col-start-2': index === 0,
                                                'col-end-3': index === grid.length - 1
                                            }),
                                            title: Drupal.t('Remove'),
                                            onClick: ()=>clearCell(index),
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jsUR6.default), {
                                                className: "size-5 text-red-500"
                                            })
                                        }),
                                        index !== grid.length - 1 && /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                            className: "cursor-pointer",
                                            title: Drupal.t('Move right'),
                                            onClick: ()=>moveCellRight(index),
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hcjAO.default), {
                                                className: "size-5"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, index))
        })
    });
}

});
parcelRegister("4hwI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e21f515ddd066e$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $31e21f515ddd066e$var$ArrowLeftCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $31e21f515ddd066e$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($31e21f515ddd066e$var$ArrowLeftCircleIcon);
var $31e21f515ddd066e$export$2e2bcd8739ae039 = $31e21f515ddd066e$var$ForwardRef;

});

parcelRegister("hcjAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c852c159548b64b9$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $c852c159548b64b9$var$ArrowRightCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $c852c159548b64b9$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($c852c159548b64b9$var$ArrowRightCircleIcon);
var $c852c159548b64b9$export$2e2bcd8739ae039 = $c852c159548b64b9$var$ForwardRef;

});

parcelRegister("jsUR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2bcbc2e3aa543c9$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $e2bcbc2e3aa543c9$var$XCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $e2bcbc2e3aa543c9$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($e2bcbc2e3aa543c9$var$XCircleIcon);
var $e2bcbc2e3aa543c9$export$2e2bcd8739ae039 = $e2bcbc2e3aa543c9$var$ForwardRef;

});

parcelRegister("lmhZG", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("3hUXe", function(module, exports) {

$parcel$export(module.exports, "VideoModalProvider", () => $3a4c7daa4e962e25$export$aac67dd9edfc152b);
$parcel$export(module.exports, "useVideoModal", () => $3a4c7daa4e962e25$export$71ce83fb4de02b20);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
const $3a4c7daa4e962e25$var$VideoModalContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
function $3a4c7daa4e962e25$export$aac67dd9edfc152b({ children: children }) {
    const [item, setItem] = (0, $8NFma.useState)(null);
    const contextValue = {
        item: item,
        setItem: setItem
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)($3a4c7daa4e962e25$var$VideoModalContext, {
        value: contextValue,
        children: children
    });
}
function $3a4c7daa4e962e25$export$71ce83fb4de02b20() {
    return (0, $8NFma.useContext)($3a4c7daa4e962e25$var$VideoModalContext);
}

});

parcelRegister("1DKzi", function(module, exports) {

$parcel$export(module.exports, "gridColumnVariants", () => $131d8e6ef1801dbf$export$98d8f5446e2ab319);
$parcel$export(module.exports, "gridCellOptions", () => $131d8e6ef1801dbf$export$cd67f9c8d337e332);
const $131d8e6ef1801dbf$export$bc5045fb21e4213b = [
    1,
    2,
    4,
    6,
    9,
    12
];
const $131d8e6ef1801dbf$export$98d8f5446e2ab319 = {
    1: 'grid-cols-1',
    2: 'grid-cols-1',
    4: 'grid-cols-2',
    6: 'grid-cols-2',
    9: 'grid-cols-3',
    12: 'grid-cols-3'
};
const $131d8e6ef1801dbf$export$cd67f9c8d337e332 = Array.from($131d8e6ef1801dbf$export$bc5045fb21e4213b, (count)=>{
    return {
        count: count,
        text: Drupal.formatPlural(count, '1 square', '@count squares')
    };
});

});


parcelRegister("cltGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $08bb763679e3554e$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $ivFw5 = parcelRequire("ivFw5");

var $2pmb0 = parcelRequire("2pmb0");

var $3hUXe = parcelRequire("3hUXe");
function $08bb763679e3554e$export$2e2bcd8739ae039() {
    const ref = (0, $8NFma.useRef)();
    const { item: item, setItem: setItem } = (0, $3hUXe.useVideoModal)();
    (0, $8NFma.useEffect)(()=>{
        if (item) {
            document.body.classList.add('overflow-hidden');
            ref.current?.showModal();
        } else {
            document.body.classList.remove('overflow-hidden');
            ref.current?.close();
        }
    }, [
        item
    ]);
    const closeModal = ()=>{
        setItem(null);
    };
    return /*#__PURE__*/ (0, $2pmb0.createPortal)(/*#__PURE__*/ (0, $1IdZj.jsx)("dialog", {
        ref: ref,
        className: "video-dialog",
        closedby: "any",
        onCancel: closeModal,
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "video-dialog__container",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "video-dialog__header",
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("button", {
                        className: "close-button keep-in-pure-printable",
                        type: "button",
                        "aria-label": Drupal.t('Close dialog'),
                        onClick: closeModal,
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ivFw5.default), {
                                className: "size-4"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                className: "sr-only",
                                children: Drupal.t('Close dialog')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "video-dialog__body",
                    children: item && item.video && /*#__PURE__*/ (0, $1IdZj.jsx)("video", {
                        controls: true,
                        autoPlay: true,
                        loop: false,
                        muted: false,
                        children: item.video.sources.map((source, i)=>/*#__PURE__*/ (0, $1IdZj.jsx)("source", {
                                src: source.src,
                                type: source.type
                            }, i))
                    })
                })
            ]
        })
    }), document.body);
}

});
parcelRegister("ivFw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b5390fa4505d0$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $d79b5390fa4505d0$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
    }));
}
const $d79b5390fa4505d0$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($d79b5390fa4505d0$var$XMarkIcon);
var $d79b5390fa4505d0$export$2e2bcd8739ae039 = $d79b5390fa4505d0$var$ForwardRef;

});


parcelRegister("499od", function(module, exports) {

$parcel$export(module.exports, "createArrayWithEmptyCells", () => $304f4942edb8d9d6$export$d7b81b79d10accc9);
$parcel$export(module.exports, "buildWorksheetUrl", () => $304f4942edb8d9d6$export$b627f9c9fdb10458);
$parcel$export(module.exports, "copyToClipboard", () => $304f4942edb8d9d6$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "saveGridImage", () => $304f4942edb8d9d6$export$2e46c552e72725c6);

var $lUg0n = parcelRequire("lUg0n");
const $304f4942edb8d9d6$export$d7b81b79d10accc9 = (count = 1)=>{
    return Array(count).fill(null);
};
const $304f4942edb8d9d6$export$b627f9c9fdb10458 = (grid)=>{
    const url = new URL(window.location.origin + Drupal.url('worksheet'));
    for (const [index, item] of grid.entries())url.searchParams.set(`t[${index}]`, item?.id ?? '');
    return url.toString();
};
const $304f4942edb8d9d6$export$ed80d9de1d9df928 = (grid)=>{
    window.open($304f4942edb8d9d6$export$b627f9c9fdb10458(grid));
};
const $304f4942edb8d9d6$export$2cdf1b96a9f86d16 = async (text)=>{
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        console.error(error);
    }
};
const $304f4942edb8d9d6$export$2e46c552e72725c6 = async (element)=>{
    const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($lUg0n)))(element, {
        scale: Math.max(window.devicePixelRatio, 2),
        logging: false
    });
    const imageDataUrl = canvas.toDataURL('image/jpeg');
    const downloadLink = document.createElement('a');
    downloadLink.download = 'worksheet.jpg';
    downloadLink.href = imageDataUrl;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

});
parcelRegister("lUg0n", function(module, exports) {
/*!
 * html2canvas-pro 2.0.2 <https://yorickshan.github.io/html2canvas-pro/>
 * Copyright (c) 2024-present yorickshan and html2canvas-pro contributors
 * Released under MIT License
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    class Bounds {
        constructor(left, top, width, height){
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        add(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        }
        static fromClientRect(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        }
        static fromDOMRectList(context, domRectList) {
            const rects = Array.from(domRectList);
            // First try to find a rect with non-zero width
            let domRect = rects.find((rect)=>rect.width !== 0);
            // If not found, try to find a rect with non-zero height
            // This handles cases like inline-flex with single child where width might be 0
            if (!domRect) domRect = rects.find((rect)=>rect.height !== 0);
            // If still not found but rects exist, use the first rect
            // Position info (left, top) might still be valid even if dimensions are 0
            if (!domRect && rects.length > 0) domRect = rects[0];
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        }
    }
    Bounds.EMPTY = new Bounds(0, 0, 0, 0);
    const parseBounds = (context, node)=>{
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    const parseDocumentSize = (document1)=>{
        const body = document1.body;
        const documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error(`Unable to get document size`);
        const width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        const height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = 'KwAAAAAAAAAACA4AUD0AADAgAAACAAAAAAAIABAAGABAAEgAUABYAGAAaABgAGgAYgBqAF8AZwBgAGgAcQB5AHUAfQCFAI0AlQCdAKIAqgCyALoAYABoAGAAaABgAGgAwgDKAGAAaADGAM4A0wDbAOEA6QDxAPkAAQEJAQ8BFwF1AH0AHAEkASwBNAE6AUIBQQFJAVEBWQFhAWgBcAF4ATAAgAGGAY4BlQGXAZ8BpwGvAbUBvQHFAc0B0wHbAeMB6wHxAfkBAQIJAvEBEQIZAiECKQIxAjgCQAJGAk4CVgJeAmQCbAJ0AnwCgQKJApECmQKgAqgCsAK4ArwCxAIwAMwC0wLbAjAA4wLrAvMC+AIAAwcDDwMwABcDHQMlAy0DNQN1AD0DQQNJA0kDSQNRA1EDVwNZA1kDdQB1AGEDdQBpA20DdQN1AHsDdQCBA4kDkQN1AHUAmQOhA3UAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AKYDrgN1AHUAtgO+A8YDzgPWAxcD3gPjA+sD8wN1AHUA+wMDBAkEdQANBBUEHQQlBCoEFwMyBDgEYABABBcDSARQBFgEYARoBDAAcAQzAXgEgASIBJAEdQCXBHUAnwSnBK4EtgS6BMIEyAR1AHUAdQB1AHUAdQCVANAEYABgAGAAYABgAGAAYABgANgEYADcBOQEYADsBPQE/AQEBQwFFAUcBSQFLAU0BWQEPAVEBUsFUwVbBWAAYgVgAGoFcgV6BYIFigWRBWAAmQWfBaYFYABgAGAAYABgAKoFYACxBbAFuQW6BcEFwQXHBcEFwQXPBdMF2wXjBeoF8gX6BQIGCgYSBhoGIgYqBjIGOgZgAD4GRgZMBmAAUwZaBmAAYABgAGAAYABgAGAAYABgAGAAYABgAGIGYABpBnAGYABgAGAAYABgAGAAYABgAGAAYAB4Bn8GhQZgAGAAYAB1AHcDFQSLBmAAYABgAJMGdQA9A3UAmwajBqsGqwaVALMGuwbDBjAAywbSBtIG1QbSBtIG0gbSBtIG0gbdBuMG6wbzBvsGAwcLBxMHAwcbByMHJwcsBywHMQcsB9IGOAdAB0gHTgfSBkgHVgfSBtIG0gbSBtIG0gbSBtIG0gbSBiwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdgAGAALAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdbB2MHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB2kH0gZwB64EdQB1AHUAdQB1AHUAdQB1AHUHfQdgAIUHjQd1AHUAlQedB2AAYAClB6sHYACzB7YHvgfGB3UAzgfWBzMB3gfmB1EB7gf1B/0HlQENAQUIDQh1ABUIHQglCBcDLQg1CD0IRQhNCEEDUwh1AHUAdQBbCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIcAh3CHoIMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIgggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAALAcsBywHLAcsBywHLAcsBywHLAcsB4oILAcsB44I0gaWCJ4Ipgh1AHUAqgiyCHUAdQB1AHUAdQB1AHUAdQB1AHUAtwh8AXUAvwh1AMUIyQjRCNkI4AjoCHUAdQB1AO4I9gj+CAYJDgkTCS0HGwkjCYIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiAAIAAAAFAAYABgAGIAXwBgAHEAdQBFAJUAogCyAKAAYABgAEIA4ABGANMA4QDxAMEBDwE1AFwBLAE6AQEBUQF4QkhCmEKoQrhCgAHIQsAB0MLAAcABwAHAAeDC6ABoAHDCwMMAAcABwAHAAdDDGMMAAcAB6MM4wwjDWMNow3jDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEjDqABWw6bDqABpg6gAaABoAHcDvwOPA+gAaABfA/8DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DpcPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB9cPKwkyCToJMAB1AHUAdQBCCUoJTQl1AFUJXAljCWcJawkwADAAMAAwAHMJdQB2CX4JdQCECYoJjgmWCXUAngkwAGAAYABxAHUApgn3A64JtAl1ALkJdQDACTAAMAAwADAAdQB1AHUAdQB1AHUAdQB1AHUAowYNBMUIMAAwADAAMADICcsJ0wnZCRUE4QkwAOkJ8An4CTAAMAB1AAAKvwh1AAgKDwoXCh8KdQAwACcKLgp1ADYKqAmICT4KRgowADAAdQB1AE4KMAB1AFYKdQBeCnUAZQowADAAMAAwADAAMAAwADAAMAAVBHUAbQowADAAdQC5CXUKMAAwAHwBxAijBogEMgF9CoQKiASMCpQKmgqIBKIKqgquCogEDQG2Cr4KxgrLCjAAMADTCtsKCgHjCusK8Qr5CgELMAAwADAAMAB1AIsECQsRC3UANAEZCzAAMAAwADAAMAB1ACELKQswAHUANAExCzkLdQBBC0kLMABRC1kLMAAwADAAMAAwADAAdQBhCzAAMAAwAGAAYABpC3ELdwt/CzAAMACHC4sLkwubC58Lpwt1AK4Ltgt1APsDMAAwADAAMAAwADAAMAAwAL4LwwvLC9IL1wvdCzAAMADlC+kL8Qv5C/8LSQswADAAMAAwADAAMAAwADAAMAAHDDAAMAAwADAAMAAODBYMHgx1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1ACYMMAAwADAAdQB1AHUALgx1AHUAdQB1AHUAdQA2DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AD4MdQBGDHUAdQB1AHUAdQB1AEkMdQB1AHUAdQB1AFAMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQBYDHUAdQB1AF8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUA+wMVBGcMMAAwAHwBbwx1AHcMfwyHDI8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAYABgAJcMMAAwADAAdQB1AJ8MlQClDDAAMACtDCwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB7UMLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AA0EMAC9DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAsBywHLAcsBywHLAcsBywHLQcwAMEMyAwsBywHLAcsBywHLAcsBywHLAcsBywHzAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1ANQM2QzhDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMABgAGAAYABgAGAAYABgAOkMYADxDGAA+AwADQYNYABhCWAAYAAODTAAMAAwADAAFg1gAGAAHg37AzAAMAAwADAAYABgACYNYAAsDTQNPA1gAEMNPg1LDWAAYABgAGAAYABgAGAAYABgAGAAUg1aDYsGVglhDV0NcQBnDW0NdQ15DWAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAlQCBDZUAiA2PDZcNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAnw2nDTAAMAAwADAAMAAwAHUArw23DTAAMAAwADAAMAAwADAAMAAwADAAMAB1AL8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQDHDTAAYABgAM8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA1w11ANwNMAAwAD0B5A0wADAAMAAwADAAMADsDfQN/A0EDgwOFA4wABsOMAAwADAAMAAwADAAMAAwANIG0gbSBtIG0gbSBtIG0gYjDigOwQUuDsEFMw7SBjoO0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGQg5KDlIOVg7SBtIGXg5lDm0OdQ7SBtIGfQ6EDooOjQ6UDtIGmg6hDtIG0gaoDqwO0ga0DrwO0gZgAGAAYADEDmAAYAAkBtIGzA5gANIOYADaDokO0gbSBt8O5w7SBu8O0gb1DvwO0gZgAGAAxA7SBtIG0gbSBtIGYABgAGAAYAAED2AAsAUMD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHJA8sBywHLAcsBywHLAccDywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywPLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAc0D9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHPA/SBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gYUD0QPlQCVAJUAMAAwADAAMACVAJUAlQCVAJUAlQCVAEwPMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA//8EAAQABAAEAAQABAAEAAQABAANAAMAAQABAAIABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQACgATABcAHgAbABoAHgAXABYAEgAeABsAGAAPABgAHABLAEsASwBLAEsASwBLAEsASwBLABgAGAAeAB4AHgATAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAGwASAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWAA0AEQAeAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAFAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJABYAGgAbABsAGwAeAB0AHQAeAE8AFwAeAA0AHgAeABoAGwBPAE8ADgBQAB0AHQAdAE8ATwAXAE8ATwBPABYAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwBWAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsABAAbABsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEAA0ADQBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABABQACsAKwArACsAKwArACsAKwAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUAAaABoAUABQAFAAUABQAEwAHgAbAFAAHgAEACsAKwAEAAQABAArAFAAUABQAFAAUABQACsAKwArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQACsAUABQACsAKwAEACsABAAEAAQABAAEACsAKwArACsABAAEACsAKwAEAAQABAArACsAKwAEACsAKwArACsAKwArACsAUABQAFAAUAArAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAAQABABQAFAAUAAEAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAArACsAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AGwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAKwArACsAKwArAAQABAAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAAQAUAArAFAAUABQAFAAUABQACsAKwArAFAAUABQACsAUABQAFAAUAArACsAKwBQAFAAKwBQACsAUABQACsAKwArAFAAUAArACsAKwBQAFAAUAArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAArACsAKwAEAAQABAArAAQABAAEAAQAKwArAFAAKwArACsAKwArACsABAArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAHgAeAB4AHgAeAB4AGwAeACsAKwArACsAKwAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAUABQAFAAKwArACsAKwArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwAOAFAAUABQAFAAUABQAFAAHgBQAAQABAAEAA4AUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAKwArAAQAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAKwArACsAKwArACsAUAArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAXABcAFwAXABcACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAXAArAFwAXABcAFwAXABcAFwAXABcAFwAKgBcAFwAKgAqACoAKgAqACoAKgAqACoAXAArACsAXABcAFwAXABcACsAXAArACoAKgAqACoAKgAqACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwBcAFwAXABcAFAADgAOAA4ADgAeAA4ADgAJAA4ADgANAAkAEwATABMAEwATAAkAHgATAB4AHgAeAAQABAAeAB4AHgAeAB4AHgBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAADQAEAB4ABAAeAAQAFgARABYAEQAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAAQABAAEAAQADQAEAAQAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAA0ADQAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeACsAHgAeAA4ADgANAA4AHgAeAB4AHgAeAAkACQArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgBcAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4AHgAeAB4AXABcAFwAXABcAFwAKgAqACoAKgBcAFwAXABcACoAKgAqAFwAKgAqACoAXABcACoAKgAqACoAKgAqACoAXABcAFwAKgAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwAKgBLAEsASwBLAEsASwBLAEsASwBLACoAKgAqACoAKgAqAFAAUABQAFAAUABQACsAUAArACsAKwArACsAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAKwBQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsABAAEAAQAHgANAB4AHgAeAB4AHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUAArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWABEAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAANAA0AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUAArAAQABAArACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAA0ADQAVAFwADQAeAA0AGwBcACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwAeAB4AEwATAA0ADQAOAB4AEwATAB4ABAAEAAQACQArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAHgArACsAKwATABMASwBLAEsASwBLAEsASwBLAEsASwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAXABcAFwAXABcACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXAArACsAKwAqACoAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsAHgAeAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKwArAAQASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACoAKgAqACoAKgAqACoAXAAqACoAKgAqACoAKgArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABABQAFAAUABQAFAAUABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgANAA0ADQANAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwAeAB4AHgAeAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArAA0ADQANAA0ADQBLAEsASwBLAEsASwBLAEsASwBLACsAKwArAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUAAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAAQAUABQAFAAUABQAFAABABQAFAABAAEAAQAUAArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQACsAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQACsAKwAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQACsAHgAeAB4AHgAeAB4AHgAOAB4AKwANAA0ADQANAA0ADQANAAkADQANAA0ACAAEAAsABAAEAA0ACQANAA0ADAAdAB0AHgAXABcAFgAXABcAFwAWABcAHQAdAB4AHgAUABQAFAANAAEAAQAEAAQABAAEAAQACQAaABoAGgAaABoAGgAaABoAHgAXABcAHQAVABUAHgAeAB4AHgAeAB4AGAAWABEAFQAVABUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ADQAeAA0ADQANAA0AHgANAA0ADQAHAB4AHgAeAB4AKwAEAAQABAAEAAQABAAEAAQABAAEAFAAUAArACsATwBQAFAAUABQAFAAHgAeAB4AFgARAE8AUABPAE8ATwBPAFAAUABQAFAAUAAeAB4AHgAWABEAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArABsAGwAbABsAGwAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGgAbABsAGwAbABoAGwAbABoAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAFAAGgAeAB0AHgBQAB4AGgAeAB4AHgAeAB4AHgAeAB4AHgBPAB4AUAAbAB4AHgBQAFAAUABQAFAAHgAeAB4AHQAdAB4AUAAeAFAAHgBQAB4AUABPAFAAUAAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgBQAFAAUABQAE8ATwBQAFAAUABQAFAATwBQAFAATwBQAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAUABQAFAATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABPAB4AHgArACsAKwArAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAdAB4AHgAeAB0AHQAeAB4AHQAeAB4AHgAdAB4AHQAbABsAHgAdAB4AHgAeAB4AHQAeAB4AHQAdAB0AHQAeAB4AHQAeAB0AHgAdAB0AHQAdAB0AHQAeAB0AHgAeAB4AHgAeAB0AHQAdAB0AHgAeAB4AHgAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB0AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAdAB0AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHQAdAB0AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHQAdAB4AHgAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AJQAlAB0AHQAlAB4AJQAlACUAIAAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAeAB0AJQAdAB0AHgAdAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAdAB0AHQAdACUAHgAlACUAJQAdACUAJQAdAB0AHQAlACUAHQAdACUAHQAdACUAJQAlAB4AHQAeAB4AHgAeAB0AHQAlAB0AHQAdAB0AHQAdACUAJQAlACUAJQAdACUAJQAgACUAHQAdACUAJQAlACUAJQAlACUAJQAeAB4AHgAlACUAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AFwAXABcAFwAXABcAHgATABMAJQAeAB4AHgAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARABYAEQAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANAA0AHgANAB4ADQANAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwAlACUAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACsAKwArACsAKwArACsAKwArACsAKwArAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBPAE8ATwBPAE8ATwBPAE8AJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeAAQAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUABQAAQAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAUABQAFAAUABQAAQABAAEACsABAAEACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAKwBQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAA0ADQANAA0ADQANAA0ADQAeACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAArACsAKwArAFAAUABQAFAAUAANAA0ADQANAA0ADQAUACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQANAA0ADQANAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAANACsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAB4AHgAeAB4AHgArACsAKwArACsAKwAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANAFAABAAEAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAEAAQABAAEAB4ABAAEAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsABAAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLAA0ADQArAB4ABABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUAAeAFAAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAAEAAQADgANAA0AEwATAB4AHgAeAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAFAAUABQAFAABAAEACsAKwAEAA0ADQAeAFAAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcAFwADQANAA0AKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQAKwAEAAQAKwArAAQABAAEAAQAUAAEAFAABAAEAA0ADQANACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABABQAA4AUAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANAFAADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAaABoAGgAaAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAJAAkACQAJAAkACQAJABYAEQArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AHgAeACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAARwBHABUARwAJACsAKwArACsAKwArACsAKwArACsAKwAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAKwArACsAKwArACsAKwArACsAKwArACsAKwBRAFEAUQBRACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAHgAEAAQADQAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAeAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQAHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAKwArAFAAKwArAFAAUAArACsAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAHgAeAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeACsAKwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4ABAAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAHgAeAA0ADQANAA0AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArAAQABAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwBQAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArABsAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAB4AHgAeAB4ABAAEAAQABAAEAAQABABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArABYAFgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAGgBQAFAAUAAaAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUAArACsAKwArACsAKwBQACsAKwArACsAUAArAFAAKwBQACsAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUAArAFAAKwBQACsAUAArAFAAUAArAFAAKwArAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAKwBQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeACUAJQAlAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAHgAlACUAJQAlACUAIAAgACAAJQAlACAAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACEAIQAhACEAIQAlACUAIAAgACUAJQAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAlACUAJQAlACAAIAAgACUAIAAgACAAJQAlACUAJQAlACUAJQAgACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAlAB4AJQAeACUAJQAlACUAJQAgACUAJQAlACUAHgAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACAAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABcAFwAXABUAFQAVAB4AHgAeAB4AJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAgACUAJQAgACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAIAAgACUAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACAAIAAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACAAIAAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAA==';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    const FLAG_UNRESTRICTED = 1;
    const FLAG_ID = 2;
    const FLAG_INTEGER = 4;
    const FLAG_NUMBER = 8;
    const LINE_FEED = 0x000a;
    const SOLIDUS = 0x002f;
    const REVERSE_SOLIDUS = 0x005c;
    const CHARACTER_TABULATION = 0x0009;
    const SPACE = 0x0020;
    const QUOTATION_MARK = 0x0022;
    const EQUALS_SIGN = 0x003d;
    const NUMBER_SIGN = 0x0023;
    const DOLLAR_SIGN = 0x0024;
    const PERCENTAGE_SIGN = 0x0025;
    const APOSTROPHE = 0x0027;
    const LEFT_PARENTHESIS = 0x0028;
    const RIGHT_PARENTHESIS = 0x0029;
    const LOW_LINE = 0x005f;
    const HYPHEN_MINUS = 0x002d;
    const EXCLAMATION_MARK = 0x0021;
    const LESS_THAN_SIGN = 0x003c;
    const GREATER_THAN_SIGN = 0x003e;
    const COMMERCIAL_AT = 0x0040;
    const LEFT_SQUARE_BRACKET = 0x005b;
    const RIGHT_SQUARE_BRACKET = 0x005d;
    const CIRCUMFLEX_ACCENT = 0x003d;
    const LEFT_CURLY_BRACKET = 0x007b;
    const QUESTION_MARK = 0x003f;
    const RIGHT_CURLY_BRACKET = 0x007d;
    const VERTICAL_LINE = 0x007c;
    const TILDE = 0x007e;
    const CONTROL = 0x0080;
    const REPLACEMENT_CHARACTER = 0xfffd;
    const ASTERISK = 0x002a;
    const PLUS_SIGN = 0x002b;
    const COMMA = 0x002c;
    const COLON = 0x003a;
    const SEMICOLON = 0x003b;
    const FULL_STOP = 0x002e;
    const NULL = 0x0000;
    const BACKSPACE = 0x0008;
    const LINE_TABULATION = 0x000b;
    const SHIFT_OUT = 0x000e;
    const INFORMATION_SEPARATOR_ONE = 0x001f;
    const DELETE = 0x007f;
    const EOF = -1;
    const ZERO = 0x0030;
    const a = 0x0061;
    const e = 0x0065;
    const f = 0x0066;
    const u = 0x0075;
    const z = 0x007a;
    const A = 0x0041;
    const E = 0x0045;
    const F = 0x0046;
    const U = 0x0055;
    const Z = 0x005a;
    const isDigit = (codePoint)=>codePoint >= ZERO && codePoint <= 0x0039;
    const isSurrogateCodePoint = (codePoint)=>codePoint >= 0xd800 && codePoint <= 0xdfff;
    const isHex = (codePoint)=>isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    const isLowerCaseLetter = (codePoint)=>codePoint >= a && codePoint <= z;
    const isUpperCaseLetter = (codePoint)=>codePoint >= A && codePoint <= Z;
    const isLetter = (codePoint)=>isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    const isNonASCIICodePoint = (codePoint)=>codePoint >= CONTROL;
    const isWhiteSpace = (codePoint)=>codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    const isNameStartCodePoint = (codePoint)=>isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    const isNameCodePoint = (codePoint)=>isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    const isNonPrintableCodePoint = (codePoint)=>{
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    const isValidEscape = (c1, c2)=>{
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    const isIdentifierStart = (c1, c2, c3)=>{
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    const isNumberStart = (c1, c2, c3)=>{
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    const stringToNumber = (codePoints)=>{
        let c = 0;
        let sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        const integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        const int = integers.length ? parseInt(fromCodePoint$1(...integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        const fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        const fracd = fraction.length;
        const frac = fracd ? parseInt(fromCodePoint$1(...fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        let expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        const exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        const exp = exponent.length ? parseInt(fromCodePoint$1(...exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    const LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* TokenType.LEFT_PARENTHESIS_TOKEN */ 
    };
    const RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* TokenType.RIGHT_PARENTHESIS_TOKEN */ 
    };
    const COMMA_TOKEN = {
        type: 4 /* TokenType.COMMA_TOKEN */ 
    };
    const SUFFIX_MATCH_TOKEN = {
        type: 13 /* TokenType.SUFFIX_MATCH_TOKEN */ 
    };
    const PREFIX_MATCH_TOKEN = {
        type: 8 /* TokenType.PREFIX_MATCH_TOKEN */ 
    };
    const COLUMN_TOKEN = {
        type: 21 /* TokenType.COLUMN_TOKEN */ 
    };
    const DASH_MATCH_TOKEN = {
        type: 9 /* TokenType.DASH_MATCH_TOKEN */ 
    };
    const INCLUDE_MATCH_TOKEN = {
        type: 10 /* TokenType.INCLUDE_MATCH_TOKEN */ 
    };
    const LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* TokenType.LEFT_CURLY_BRACKET_TOKEN */ 
    };
    const RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* TokenType.RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    const SUBSTRING_MATCH_TOKEN = {
        type: 14 /* TokenType.SUBSTRING_MATCH_TOKEN */ 
    };
    const BAD_URL_TOKEN = {
        type: 23 /* TokenType.BAD_URL_TOKEN */ 
    };
    const BAD_STRING_TOKEN = {
        type: 1 /* TokenType.BAD_STRING_TOKEN */ 
    };
    const CDO_TOKEN = {
        type: 25 /* TokenType.CDO_TOKEN */ 
    };
    const CDC_TOKEN = {
        type: 24 /* TokenType.CDC_TOKEN */ 
    };
    const COLON_TOKEN = {
        type: 26 /* TokenType.COLON_TOKEN */ 
    };
    const SEMICOLON_TOKEN = {
        type: 27 /* TokenType.SEMICOLON_TOKEN */ 
    };
    const LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* TokenType.LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    const RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* TokenType.RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    const WHITESPACE_TOKEN = {
        type: 31 /* TokenType.WHITESPACE_TOKEN */ 
    };
    const EOF_TOKEN = {
        type: 32 /* TokenType.EOF_TOKEN */ 
    };
    class Tokenizer {
        constructor(){
            this._value = [];
        }
        write(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        }
        read() {
            const tokens = [];
            let token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        }
        consumeToken() {
            const codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    const c1 = this.peekCodePoint(0);
                    const c2 = this.peekCodePoint(1);
                    const c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        const flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        const value = this.consumeName();
                        return {
                            type: 5 /* TokenType.HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    const e1 = codePoint;
                    const e2 = this.peekCodePoint(0);
                    const e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            let c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    const a1 = this.peekCodePoint(0);
                    const a2 = this.peekCodePoint(1);
                    const a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        const value = this.consumeName();
                        return {
                            type: 7 /* TokenType.AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    const u1 = this.peekCodePoint(0);
                    const u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* TokenType.DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        }
        consumeCodePoint() {
            const value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        }
        reconsumeCodePoint(codePoint) {
            this._value.unshift(codePoint);
        }
        peekCodePoint(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        }
        consumeUnicodeRangeToken() {
            const digits = [];
            let codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            let questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                const start = parseInt(fromCodePoint$1(...digits.map((digit)=>digit === QUESTION_MARK ? ZERO : digit)), 16);
                const end = parseInt(fromCodePoint$1(...digits.map((digit)=>digit === QUESTION_MARK ? F : digit)), 16);
                return {
                    type: 30 /* TokenType.UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            }
            const start = parseInt(fromCodePoint$1(...digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                const endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                const end = parseInt(fromCodePoint$1(...endDigits), 16);
                return {
                    type: 30 /* TokenType.UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* TokenType.UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        }
        consumeIdentLikeToken() {
            const value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* TokenType.FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* TokenType.IDENT_TOKEN */ ,
                value: value
            };
        }
        consumeUrlToken() {
            const value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* TokenType.URL_TOKEN */ ,
                value: ''
            };
            const next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                const stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* TokenType.STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* TokenType.URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                const codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* TokenType.URL_TOKEN */ ,
                    value: fromCodePoint$1(...value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* TokenType.URL_TOKEN */ ,
                            value: fromCodePoint$1(...value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        }
        consumeWhiteSpace() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        }
        consumeBadUrlRemnants() {
            while(true){
                const codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        }
        consumeStringSlice(count) {
            const SLICE_STACK_SIZE = 50000;
            let value = '';
            while(count > 0){
                const amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1(...this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        }
        consumeStringToken(endingCodePoint) {
            let value = '';
            let i = 0;
            do {
                const codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* TokenType.STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    const next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        }
        consumeNumber() {
            const repr = [];
            let type = FLAG_INTEGER;
            let c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            let c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            const c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        }
        consumeNumericToken() {
            const [number, flags] = this.consumeNumber();
            const c1 = this.peekCodePoint(0);
            const c2 = this.peekCodePoint(1);
            const c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                const unit = this.consumeName();
                return {
                    type: 15 /* TokenType.DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* TokenType.PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* TokenType.NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        }
        consumeEscapedCodePoint() {
            const codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                let hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                const hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        }
        consumeName() {
            let result = '';
            while(true){
                const codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        }
    }
    class Parser {
        constructor(tokens){
            this._tokens = tokens;
        }
        static create(value) {
            const tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        }
        static parseValue(value) {
            return Parser.create(value).parseComponentValue();
        }
        static parseValues(value) {
            return Parser.create(value).parseComponentValues();
        }
        parseComponentValue() {
            let token = this.consumeToken();
            while(token.type === 31 /* TokenType.WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* TokenType.EOF_TOKEN */ ) throw new SyntaxError(`Error parsing CSS component value, unexpected EOF`);
            this.reconsumeToken(token);
            const value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* TokenType.WHITESPACE_TOKEN */ );
            if (token.type === 32 /* TokenType.EOF_TOKEN */ ) return value;
            throw new SyntaxError(`Error parsing CSS component value, multiple values found when expecting only one`);
        }
        parseComponentValues() {
            const values = [];
            while(true){
                const value = this.consumeComponentValue();
                if (value.type === 32 /* TokenType.EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        }
        consumeComponentValue() {
            const token = this.consumeToken();
            switch(token.type){
                case 11 /* TokenType.LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* TokenType.LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* TokenType.LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* TokenType.FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        }
        consumeSimpleBlock(type) {
            const block = {
                type: type,
                values: []
            };
            let token = this.consumeToken();
            while(true){
                if (token.type === 32 /* TokenType.EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        }
        consumeFunction(functionToken) {
            const cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* TokenType.FUNCTION */ 
            };
            while(true){
                const token = this.consumeToken();
                if (token.type === 32 /* TokenType.EOF_TOKEN */  || token.type === 3 /* TokenType.RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        }
        consumeToken() {
            const token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        }
        reconsumeToken(token) {
            this._tokens.unshift(token);
        }
    }
    const isDimensionToken = (token)=>token.type === 15 /* TokenType.DIMENSION_TOKEN */ ;
    const isNumberToken = (token)=>token.type === 17 /* TokenType.NUMBER_TOKEN */ ;
    const isIdentToken = (token)=>token.type === 20 /* TokenType.IDENT_TOKEN */ ;
    const isStringToken = (token)=>token.type === 0 /* TokenType.STRING_TOKEN */ ;
    const isIdentWithValue = (token, value)=>isIdentToken(token) && token.value === value;
    const nonWhiteSpace = (token)=>token.type !== 31 /* TokenType.WHITESPACE_TOKEN */ ;
    const nonFunctionArgSeparator = (token)=>token.type !== 31 /* TokenType.WHITESPACE_TOKEN */  && token.type !== 4 /* TokenType.COMMA_TOKEN */ ;
    const parseFunctionArgs = (tokens)=>{
        const args = [];
        let arg = [];
        tokens.forEach((token)=>{
            if (token.type === 4 /* TokenType.COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error(`Error parsing function args, zero tokens for arg`);
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* TokenType.WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    const isEndingTokenFor = (token, type)=>{
        if (type === 11 /* TokenType.LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* TokenType.RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* TokenType.LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* TokenType.RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* TokenType.LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* TokenType.RIGHT_PARENTHESIS_TOKEN */ ;
    };
    /**
     * Color mathematics utilities
     * Extracted to break circular dependency between srgb.ts and color-utilities.ts
     */ /**
     * Clamp a value between min and max
     */ const clamp = (value, min, max)=>{
        return Math.min(Math.max(value, min), max);
    };
    /**
     * Multiply two 3x3 matrices
     */ const multiplyMatrices = (A, B)=>{
        return [
            A[0] * B[0] + A[1] * B[1] + A[2] * B[2],
            A[3] * B[0] + A[4] * B[1] + A[5] * B[2],
            A[6] * B[0] + A[7] * B[1] + A[8] * B[2]
        ];
    };
    /**
     * SRGB related functions
     */ /**
     * Convert XYZ to linear-light sRGB
     *
     * @param xyz
     */ const xyz2rgbLinear = (xyz)=>{
        return multiplyMatrices([
            3.2409699419045226,
            -1.537383177570094,
            -0.4986107602930034,
            -0.9692436362808796,
            1.8759675015077202,
            0.04155505740717559,
            0.05563007969699366,
            -0.20397695888897652,
            1.0569715142428786
        ], xyz);
    };
    /**
     * Convert XYZ to linear-light sRGB
     *
     * @param xyz
     */ const rgbLinear2xyz = (xyz)=>{
        return multiplyMatrices([
            0.41239079926595934,
            0.357584339383878,
            0.1804807884018343,
            0.21263900587151027,
            0.715168678767756,
            0.07219231536073371,
            0.01933081871559182,
            0.11919477979462598,
            0.9505321522496607
        ], xyz);
    };
    /**
     * Convert sRGB to RGB
     *
     * @param rgb
     */ const srgbLinear2rgb = (rgb)=>{
        return rgb.map((c)=>{
            const sign = c < 0 ? -1 : 1, abs = Math.abs(c);
            return abs > 0.0031308 ? sign * (1.055 * abs ** (1 / 2.4) - 0.055) : 12.92 * c;
        });
    };
    /**
     * Convert RGB to sRGB
     *
     * @param rgb
     */ const rgb2rgbLinear = (rgb)=>{
        return rgb.map((c)=>{
            const sign = c < 0 ? -1 : 1, abs = Math.abs(c);
            return abs <= 0.04045 ? c / 12.92 : sign * ((abs + 0.055) / 1.055) ** 2.4;
        });
    };
    /**
     * XYZ to SRGB
     *
     * @param args
     */ const srgbFromXYZ = (args)=>{
        const [r, g, b] = srgbLinear2rgb(xyz2rgbLinear([
            args[0],
            args[1],
            args[2]
        ]));
        return [
            r,
            g,
            b,
            args[3]
        ];
    };
    /**
     * XYZ to SRGB-Linear
     * @param args
     */ const srgbLinearFromXYZ = (args)=>{
        const [r, g, b] = xyz2rgbLinear([
            args[0],
            args[1],
            args[2]
        ]);
        return [
            clamp(Math.round(r * 255), 0, 255),
            clamp(Math.round(g * 255), 0, 255),
            clamp(Math.round(b * 255), 0, 255),
            args[3]
        ];
    };
    const isLength = (token)=>token.type === 17 /* TokenType.NUMBER_TOKEN */  || token.type === 15 /* TokenType.DIMENSION_TOKEN */ ;
    const isLengthPercentage = (token)=>token.type === 16 /* TokenType.PERCENTAGE_TOKEN */  || isLength(token);
    /**
     * Check if a token is a calc() function
     */ const isCalcFunction = (token)=>token.type === 18 /* TokenType.FUNCTION */  && token.name === 'calc';
    /**
     * Evaluate a calc() expression and convert to LengthPercentage token
     * Supports basic arithmetic: +, -, *, /
     * Note: Percentages in calc() are converted based on a context value
     */ const evaluateCalcToLengthPercentage = (calcToken, contextValue = 0)=>{
        // Build expression string from tokens
        const buildExpression = (values)=>{
            let expression = '';
            for (const value of values){
                if (value.type === 31 /* TokenType.WHITESPACE_TOKEN */ ) continue;
                if (value.type === 18 /* TokenType.FUNCTION */ ) {
                    if (value.name === 'calc') {
                        const nested = buildExpression(value.values);
                        if (nested === null) return null;
                        expression += `(${nested})`;
                    } else return null;
                } else if (value.type === 17 /* TokenType.NUMBER_TOKEN */ ) expression += value.number.toString();
                else if (value.type === 15 /* TokenType.DIMENSION_TOKEN */ ) {
                    // Convert units to px
                    if (value.unit === 'px') expression += value.number.toString();
                    else if (value.unit === 'rem' || value.unit === 'em') expression += (value.number * 16).toString();
                    else expression += value.number.toString();
                } else if (value.type === 16 /* TokenType.PERCENTAGE_TOKEN */ ) // Convert percentage to absolute value based on context
                expression += (value.number / 100 * contextValue).toString();
                else if (value.type === 6 /* TokenType.DELIM_TOKEN */ ) {
                    const op = value.value;
                    if (op === '+' || op === '-' || op === '*' || op === '/') expression += ` ${op} `;
                    else if (op === '(') expression += '(';
                    else if (op === ')') expression += ')';
                }
            }
            return expression;
        };
        try {
            const expression = buildExpression(calcToken.values);
            if (expression === null || expression.trim() === '') return null;
            // Evaluate the expression
            // Note: Using Function constructor (similar to color.ts line 185)
            const result = new Function('return ' + expression)();
            if (typeof result === 'number' && !isNaN(result)) // Return as a number token in px
            return {
                type: 17 /* TokenType.NUMBER_TOKEN */ ,
                number: result,
                flags: FLAG_INTEGER
            };
        } catch (e) {
            return null;
        }
        return null;
    };
    const parseLengthPercentageTuple = (tokens)=>tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    const ZERO_LENGTH = {
        type: 17 /* TokenType.NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    const FIFTY_PERCENT = {
        type: 16 /* TokenType.PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    const HUNDRED_PERCENT = {
        type: 16 /* TokenType.PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    const getAbsoluteValueForTuple = (tuple, width, height)=>{
        const [x, y] = tuple;
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    const getAbsoluteValue = (token, parent)=>{
        if (token.type === 16 /* TokenType.PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    const DEG = 'deg';
    const GRAD = 'grad';
    const RAD = 'rad';
    const TURN = 'turn';
    const angle = {
        name: 'angle',
        parse: (_context, value)=>{
            if (value.type === 15 /* TokenType.DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error(`Unsupported angle type`);
        }
    };
    const isAngle = (value)=>{
        if (value.type === 15 /* TokenType.DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    const parseNamedSide = (tokens)=>{
        const sideOrCorner = tokens.filter(isIdentToken).map((ident)=>ident.value).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    const deg = (deg)=>Math.PI * deg / 180;
    const isTransparent = (color)=>(0xff & color) === 0;
    const asString = (color)=>{
        const alpha = 0xff & color;
        const blue = 0xff & color >> 8;
        const green = 0xff & color >> 16;
        const red = 0xff & color >> 24;
        return alpha < 255 ? `rgba(${red},${green},${blue},${alpha / 255})` : `rgb(${red},${green},${blue})`;
    };
    const pack = (r, g, b, a)=>(r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    const getTokenColorValue = (token, i)=>{
        if (token.type === 17 /* TokenType.NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* TokenType.PERCENTAGE_TOKEN */ ) {
            const max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    const isRelativeTransform = (tokens)=>(tokens[0].type === 20 /* TokenType.IDENT_TOKEN */  ? tokens[0].value : 'unknown') === 'from';
    const packSrgb = (args)=>{
        return pack(clamp(Math.round(args[0] * 255), 0, 255), clamp(Math.round(args[1] * 255), 0, 255), clamp(Math.round(args[2] * 255), 0, 255), clamp(args[3], 0, 1));
    };
    const packSrgbLinear = ([r, g, b, a])=>{
        const rgb = srgbLinear2rgb([
            r,
            g,
            b
        ]);
        return pack(clamp(Math.round(rgb[0] * 255), 0, 255), clamp(Math.round(rgb[1] * 255), 0, 255), clamp(Math.round(rgb[2] * 255), 0, 255), a);
    };
    const packXYZ = (args)=>{
        const srgb_linear = xyz2rgbLinear([
            args[0],
            args[1],
            args[2]
        ]);
        return packSrgbLinear([
            srgb_linear[0],
            srgb_linear[1],
            srgb_linear[2],
            args[3]
        ]);
    };
    const packLab = (_context, args)=>{
        if (isRelativeTransform(args.filter(nonFunctionArgSeparator))) throw new Error('Relative color not supported for lab()');
        const [l, a, b, alpha] = extractLabComponents(args), rgb = srgbLinear2rgb(xyz2rgbLinear(lab2xyz([
            l,
            a,
            b
        ])));
        return pack(clamp(Math.round(rgb[0] * 255), 0, 255), clamp(Math.round(rgb[1] * 255), 0, 255), clamp(Math.round(rgb[2] * 255), 0, 255), alpha);
    };
    const packOkLab = (_context, args)=>{
        if (isRelativeTransform(args.filter(nonFunctionArgSeparator))) throw new Error('Relative color not supported for oklab()');
        const [l, a, b, alpha] = extractLabComponents(args), rgb = srgbLinear2rgb(xyz2rgbLinear(oklab2xyz([
            l,
            a,
            b
        ])));
        return pack(clamp(Math.round(rgb[0] * 255), 0, 255), clamp(Math.round(rgb[1] * 255), 0, 255), clamp(Math.round(rgb[2] * 255), 0, 255), alpha);
    };
    const packOkLch = (_context, args)=>{
        if (isRelativeTransform(args.filter(nonFunctionArgSeparator))) throw new Error('Relative color not supported for oklch()');
        const [l, c, h, alpha] = extractOkLchComponents(args), rgb = srgbLinear2rgb(xyz2rgbLinear(oklab2xyz(lch2lab([
            l,
            c,
            h
        ]))));
        return pack(clamp(Math.round(rgb[0] * 255), 0, 255), clamp(Math.round(rgb[1] * 255), 0, 255), clamp(Math.round(rgb[2] * 255), 0, 255), alpha);
    };
    const packLch = (_context, args)=>{
        if (isRelativeTransform(args.filter(nonFunctionArgSeparator))) throw new Error('Relative color not supported for lch()');
        const [l, c, h, a] = extractLchComponents(args), rgb = srgbLinear2rgb(xyz2rgbLinear(lab2xyz(lch2lab([
            l,
            c,
            h
        ]))));
        return pack(clamp(Math.round(rgb[0] * 255), 0, 255), clamp(Math.round(rgb[1] * 255), 0, 255), clamp(Math.round(rgb[2] * 255), 0, 255), a);
    };
    const extractHslComponents = (context, args)=>{
        const tokens = args.filter(nonFunctionArgSeparator), [hue, saturation, lightness, alpha] = tokens, h = (hue.type === 17 /* TokenType.NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2), s = isLengthPercentage(saturation) ? saturation.number / 100 : 0, l = isLengthPercentage(lightness) ? lightness.number / 100 : 0, a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        return [
            h,
            s,
            l,
            a
        ];
    };
    const packHSL = (context, args)=>{
        if (isRelativeTransform(args)) throw new Error('Relative color not supported for hsl()');
        const [h, s, l, a] = extractHslComponents(context, args), rgb = hsl2rgb([
            h,
            s,
            l
        ]);
        return pack(rgb[0] * 255, rgb[1] * 255, rgb[2] * 255, s === 0 ? 1 : a);
    };
    const extractLchComponents = (args)=>{
        const tokens = args.filter(nonFunctionArgSeparator), l = isLengthPercentage(tokens[0]) ? tokens[0].number : 0, c = isLengthPercentage(tokens[1]) ? tokens[1].number : 0, h = isNumberToken(tokens[2]) || isDimensionToken(tokens[2]) ? tokens[2].number : 0, a = typeof tokens[4] !== 'undefined' && isLengthPercentage(tokens[4]) ? getAbsoluteValue(tokens[4], 1) : 1;
        return [
            l,
            c,
            h,
            a
        ];
    };
    const extractLabComponents = (args)=>{
        const tokens = args.filter(nonFunctionArgSeparator), l = tokens[0].type === 16 /* TokenType.PERCENTAGE_TOKEN */  ? tokens[0].number / 100 : isNumberToken(tokens[0]) ? tokens[0].number : 0, a = tokens[1].type === 16 /* TokenType.PERCENTAGE_TOKEN */  ? tokens[1].number / 100 : isNumberToken(tokens[1]) ? tokens[1].number : 0, b = isNumberToken(tokens[2]) || isDimensionToken(tokens[2]) ? tokens[2].number : 0, alpha = typeof tokens[4] !== 'undefined' && isLengthPercentage(tokens[4]) ? getAbsoluteValue(tokens[4], 1) : 1;
        return [
            l,
            a,
            b,
            alpha
        ];
    };
    const extractOkLchComponents = (args)=>{
        const tokens = args.filter(nonFunctionArgSeparator), l = tokens[0].type === 16 /* TokenType.PERCENTAGE_TOKEN */  ? tokens[0].number / 100 : isNumberToken(tokens[0]) ? tokens[0].number : 0, c = tokens[1].type === 16 /* TokenType.PERCENTAGE_TOKEN */  ? tokens[1].number / 100 : isNumberToken(tokens[1]) ? tokens[1].number : 0, h = isNumberToken(tokens[2]) || isDimensionToken(tokens[2]) ? tokens[2].number : 0, a = typeof tokens[4] !== 'undefined' && isLengthPercentage(tokens[4]) ? getAbsoluteValue(tokens[4], 1) : 1;
        return [
            l,
            c,
            h,
            a
        ];
    };
    /**
     * Convert D65 to D50
     *
     * @param xyz
     */ const d65toD50 = (xyz)=>{
        return multiplyMatrices([
            1.0479297925449969,
            0.022946870601609652,
            -0.05019226628920524,
            0.02962780877005599,
            0.9904344267538799,
            -0.017073799063418826,
            -0.009243040646204504,
            0.015055191490298152,
            0.7518742814281371
        ], xyz);
    };
    /**
     * Convert D50 to D65
     *
     * @param xyz
     */ const d50toD65 = (xyz)=>{
        return multiplyMatrices([
            0.955473421488075,
            -0.02309845494876471,
            0.06325924320057072,
            -0.0283697093338637,
            1.0099953980813041,
            0.021041441191917323,
            0.012314014864481998,
            -0.020507649298898964,
            1.330365926242124
        ], xyz);
    };
    const hue2rgb = (t1, t2, hue)=>{
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    };
    const hsl2rgb = ([h, s, l])=>{
        if (s === 0) return [
            l * 255,
            l * 255,
            l * 255
        ];
        const t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s, t1 = l * 2 - t2, r = hue2rgb(t1, t2, h + 1 / 3), g = hue2rgb(t1, t2, h), b = hue2rgb(t1, t2, h - 1 / 3);
        return [
            r,
            g,
            b
        ];
    };
    /**
     * Convert lch to OKLab
     *
     * @param l
     * @param c
     * @param h
     */ const lch2lab = ([l, c, h])=>{
        if (c < 0) c = 0;
        if (isNaN(h)) h = 0;
        return [
            l,
            c * Math.cos(h * Math.PI / 180),
            c * Math.sin(h * Math.PI / 180)
        ];
    };
    /**
     * Convert OKLab to XYZ relative to D65
     *
     * @param lab
     */ const oklab2xyz = (lab)=>{
        const LMSg = multiplyMatrices([
            1,
            0.3963377773761749,
            0.2158037573099136,
            1,
            -0.1055613458156586,
            -0.0638541728258133,
            1,
            -0.0894841775298119,
            -1.2914855480194092
        ], lab), LMS = LMSg.map((val)=>val ** 3);
        return multiplyMatrices([
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647,
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164,
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ], LMS);
    };
    /**
     * Convert Lab to D50-adapted XYZ
     *
     * @param lab
     */ const lab2xyz = (lab)=>{
        const fy = (lab[0] + 16) / 116, fx = lab[1] / 500 + fy, fz = fy - lab[2] / 200, k = 24389 / 27, e = 24 / 116, xyz = [
            (fx > e ? fx ** 3 : (116 * fx - 16) / k) * 0.3457 / 0.3585,
            lab[0] > 8 ? fy ** 3 : lab[0] / k,
            (fz > e ? fz ** 3 : (116 * fz - 16) / k) * 0.2958 / 0.3585
        ];
        return d50toD65([
            xyz[0],
            xyz[1],
            xyz[2]
        ]);
    };
    /**
     * Convert RGB to XYZ
     *
     * @param _context
     * @param args
     */ const rgbToXyz = (_context, args)=>{
        const tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            const [r, g, b] = tokens.map(getTokenColorValue), rgb_linear = rgb2rgbLinear([
                r / 255,
                g / 255,
                b / 255
            ]), [x, y, z] = rgbLinear2xyz([
                rgb_linear[0],
                rgb_linear[1],
                rgb_linear[2]
            ]);
            return [
                x,
                y,
                z,
                1
            ];
        }
        if (tokens.length === 4) {
            const [r, g, b, a] = tokens.map(getTokenColorValue), rgb_linear = rgb2rgbLinear([
                r / 255,
                g / 255,
                b / 255
            ]), [x, y, z] = rgbLinear2xyz([
                rgb_linear[0],
                rgb_linear[1],
                rgb_linear[2]
            ]);
            return [
                x,
                y,
                z,
                a
            ];
        }
        return [
            0,
            0,
            0,
            1
        ];
    };
    /**
     * HSL to XYZ
     *
     * @param context
     * @param args
     */ const hslToXyz = (context, args)=>{
        const [h, s, l, a] = extractHslComponents(context, args), rgb_linear = rgb2rgbLinear(hsl2rgb([
            h,
            s,
            l
        ])), [x, y, z] = rgbLinear2xyz([
            rgb_linear[0],
            rgb_linear[1],
            rgb_linear[2]
        ]);
        return [
            x,
            y,
            z,
            a
        ];
    };
    /**
     * LAB to XYZ
     *
     * @param _context
     * @param args
     */ const labToXyz = (_context, args)=>{
        const [l, a, b, alpha] = extractLabComponents(args), [x, y, z] = lab2xyz([
            l,
            a,
            b
        ]);
        return [
            x,
            y,
            z,
            alpha
        ];
    };
    /**
     * LCH to XYZ
     *
     * @param _context
     * @param args
     */ const lchToXyz = (_context, args)=>{
        const [l, c, h, alpha] = extractLchComponents(args), [x, y, z] = lab2xyz(lch2lab([
            l,
            c,
            h
        ]));
        return [
            x,
            y,
            z,
            alpha
        ];
    };
    /**
     * OKLch to XYZ
     *
     * @param _context
     * @param args
     */ const oklchToXyz = (_context, args)=>{
        const [l, c, h, alpha] = extractOkLchComponents(args), [x, y, z] = oklab2xyz(lch2lab([
            l,
            c,
            h
        ]));
        return [
            x,
            y,
            z,
            alpha
        ];
    };
    /**
     * OKLab to XYZ
     *
     * @param _context
     * @param args
     */ const oklabToXyz = (_context, args)=>{
        const [l, c, h, alpha] = extractLabComponents(args), [x, y, z] = oklab2xyz([
            l,
            c,
            h
        ]);
        return [
            x,
            y,
            z,
            alpha
        ];
    };
    /**
     * XYZ-50 to XYZ
     *
     * @param args
     */ const xyz50ToXYZ = (args)=>{
        return d50toD65([
            args[0],
            args[1],
            args[2]
        ]);
    };
    /**
     * Does nothing, required for SUPPORTED_COLOR_SPACES_FROM_XYZ in the _color() function
     *
     * @param args
     */ const xyzFromXYZ = (args)=>{
        return args;
    };
    /**
     * XYZ-65 to XYZ-50
     *
     * @param args
     */ const xyz50FromXYZ = (args)=>{
        const [x, y, z] = d65toD50([
            args[0],
            args[2],
            args[3]
        ]);
        return [
            x,
            y,
            z,
            args[3]
        ];
    };
    /**
     * Convert XYZ to SRGB and Pack
     *
     * @param args
     */ const convertXyz = (args)=>{
        return packXYZ([
            args[0],
            args[1],
            args[2],
            args[3]
        ]);
    };
    /**
     * Convert XYZ-50 to SRGB and Pack
     *
     * @param args
     */ const convertXyz50 = (args)=>{
        const xyz = xyz50ToXYZ([
            args[0],
            args[1],
            args[2]
        ]);
        return packXYZ([
            xyz[0],
            xyz[1],
            xyz[2],
            args[3]
        ]);
    };
    /**
     * Display-P3 related functions
     */ /**
     * Convert P3 Linear to xyz
     *
     * @param p3l
     */ const p3LinearToXyz = (p3l)=>{
        return multiplyMatrices([
            0.4865709486482162,
            0.26566769316909306,
            0.1982172852343625,
            0.2289745640697488,
            0.6917385218365064,
            0.079286914093745,
            0.0,
            0.04511338185890264,
            1.043944368900976
        ], p3l);
    };
    /**
     * Convert XYZ to P3 Linear
     *
     * @param xyz
     */ const xyzToP3Linear = (xyz)=>{
        return multiplyMatrices([
            2.493496911941425,
            -0.9313836179191239,
            -0.40271078445071684,
            -0.8294889695615747,
            1.7626640603183463,
            0.023624685841943577,
            0.03584583024378447,
            -0.07617238926804182,
            0.9568845240076872
        ], xyz);
    };
    /**
     * Convert P3 to P3 linear
     *
     * @param p3
     */ const p32p3Linear = (p3)=>{
        return p3.map((c)=>{
            const sign = c < 0 ? -1 : 1, abs = c * sign;
            if (abs <= 0.04045) return c / 12.92;
            return sign * ((c + 0.055) / 1.055) ** 2.4 || 0;
        });
    };
    /**
     * Convert P3 Linear to P3
     *
     * @param p3l
     */ const p3Linear2p3 = (p3l)=>{
        return srgbLinear2rgb(p3l);
    };
    /**
     * Convert P3 to XYZ
     *
     * @param args
     */ const p3ToXYZ = (args)=>{
        const p3_linear = p32p3Linear([
            args[0],
            args[1],
            args[2]
        ]);
        return p3LinearToXyz([
            p3_linear[0],
            p3_linear[1],
            p3_linear[2]
        ]);
    };
    /**
     * Convert XYZ to P3
     *
     * @param args
     */ const p3FromXYZ = (args)=>{
        const [r, g, b] = p3Linear2p3(xyzToP3Linear([
            args[0],
            args[1],
            args[2]
        ]));
        return [
            r,
            g,
            b,
            args[3]
        ];
    };
    /**
     * Convert P3 to SRGB and Pack
     *
     * @param args
     */ const convertP3 = (args)=>{
        const xyz = p3ToXYZ([
            args[0],
            args[1],
            args[2]
        ]);
        return packXYZ([
            xyz[0],
            xyz[1],
            xyz[2],
            args[3]
        ]);
    };
    /**
     * A98-RGB related functions
     */ /**
     * Convert XYZ to a98 linear
     *
     * @param xyz
     */ const xyz2a98Linear = (xyz)=>{
        return multiplyMatrices([
            2.0415879038107465,
            -0.5650069742788596,
            -0.34473135077832956,
            -0.9692436362808795,
            1.8759675015077202,
            0.04155505740717557,
            0.013444280632031142,
            -0.11836239223101838,
            1.0151749943912054
        ], xyz);
    };
    /**
     * Convert XYZ to a98 linear
     *
     * @param a98
     */ const a98Linear2xyz = (a98)=>{
        return multiplyMatrices([
            0.5766690429101305,
            0.1855582379065463,
            0.1882286462349947,
            0.29734497525053605,
            0.6273635662554661,
            0.0752914584939978,
            0.02703136138641234,
            0.07068885253582723,
            0.9913375368376388
        ], a98);
    };
    /**
     * Convert A98 RGB to rgb linear
     *
     * @param rgb
     */ const a982a98Linear = (rgb)=>{
        const mapped = rgb.map((c)=>{
            const sign = c < 0 ? -1 : 1, abs = Math.abs(c);
            return sign * abs ** (563 / 256);
        });
        return [
            mapped[0],
            mapped[1],
            mapped[2]
        ];
    };
    /**
     * Convert A98 RGB Linear to A98
     *
     * @param rgb
     */ const a98Linear2a98 = (rgb)=>{
        const mapped = rgb.map((c)=>{
            const sign = c < 0 ? -1 : 1, abs = Math.abs(c);
            return sign * abs ** (256 / 563);
        });
        return [
            mapped[0],
            mapped[1],
            mapped[2]
        ];
    };
    /**
     * Convert XYZ to A98
     *
     * @param args
     */ const a98FromXYZ = (args)=>{
        const [r, g, b] = a98Linear2a98(xyz2a98Linear([
            args[0],
            args[1],
            args[2]
        ]));
        return [
            r,
            g,
            b,
            args[3]
        ];
    };
    /**
     * Convert A98 to XYZ and Pack
     *
     * @param args
     */ const convertA98rgb = (args)=>{
        const srgb_linear = xyz2rgbLinear(a98Linear2xyz(a982a98Linear([
            args[0],
            args[1],
            args[2]
        ])));
        return packSrgbLinear([
            srgb_linear[0],
            srgb_linear[1],
            srgb_linear[2],
            args[3]
        ]);
    };
    /**
     * Pro Photo related functions
     */ /**
     * Convert linear-light display-p3 to XYZ D65
     *
     * @param p3
     */ const proPhotoLinearToXyz = (p3)=>{
        return multiplyMatrices([
            0.7977666449006423,
            0.13518129740053308,
            0.0313477341283922,
            0.2880748288194013,
            0.711835234241873,
            0.00008993693872564,
            0.0,
            0.0,
            0.8251046025104602
        ], p3);
    };
    /**
     * Convert XYZ D65 to linear-light display-p3
     *
     * @param xyz
     */ const xyzToProPhotoLinear = (xyz)=>{
        return multiplyMatrices([
            1.3457868816471583,
            -0.25557208737979464,
            -0.05110186497554526,
            -0.5446307051249019,
            1.5082477428451468,
            0.02052744743642139,
            0.0,
            0.0,
            1.2119675456389452
        ], xyz);
    };
    /**
     * Convert Pro-Photo to Pro-Photo Linear
     *
     * @param p3
     */ const proPhotoToProPhotoLinear = (p3)=>{
        return p3.map((c)=>{
            return c < 16 / 512 ? c / 16 : c ** 1.8;
        });
    };
    /**
     * Convert Pro-Photo Linear to Pro-Photo
     *
     * @param p3
     */ const proPhotoLinearToProPhoto = (p3)=>{
        return p3.map((c)=>{
            return c > 1 / 512 ? c ** (1 / 1.8) : c * 16;
        });
    };
    /**
     * Convert Pro-Photo to XYZ
     *
     * @param args
     */ const proPhotoToXYZ = (args)=>{
        const prophoto_linear = proPhotoToProPhotoLinear([
            args[0],
            args[1],
            args[2]
        ]);
        return d50toD65(proPhotoLinearToXyz([
            prophoto_linear[0],
            prophoto_linear[1],
            prophoto_linear[2]
        ]));
    };
    /**
     * Convert XYZ to Pro-Photo
     *
     * @param args
     */ const proPhotoFromXYZ = (args)=>{
        const [r, g, b] = proPhotoLinearToProPhoto(xyzToProPhotoLinear(d65toD50([
            args[0],
            args[1],
            args[2]
        ])));
        return [
            r,
            g,
            b,
            args[3]
        ];
    };
    /**
     * Convert Pro-Photo to XYZ and Pack
     *
     * @param args
     */ const convertProPhoto = (args)=>{
        const xyz = proPhotoToXYZ([
            args[0],
            args[1],
            args[2]
        ]);
        return packXYZ([
            xyz[0],
            xyz[1],
            xyz[2],
            args[3]
        ]);
    };
    /**
     * REC2020 related functions
     */ const _a = 1.09929682680944;
    const _b = 0.018053968510807;
    /**
     * Convert rec2020 to rec2020 linear
     *
     * @param rgb
     */ const rec20202rec2020Linear = (rgb)=>{
        return rgb.map(function(c) {
            return c < _b * 4.5 ? c / 4.5 : Math.pow((c + _a - 1) / _a, 1 / 0.45);
        });
    };
    /**
     * Convert rec2020 linear to rec2020
     *
     * @param rgb
     */ const rec2020Linear2rec2020 = (rgb)=>{
        return rgb.map(function(c) {
            return c >= _b ? _a * Math.pow(c, 0.45) - (_a - 1) : 4.5 * c;
        });
    };
    /**
     * Convert rec2020 linear to XYZ D65
     *
     * @param rec
     */ const rec2020LinearToXyz = (rec)=>{
        return multiplyMatrices([
            0.6369580483012914,
            0.14461690358620832,
            0.1688809751641721,
            0.2627002120112671,
            0.6779980715188708,
            0.05930171646986196,
            0.0,
            0.028072693049087428,
            1.060985057710791
        ], rec);
    };
    /**
     * Convert XYZ D65 to rec2020 linear
     *
     * @param xyz
     */ const xyzToRec2020Linear = (xyz)=>{
        return multiplyMatrices([
            1.716651187971268,
            -0.355670783776392,
            -0.25336628137366,
            -0.666684351832489,
            1.616481236634939,
            0.0157685458139111,
            0.017639857445311,
            -0.042770613257809,
            0.942103121235474
        ], xyz);
    };
    /**
     * Convert Rec2020 to XYZ
     *
     * @param args
     */ const rec2020ToXYZ = (args)=>{
        const rec2020_linear = rec20202rec2020Linear([
            args[0],
            args[1],
            args[2]
        ]);
        return rec2020LinearToXyz([
            rec2020_linear[0],
            rec2020_linear[1],
            rec2020_linear[2]
        ]);
    };
    /**
     * Convert XYZ to Rec2020
     *
     * @param args
     */ const rec2020FromXYZ = (args)=>{
        const [r, g, b] = rec2020Linear2rec2020(xyzToRec2020Linear([
            args[0],
            args[1],
            args[2]
        ]));
        return [
            r,
            g,
            b,
            args[3]
        ];
    };
    /**
     * Convert Rec2020 to SRGB and Pack
     *
     * @param args
     */ const convertRec2020 = (args)=>{
        const xyz = rec2020ToXYZ([
            args[0],
            args[1],
            args[2]
        ]);
        return packXYZ([
            xyz[0],
            xyz[1],
            xyz[2],
            args[3]
        ]);
    };
    const color$1 = {
        name: 'color',
        parse: (context, value)=>{
            if (value.type === 18 /* TokenType.FUNCTION */ ) {
                const colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error(`Attempting to parse an unsupported color function "${value.name}"`);
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* TokenType.HASH_TOKEN */ ) {
                const [r, g, b, a] = hash2rgb(value);
                return pack(r, g, b, a);
            }
            if (value.type === 20 /* TokenType.IDENT_TOKEN */ ) {
                const namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    const hash2rgb = (token)=>{
        if (token.value.length === 3) {
            const r = token.value.substring(0, 1);
            const g = token.value.substring(1, 2);
            const b = token.value.substring(2, 3);
            return [
                parseInt(r + r, 16),
                parseInt(g + g, 16),
                parseInt(b + b, 16),
                1
            ];
        }
        if (token.value.length === 4) {
            const r = token.value.substring(0, 1);
            const g = token.value.substring(1, 2);
            const b = token.value.substring(2, 3);
            const a = token.value.substring(3, 4);
            return [
                parseInt(r + r, 16),
                parseInt(g + g, 16),
                parseInt(b + b, 16),
                parseInt(a + a, 16) / 255
            ];
        }
        if (token.value.length === 6) {
            const r = token.value.substring(0, 2);
            const g = token.value.substring(2, 4);
            const b = token.value.substring(4, 6);
            return [
                parseInt(r, 16),
                parseInt(g, 16),
                parseInt(b, 16),
                1
            ];
        }
        if (token.value.length === 8) {
            const r = token.value.substring(0, 2);
            const g = token.value.substring(2, 4);
            const b = token.value.substring(4, 6);
            const a = token.value.substring(6, 8);
            return [
                parseInt(r, 16),
                parseInt(g, 16),
                parseInt(b, 16),
                parseInt(a, 16) / 255
            ];
        }
        return [
            0,
            0,
            0,
            1
        ];
    };
    const rgb = (_context, args)=>{
        const tokens = args.filter(nonFunctionArgSeparator);
        if (isRelativeTransform(tokens)) throw new Error('Relative color not supported for rgb()');
        if (tokens.length === 3) {
            const [r, g, b] = tokens.map(getTokenColorValue);
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            const [r, g, b, a] = tokens.map(getTokenColorValue);
            return pack(r, g, b, a);
        }
        // Handle modern CSS syntax with / separator: rgb(r g b / alpha)
        // tokens[0] = r, tokens[1] = g, tokens[2] = b, tokens[3] = '/', tokens[4] = alpha
        if (tokens.length === 5 && tokens[3].type === 6 /* TokenType.DELIM_TOKEN */  && tokens[3].value === '/') {
            const r = getTokenColorValue(tokens[0], 0);
            const g = getTokenColorValue(tokens[1], 1);
            const b = getTokenColorValue(tokens[2], 2);
            const a = getTokenColorValue(tokens[4], 3);
            return pack(r, g, b, a);
        }
        return 0;
    };
    /**
     * Handle the CSS color() function
     *
     * @param context
     * @param args
     */ const _color = (context, args)=>{
        const tokens = args.filter(nonFunctionArgSeparator), token_1_value = tokens[0].type === 20 /* TokenType.IDENT_TOKEN */  ? tokens[0].value : 'unknown', is_absolute = !isRelativeTransform(tokens);
        if (is_absolute) {
            const color_space = token_1_value, colorSpaceFunction = SUPPORTED_COLOR_SPACES_ABSOLUTE[color_space];
            if (typeof colorSpaceFunction === 'undefined') throw new Error(`Attempting to parse an unsupported color space "${color_space}" for color() function`);
            const c1 = isNumberToken(tokens[1]) ? tokens[1].number : 0, c2 = isNumberToken(tokens[2]) ? tokens[2].number : 0, c3 = isNumberToken(tokens[3]) ? tokens[3].number : 0, a = tokens.length > 4 && tokens[4].type === 6 /* TokenType.DELIM_TOKEN */  && tokens[4].value === '/' && isNumberToken(tokens[5]) ? tokens[5].number : 1;
            return colorSpaceFunction([
                c1,
                c2,
                c3,
                a
            ]);
        } else {
            const extractComponent = (color, token)=>{
                if (isNumberToken(token)) return token.number;
                const posFromVal = (value)=>{
                    return value === 'r' || value === 'x' ? 0 : value === 'g' || value === 'y' ? 1 : 2;
                };
                if (isIdentToken(token)) {
                    const position = posFromVal(token.value);
                    return color[position];
                }
                const parseCalc = (args)=>{
                    const parts = args.filter(nonFunctionArgSeparator);
                    let expression = '(';
                    for (const part of parts)expression += part.type === 18 /* TokenType.FUNCTION */  && part.name === 'calc' ? parseCalc(part.values) : isNumberToken(part) ? part.number : part.type === 6 /* TokenType.DELIM_TOKEN */  || isIdentToken(part) ? part.value : '';
                    expression += ')';
                    return expression;
                };
                if (token.type === 18 /* TokenType.FUNCTION */ ) {
                    const args = token.values.filter(nonFunctionArgSeparator);
                    if (token.name === 'calc') {
                        const expression = parseCalc(args).replace(/r|x/, color[0].toString()).replace(/g|y/, color[1].toString()).replace(/b|z/, color[2].toString());
                        return new Function('return ' + expression)();
                    }
                }
                return null;
            };
            const from_colorspace = tokens[1].type === 18 /* TokenType.FUNCTION */  ? tokens[1].name : isIdentToken(tokens[1]) || tokens[1].type === 5 /* TokenType.HASH_TOKEN */  ? 'rgb' : 'unknown', to_colorspace = isIdentToken(tokens[2]) ? tokens[2].value : 'unknown';
            let from = tokens[1].type === 18 /* TokenType.FUNCTION */  ? tokens[1].values : isIdentToken(tokens[1]) ? [
                tokens[1]
            ] : [];
            if (isIdentToken(tokens[1])) {
                const named_color = COLORS[tokens[1].value.toUpperCase()];
                if (typeof named_color === 'undefined') throw new Error(`Attempting to use unknown color in relative color 'from'`);
                else {
                    const _c = parseColor(context, tokens[1].value), alpha = 0xff & _c, blue = 0xff & _c >> 8, green = 0xff & _c >> 16, red = 0xff & _c >> 24;
                    from = [
                        {
                            type: 17 /* TokenType.NUMBER_TOKEN */ ,
                            number: red,
                            flags: 1
                        },
                        {
                            type: 17 /* TokenType.NUMBER_TOKEN */ ,
                            number: green,
                            flags: 1
                        },
                        {
                            type: 17 /* TokenType.NUMBER_TOKEN */ ,
                            number: blue,
                            flags: 1
                        },
                        {
                            type: 17 /* TokenType.NUMBER_TOKEN */ ,
                            number: alpha > 1 ? alpha / 255 : alpha,
                            flags: 1
                        }
                    ];
                }
            } else if (tokens[1].type === 5 /* TokenType.HASH_TOKEN */ ) {
                const [red, green, blue, alpha] = hash2rgb(tokens[1]);
                from = [
                    {
                        type: 17 /* TokenType.NUMBER_TOKEN */ ,
                        number: red,
                        flags: 1
                    },
                    {
                        type: 17 /* TokenType.NUMBER_TOKEN */ ,
                        number: green,
                        flags: 1
                    },
                    {
                        type: 17 /* TokenType.NUMBER_TOKEN */ ,
                        number: blue,
                        flags: 1
                    },
                    {
                        type: 17 /* TokenType.NUMBER_TOKEN */ ,
                        number: alpha > 1 ? alpha / 255 : alpha,
                        flags: 1
                    }
                ];
            }
            if (from.length === 0) throw new Error(`Attempting to use unknown color in relative color 'from'`);
            if (to_colorspace === 'unknown') throw new Error(`Attempting to use unknown colorspace in relative color 'to'`);
            const fromColorToXyz = SUPPORTED_COLOR_SPACES_TO_XYZ[from_colorspace], toColorFromXyz = SUPPORTED_COLOR_SPACES_FROM_XYZ[to_colorspace], toColorPack = SUPPORTED_COLOR_SPACES_ABSOLUTE[to_colorspace];
            if (typeof fromColorToXyz === 'undefined') throw new Error(`Attempting to parse an unsupported color space "${from_colorspace}" for color() function`);
            if (typeof toColorFromXyz === 'undefined') throw new Error(`Attempting to parse an unsupported color space "${to_colorspace}" for color() function`);
            const from_color = fromColorToXyz(context, from), from_final_colorspace = toColorFromXyz(from_color), c1 = extractComponent(from_final_colorspace, tokens[3]), c2 = extractComponent(from_final_colorspace, tokens[4]), c3 = extractComponent(from_final_colorspace, tokens[5]), a = tokens.length > 6 && tokens[6].type === 6 /* TokenType.DELIM_TOKEN */  && tokens[6].value === '/' && isNumberToken(tokens[7]) ? tokens[7].number : 1;
            if (c1 === null || c2 === null || c3 === null) throw new Error(`Invalid relative color in color() function`);
            return toColorPack([
                c1,
                c2,
                c3,
                a
            ]);
        }
    };
    const SUPPORTED_COLOR_SPACES_ABSOLUTE = {
        srgb: packSrgb,
        'srgb-linear': packSrgbLinear,
        'display-p3': convertP3,
        'a98-rgb': convertA98rgb,
        'prophoto-rgb': convertProPhoto,
        xyz: convertXyz,
        'xyz-d50': convertXyz50,
        'xyz-d65': convertXyz,
        rec2020: convertRec2020
    };
    const SUPPORTED_COLOR_SPACES_TO_XYZ = {
        rgb: rgbToXyz,
        hsl: hslToXyz,
        lab: labToXyz,
        lch: lchToXyz,
        oklab: oklabToXyz,
        oklch: oklchToXyz
    };
    const SUPPORTED_COLOR_SPACES_FROM_XYZ = {
        srgb: srgbFromXYZ,
        'srgb-linear': srgbLinearFromXYZ,
        'display-p3': p3FromXYZ,
        'a98-rgb': a98FromXYZ,
        'prophoto-rgb': proPhotoFromXYZ,
        xyz: xyzFromXYZ,
        'xyz-d50': xyz50FromXYZ,
        'xyz-d65': xyzFromXYZ,
        rec2020: rec2020FromXYZ
    };
    const SUPPORTED_COLOR_FUNCTIONS = {
        hsl: packHSL,
        hsla: packHSL,
        rgb: rgb,
        rgba: rgb,
        lch: packLch,
        oklch: packOkLch,
        oklab: packOkLab,
        lab: packLab,
        color: _color
    };
    const parseColor = (context, value)=>color$1.parse(context, Parser.create(value).parseComponentValue());
    const COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    const backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return tokens.map((token)=>{
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* BACKGROUND_CLIP.PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* BACKGROUND_CLIP.CONTENT_BOX */ ;
                }
                return 0 /* BACKGROUND_CLIP.BORDER_BOX */ ;
            });
        }
    };
    const backgroundColor = {
        name: `background-color`,
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
        format: 'color'
    };
    const parseColorStop = (context, args)=>{
        const color = color$1.parse(context, args[0]);
        const stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    const processColorStops = (stops, lineLength)=>{
        const first = stops[0];
        const last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        const processStops = [];
        let previous = 0;
        for(let i = 0; i < stops.length; i++){
            const stop = stops[i].stop;
            if (stop !== null) {
                const absoluteValue = getAbsoluteValue(stop, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        let gapBegin = null;
        for(let i = 0; i < processStops.length; i++){
            const stop = processStops[i];
            if (stop === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                const gapLength = i - gapBegin;
                const beforeGap = processStops[gapBegin - 1];
                const gapValue = (stop - beforeGap) / (gapLength + 1);
                for(let g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(({ color: color }, i)=>{
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    const getAngleFromCorner = (corner, width, height)=>{
        const centerX = width / 2;
        const centerY = height / 2;
        const x = getAbsoluteValue(corner[0], width) - centerX;
        const y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    const calculateGradientDirection = (angle, width, height)=>{
        const radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        const lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        const halfLineLength = lineLength / 2;
        const yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        const xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    const distance = (a, b)=>Math.sqrt(a * a + b * b);
    const findCorner = (width, height, x, y, closest)=>{
        const corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce((stat, corner)=>{
            const [cx, cy] = corner;
            const d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    const calculateRadius = (gradient, x, y, width, height)=>{
        let rx = 0;
        let ry = 0;
        switch(gradient.size){
            case 0 /* CSSRadialExtent.CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CSSRadialShape.CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* CSSRadialShape.ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CSSRadialExtent.CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CSSRadialShape.CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* CSSRadialShape.ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    const c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    const [cx, cy] = findCorner(width, height, x, y, true);
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* CSSRadialExtent.FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CSSRadialShape.CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* CSSRadialShape.ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* CSSRadialExtent.FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CSSRadialShape.CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* CSSRadialShape.ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    const c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    const [cx, cy] = findCorner(width, height, x, y, false);
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    const linearGradient = (context, tokens)=>{
        let angle$1 = deg(180);
        const stops = [];
        parseFunctionArgs(tokens).forEach((arg, i)=>{
            if (i === 0) {
                const firstToken = arg[0];
                if (firstToken.type === 20 /* TokenType.IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            const colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* CSSImageType.LINEAR_GRADIENT */ 
        };
    };
    const prefixLinearGradient = (context, tokens)=>{
        let angle$1 = deg(180);
        const stops = [];
        parseFunctionArgs(tokens).forEach((arg, i)=>{
            if (i === 0) {
                const firstToken = arg[0];
                if (firstToken.type === 20 /* TokenType.IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            const colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* CSSImageType.LINEAR_GRADIENT */ 
        };
    };
    const webkitGradient = (context, tokens)=>{
        const angle = deg(180);
        const stops = [];
        let type = 1 /* CSSImageType.LINEAR_GRADIENT */ ;
        const shape = 0 /* CSSRadialShape.CIRCLE */ ;
        const size = 3 /* CSSRadialExtent.FARTHEST_CORNER */ ;
        const position = [];
        parseFunctionArgs(tokens).forEach((arg, i)=>{
            const firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* CSSImageType.LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* CSSImageType.RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* TokenType.FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    const color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    const color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    const values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        const color = color$1.parse(context, values[1]);
                        const stop = values[0];
                        if (isNumberToken(stop)) stops.push({
                            stop: {
                                type: 16 /* TokenType.PERCENTAGE_TOKEN */ ,
                                number: stop.number * 100,
                                flags: stop.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* CSSImageType.LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    const CLOSEST_SIDE = 'closest-side';
    const FARTHEST_SIDE = 'farthest-side';
    const CLOSEST_CORNER = 'closest-corner';
    const FARTHEST_CORNER = 'farthest-corner';
    const CIRCLE = 'circle';
    const ELLIPSE = 'ellipse';
    const COVER = 'cover';
    const CONTAIN = 'contain';
    const radialGradient = (context, tokens)=>{
        let shape = 0 /* CSSRadialShape.CIRCLE */ ;
        let size = 3 /* CSSRadialExtent.FARTHEST_CORNER */ ;
        const stops = [];
        const position = [];
        parseFunctionArgs(tokens).forEach((arg, i)=>{
            let isColorStop = true;
            if (i === 0) {
                let isAtPosition = false;
                isColorStop = arg.reduce((acc, token)=>{
                    if (isAtPosition) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CSSRadialShape.CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* CSSRadialShape.ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CSSRadialExtent.CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* CSSRadialExtent.FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CSSRadialExtent.CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* CSSRadialExtent.FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                const colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* CSSImageType.RADIAL_GRADIENT */ 
        };
    };
    const prefixRadialGradient = (context, tokens)=>{
        let shape = 0 /* CSSRadialShape.CIRCLE */ ;
        let size = 3 /* CSSRadialExtent.FARTHEST_CORNER */ ;
        const stops = [];
        const position = [];
        parseFunctionArgs(tokens).forEach((arg, i)=>{
            let isColorStop = true;
            if (i === 0) isColorStop = arg.reduce((acc, token)=>{
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce((acc, token)=>{
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CSSRadialShape.CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* CSSRadialShape.ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CSSRadialExtent.CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* CSSRadialExtent.FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CSSRadialExtent.CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* CSSRadialExtent.FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                const colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* CSSImageType.RADIAL_GRADIENT */ 
        };
    };
    const isLinearGradient = (background)=>{
        return background.type === 1 /* CSSImageType.LINEAR_GRADIENT */ ;
    };
    const isRadialGradient = (background)=>{
        return background.type === 2 /* CSSImageType.RADIAL_GRADIENT */ ;
    };
    const image = {
        name: 'image',
        parse: (context, value)=>{
            if (value.type === 22 /* TokenType.URL_TOKEN */ ) {
                const image = {
                    url: value.value,
                    type: 0 /* CSSImageType.URL */ 
                };
                context.cache.addImage(value.value);
                return image;
            }
            if (value.type === 18 /* TokenType.FUNCTION */ ) {
                const imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error(`Attempting to parse an unsupported image function "${value.name}"`);
                return imageFunction(context, value.values);
            }
            throw new Error(`Unsupported image type ${value.type}`);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* TokenType.IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* TokenType.FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    const SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    const backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        prefix: false,
        parse: (context, tokens)=>{
            if (tokens.length === 0) return [];
            const first = tokens[0];
            if (first.type === 20 /* TokenType.IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter((value)=>nonFunctionArgSeparator(value) && isSupportedImage(value)).map((value)=>image.parse(context, value));
        }
    };
    const backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return tokens.map((token)=>{
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* BACKGROUND_ORIGIN.PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* BACKGROUND_ORIGIN.CONTENT_BOX */ ;
                }
                return 0 /* BACKGROUND_ORIGIN.BORDER_BOX */ ;
            });
        }
    };
    const backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        prefix: false,
        parse: (_context, tokens)=>{
            return parseFunctionArgs(tokens).map((values)=>{
                // Convert calc() to length-percentage tokens, keep other length-percentage as is
                return values.map((value)=>{
                    if (isCalcFunction(value)) // For calc() at parse time, we can't know the container size
                    // So we evaluate with 0 context which will work for px-only calc()
                    // Percentage-based calc() will need special handling
                    return evaluateCalcToLengthPercentage(value, 0);
                    return isLengthPercentage(value) ? value : null;
                }).filter((v)=>v !== null);
            }).map(parseLengthPercentageTuple);
        }
    };
    const backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return parseFunctionArgs(tokens).map((values)=>values.filter(isIdentToken).map((token)=>token.value).join(' ')).map(parseBackgroundRepeat);
        }
    };
    const parseBackgroundRepeat = (value)=>{
        switch(value){
            case 'no-repeat':
                return 1 /* BACKGROUND_REPEAT.NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* BACKGROUND_REPEAT.REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* BACKGROUND_REPEAT.REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* BACKGROUND_REPEAT.REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    const backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return parseFunctionArgs(tokens).map((values)=>values.filter(isBackgroundSizeInfoToken));
        }
    };
    const isBackgroundSizeInfoToken = (value)=>isIdentToken(value) || isLengthPercentage(value);
    const borderColorForSide = (side)=>({
            name: `border-${side}-color`,
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
            format: 'color'
        });
    const borderTopColor = borderColorForSide('top');
    const borderRightColor = borderColorForSide('right');
    const borderBottomColor = borderColorForSide('bottom');
    const borderLeftColor = borderColorForSide('left');
    const borderRadiusForSide = (side)=>({
            name: `border-radius-${side}`,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* PropertyDescriptorParsingType.LIST */ ,
            parse: (_context, tokens)=>parseLengthPercentageTuple(tokens.filter(isLengthPercentage))
        });
    const borderTopLeftRadius = borderRadiusForSide('top-left');
    const borderTopRightRadius = borderRadiusForSide('top-right');
    const borderBottomRightRadius = borderRadiusForSide('bottom-right');
    const borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    const borderStyleForSide = (side)=>({
            name: `border-${side}-style`,
            initialValue: 'solid',
            prefix: false,
            type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
            parse: (_context, style)=>{
                switch(style){
                    case 'none':
                        return 0 /* BORDER_STYLE.NONE */ ;
                    case 'dashed':
                        return 2 /* BORDER_STYLE.DASHED */ ;
                    case 'dotted':
                        return 3 /* BORDER_STYLE.DOTTED */ ;
                    case 'double':
                        return 4 /* BORDER_STYLE.DOUBLE */ ;
                }
                return 1 /* BORDER_STYLE.SOLID */ ;
            }
        });
    const borderTopStyle = borderStyleForSide('top');
    const borderRightStyle = borderStyleForSide('right');
    const borderBottomStyle = borderStyleForSide('bottom');
    const borderLeftStyle = borderStyleForSide('left');
    const borderWidthForSide = (side)=>({
            name: `border-${side}-width`,
            initialValue: '0',
            type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
            prefix: false,
            parse: (_context, token)=>{
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        });
    const borderTopWidth = borderWidthForSide('top');
    const borderRightWidth = borderWidthForSide('right');
    const borderBottomWidth = borderWidthForSide('bottom');
    const borderLeftWidth = borderWidthForSide('left');
    const NONE = {
        type: 0 /* CLIP_PATH_TYPE.NONE */ 
    };
    /**
     * Parse a shape-radius token: <length-percentage> | closest-side | farthest-side.
     * Defaults to 'closest-side' when no tokens are provided.
     */ const parseShapeRadius = (tokens)=>{
        const [first] = tokens;
        if (!first) return 'closest-side';
        if (isIdentToken(first)) // Any unrecognised keyword (e.g. 'closest-corner') intentionally falls back to
        // 'closest-side' as the CSS spec requires unknown values to be treated as invalid
        // and the initial value of <shape-radius> is 'closest-side'.
        return first.value === 'farthest-side' ? 'farthest-side' : 'closest-side';
        return isLengthPercentage(first) ? first : 'closest-side';
    };
    /**
     * Parse a CSS <position> as (cx, cy), each as a LengthPercentage.
     *
     * Supports the **1–2 value** subset of the CSS `<position>` syntax.
     * The 4-value form (`at left 10px top 20px`) is not supported and will be
     * parsed on a best-effort basis.
     *
     * Axis assignment rules:
     *   - `left` / `right`  → x-axis (cx)
     *   - `top`  / `bottom` → y-axis (cy)
     *   - `center` or a <length-percentage> → fills the first unset axis, in order
     *
     * Examples:
     *   "at left"        → cx=0,    cy=50%   (left is x; y defaults to center)
     *   "at top"         → cx=50%,  cy=0     (top is y; x defaults to center)
     *   "at center 30%"  → cx=50%,  cy=30%
     *   "at 30% center"  → cx=30%,  cy=50%
     *   "at left top"    → cx=0,    cy=0
     *   "at top left"    → cx=0,    cy=0     (keyword order is irrelevant)
     *
     * Unset axes fall back to 50%.
     */ const parsePosition = (tokens)=>{
        let cx = null;
        let cy = null;
        for (const token of tokens){
            if (isIdentToken(token)) switch(token.value){
                case 'left':
                    cx = ZERO_LENGTH;
                    break;
                case 'right':
                    cx = HUNDRED_PERCENT;
                    break;
                case 'top':
                    cy = ZERO_LENGTH;
                    break;
                case 'bottom':
                    cy = HUNDRED_PERCENT;
                    break;
                case 'center':
                    // `center` fills whichever axis has not yet been claimed.
                    if (cx === null) cx = FIFTY_PERCENT;
                    else if (cy === null) cy = FIFTY_PERCENT;
                    break;
            }
            else if (isLengthPercentage(token)) {
                // Length-percentages are assigned in source order.
                if (cx === null) cx = token;
                else if (cy === null) cy = token;
            }
        }
        return {
            cx: cx ?? FIFTY_PERCENT,
            cy: cy ?? FIFTY_PERCENT
        };
    };
    /**
     * inset( <length-percentage>{1,4} [ round <'border-radius'> ]? )
     * The 1-4 shorthand follows the same expansion as margin/padding:
     *   1 value  → all four sides
     *   2 values → top/bottom | left/right
     *   3 values → top | left/right | bottom
     *   4 values → top | right | bottom | left
     * The optional `round` clause (border-radius) is parsed but ignored.
     */ const parseInset = (values)=>{
        const lengths = [];
        for (const token of values){
            if (token.type === 31 /* TokenType.WHITESPACE_TOKEN */ ) continue;
            if (isIdentToken(token) && token.value === 'round') break;
            if (isLengthPercentage(token)) lengths.push(token);
        }
        const v0 = lengths[0] ?? ZERO_LENGTH;
        const v1 = lengths[1] ?? v0;
        const v2 = lengths[2] ?? v0;
        const v3 = lengths[3] ?? v1;
        return {
            type: 1 /* CLIP_PATH_TYPE.INSET */ ,
            top: v0,
            right: v1,
            bottom: v2,
            left: v3
        };
    };
    /**
     * circle( [ <shape-radius> ]? [ at <position> ]? )
     */ const parseCircle = (values)=>{
        const nonWs = values.filter(nonWhiteSpace);
        const atIdx = nonWs.findIndex((t)=>isIdentWithValue(t, 'at'));
        const radiusTokens = atIdx === -1 ? nonWs : nonWs.slice(0, atIdx);
        const posTokens = atIdx === -1 ? [] : nonWs.slice(atIdx + 1);
        return {
            type: 2 /* CLIP_PATH_TYPE.CIRCLE */ ,
            radius: parseShapeRadius(radiusTokens),
            ...parsePosition(posTokens)
        };
    };
    /**
     * ellipse( [ <shape-radius>{2} ]? [ at <position> ]? )
     */ const parseEllipse = (values)=>{
        const nonWs = values.filter(nonWhiteSpace);
        const atIdx = nonWs.findIndex((t)=>isIdentWithValue(t, 'at'));
        const radiusTokens = atIdx === -1 ? nonWs : nonWs.slice(0, atIdx);
        const posTokens = atIdx === -1 ? [] : nonWs.slice(atIdx + 1);
        return {
            type: 3 /* CLIP_PATH_TYPE.ELLIPSE */ ,
            rx: parseShapeRadius(radiusTokens.slice(0, 1)),
            ry: parseShapeRadius(radiusTokens.slice(1, 2)),
            ...parsePosition(posTokens)
        };
    };
    /**
     * polygon( [ <fill-rule>, ]? [ <length-percentage> <length-percentage> ]# )
     * Each comma-separated group defines one vertex (x y).
     * A leading fill-rule keyword (nonzero/evenodd) is skipped.
     */ const parsePolygon = (values)=>{
        const args = parseFunctionArgs(values);
        const points = [];
        for (const arg of args){
            if (arg.length === 1 && isIdentToken(arg[0])) continue; // skip fill-rule
            const lengths = arg.filter(isLengthPercentage);
            if (lengths.length >= 2) points.push([
                lengths[0],
                lengths[1]
            ]);
        }
        return {
            type: 4 /* CLIP_PATH_TYPE.POLYGON */ ,
            points: points
        };
    };
    /**
     * path( [ <fill-rule>, ]? <string> )
     * The string value is the SVG path data (coordinates in the element's local space).
     */ const parsePath = (values)=>{
        const stringToken = values.find((t)=>t.type === 0 /* TokenType.STRING_TOKEN */ );
        if (!stringToken) return NONE;
        return {
            type: 5 /* CLIP_PATH_TYPE.PATH */ ,
            d: stringToken.value
        };
    };
    const clipPath = {
        name: 'clip-path',
        initialValue: 'none',
        prefix: false,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (isIdentToken(token) && token.value === 'none') return NONE;
            if (token.type === 18 /* TokenType.FUNCTION */ ) switch(token.name){
                case 'inset':
                    return parseInset(token.values);
                case 'circle':
                    return parseCircle(token.values);
                case 'ellipse':
                    return parseEllipse(token.values);
                case 'polygon':
                    return parsePolygon(token.values);
                case 'path':
                    return parsePath(token.values);
            }
            return NONE;
        }
    };
    const color = {
        name: `color`,
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
        format: 'color'
    };
    const direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, direction)=>{
            switch(direction){
                case 'rtl':
                    return 1 /* DIRECTION.RTL */ ;
                case 'ltr':
                default:
                    return 0 /* DIRECTION.LTR */ ;
            }
        }
    };
    const display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return tokens.filter(isIdentToken).reduce((bit, token)=>{
                return bit | parseDisplayValue$1(token.value);
            }, 0 /* DISPLAY.NONE */ );
        }
    };
    const parseDisplayValue$1 = (display)=>{
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* DISPLAY.BLOCK */ ;
            case 'inline':
                return 4 /* DISPLAY.INLINE */ ;
            case 'run-in':
                return 8 /* DISPLAY.RUN_IN */ ;
            case 'flow':
                return 16 /* DISPLAY.FLOW */ ;
            case 'flow-root':
                return 32 /* DISPLAY.FLOW_ROOT */ ;
            case 'table':
                return 64 /* DISPLAY.TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* DISPLAY.FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* DISPLAY.GRID */ ;
            case 'ruby':
                return 512 /* DISPLAY.RUBY */ ;
            case 'subgrid':
                return 1024 /* DISPLAY.SUBGRID */ ;
            case 'list-item':
                return 2048 /* DISPLAY.LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* DISPLAY.TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* DISPLAY.TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* DISPLAY.TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* DISPLAY.TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* DISPLAY.TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* DISPLAY.TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* DISPLAY.TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* DISPLAY.TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* DISPLAY.RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* DISPLAY.RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* DISPLAY.RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* DISPLAY.RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* DISPLAY.CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* DISPLAY.INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* DISPLAY.INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* DISPLAY.INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* DISPLAY.INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* DISPLAY.INLINE_GRID */ ;
        }
        return 0 /* DISPLAY.NONE */ ;
    };
    const float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, float)=>{
            switch(float){
                case 'left':
                    return 1 /* FLOAT.LEFT */ ;
                case 'right':
                    return 2 /* FLOAT.RIGHT */ ;
                case 'inline-start':
                    return 3 /* FLOAT.INLINE_START */ ;
                case 'inline-end':
                    return 4 /* FLOAT.INLINE_END */ ;
            }
            return 0 /* FLOAT.NONE */ ;
        }
    };
    const letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (token.type === 20 /* TokenType.IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* TokenType.NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* TokenType.DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    const lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, lineBreak)=>{
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    const lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* PropertyDescriptorParsingType.TOKEN_VALUE */ 
    };
    const computeLineHeight = (token, fontSize)=>{
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* TokenType.NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    const listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        prefix: false,
        parse: (context, token)=>{
            if (token.type === 20 /* TokenType.IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    const listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, position)=>{
            switch(position){
                case 'inside':
                    return 0 /* LIST_STYLE_POSITION.INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* LIST_STYLE_POSITION.OUTSIDE */ ;
            }
        }
    };
    const listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, type)=>{
            switch(type){
                case 'disc':
                    return 0 /* LIST_STYLE_TYPE.DISC */ ;
                case 'circle':
                    return 1 /* LIST_STYLE_TYPE.CIRCLE */ ;
                case 'square':
                    return 2 /* LIST_STYLE_TYPE.SQUARE */ ;
                case 'decimal':
                    return 3 /* LIST_STYLE_TYPE.DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* LIST_STYLE_TYPE.CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LIST_STYLE_TYPE.LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* LIST_STYLE_TYPE.UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LIST_STYLE_TYPE.LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LIST_STYLE_TYPE.LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* LIST_STYLE_TYPE.UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* LIST_STYLE_TYPE.ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* LIST_STYLE_TYPE.ARMENIAN */ ;
                case 'bengali':
                    return 13 /* LIST_STYLE_TYPE.BENGALI */ ;
                case 'cambodian':
                    return 14 /* LIST_STYLE_TYPE.CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* LIST_STYLE_TYPE.CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* LIST_STYLE_TYPE.CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* LIST_STYLE_TYPE.DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* LIST_STYLE_TYPE.ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* LIST_STYLE_TYPE.GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* LIST_STYLE_TYPE.GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* LIST_STYLE_TYPE.GURMUKHI */ ;
                case 'hebrew':
                    return 52 /* LIST_STYLE_TYPE.HEBREW */ ;
                case 'hiragana':
                    return 23 /* LIST_STYLE_TYPE.HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* LIST_STYLE_TYPE.HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* LIST_STYLE_TYPE.JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* LIST_STYLE_TYPE.JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* LIST_STYLE_TYPE.KANNADA */ ;
                case 'katakana':
                    return 28 /* LIST_STYLE_TYPE.KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* LIST_STYLE_TYPE.KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* LIST_STYLE_TYPE.KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LIST_STYLE_TYPE.LAO */ ;
                case 'lower-armenian':
                    return 35 /* LIST_STYLE_TYPE.LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* LIST_STYLE_TYPE.MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* LIST_STYLE_TYPE.MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* LIST_STYLE_TYPE.MYANMAR */ ;
                case 'oriya':
                    return 39 /* LIST_STYLE_TYPE.ORIYA */ ;
                case 'persian':
                    return 40 /* LIST_STYLE_TYPE.PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* LIST_STYLE_TYPE.TAMIL */ ;
                case 'telugu':
                    return 44 /* LIST_STYLE_TYPE.TELUGU */ ;
                case 'thai':
                    return 45 /* LIST_STYLE_TYPE.THAI */ ;
                case 'tibetan':
                    return 46 /* LIST_STYLE_TYPE.TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* LIST_STYLE_TYPE.UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* LIST_STYLE_TYPE.DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* LIST_STYLE_TYPE.DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* LIST_STYLE_TYPE.NONE */ ;
            }
        }
    };
    const marginForSide = (side)=>({
            name: `margin-${side}`,
            initialValue: '0',
            prefix: false,
            type: 4 /* PropertyDescriptorParsingType.TOKEN_VALUE */ 
        });
    const marginTop = marginForSide('top');
    const marginRight = marginForSide('right');
    const marginBottom = marginForSide('bottom');
    const marginLeft = marginForSide('left');
    const overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return tokens.filter(isIdentToken).map((overflow)=>{
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* OVERFLOW.HIDDEN */ ;
                    case 'scroll':
                        return 2 /* OVERFLOW.SCROLL */ ;
                    case 'clip':
                        return 3 /* OVERFLOW.CLIP */ ;
                    case 'auto':
                        return 4 /* OVERFLOW.AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* OVERFLOW.VISIBLE */ ;
                }
            });
        }
    };
    const overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, overflow)=>{
            switch(overflow){
                case 'break-word':
                    return "break-word" /* OVERFLOW_WRAP.BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* OVERFLOW_WRAP.NORMAL */ ;
            }
        }
    };
    const paddingForSide = (side)=>({
            name: `padding-${side}`,
            initialValue: '0',
            prefix: false,
            type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
            format: 'length-percentage'
        });
    const paddingTop = paddingForSide('top');
    const paddingRight = paddingForSide('right');
    const paddingBottom = paddingForSide('bottom');
    const paddingLeft = paddingForSide('left');
    const textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, textAlign)=>{
            switch(textAlign){
                case 'right':
                    return 2 /* TEXT_ALIGN.RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* TEXT_ALIGN.CENTER */ ;
                case 'left':
                default:
                    return 0 /* TEXT_ALIGN.LEFT */ ;
            }
        }
    };
    const position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, position)=>{
            switch(position){
                case 'relative':
                    return 1 /* POSITION.RELATIVE */ ;
                case 'absolute':
                    return 2 /* POSITION.ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* POSITION.FIXED */ ;
                case 'sticky':
                    return 4 /* POSITION.STICKY */ ;
            }
            return 0 /* POSITION.STATIC */ ;
        }
    };
    const textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        prefix: false,
        parse: (context, tokens)=>{
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map((values)=>{
                const shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                let c = 0;
                for(let i = 0; i < values.length; i++){
                    const token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    const textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, textTransform)=>{
            switch(textTransform){
                case 'uppercase':
                    return 2 /* TEXT_TRANSFORM.UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* TEXT_TRANSFORM.LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* TEXT_TRANSFORM.CAPITALIZE */ ;
            }
            return 0 /* TEXT_TRANSFORM.NONE */ ;
        }
    };
    const transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (token.type === 20 /* TokenType.IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* TokenType.FUNCTION */ ) {
                const transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error(`Attempting to parse an unsupported transform function "${token.name}"`);
                return transformFunction(_context, token.values);
            }
            return null;
        }
    };
    const matrix = (_context, args)=>{
        const values = args.filter((arg)=>arg.type === 17 /* TokenType.NUMBER_TOKEN */ ).map((arg)=>arg.number);
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    const matrix3d = (_context, args)=>{
        const values = args.filter((arg)=>arg.type === 17 /* TokenType.NUMBER_TOKEN */ ).map((arg)=>arg.number);
        const [a1, b1, {}, {}, a2, b2, {}, {}, {}, {}, {}, {}, a4, b4] = values;
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    const rotate$1 = (context, args)=>{
        if (args.length !== 1) return null;
        const arg = args[0];
        let radians = 0;
        if (arg.type === 17 /* TokenType.NUMBER_TOKEN */  && arg.number === 0) radians = 0;
        else if (arg.type === 15 /* TokenType.DIMENSION_TOKEN */ ) radians = angle.parse(context, arg);
        else return null;
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        return [
            cos,
            sin,
            -sin,
            cos,
            0,
            0
        ];
    };
    const SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d,
        rotate: rotate$1
    };
    const DEFAULT_VALUE = {
        type: 16 /* TokenType.PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    const DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    const transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            const origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    const rotate = {
        name: 'rotate',
        initialValue: 'none',
        prefix: false,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (token.type === 20 /* TokenType.IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 17 /* TokenType.NUMBER_TOKEN */ ) {
                if (token.number === 0) return 0;
            }
            if (token.type === 15 /* TokenType.DIMENSION_TOKEN */ ) {
                // Parse angle and convert to degrees for storage
                const radians = angle.parse(_context, token);
                // Store as degrees for consistency
                return radians * 180 / Math.PI;
            }
            return null;
        }
    };
    const visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, visibility)=>{
            switch(visibility){
                case 'hidden':
                    return 1 /* VISIBILITY.HIDDEN */ ;
                case 'collapse':
                    return 2 /* VISIBILITY.COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBILITY.VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    const wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, wordBreak)=>{
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    const zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (token.type === 20 /* TokenType.IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error(`Invalid z-index number parsed`);
        }
    };
    const time = {
        name: 'time',
        parse: (_context, value)=>{
            if (value.type === 15 /* TokenType.DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error(`Unsupported time type`);
        }
    };
    const opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        prefix: false,
        parse: (_context, token)=>{
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    const textDecorationColor = {
        name: `text-decoration-color`,
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
        format: 'color'
    };
    const textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return tokens.filter(isIdentToken).map((token)=>{
                switch(token.value){
                    case 'underline':
                        return 1 /* TEXT_DECORATION_LINE.UNDERLINE */ ;
                    case 'overline':
                        return 2 /* TEXT_DECORATION_LINE.OVERLINE */ ;
                    case 'line-through':
                        return 3 /* TEXT_DECORATION_LINE.LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* TEXT_DECORATION_LINE.BLINK */ ;
                }
                return 0 /* TEXT_DECORATION_LINE.NONE */ ;
            }).filter((line)=>line !== 0 /* TEXT_DECORATION_LINE.NONE */ );
        }
    };
    const textDecorationStyle = {
        name: 'text-decoration-style',
        initialValue: 'solid',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, style)=>{
            switch(style){
                case 'double':
                    return 1 /* TEXT_DECORATION_STYLE.DOUBLE */ ;
                case 'dotted':
                    return 2 /* TEXT_DECORATION_STYLE.DOTTED */ ;
                case 'dashed':
                    return 3 /* TEXT_DECORATION_STYLE.DASHED */ ;
                case 'wavy':
                    return 4 /* TEXT_DECORATION_STYLE.WAVY */ ;
                case 'solid':
                default:
                    return 0 /* TEXT_DECORATION_STYLE.SOLID */ ;
            }
        }
    };
    const textDecorationThickness = {
        name: 'text-decoration-thickness',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (isIdentToken(token)) switch(token.value){
                case 'auto':
                    return 'auto';
                case 'from-font':
                    return 'from-font';
            }
            if (isDimensionToken(token)) // Convert to pixels
            return token.number;
            // Default to auto
            return 'auto';
        }
    };
    const textUnderlineOffset = {
        name: 'text-underline-offset',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            if (isIdentToken(token)) {
                if (token.value === 'auto') return 'auto';
            }
            if (isDimensionToken(token)) // Return pixel value
            return token.number;
            // Default to auto
            return 'auto';
        }
    };
    const fontFamily = {
        name: `font-family`,
        initialValue: '',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            const accumulator = [];
            const results = [];
            tokens.forEach((token)=>{
                switch(token.type){
                    case 20 /* TokenType.IDENT_TOKEN */ :
                    case 0 /* TokenType.STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* TokenType.NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* TokenType.COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map((result)=>result.indexOf(' ') === -1 ? result : `'${result}'`);
        }
    };
    const fontSize = {
        name: `font-size`,
        initialValue: '0',
        prefix: false,
        type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
        format: 'length'
    };
    const fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        prefix: false,
        parse: (_context, token)=>{
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    const fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        prefix: false,
        parse: (_context, tokens)=>{
            return tokens.filter(isIdentToken).map((token)=>token.value);
        }
    };
    const fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, overflow)=>{
            switch(overflow){
                case 'oblique':
                    return "oblique" /* FONT_STYLE.OBLIQUE */ ;
                case 'italic':
                    return "italic" /* FONT_STYLE.ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* FONT_STYLE.NORMAL */ ;
            }
        }
    };
    const contains = (bit, value)=>(bit & value) !== 0;
    const content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        prefix: false,
        parse: (_context, tokens)=>{
            if (tokens.length === 0) return [];
            const first = tokens[0];
            if (first.type === 20 /* TokenType.IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    const counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            if (tokens.length === 0) return null;
            const first = tokens[0];
            if (first.type === 20 /* TokenType.IDENT_TOKEN */  && first.value === 'none') return null;
            const increments = [];
            const filtered = tokens.filter(nonWhiteSpace);
            for(let i = 0; i < filtered.length; i++){
                const counter = filtered[i];
                const next = filtered[i + 1];
                if (counter.type === 20 /* TokenType.IDENT_TOKEN */ ) {
                    const increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    const counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            if (tokens.length === 0) return [];
            const resets = [];
            const filtered = tokens.filter(nonWhiteSpace);
            for(let i = 0; i < filtered.length; i++){
                const counter = filtered[i];
                const next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    const reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    const duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (context, tokens)=>{
            return tokens.filter(isDimensionToken).map((token)=>time.parse(context, token));
        }
    };
    const quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            if (tokens.length === 0) return null;
            const first = tokens[0];
            if (first.type === 20 /* TokenType.IDENT_TOKEN */  && first.value === 'none') return null;
            const quotes = [];
            const filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(let i = 0; i < filtered.length; i += 2){
                const open = filtered[i].value;
                const close = filtered[i + 1].value;
                quotes.push({
                    open: open,
                    close: close
                });
            }
            return quotes;
        }
    };
    const getQuote = (quotes, depth, open)=>{
        if (!quotes) return '';
        const quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    const boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        prefix: false,
        parse: (context, tokens)=>{
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map((values)=>{
                const shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                let c = 0;
                for(let i = 0; i < values.length; i++){
                    const token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    const paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            const DEFAULT_VALUE = [
                0 /* PAINT_ORDER_LAYER.FILL */ ,
                1 /* PAINT_ORDER_LAYER.STROKE */ ,
                2 /* PAINT_ORDER_LAYER.MARKERS */ 
            ];
            const layers = [];
            tokens.filter(isIdentToken).forEach((token)=>{
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* PAINT_ORDER_LAYER.STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* PAINT_ORDER_LAYER.FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* PAINT_ORDER_LAYER.MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach((value)=>{
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    const webkitTextStrokeColor = {
        name: `-webkit-text-stroke-color`,
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ ,
        format: 'color'
    };
    const webkitTextStrokeWidth = {
        name: `-webkit-text-stroke-width`,
        initialValue: '0',
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        prefix: false,
        parse: (_context, token)=>{
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    /**
     * -webkit-line-clamp property descriptor
     * Used with display: -webkit-box and -webkit-box-orient: vertical
     * to limit text to a specific number of lines
     */ const webkitLineClamp = {
        name: '-webkit-line-clamp',
        initialValue: 'none',
        prefix: true,
        type: 0 /* PropertyDescriptorParsingType.VALUE */ ,
        parse: (_context, token)=>{
            // 'none' means no line clamping
            if (token.type === 20 /* TokenType.IDENT_TOKEN */  && token.value === 'none') return 0;
            // Number value specifies the number of lines
            if (token.type === 17 /* TokenType.NUMBER_TOKEN */ ) return Math.max(0, Math.floor(token.number));
            // Default to 0 (no clamping)
            return 0;
        }
    };
    const objectFit = {
        name: 'objectFit',
        initialValue: 'fill',
        prefix: false,
        type: 1 /* PropertyDescriptorParsingType.LIST */ ,
        parse: (_context, tokens)=>{
            return tokens.filter(isIdentToken).reduce((bit, token)=>{
                return bit | parseDisplayValue(token.value);
            }, 0 /* OBJECT_FIT.FILL */ );
        }
    };
    const parseDisplayValue = (display)=>{
        switch(display){
            case 'contain':
                return 2 /* OBJECT_FIT.CONTAIN */ ;
            case 'cover':
                return 4 /* OBJECT_FIT.COVER */ ;
            case 'none':
                return 8 /* OBJECT_FIT.NONE */ ;
            case 'scale-down':
                return 16 /* OBJECT_FIT.SCALE_DOWN */ ;
        }
        return 0 /* OBJECT_FIT.FILL */ ;
    };
    const textOverflow = {
        name: 'text-overflow',
        initialValue: 'clip',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, textOverflow)=>{
            switch(textOverflow){
                case 'ellipsis':
                    return 1 /* TEXT_OVERFLOW.ELLIPSIS */ ;
                case 'clip':
                default:
                    return 0 /* TEXT_OVERFLOW.CLIP */ ;
            }
        }
    };
    exports1.IMAGE_RENDERING = void 0;
    (function(IMAGE_RENDERING) {
        IMAGE_RENDERING[IMAGE_RENDERING["AUTO"] = 0] = "AUTO";
        IMAGE_RENDERING[IMAGE_RENDERING["CRISP_EDGES"] = 1] = "CRISP_EDGES";
        IMAGE_RENDERING[IMAGE_RENDERING["PIXELATED"] = 2] = "PIXELATED";
        IMAGE_RENDERING[IMAGE_RENDERING["SMOOTH"] = 3] = "SMOOTH";
    })(exports1.IMAGE_RENDERING || (exports1.IMAGE_RENDERING = {}));
    const imageRendering = {
        name: 'image-rendering',
        initialValue: 'auto',
        prefix: false,
        type: 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ ,
        parse: (_context, value)=>{
            switch(value.toLowerCase()){
                case 'crisp-edges':
                case '-webkit-crisp-edges':
                case '-moz-crisp-edges':
                    return exports1.IMAGE_RENDERING.CRISP_EDGES;
                case 'pixelated':
                case '-webkit-optimize-contrast':
                    return exports1.IMAGE_RENDERING.PIXELATED;
                case 'smooth':
                case 'high-quality':
                    return exports1.IMAGE_RENDERING.SMOOTH;
                case 'auto':
                default:
                    return exports1.IMAGE_RENDERING.AUTO;
            }
        }
    };
    class CSSParsedDeclaration {
        constructor(context, declaration){
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.clipPath = parse(context, clipPath, declaration.clipPath);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            const overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, declaration.textDecorationColor ?? declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, declaration.textDecorationLine ?? declaration.textDecoration);
            this.textDecorationStyle = parse(context, textDecorationStyle, declaration.textDecorationStyle);
            this.textDecorationThickness = parse(context, textDecorationThickness, declaration.textDecorationThickness);
            this.textUnderlineOffset = parse(context, textUnderlineOffset, declaration.textUnderlineOffset);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.textOverflow = parse(context, textOverflow, declaration.textOverflow);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.rotate = parse(context, rotate, declaration.rotate);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.webkitLineClamp = parse(context, webkitLineClamp, declaration.webkitLineClamp);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
            this.objectFit = parse(context, objectFit, declaration.objectFit);
            this.imageRendering = parse(context, imageRendering, declaration.imageRendering);
        }
        isVisible() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBILITY.VISIBLE */ ;
        }
        isTransparent() {
            return isTransparent(this.backgroundColor);
        }
        isTransformed() {
            return this.transform !== null || this.rotate !== null;
        }
        isPositioned() {
            return this.position !== 0 /* POSITION.STATIC */ ;
        }
        isPositionedWithZIndex() {
            return this.isPositioned() && !this.zIndex.auto;
        }
        isFloating() {
            return this.float !== 0 /* FLOAT.NONE */ ;
        }
        isInlineLevel() {
            return contains(this.display, 4 /* DISPLAY.INLINE */ ) || contains(this.display, 33554432 /* DISPLAY.INLINE_BLOCK */ ) || contains(this.display, 268435456 /* DISPLAY.INLINE_FLEX */ ) || contains(this.display, 536870912 /* DISPLAY.INLINE_GRID */ ) || contains(this.display, 67108864 /* DISPLAY.INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* DISPLAY.INLINE_TABLE */ );
        }
    }
    class CSSParsedPseudoDeclaration {
        constructor(context, declaration){
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
    }
    class CSSParsedCounterDeclaration {
        constructor(context, declaration){
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
    }
    const parse = (context, descriptor, style)=>{
        const tokenizer = new Tokenizer();
        const value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        const parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* PropertyDescriptorParsingType.IDENT_VALUE */ :
                const token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* PropertyDescriptorParsingType.VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* PropertyDescriptorParsingType.LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* PropertyDescriptorParsingType.TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* PropertyDescriptorParsingType.TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        const length = parser.parseComponentValue();
                        return isLength(length) ? length : ZERO_LENGTH;
                    case 'length-percentage':
                        const value1 = parser.parseComponentValue();
                        return isLengthPercentage(value1) ? value1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    /**
     * DOM Node Type Guards
     * Extracted to break circular dependencies
     */ /**
     * Check if node is an Element
     */ const isElementNode = (node)=>node.nodeType === Node.ELEMENT_NODE;
    /**
     * Check if node is a Text node
     */ const isTextNode = (node)=>node.nodeType === Node.TEXT_NODE;
    /**
     * Check if element is an SVG element
     */ const isSVGElementNode = (element)=>typeof element.className === 'object';
    /**
     * Check if node is an HTML element
     */ const isHTMLElementNode = (node)=>isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    /**
     * Check if node is an LI element
     */ const isLIElement = (node)=>node.tagName === 'LI';
    /**
     * Check if node is an OL element
     */ const isOLElement = (node)=>node.tagName === 'OL';
    /**
     * Check if element is a custom element
     * Custom elements must have a hyphen and cannot be SVG elements
     */ const isCustomElement = (element)=>!isSVGElementNode(element) && element.tagName.indexOf('-') > 0;
    const elementDebuggerAttribute = 'data-html2canvas-debug';
    const getElementDebugType = (element)=>{
        if (typeof element.getAttribute !== 'function') return 0 /* DebuggerType.NONE */ ;
        const attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* DebuggerType.ALL */ ;
            case 'clone':
                return 2 /* DebuggerType.CLONE */ ;
            case 'parse':
                return 3 /* DebuggerType.PARSE */ ;
            case 'render':
                return 4 /* DebuggerType.RENDER */ ;
            default:
                return 0 /* DebuggerType.NONE */ ;
        }
    };
    const isDebugging = (element, type)=>{
        const elementType = getElementDebugType(element);
        return elementType === 1 /* DebuggerType.ALL */  || type === elementType;
    };
    /**
     * DOM Normalizer
     * Handles DOM side effects that need to happen before rendering
     * Extracted from ElementContainer to follow SRP
     */ /**
     * Normalize element styles for accurate rendering
     * This includes disabling animations and neutralizing transforms.
     */ class DOMNormalizer {
        /**
         * Normalize a single element and return original styles.
         *
         * ## Why we replace transforms with an identity value instead of "none"
         *
         * `getBoundingClientRect()` returns visual (post-transform) coordinates, so we
         * must neutralize any active transform before measuring element bounds.
         *
         * The naive approach of setting `transform: none` (or `rotate: none`) has a
         * critical side-effect: per **CSS Transforms Level 2**, an element whose
         * `transform` is non-none automatically becomes the **containing block** for
         * all of its `position: absolute` *and* `position: fixed` descendants.
         * Setting it to `none` destroys that role, causing children to resolve their
         * percentage dimensions and offsets against an unintended ancestor — which
         * produces completely wrong bounds.
         *
         * Solution: instead of removing the transform, we replace it with a visually
         * inert identity value:
         *
         * - `transform: scale(0.5)` → `transform: translate(0, 0)`
         *   - `translate(0, 0)` is an identity transform (no visual change, no layout shift).
         *   - `getBoundingClientRect()` returns the same layout-space coordinates as
         *     if there were no transform at all.
         *   - Because the value is still non-none, the element **remains a containing
         *     block** for both `position: absolute` and `position: fixed` descendants.
         *
         * - `rotate: 45deg` → `rotate: 0deg`
         *   - `0deg` is the identity rotation; `0deg ≠ none`, so the same containing-
         *     block guarantee holds.
         *
         * @param element - Element to normalize
         * @param styles - Parsed CSS styles
         * @returns Original styles map for restoration
         */ static normalizeElement(element, styles) {
            const originalStyles = {};
            if (!isHTMLElementNode(element)) return originalStyles;
            // Disable animations to capture static state
            if (styles.animationDuration.some((duration)=>duration > 0)) {
                originalStyles.animationDuration = element.style.animationDuration;
                element.style.animationDuration = '0s';
            }
            // Replace the actual transform with an identity translate so that:
            //   1. getBoundingClientRect() returns layout-space (unscaled/unrotated) coords.
            //   2. The element still satisfies "transform != none" and therefore keeps
            //      its role as a containing block for position:absolute / position:fixed
            //      descendants (CSS Transforms Level 2 §2.3).
            if (styles.transform !== null) {
                originalStyles.transform = element.style.transform;
                element.style.transform = 'translate(0, 0)';
            }
            // Same rationale for the standalone `rotate` property.
            // `rotate: 0deg` is an identity rotation with no visual effect.
            //
            // However, individual transform properties (`rotate`, `translate`, `scale`)
            // are part of CSS Transforms Level 2 and their containing-block guarantee
            // is not uniformly implemented across all browsers. To be safe, if `rotate`
            // is the only transform-like property active on this element, we also set
            // `transform: translate(0, 0)` so that the containing-block role is reliably
            // preserved via the well-supported `transform` property.
            if (styles.rotate !== null) {
                originalStyles.rotate = element.style.rotate;
                element.style.rotate = '0deg';
                // Individual transform properties (`rotate`, `translate`, `scale`) are
                // CSS Transforms Level 2 and their containing-block guarantee is not
                // uniformly implemented in all browsers. If `transform` was not already
                // set to translate(0,0) in the block above (i.e. this element has
                // `rotate` but no `transform`), we set it now so the containing-block
                // role is reliably established via the widely-supported `transform`
                // property – independently of browser support for individual props.
                if (originalStyles.transform === undefined) {
                    originalStyles.transform = element.style.transform;
                    element.style.transform = 'translate(0, 0)';
                }
            }
            return originalStyles;
        }
        /**
         * Restore element styles after rendering.
         *
         * @param element - Element to restore
         * @param originalStyles - Original styles to restore
         */ static restoreElement(element, originalStyles) {
            if (!isHTMLElementNode(element)) return;
            if (originalStyles.animationDuration !== undefined) element.style.animationDuration = originalStyles.animationDuration;
            if (originalStyles.transform !== undefined) element.style.transform = originalStyles.transform;
            if (originalStyles.rotate !== undefined) element.style.rotate = originalStyles.rotate;
        }
    }
    class ElementContainer {
        constructor(context, element, options = {}){
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* DebuggerType.PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, context.config.window.getComputedStyle(element, null));
            // Side effects moved to DOMNormalizer (can be disabled via options)
            const shouldNormalize = options.normalizeDom !== false; // Default: true
            if (shouldNormalize && isHTMLElementNode(element)) {
                this.originalStyles = DOMNormalizer.normalizeElement(element, this.styles);
                this.originalElement = element; // Save reference for restoration
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* DebuggerType.RENDER */ )) this.flags |= 16 /* FLAGS.DEBUG_RENDER */ ;
        }
        /**
         * Restore original element styles (if normalized)
         * Call this after rendering is complete to clean up DOM state
         */ restore() {
            if (this.originalStyles && this.originalElement) {
                DOMNormalizer.restoreElement(this.originalElement, this.originalStyles);
                // Clear references to prevent memory leaks
                this.originalStyles = undefined;
                this.originalElement = undefined;
            }
        }
        /**
         * Recursively restore all elements in the tree
         * Call this on the root container after rendering is complete
         */ restoreTree() {
            this.restore();
            // Recursively restore all child elements
            for (const child of this.elements)child.restoreTree();
        }
    }
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    const testRangeBounds = (document1)=>{
        const TEST_HEIGHT = 123;
        if (document1.createRange) {
            const range = document1.createRange();
            if (range.getBoundingClientRect) {
                const testElement = document1.createElement('boundtest');
                testElement.style.height = `${TEST_HEIGHT}px`;
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                const rangeBounds = range.getBoundingClientRect();
                const rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    const testIOSLineBreak = (document1)=>{
        const testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        const range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        const node = testElement.firstChild;
        const textList = toCodePoints$1(node.data).map((i)=>fromCodePoint$1(i));
        let offset = 0;
        let prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        const supports = textList.every((text, i)=>{
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            const rect = range.getBoundingClientRect();
            offset += text.length;
            const boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    const testCORS = ()=>typeof new Image().crossOrigin !== 'undefined';
    const testResponseType = ()=>typeof new XMLHttpRequest().responseType === 'string';
    const testSVG = (document1)=>{
        const img = new Image();
        const canvas = document1.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>`;
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    const isGreenPixel = (data)=>data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    const testForeignObject = (document1)=>{
        const canvas = document1.createElement('canvas');
        const size = 100;
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        const img = new Image();
        const greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        const svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then((img)=>{
            ctx.drawImage(img, 0, 0);
            const data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            const node = document1.createElement('div');
            node.style.backgroundImage = `url(${greenImageSrc})`;
            node.style.height = `${size}px`;
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then((img)=>{
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(()=>false);
    };
    const createForeignObjectSVG = (width, height, x, y, node)=>{
        const xmlns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(xmlns, 'svg');
        const foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    const loadSerializedSVG$1 = (svg)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = reject;
            img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(svg))}`;
        });
    };
    const FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            const value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            const value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value
            });
            return value;
        },
        get SUPPORT_SVG_DRAWING () {
            const value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value
            });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            const value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value
            });
            return value;
        },
        get SUPPORT_CORS_IMAGES () {
            const value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value
            });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE () {
            const value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value
            });
            return value;
        },
        get SUPPORT_CORS_XHR () {
            const value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value
            });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            const value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value
            });
            return value;
        }
    };
    class TextBounds {
        constructor(text, bounds){
            this.text = text;
            this.bounds = bounds;
        }
    }
    const parseTextBounds = (context, value, styles, node)=>{
        const textList = breakText(value, styles);
        const textBounds = [];
        let offset = 0;
        textList.forEach((text)=>{
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    const clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        const subSegments = segmentGraphemes(text);
                        let subOffset = 0;
                        subSegments.forEach((subSegment)=>{
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset + offset, subSegment.length).getClientRects())));
                            subOffset += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    const replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    const getWrapperBounds = (context, node)=>{
        const ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            const wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            const parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                const bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    const createRange = (node, offset, length)=>{
        const ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        const range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    const segmentGraphemes = (value)=>{
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            const segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            return Array.from(segmenter.segment(value)).map((segment)=>segment.segment);
        }
        return splitGraphemes(value);
    };
    const segmentWords = (value, styles)=>{
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            const segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            return Array.from(segmenter.segment(value)).map((segment)=>segment.segment);
        }
        return breakWords(value, styles);
    };
    const breakText = (value, styles)=>{
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    const wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    const breakWords = (str, styles)=>{
        const breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* OVERFLOW_WRAP.BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        const words = [];
        let bk;
        while(!(bk = breaker.next()).done)if (bk.value) {
            const value = bk.value.slice();
            const codePoints = toCodePoints$1(value);
            let word = '';
            codePoints.forEach((codePoint)=>{
                if (wordSeparators.indexOf(codePoint) === -1) word += fromCodePoint$1(codePoint);
                else {
                    if (word.length) words.push(word);
                    words.push(fromCodePoint$1(codePoint));
                    word = '';
                }
            });
            if (word.length) words.push(word);
        }
        return words;
    };
    class TextContainer {
        constructor(context, node, styles){
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
    }
    const transform = (text, transform)=>{
        switch(transform){
            case 1 /* TEXT_TRANSFORM.LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* TEXT_TRANSFORM.CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* TEXT_TRANSFORM.UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    const CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    const capitalize = (m, p1, p2)=>{
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    class ImageElementContainer extends ElementContainer {
        constructor(context, img){
            super(context, img);
            this.src = img.currentSrc || img.src;
            this.intrinsicWidth = img.naturalWidth;
            this.intrinsicHeight = img.naturalHeight;
            this.context.cache.addImage(this.src);
        }
    }
    class CanvasElementContainer extends ElementContainer {
        constructor(context, canvas){
            super(context, canvas);
            this.canvas = canvas;
            this.intrinsicWidth = canvas.width;
            this.intrinsicHeight = canvas.height;
        }
    }
    class SVGElementContainer extends ElementContainer {
        constructor(context, img){
            super(context, img);
            const s = new XMLSerializer();
            const bounds = parseBounds(context, img);
            img.setAttribute('width', `${bounds.width}px`);
            img.setAttribute('height', `${bounds.height}px`);
            this.svg = `data:image/svg+xml,${encodeURIComponent(s.serializeToString(img))}`;
            this.intrinsicWidth = img.width.baseVal.value;
            this.intrinsicHeight = img.height.baseVal.value;
            this.context.cache.addImage(this.svg);
        }
    }
    class LIElementContainer extends ElementContainer {
        constructor(context, element){
            super(context, element);
            this.value = element.value;
        }
    }
    class OLElementContainer extends ElementContainer {
        constructor(context, element){
            super(context, element);
            this.start = element.start;
            this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
        }
    }
    const CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* TokenType.DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    const RADIO_BORDER_RADIUS = [
        {
            type: 16 /* TokenType.PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    const reformatInputBounds = (bounds)=>{
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    const getInputValue = (node)=>{
        const value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    const isPlaceholder = (node)=>{
        return node.value.length === 0 && !!node.placeholder;
    };
    const CHECKBOX = 'checkbox';
    const RADIO = 'radio';
    const PASSWORD = 'password';
    const INPUT_COLOR = 0x2a2a2aff;
    // Default placeholder color (similar to browsers: rgba(117, 117, 117, 1) or #757575)
    const PLACEHOLDER_COLOR = 0x757575ff;
    class InputElementContainer extends ElementContainer {
        constructor(context, input){
            super(context, input);
            this.type = input.type.toLowerCase();
            this.checked = input.checked;
            this.value = getInputValue(input);
            this.isPlaceholder = isPlaceholder(input);
            if (this.type === CHECKBOX || this.type === RADIO) {
                this.styles.backgroundColor = 0xdededeff;
                this.styles.borderTopColor = this.styles.borderRightColor = this.styles.borderBottomColor = this.styles.borderLeftColor = 0xa5a5a5ff;
                this.styles.borderTopWidth = this.styles.borderRightWidth = this.styles.borderBottomWidth = this.styles.borderLeftWidth = 1;
                this.styles.borderTopStyle = this.styles.borderRightStyle = this.styles.borderBottomStyle = this.styles.borderLeftStyle = 1 /* BORDER_STYLE.SOLID */ ;
                this.styles.backgroundClip = [
                    0 /* BACKGROUND_CLIP.BORDER_BOX */ 
                ];
                this.styles.backgroundOrigin = [
                    0 /* BACKGROUND_ORIGIN.BORDER_BOX */ 
                ];
                this.bounds = reformatInputBounds(this.bounds);
            }
            switch(this.type){
                case CHECKBOX:
                    this.styles.borderTopRightRadius = this.styles.borderTopLeftRadius = this.styles.borderBottomRightRadius = this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    this.styles.borderTopRightRadius = this.styles.borderTopLeftRadius = this.styles.borderBottomRightRadius = this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
        }
    }
    class SelectElementContainer extends ElementContainer {
        constructor(context, element){
            super(context, element);
            const option = element.options[element.selectedIndex || 0];
            this.value = option ? option.text || '' : '';
        }
    }
    class TextareaElementContainer extends ElementContainer {
        constructor(context, element){
            super(context, element);
            this.value = element.value;
        }
    }
    class IFrameElementContainer extends ElementContainer {
        constructor(context, iframe, parseTreeFn){
            super(context, iframe);
            this.src = iframe.src;
            this.width = parseInt(iframe.width, 10) || 0;
            this.height = parseInt(iframe.height, 10) || 0;
            this.backgroundColor = this.styles.backgroundColor;
            this.parseTreeFn = parseTreeFn;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement && this.parseTreeFn) {
                    this.tree = this.parseTreeFn(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    const documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    const bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
        }
    }
    const LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    const parseNodeTree = (context, node, parent, root)=>{
        for(let childNode = node.firstChild, nextNode; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            // Fixes #2238 #1624 - Fix the issue of TextNode content being overlooked in rendering due to being perceived as blank by trim().
            if (isTextNode(childNode) && childNode.data.length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach((childNode)=>parseNodeTree(context, childNode, parent, root));
                else {
                    const container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* FLAGS.CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* FLAGS.CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* FLAGS.IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    const createContainer = (context, element)=>{
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element, parseTree);
        return new ElementContainer(context, element);
    };
    const parseTree = (context, element)=>{
        const container = createContainer(context, element);
        container.flags |= 4 /* FLAGS.CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    const createsRealStackingContext = (node, container, root)=>{
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    const createsStackingContext = (styles)=>{
        // Positioned and floating elements create stacking contexts
        if (styles.isPositioned() || styles.isFloating()) return true;
        // Fix for Issue #137: Inline-level containers (inline-flex, inline-block, etc.)
        // should create stacking contexts to prevent their children from being added
        // to the parent's stacking context, which causes rendering order issues
        return contains(styles.display, 268435456 /* DISPLAY.INLINE_FLEX */ ) || contains(styles.display, 33554432 /* DISPLAY.INLINE_BLOCK */ ) || contains(styles.display, 536870912 /* DISPLAY.INLINE_GRID */ ) || contains(styles.display, 134217728 /* DISPLAY.INLINE_TABLE */ );
    };
    // Type guards moved to node-type-guards.ts and re-exported above
    const isInputElement = (node)=>node.tagName === 'INPUT';
    const isHTMLElement = (node)=>node.tagName === 'HTML';
    const isSVGElement = (node)=>node.tagName === 'svg';
    const isBodyElement = (node)=>node.tagName === 'BODY';
    const isCanvasElement = (node)=>node.tagName === 'CANVAS';
    const isVideoElement = (node)=>node.tagName === 'VIDEO';
    const isImageElement = (node)=>node.tagName === 'IMG';
    const isIFrameElement = (node)=>node.tagName === 'IFRAME';
    const isStyleElement = (node)=>node.tagName === 'STYLE';
    const isScriptElement = (node)=>node.tagName === 'SCRIPT';
    const isTextareaElement = (node)=>node.tagName === 'TEXTAREA';
    const isSelectElement = (node)=>node.tagName === 'SELECT';
    const isSlotElement = (node)=>node.tagName === 'SLOT';
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    // isCustomElement moved to node-type-guards.ts and re-exported above
    class CounterState {
        constructor(){
            this.counters = {};
        }
        getCounterValue(name) {
            const counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        }
        getCounterValues(name) {
            const counter = this.counters[name];
            return counter ? counter : [];
        }
        pop(counters) {
            counters.forEach((counter)=>this.counters[counter].pop());
        }
        parse(style) {
            const counterIncrement = style.counterIncrement;
            const counterReset = style.counterReset;
            let canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach((entry)=>{
                const counter = this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            const counterNames = [];
            if (canReset) counterReset.forEach((entry)=>{
                let counter = this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        }
    }
    const ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    const ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    const HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    const GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    const createAdditiveCounter = (value, min, max, symbols, fallback, suffix)=>{
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce((string, integer, index)=>{
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    const createCounterStyleWithSymbolResolver = (value, codePointRangeLength, isNumeric, resolver)=>{
        let string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    const createCounterStyleFromRange = (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix)=>{
        const codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, (codePoint)=>fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart)) + suffix);
    };
    const createCounterStyleFromSymbols = (value, symbols, suffix = '. ')=>{
        const codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, (codePoint)=>symbols[Math.floor(codePoint % codePointRangeLength)]) + suffix;
    };
    const CJK_ZEROS = 1;
    const CJK_TEN_COEFFICIENTS = 2;
    const CJK_TEN_HIGH_COEFFICIENTS = 4;
    const CJK_HUNDRED_COEFFICIENTS = 8;
    const createCJKCounter = (value, numbers, multipliers, negativeSign, suffix, flags)=>{
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* LIST_STYLE_TYPE.CJK_DECIMAL */ , suffix.length > 0);
        let tmp = Math.abs(value);
        let string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(let digit = 0; tmp > 0 && digit <= 4; digit++){
            const coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    const CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    const CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    const JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    const KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    const createCounterText = (value, type, appendSuffix)=>{
        const defaultSuffix = appendSuffix ? '. ' : '';
        const cjkSuffix = appendSuffix ? "\u3001" : '';
        const koreanSuffix = appendSuffix ? ', ' : '';
        const spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* LIST_STYLE_TYPE.DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* LIST_STYLE_TYPE.CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* LIST_STYLE_TYPE.SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO */ :
                const string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? `0${string}` : string;
            case 4 /* LIST_STYLE_TYPE.CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LIST_STYLE_TYPE.LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* LIST_STYLE_TYPE.DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* LIST_STYLE_TYPE.UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* LIST_STYLE_TYPE.DECIMAL */ , defaultSuffix);
            case 8 /* LIST_STYLE_TYPE.LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LIST_STYLE_TYPE.LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* LIST_STYLE_TYPE.UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* LIST_STYLE_TYPE.ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* LIST_STYLE_TYPE.ARMENIAN */ :
            case 49 /* LIST_STYLE_TYPE.UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* LIST_STYLE_TYPE.DECIMAL */ , defaultSuffix);
            case 35 /* LIST_STYLE_TYPE.LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* LIST_STYLE_TYPE.DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* LIST_STYLE_TYPE.BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* LIST_STYLE_TYPE.CAMBODIAN */ :
            case 30 /* LIST_STYLE_TYPE.KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* LIST_STYLE_TYPE.CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* LIST_STYLE_TYPE.CJK_IDEOGRAPHIC */ :
            case 48 /* LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* LIST_STYLE_TYPE.JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* LIST_STYLE_TYPE.JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* LIST_STYLE_TYPE.DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* LIST_STYLE_TYPE.GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* LIST_STYLE_TYPE.DECIMAL */ , defaultSuffix);
            case 21 /* LIST_STYLE_TYPE.GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* LIST_STYLE_TYPE.GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 52 /* LIST_STYLE_TYPE.HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* LIST_STYLE_TYPE.DECIMAL */ , defaultSuffix);
            case 23 /* LIST_STYLE_TYPE.HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* LIST_STYLE_TYPE.HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* LIST_STYLE_TYPE.KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* LIST_STYLE_TYPE.KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* LIST_STYLE_TYPE.KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LIST_STYLE_TYPE.LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* LIST_STYLE_TYPE.MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* LIST_STYLE_TYPE.MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* LIST_STYLE_TYPE.ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* LIST_STYLE_TYPE.PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* LIST_STYLE_TYPE.TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* LIST_STYLE_TYPE.TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* LIST_STYLE_TYPE.THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* LIST_STYLE_TYPE.TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* LIST_STYLE_TYPE.DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    const IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    /**
     * Find the parent ShadowRoot of an element, if any
     * @param element - The element to check
     * @returns The parent ShadowRoot or null
     */ const findParentShadowRoot = (element)=>{
        let current = element;
        while(current){
            // Check if we've reached a shadow root boundary
            if (current.parentNode && current.parentNode.host) return current.parentNode;
            // Use getRootNode to check if we're in a shadow root
            const root = current.getRootNode();
            if (root && root !== current.ownerDocument && root.host) return root;
            current = current.parentNode;
        }
        return null;
    };
    class DocumentCloner {
        constructor(context, element, options){
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            // Auto-detect Shadow Root if not explicitly provided
            if (!this.options.iframeContainer) {
                const shadowRoot = findParentShadowRoot(element);
                if (shadowRoot) this.options.iframeContainer = shadowRoot;
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        toIFrame(ownerDocument, windowSize) {
            const iframe = createIFrameContainer(ownerDocument, windowSize, this.options.iframeContainer);
            if (!iframe.contentWindow) throw new Error('Unable to find iframe window');
            const scrollX = ownerDocument.defaultView.pageXOffset;
            const scrollY = ownerDocument.defaultView.pageYOffset;
            const cloneWindow = iframe.contentWindow;
            const documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ const iframeLoad = iframeLoader(iframe).then(async ()=>{
                this.scrolledElements.forEach(restoreNodeScroll);
                if (cloneWindow) {
                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                    }
                }
                const onclone = this.options.onclone;
                const referenceElement = this.clonedReferenceElement;
                if (typeof referenceElement === 'undefined') throw new Error(`Error finding the ${this.referenceElement.nodeName} in the cloned document`);
                if (documentClone.fonts && documentClone.fonts.ready) await documentClone.fonts.ready;
                if (/(AppleWebKit)/g.test(navigator.userAgent)) await imagesReady(documentClone);
                if (typeof onclone === 'function') return Promise.resolve().then(()=>onclone(documentClone, referenceElement)).then(()=>iframe);
                return iframe;
            });
            /**
             * The baseURI of the document will be lost after documentClone.open().
             * We save it before open() to preserve the original base URI for resource resolution.
             * */ const baseUri = documentClone.baseURI;
            documentClone.open();
            const rawHTML = serializeDoctype(document.doctype) + '<html></html>';
            try {
                // Fixing "This document requires 'TrustedHTML' assignment. The action has been blocked." error.
                // Reuse existing policy when present (e.g. second html2canvas call) to avoid createPolicy duplicate-name throw.
                const ownerWindow = this.referenceElement.ownerDocument?.defaultView;
                const trustedTypesFactory = ownerWindow && ownerWindow.trustedTypes;
                let policy = trustedTypesFactory?.getPolicy?.('html2canvas-pro');
                if (!policy && trustedTypesFactory) policy = trustedTypesFactory.createPolicy('html2canvas-pro', {
                    createHTML: (string)=>string
                });
                if (policy) documentClone.write(policy.createHTML(rawHTML));
                else documentClone.write(rawHTML);
            } catch (_e) {
                documentClone.write(rawHTML);
            }
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            /**
             * IMPORTANT: documentClone.close() MUST be called BEFORE adoptNode().
             *
             * In Chrome, calling adoptNode() while the document is still "open"
             * (between document.open() and document.close()) causes CSS rules with
             * uppercase characters in class names (e.g. ".MyClass") to not match
             * correctly. Chrome's CSS engine only enters a fully-resolved matching
             * mode once the document is closed.
             *
             * Correct order: open() → write() → close() → adoptNode() → replaceChild()
             *
             * Timing: close() queues the iframe 'load' event; because JS is single-threaded,
             * the synchronous adoptNode() and replaceChild() below complete before that
             * event is dispatched. iframeLoader's setInterval will therefore see the body
             * already populated on its first tick.
             */ documentClone.close();
            const adoptedNode = documentClone.adoptNode(this.documentElement);
            addBase(adoptedNode, baseUri);
            documentClone.replaceChild(adoptedNode, documentClone.documentElement);
            return iframeLoad;
        }
        createElementClone(node) {
            if (isDebugging(node, 2 /* DebuggerType.CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            const clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone) && !isSVGElementNode(clone)) return this.createCustomElementClone(clone);
            return clone;
        }
        createCustomElementClone(node) {
            const clone = document.createElement('div');
            clone.className = node.className;
            copyCSSStyles(node.style, clone);
            // Clone shadow DOM if it exists
            // Fix for Issue #108: This is critical for Web Components with slots to work correctly
            if (node.shadowRoot) try {
                clone.attachShadow({
                    mode: 'open'
                });
            // The actual shadow DOM content will be cloned in cloneChildNodes
            } catch (e) {
                // Some elements cannot have shadow roots attached
                // This can happen if the element doesn't support shadow DOM
                this.context.logger.error('Failed to attach shadow root to custom element clone:', e);
            }
            return clone;
        }
        createStyleClone(node) {
            try {
                const sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    const css = [].slice.call(sheet.cssRules, 0).reduce((css, rule)=>{
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    const style = node.cloneNode(false);
                    style.textContent = css;
                    if (this.options.cspNonce) style.nonce = this.options.cspNonce;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            const cloned = node.cloneNode(false);
            if (this.options.cspNonce) cloned.nonce = this.options.cspNonce;
            return cloned;
        }
        createCanvasClone(canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                const img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info(`Unable to inline canvas contents, canvas is tainted`, canvas);
                }
            }
            const clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                const ctx = canvas.getContext('2d');
                const clonedCtx = clonedCanvas.getContext('2d', {
                    willReadFrequently: true
                });
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        const gl = canvas.getContext('webgl2') ?? canvas.getContext('webgl');
                        if (gl) {
                            const attribs = gl.getContextAttributes();
                            if (attribs?.preserveDrawingBuffer === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info(`Unable to clone canvas as it is tainted`, canvas);
            }
            return clonedCanvas;
        }
        createVideoClone(video) {
            const canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            const ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info(`Unable to clone video as it is tainted`, video);
            }
            const blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        }
        appendChildNode(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        }
        /**
         * Check if a child node should be cloned based on filtering rules
         * Filters out: scripts, ignored elements, and optionally styles
         */ shouldCloneChild(child) {
            return !isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child));
        }
        /**
         * Check if a style element should be cloned based on copyStyles option
         */ shouldCloneStyleElement(child) {
            return !this.options.copyStyles || !isElementNode(child) || !isStyleElement(child);
        }
        /**
         * Safely append a cloned child to a target, applying all filtering rules
         */ safeAppendClonedChild(target, child, copyStyles) {
            if (this.shouldCloneChild(child) && this.shouldCloneStyleElement(child)) target.appendChild(this.cloneNode(child, copyStyles));
        }
        /**
         * Clone assigned nodes from a slot element to the target
         */ cloneAssignedNodes(assignedNodes, target, copyStyles) {
            assignedNodes.forEach((node)=>{
                this.safeAppendClonedChild(target, node, copyStyles);
            });
        }
        /**
         * Clone fallback content from a slot element when no nodes are assigned
         */ cloneSlotFallbackContent(slot, target, copyStyles) {
            for(let child = slot.firstChild; child; child = child.nextSibling)this.safeAppendClonedChild(target, child, copyStyles);
        }
        /**
         * Handle cloning of a slot element, including assigned nodes or fallback content
         */ cloneSlotElement(slot, targetShadowRoot, copyStyles) {
            if (!isSlotElement(slot)) return;
            const slotElement = slot;
            // Defensive check: ensure assignedNodes method exists
            if (typeof slotElement.assignedNodes !== 'function') {
                this.context.logger.warn('HTMLSlotElement.assignedNodes is not available', slot);
                this.cloneSlotFallbackContent(slot, targetShadowRoot, copyStyles);
                return;
            }
            const assignedNodes = slotElement.assignedNodes();
            // Defensive check: ensure assignedNodes returns an array
            if (!assignedNodes || !Array.isArray(assignedNodes)) {
                this.context.logger.warn('assignedNodes() did not return a valid array', slot);
                this.cloneSlotFallbackContent(slot, targetShadowRoot, copyStyles);
                return;
            }
            if (assignedNodes.length > 0) // Clone assigned nodes
            this.cloneAssignedNodes(assignedNodes, targetShadowRoot, copyStyles);
            else // Clone fallback content
            this.cloneSlotFallbackContent(slot, targetShadowRoot, copyStyles);
        }
        /**
         * Clone shadow DOM children to the target shadow root
         */ cloneShadowDOMChildren(shadowRoot, targetShadowRoot, copyStyles) {
            for(let child = shadowRoot.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child)) // Handle slot elements specially
            this.cloneSlotElement(child, targetShadowRoot, copyStyles);
            else // Clone regular elements
            this.safeAppendClonedChild(targetShadowRoot, child, copyStyles);
        }
        /**
         * Clone light DOM children to the target element
         */ cloneLightDOMChildren(node, clone, copyStyles) {
            for(let child = node.firstChild; child; child = child.nextSibling)this.appendChildNode(clone, child, copyStyles);
        }
        /**
         * Clone slot element as light DOM when shadow root creation failed
         */ cloneSlotElementAsLightDOM(slot, clone, copyStyles) {
            if (!isSlotElement(slot)) return;
            const slotElement = slot;
            if (typeof slotElement.assignedNodes !== 'function') {
                // Fallback: clone slot's children
                for(let child = slot.firstChild; child; child = child.nextSibling)this.appendChildNode(clone, child, copyStyles);
                return;
            }
            const assignedNodes = slotElement.assignedNodes();
            if (assignedNodes && Array.isArray(assignedNodes) && assignedNodes.length > 0) // Clone assigned nodes as light DOM
            assignedNodes.forEach((node)=>this.appendChildNode(clone, node, copyStyles));
            else // Clone fallback content as light DOM
            for(let child = slot.firstChild; child; child = child.nextSibling)this.appendChildNode(clone, child, copyStyles);
        }
        /**
         * Clone shadow DOM content as light DOM when shadow root creation failed
         * This is a fallback mechanism to ensure content is not lost
         */ cloneShadowDOMAsLightDOM(shadowRoot, clone, copyStyles) {
            for(let child = shadowRoot.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child)) this.cloneSlotElementAsLightDOM(child, clone, copyStyles);
            else this.appendChildNode(clone, child, copyStyles);
        }
        /**
         * Clone child nodes from source element to clone element
         * Handles shadow DOM, slots, and light DOM appropriately
         */ cloneChildNodes(node, clone, copyStyles) {
            if (node.shadowRoot && clone.shadowRoot) {
                // Both original and clone have shadow roots - clone shadow DOM content
                this.cloneShadowDOMChildren(node.shadowRoot, clone.shadowRoot, copyStyles);
                // Also clone light DOM (slot content sources)
                this.cloneLightDOMChildren(node, clone, copyStyles);
            } else if (node.shadowRoot && !clone.shadowRoot) // Original has shadow root but clone doesn't (creation failed)
            // Fallback: clone shadow DOM content as light DOM to preserve content
            this.cloneShadowDOMAsLightDOM(node.shadowRoot, clone, copyStyles);
            else // No shadow DOM - just clone light DOM children
            this.cloneLightDOMChildren(node, clone, copyStyles);
        }
        cloneNode(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            const window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                const clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                const style = window1.getComputedStyle(node);
                const styleBefore = window1.getComputedStyle(node, ':before');
                const styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone, this.options.cspNonce);
                const counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                const before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                const after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        }
        resolvePseudoContent(node, clone, style, pseudoElt) {
            if (!style) return;
            const value = style.content;
            const document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            const declaration = new CSSParsedPseudoDeclaration(this.context, style);
            const anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach((token)=>{
                if (token.type === 0 /* TokenType.STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* TokenType.URL_TOKEN */ ) {
                    const img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* TokenType.FUNCTION */ ) {
                    if (token.name === 'attr') {
                        const attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        const [counter, counterStyle] = token.values.filter(nonFunctionArgSeparator);
                        if (counter && isIdentToken(counter)) {
                            const counterState = this.counters.getCounterValue(counter.value);
                            const counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(this.context, counterStyle.value) : 3 /* LIST_STYLE_TYPE.DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        const [counter, delim, counterStyle] = token.values.filter(nonFunctionArgSeparator);
                        if (counter && isIdentToken(counter)) {
                            const counterStates = this.counters.getCounterValues(counter.value);
                            const counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(this.context, counterStyle.value) : 3 /* LIST_STYLE_TYPE.DECIMAL */ ;
                            const separator = delim && delim.type === 0 /* TokenType.STRING_TOKEN */  ? delim.value : '';
                            const text = counterStates.map((value)=>createCounterText(value, counterType, false)).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* TokenType.IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = `${PSEUDO_HIDE_ELEMENT_CLASS_BEFORE} ${PSEUDO_HIDE_ELEMENT_CLASS_AFTER}`;
            const newClassName = pseudoElt === PseudoElementType.BEFORE ? ` ${PSEUDO_HIDE_ELEMENT_CLASS_BEFORE}` : ` ${PSEUDO_HIDE_ELEMENT_CLASS_AFTER}`;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        }
        static destroy(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        }
    }
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    const createIFrameContainer = (ownerDocument, bounds, customContainer)=>{
        const cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        // Use custom container if provided, otherwise use body
        const container = customContainer || ownerDocument.body;
        container.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    const imageReady = (img)=>{
        return new Promise((resolve)=>{
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    const imagesReady = (document1)=>{
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    const iframeLoader = (iframe)=>{
        return new Promise((resolve, reject)=>{
            const cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject(`No window assigned for iframe`);
            const documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = ()=>{
                cloneWindow.onload = iframe.onload = null;
                const interval = setInterval(()=>{
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    const ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    const copyCSSStyles = (style, target)=>{
        // Edge does not provide value for cssText
        for(let i = style.length - 1; i >= 0; i--){
            const property = style.item(i);
            // fix: Chrome_138 ignore custom properties
            if (ignoredStyleProperties.indexOf(property) === -1 && !property.startsWith('--')) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    const serializeDoctype = (doctype)=>{
        let str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += ' ' + doctype.internalSubset.replace(/"/g, '&quot;').replace(/>/g, '&gt;');
            if (doctype.publicId) {
                str += ' PUBLIC "' + doctype.publicId.replace(/"/g, '&quot;') + '"';
                if (doctype.systemId) str += ' "' + doctype.systemId.replace(/"/g, '&quot;') + '"';
            } else if (doctype.systemId) str += ' SYSTEM "' + doctype.systemId.replace(/"/g, '&quot;') + '"';
            str += '>';
        }
        return str;
    };
    const restoreOwnerScroll = (ownerDocument, x, y)=>{
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    const restoreNodeScroll = ([element, x, y])=>{
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    const PSEUDO_BEFORE = ':before';
    const PSEUDO_AFTER = ':after';
    const PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    const PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    const PSEUDO_HIDE_ELEMENT_STYLE = `{
    content: "" !important;
    display: none !important;
}`;
    const createPseudoHideStyles = (body, cspNonce)=>{
        createStyles(body, `.${PSEUDO_HIDE_ELEMENT_CLASS_BEFORE}${PSEUDO_BEFORE}${PSEUDO_HIDE_ELEMENT_STYLE}
         .${PSEUDO_HIDE_ELEMENT_CLASS_AFTER}${PSEUDO_AFTER}${PSEUDO_HIDE_ELEMENT_STYLE}`, cspNonce);
    };
    const createStyles = (body, styles, cspNonce)=>{
        const document1 = body.ownerDocument;
        if (document1) {
            const style = document1.createElement('style');
            style.textContent = styles;
            if (cspNonce) style.nonce = cspNonce;
            body.appendChild(style);
        }
    };
    const addBase = (targetELement, baseUri)=>{
        const baseNode = targetELement.ownerDocument.createElement('base');
        baseNode.href = baseUri;
        const headEle = targetELement.getElementsByTagName('head').item(0);
        headEle?.insertBefore(baseNode, headEle?.firstChild ?? null);
    };
    class Vector {
        constructor(x, y){
            this.type = 0 /* PathType.VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        add(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        }
    }
    const lerp = (a, b, t)=>{
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    class BezierCurve {
        constructor(start, startControl, endControl, end){
            this.type = 1 /* PathType.BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        subdivide(t, firstHalf) {
            const ab = lerp(this.start, this.startControl, t);
            const bc = lerp(this.startControl, this.endControl, t);
            const cd = lerp(this.endControl, this.end, t);
            const abbc = lerp(ab, bc, t);
            const bccd = lerp(bc, cd, t);
            const dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        }
        add(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        }
        reverse() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        }
    }
    const isBezierCurve = (path)=>path.type === 1 /* PathType.BEZIER_CURVE */ ;
    class BoundCurves {
        constructor(element){
            const styles = element.styles;
            const bounds = element.bounds;
            let [tlh, tlv] = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height);
            let [trh, trv] = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height);
            let [brh, brv] = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height);
            let [blh, blv] = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height);
            const factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            const maxFactor = Math.max(...factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            const topWidth = bounds.width - trh;
            const rightHeight = bounds.height - brv;
            const bottomWidth = bounds.width - brh;
            const leftHeight = bounds.height - blv;
            const borderTopWidth = styles.borderTopWidth;
            const borderRightWidth = styles.borderRightWidth;
            const borderBottomWidth = styles.borderBottomWidth;
            const borderLeftWidth = styles.borderLeftWidth;
            const paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            const paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            const paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            const paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
    }
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    const getCurvePoints = (x, y, r1, r2, position)=>{
        const kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        const ox = r1 * kappa; // control point offset horizontal
        const oy = r2 * kappa; // control point offset vertical
        const xm = x + r1; // x-middle
        const ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    const calculateBorderBoxPath = (curves)=>{
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    const calculateContentBoxPath = (curves)=>{
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    const calculatePaddingBoxPath = (curves)=>{
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    class TransformEffect {
        constructor(offsetX, offsetY, matrix){
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* EffectType.TRANSFORM */ ;
            this.target = 6 /* EffectTarget.CONTENT */ ;
        }
    }
    class ClipEffect {
        constructor(path, target){
            this.path = path;
            this.target = target;
            this.type = 1 /* EffectType.CLIP */ ;
        }
    }
    class OpacityEffect {
        constructor(opacity){
            this.opacity = opacity;
            this.type = 2 /* EffectType.OPACITY */ ;
            this.target = 6 /* EffectTarget.CONTENT */ ;
        }
    }
    /**
     * Clips the element and all its descendants to an arbitrary canvas-drawn shape.
     * The `applyClip` callback is responsible for calling beginPath, the shape
     * operations, and ctx.clip() — giving each shape type full control over how
     * the path is constructed (arc, ellipse, lineTo, Path2D, etc.).
     */ class ClipPathEffect {
        constructor(applyClip){
            this.applyClip = applyClip;
            this.type = 3 /* EffectType.CLIP_PATH */ ;
            this.target = 6 /* EffectTarget.CONTENT */ ;
        }
    }
    const isTransformEffect = (effect)=>effect.type === 0 /* EffectType.TRANSFORM */ ;
    const isClipEffect = (effect)=>effect.type === 1 /* EffectType.CLIP */ ;
    const isOpacityEffect = (effect)=>effect.type === 2 /* EffectType.OPACITY */ ;
    const isClipPathEffect = (effect)=>effect.type === 3 /* EffectType.CLIP_PATH */ ;
    const equalPath = (a, b)=>{
        if (a.length === b.length) return a.some((v, i)=>v === b[i]);
        return false;
    };
    const transformPath = (path, deltaX, deltaY, deltaW, deltaH)=>{
        return path.map((point, index)=>{
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    class StackingContext {
        constructor(container){
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
    }
    class ElementPaint {
        constructor(container, parent){
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.rotate !== null) {
                const origin = this.container.styles.transformOrigin;
                const offsetX = this.container.bounds.left + getAbsoluteValue(origin[0], this.container.bounds.width);
                const offsetY = this.container.bounds.top + getAbsoluteValue(origin[1], this.container.bounds.height);
                // Apply rotate property if present
                const angle = this.container.styles.rotate;
                const rad = angle * Math.PI / 180;
                const cos = Math.cos(rad);
                const sin = Math.sin(rad);
                const rotateMatrix = [
                    cos,
                    sin,
                    -sin,
                    cos,
                    0,
                    0
                ];
                this.effects.push(new TransformEffect(offsetX, offsetY, rotateMatrix));
            }
            if (this.container.styles.transform !== null) {
                const origin = this.container.styles.transformOrigin;
                const offsetX = this.container.bounds.left + getAbsoluteValue(origin[0], this.container.bounds.width);
                const offsetY = this.container.bounds.top + getAbsoluteValue(origin[1], this.container.bounds.height);
                const matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* OVERFLOW.VISIBLE */ ) {
                const borderBox = calculateBorderBoxPath(this.curves);
                const paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* EffectTarget.CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* EffectTarget.BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* EffectTarget.CONTENT */ ));
                }
            }
            if (this.container.styles.clipPath.type !== 0 /* CLIP_PATH_TYPE.NONE */ ) {
                const clipPathEffect = buildClipPathEffect(this.container.styles.clipPath, this.container.bounds);
                if (clipPathEffect) this.effects.push(clipPathEffect);
            }
        }
        getEffects(target) {
            let inFlow = [
                2 /* POSITION.ABSOLUTE */ ,
                3 /* POSITION.FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            let parent = this.parent;
            const effects = this.effects.slice(0);
            while(parent){
                const croplessEffects = parent.effects.filter((effect)=>!isClipEffect(effect));
                if (inFlow || parent.container.styles.position !== 0 /* POSITION.STATIC */  || !parent.parent) {
                    inFlow = [
                        2 /* POSITION.ABSOLUTE */ ,
                        3 /* POSITION.FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* OVERFLOW.VISIBLE */ ) {
                        const borderBox = calculateBorderBoxPath(parent.curves);
                        const paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* EffectTarget.CONTENT */ ));
                    }
                    effects.unshift(...croplessEffects);
                } else effects.unshift(...croplessEffects);
                parent = parent.parent;
            }
            return effects.filter((effect)=>contains(effect.target, target));
        }
    }
    /**
     * Resolve a `closest-side` or `farthest-side` shape-radius keyword to pixels
     * for a single axis. Used by both `circle()` (per-axis) and `ellipse()`.
     *
     * @param r       - The ShapeRadius (keyword or length-percentage).
     * @param center  - Absolute center coordinate on this axis (cx or cy).
     * @param start   - Absolute start of the reference box on this axis.
     * @param end     - Absolute end of the reference box on this axis.
     * @param dimRef  - Reference dimension for resolving a length-percentage value.
     */ const resolveAxisRadius = (r, center, start, end, dimRef)=>{
        if (r === 'closest-side') return Math.min(center - start, end - center);
        if (r === 'farthest-side') return Math.max(center - start, end - center);
        return getAbsoluteValue(r, dimRef);
    };
    /**
     * Convert a parsed ClipPathValue + element bounds into a ClipPathEffect whose
     * `applyClip` callback draws the clip shape directly onto the canvas context.
     *
     * All coordinates are computed in page-absolute space at construction time so
     * the callback itself is allocation-free and executes synchronously.
     */ const buildClipPathEffect = (clipPath, bounds)=>{
        const { left: bLeft, top: bTop, width: bWidth, height: bHeight } = bounds;
        switch(clipPath.type){
            case 1 /* CLIP_PATH_TYPE.INSET */ :
                {
                    const iLeft = getAbsoluteValue(clipPath.left, bWidth);
                    const iTop = getAbsoluteValue(clipPath.top, bHeight);
                    const x = bLeft + iLeft;
                    const y = bTop + iTop;
                    // Clamp to zero: per CSS spec, overlapping insets produce an empty shape.
                    const w = Math.max(0, bWidth - iLeft - getAbsoluteValue(clipPath.right, bWidth));
                    const h = Math.max(0, bHeight - iTop - getAbsoluteValue(clipPath.bottom, bHeight));
                    return new ClipPathEffect((ctx)=>{
                        ctx.beginPath();
                        ctx.rect(x, y, w, h);
                        ctx.clip();
                    });
                }
            case 2 /* CLIP_PATH_TYPE.CIRCLE */ :
                {
                    const cx = bLeft + getAbsoluteValue(clipPath.cx, bWidth);
                    const cy = bTop + getAbsoluteValue(clipPath.cy, bHeight);
                    let r;
                    if (clipPath.radius === 'closest-side') r = Math.min(cx - bLeft, cy - bTop, bLeft + bWidth - cx, bTop + bHeight - cy);
                    else if (clipPath.radius === 'farthest-side') r = Math.max(cx - bLeft, cy - bTop, bLeft + bWidth - cx, bTop + bHeight - cy);
                    else // Per CSS spec, percentage is relative to sqrt(w² + h²) / sqrt(2).
                    r = getAbsoluteValue(clipPath.radius, Math.sqrt(bWidth * bWidth + bHeight * bHeight) / Math.SQRT2);
                    return new ClipPathEffect((ctx)=>{
                        ctx.beginPath();
                        ctx.arc(cx, cy, Math.max(0, r), 0, Math.PI * 2);
                        ctx.clip();
                    });
                }
            case 3 /* CLIP_PATH_TYPE.ELLIPSE */ :
                {
                    const cx = bLeft + getAbsoluteValue(clipPath.cx, bWidth);
                    const cy = bTop + getAbsoluteValue(clipPath.cy, bHeight);
                    const rx = resolveAxisRadius(clipPath.rx, cx, bLeft, bLeft + bWidth, bWidth);
                    const ry = resolveAxisRadius(clipPath.ry, cy, bTop, bTop + bHeight, bHeight);
                    return new ClipPathEffect((ctx)=>{
                        ctx.beginPath();
                        ctx.ellipse(cx, cy, Math.max(0, rx), Math.max(0, ry), 0, 0, Math.PI * 2);
                        ctx.clip();
                    });
                }
            case 4 /* CLIP_PATH_TYPE.POLYGON */ :
                {
                    // Pre-compute all vertices in page-absolute coordinates.
                    const absPoints = clipPath.points.map(([px, py])=>[
                            bLeft + getAbsoluteValue(px, bWidth),
                            bTop + getAbsoluteValue(py, bHeight)
                        ]);
                    return new ClipPathEffect((ctx)=>{
                        ctx.beginPath();
                        if (absPoints.length > 0) {
                            ctx.moveTo(absPoints[0][0], absPoints[0][1]);
                            for(let i = 1; i < absPoints.length; i++)ctx.lineTo(absPoints[i][0], absPoints[i][1]);
                            ctx.closePath();
                        }
                        // Calling clip() with an empty path (zero points) is intentional:
                        // it clips the entire region to nothing, which is the correct
                        // behaviour for a degenerate polygon() per the CSS spec.
                        ctx.clip();
                    });
                }
            case 5 /* CLIP_PATH_TYPE.PATH */ :
                {
                    // path() coordinates are in the element's local space (0,0 = element top-left).
                    // We temporarily translate the canvas origin to the element's position, clip
                    // with the Path2D, then restore only the transform matrix (not the clipping
                    // region) via setTransform so the clip persists for the enclosing
                    // ctx.save() / ctx.restore() pair managed by EffectsRenderer.
                    //
                    // When the element also has a CSS transform, that transform was already applied
                    // by a preceding TransformEffect, so the path coordinates end up correctly in
                    // the element's transformed local space — matching browser behaviour.
                    const { d: d } = clipPath;
                    return new ClipPathEffect((ctx)=>{
                        try {
                            const savedTransform = ctx.getTransform();
                            ctx.translate(bLeft, bTop);
                            ctx.clip(new Path2D(d));
                            ctx.setTransform(savedTransform);
                        } catch (_e) {
                        // Path2D or getTransform/setTransform not supported in this environment.
                        }
                    });
                }
            case 0 /* CLIP_PATH_TYPE.NONE */ :
                return null;
            default:
                return null;
        }
    };
    const parseStackTree = (parent, stackingContext, realStackingContext, listItems)=>{
        parent.container.elements.forEach((child)=>{
            const treatAsRealStackingContext = contains(child.flags, 4 /* FLAGS.CREATES_REAL_STACKING_CONTEXT */ );
            const createsStackingContext = contains(child.flags, 2 /* FLAGS.CREATES_STACKING_CONTEXT */ );
            const paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* DISPLAY.LIST_ITEM */ )) listItems.push(paintContainer);
            const listOwnerItems = contains(child.flags, 8 /* FLAGS.IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                const parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                const stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    const order = child.styles.zIndex.order;
                    if (order < 0) {
                        let index = 0;
                        parentStack.negativeZIndex.some((current, i)=>{
                            if (order > current.element.container.styles.zIndex.order) {
                                index = i;
                                return false;
                            } else if (index > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index, 0, stack);
                    } else if (order > 0) {
                        let index = 0;
                        parentStack.positiveZIndex.some((current, i)=>{
                            if (order >= current.element.container.styles.zIndex.order) {
                                index = i + 1;
                                return false;
                            } else if (index > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* FLAGS.IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    const processListItems = (owner, elements)=>{
        let numbering = owner instanceof OLElementContainer ? owner.start : 1;
        const reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(let i = 0; i < elements.length; i++){
            const item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    const parseStackingContexts = (container)=>{
        const paintContainer = new ElementPaint(container, null);
        const root = new StackingContext(paintContainer);
        const listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    const paddingBox = (element)=>{
        const bounds = element.bounds;
        const styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    const contentBox = (element)=>{
        const styles = element.styles;
        const bounds = element.bounds;
        const paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        const paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        const paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        const paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    const calculateBackgroundPositioningArea = (backgroundOrigin, element)=>{
        if (backgroundOrigin === 0 /* BACKGROUND_ORIGIN.BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* BACKGROUND_ORIGIN.CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    const calculateBackgroundPaintingArea = (backgroundClip, element)=>{
        if (backgroundClip === 0 /* BACKGROUND_CLIP.BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* BACKGROUND_CLIP.CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    const calculateBackgroundRendering = (container, index, intrinsicSize)=>{
        const backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        const backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        const backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        let [sizeWidth, sizeHeight] = backgroundImageSize;
        const position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        const path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        const offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        const offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        sizeWidth = Math.max(1, sizeWidth);
        sizeHeight = Math.max(1, sizeHeight);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    const isAuto = (token)=>isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    const hasIntrinsicValue = (value)=>typeof value === 'number';
    const calculateBackgroundSize = (size, [intrinsicWidth, intrinsicHeight, intrinsicProportion], bounds)=>{
        const [first, second] = size;
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        const hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                const targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        const hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        const hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        const hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                const width = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                const height = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width,
                    height
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            const width = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            const height = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width,
                height
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            let width = 0;
            let height = 0;
            if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width = height * intrinsicProportion;
            else if (!second || isAuto(second)) height = width / intrinsicProportion;
            return [
                width,
                height
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        let width = null;
        let height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error(`Unable to calculate background-size for element`);
    };
    const getBackgroundValueForIndex = (values, index)=>{
        const value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    const calculateBackgroundRepeatPath = (repeat, [x, y], [width, height], backgroundPositioningArea, backgroundPaintingArea)=>{
        switch(repeat){
            case 2 /* BACKGROUND_REPEAT.REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* BACKGROUND_REPEAT.REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* BACKGROUND_REPEAT.NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    const SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    const SAMPLE_TEXT = 'Hidden Text';
    class FontMetrics {
        constructor(document1){
            this._data = {};
            this._document = document1;
        }
        parseMetrics(fontFamily, fontSize) {
            const container = this._document.createElement('div');
            const img = this._document.createElement('img');
            const span = this._document.createElement('span');
            const body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            const baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            const middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        }
        getMetrics(fontFamily, fontSize) {
            const key = `${fontFamily} ${fontSize}`;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        }
    }
    class Renderer {
        constructor(context, options){
            this.context = context;
            this.options = options;
        }
    }
    /**
     * Background Renderer
     *
     * Handles rendering of element backgrounds including:
     * - Background colors
     * - Background images (URL)
     * - Linear gradients
     * - Radial gradients
     * - Background patterns and repeats
     */ /**
     * Background Renderer
     *
     * Specialized renderer for element backgrounds.
     * Extracted from CanvasRenderer to improve code organization and maintainability.
     */ class BackgroundRenderer {
        constructor(deps){
            this.ctx = deps.ctx;
            this.context = deps.context;
            this.canvas = deps.canvas;
        // Options stored in deps but not needed as instance property
        }
        /**
         * Render background images for a container
         * Supports URL images, linear gradients, and radial gradients
         *
         * @param container - Element container with background styles
         */ async renderBackgroundImage(container) {
            let index = container.styles.backgroundImage.length - 1;
            for (const backgroundImage of container.styles.backgroundImage.slice(0).reverse()){
                if (backgroundImage.type === 0 /* CSSImageType.URL */ ) await this.renderBackgroundURLImage(container, backgroundImage, index);
                else if (isLinearGradient(backgroundImage)) this.renderLinearGradient(container, backgroundImage, index);
                else if (isRadialGradient(backgroundImage)) this.renderRadialGradient(container, backgroundImage, index);
                index--;
            }
        }
        /**
         * Render a URL-based background image
         */ async renderBackgroundURLImage(container, backgroundImage, index) {
            let image;
            const url = backgroundImage.url;
            try {
                image = await this.context.cache.match(url);
            } catch (e) {
                this.context.logger.error(`Error loading background-image ${url}`);
            }
            if (image) {
                const imageWidth = isNaN(image.width) || image.width === 0 ? 1 : image.width;
                const imageHeight = isNaN(image.height) || image.height === 0 ? 1 : image.height;
                const [path, x, y, width, height] = calculateBackgroundRendering(container, index, [
                    imageWidth,
                    imageHeight,
                    imageWidth / imageHeight
                ]);
                const pattern = this.ctx.createPattern(this.resizeImage(image, width, height, container.styles.imageRendering), 'repeat');
                this.renderRepeat(path, pattern, x, y);
            }
        }
        /**
         * Render a linear gradient background
         */ renderLinearGradient(container, backgroundImage, index) {
            const [path, x, y, width, height] = calculateBackgroundRendering(container, index, [
                null,
                null,
                null
            ]);
            const [lineLength, x0, x1, y0, y1] = calculateGradientDirection(backgroundImage.angle, width, height);
            const ownerDocument = this.canvas.ownerDocument ?? document;
            const canvas = ownerDocument.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            const gradient = ctx.createLinearGradient(x0, y0, x1, y1);
            processColorStops(backgroundImage.stops, lineLength || 1).forEach((colorStop)=>gradient.addColorStop(colorStop.stop, asString(colorStop.color)));
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, width, height);
            if (width > 0 && height > 0) {
                const pattern = this.ctx.createPattern(canvas, 'repeat');
                this.renderRepeat(path, pattern, x, y);
            }
        }
        /**
         * Render a radial gradient background
         */ renderRadialGradient(container, backgroundImage, index) {
            const [path, left, top, width, height] = calculateBackgroundRendering(container, index, [
                null,
                null,
                null
            ]);
            const position = backgroundImage.position.length === 0 ? [
                FIFTY_PERCENT
            ] : backgroundImage.position;
            const x = getAbsoluteValue(position[0], width);
            const y = getAbsoluteValue(position[position.length - 1], height);
            let [rx, ry] = calculateRadius(backgroundImage, x, y, width, height);
            // Handle edge case where radial gradient size is 0
            // Use a minimum value of 0.01 to ensure gradient is still rendered
            if (rx === 0 || ry === 0) {
                rx = Math.max(rx, 0.01);
                ry = Math.max(ry, 0.01);
            }
            if (rx > 0 && ry > 0) {
                const radialGradient = this.ctx.createRadialGradient(left + x, top + y, 0, left + x, top + y, rx);
                processColorStops(backgroundImage.stops, rx * 2).forEach((colorStop)=>radialGradient.addColorStop(colorStop.stop, asString(colorStop.color)));
                this.path(path);
                this.ctx.fillStyle = radialGradient;
                if (rx !== ry) {
                    // transforms for elliptical radial gradient
                    const midX = container.bounds.left + 0.5 * container.bounds.width;
                    const midY = container.bounds.top + 0.5 * container.bounds.height;
                    const f = ry / rx;
                    const invF = 1 / f;
                    this.ctx.save();
                    this.ctx.translate(midX, midY);
                    this.ctx.transform(1, 0, 0, f, 0, 0);
                    this.ctx.translate(-midX, -midY);
                    this.ctx.fillRect(left, invF * (top - midY) + midY, width, height * invF);
                    this.ctx.restore();
                } else this.ctx.fill();
            }
        }
        /**
         * Render a repeating pattern with offset
         *
         * @param path - Path to fill
         * @param pattern - Canvas pattern or gradient
         * @param offsetX - X offset for pattern
         * @param offsetY - Y offset for pattern
         */ renderRepeat(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        }
        /**
         * Resize an image to target dimensions
         *
         * @param image - Source image
         * @param width - Target width
         * @param height - Target height
         * @param imageRendering - CSS image-rendering property value
         * @returns Resized canvas or original image
         */ resizeImage(image, width, height, imageRendering) {
            // https://github.com/niklasvh/html2canvas/pull/2911
            // if (image.width === width && image.height === height) {
            //     return image;
            // }
            const ownerDocument = this.canvas.ownerDocument ?? document;
            const canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            const ctx = canvas.getContext('2d');
            // Apply image smoothing based on CSS image-rendering property
            if (imageRendering === exports1.IMAGE_RENDERING.PIXELATED || imageRendering === exports1.IMAGE_RENDERING.CRISP_EDGES) {
                this.context.logger.debug(`Disabling image smoothing for background image due to CSS image-rendering`);
                ctx.imageSmoothingEnabled = false;
            } else if (imageRendering === exports1.IMAGE_RENDERING.SMOOTH) {
                this.context.logger.debug(`Enabling image smoothing for background image due to CSS image-rendering: smooth`);
                ctx.imageSmoothingEnabled = true;
            } else // AUTO: inherit from main renderer context
            ctx.imageSmoothingEnabled = this.ctx.imageSmoothingEnabled;
            // Inherit quality setting
            if (this.ctx.imageSmoothingQuality) ctx.imageSmoothingQuality = this.ctx.imageSmoothingQuality;
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        }
        /**
         * Create a canvas path from path array
         *
         * @param paths - Array of path points
         */ path(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        }
        /**
         * Format path points into canvas path
         *
         * @param paths - Array of path points
         */ formatPath(paths) {
            paths.forEach((point, index)=>{
                const start = isBezierCurve(point) ? point.start : point;
                if (index === 0) this.ctx.moveTo(start.x, start.y);
                else this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        }
    }
    const parsePathForBorder = (curves, borderSide)=>{
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    const parsePathForBorderDoubleOuter = (curves, borderSide)=>{
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    const parsePathForBorderDoubleInner = (curves, borderSide)=>{
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    const parsePathForBorderStroke = (curves, borderSide)=>{
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    const createStrokePathFromCurves = (outer1, outer2)=>{
        const path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    const createPathFromCurves = (outer1, inner1, outer2, inner2)=>{
        const path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    /**
     * Border Renderer
     *
     * Handles rendering of element borders including:
     * - Solid borders
     * - Double borders
     * - Dashed borders
     * - Dotted borders
     */ /**
     * Border Renderer
     *
     * Specialized renderer for element borders.
     * Extracted from CanvasRenderer to improve code organization and maintainability.
     */ class BorderRenderer {
        constructor(deps, pathCallbacks){
            this.ctx = deps.ctx;
            this.pathCallbacks = pathCallbacks;
        }
        /**
         * Render a solid border
         *
         * @param color - Border color
         * @param side - Border side (0=top, 1=right, 2=bottom, 3=left)
         * @param curvePoints - Border curve points
         */ async renderSolidBorder(color, side, curvePoints) {
            this.pathCallbacks.path(parsePathForBorder(curvePoints, side));
            this.ctx.fillStyle = asString(color);
            this.ctx.fill();
        }
        /**
         * Render a double border
         * Falls back to solid border if width is too small
         *
         * @param color - Border color
         * @param width - Border width
         * @param side - Border side (0=top, 1=right, 2=bottom, 3=left)
         * @param curvePoints - Border curve points
         */ async renderDoubleBorder(color, width, side, curvePoints) {
            if (width < 3) {
                await this.renderSolidBorder(color, side, curvePoints);
                return;
            }
            const outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
            this.pathCallbacks.path(outerPaths);
            this.ctx.fillStyle = asString(color);
            this.ctx.fill();
            const innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
            this.pathCallbacks.path(innerPaths);
            this.ctx.fill();
        }
        /**
         * Render a dashed or dotted border
         *
         * @param color - Border color
         * @param width - Border width
         * @param side - Border side (0=top, 1=right, 2=bottom, 3=left)
         * @param curvePoints - Border curve points
         * @param style - Border style (DASHED or DOTTED)
         */ async renderDashedDottedBorder(color, width, side, curvePoints, style) {
            this.ctx.save();
            const strokePaths = parsePathForBorderStroke(curvePoints, side);
            const boxPaths = parsePathForBorder(curvePoints, side);
            if (style === 2 /* BORDER_STYLE.DASHED */ ) {
                this.pathCallbacks.path(boxPaths);
                this.ctx.clip();
            }
            // Extract start and end coordinates
            let startX, startY, endX, endY;
            if (isBezierCurve(boxPaths[0])) {
                startX = boxPaths[0].start.x;
                startY = boxPaths[0].start.y;
            } else {
                startX = boxPaths[0].x;
                startY = boxPaths[0].y;
            }
            if (isBezierCurve(boxPaths[1])) {
                endX = boxPaths[1].end.x;
                endY = boxPaths[1].end.y;
            } else {
                endX = boxPaths[1].x;
                endY = boxPaths[1].y;
            }
            // Calculate border length
            let length;
            if (side === 0 || side === 2) length = Math.abs(startX - endX);
            else length = Math.abs(startY - endY);
            this.ctx.beginPath();
            if (style === 3 /* BORDER_STYLE.DOTTED */ ) this.pathCallbacks.formatPath(strokePaths);
            else this.pathCallbacks.formatPath(boxPaths.slice(0, 2));
            // Calculate dash and space lengths
            let dashLength = width < 3 ? width * 3 : width * 2;
            let spaceLength = width < 3 ? width * 2 : width;
            if (style === 3 /* BORDER_STYLE.DOTTED */ ) {
                dashLength = width;
                spaceLength = width;
            }
            // Adjust dash pattern for border length
            let useLineDash = true;
            if (length <= dashLength * 2) useLineDash = false;
            else if (length <= dashLength * 2 + spaceLength) {
                const multiplier = length / (2 * dashLength + spaceLength);
                dashLength *= multiplier;
                spaceLength *= multiplier;
            } else {
                const numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                const minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                const maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
            }
            // Apply line dash pattern
            if (useLineDash) {
                if (style === 3 /* BORDER_STYLE.DOTTED */ ) this.ctx.setLineDash([
                    0,
                    dashLength + spaceLength
                ]);
                else this.ctx.setLineDash([
                    dashLength,
                    spaceLength
                ]);
            }
            // Set line style and stroke
            if (style === 3 /* BORDER_STYLE.DOTTED */ ) {
                this.ctx.lineCap = 'round';
                this.ctx.lineWidth = width;
            } else this.ctx.lineWidth = width * 2 + 1.1;
            this.ctx.strokeStyle = asString(color);
            this.ctx.stroke();
            this.ctx.setLineDash([]);
            // Fill dashed round edge gaps
            if (style === 2 /* BORDER_STYLE.DASHED */ ) {
                if (isBezierCurve(boxPaths[0])) {
                    const path1 = boxPaths[3];
                    const path2 = boxPaths[0];
                    this.ctx.beginPath();
                    this.pathCallbacks.formatPath([
                        new Vector(path1.end.x, path1.end.y),
                        new Vector(path2.start.x, path2.start.y)
                    ]);
                    this.ctx.stroke();
                }
                if (isBezierCurve(boxPaths[1])) {
                    const path1 = boxPaths[1];
                    const path2 = boxPaths[2];
                    this.ctx.beginPath();
                    this.pathCallbacks.formatPath([
                        new Vector(path1.end.x, path1.end.y),
                        new Vector(path2.start.x, path2.start.y)
                    ]);
                    this.ctx.stroke();
                }
            }
            this.ctx.restore();
        }
    }
    /**
     * Effects Renderer
     *
     * Handles rendering effects including:
     * - Opacity effects
     * - Transform effects (matrix transformations)
     * - Clip effects (overflow / border-radius clipping via Path[])
     * - Clip-path effects (CSS clip-path shapes: inset, circle, ellipse, polygon, path)
     */ /**
     * Effects Renderer
     *
     * Manages rendering effects stack including opacity, transforms, and clipping.
     * Extracted from CanvasRenderer to improve code organization and maintainability.
     */ class EffectsRenderer {
        constructor(deps, pathCallback){
            this.activeEffects = [];
            this.ctx = deps.ctx;
            this.pathCallback = pathCallback;
        }
        /**
         * Apply multiple effects
         * Clears existing effects and applies new ones
         *
         * @param effects - Array of effects to apply
         */ applyEffects(effects) {
            // Clear all existing effects
            while(this.activeEffects.length)this.popEffect();
            // Apply new effects
            effects.forEach((effect)=>this.applyEffect(effect));
        }
        /**
         * Apply a single effect
         *
         * @param effect - Effect to apply
         */ applyEffect(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) // Opacity: multiply into the current global alpha for nested transparency.
            this.ctx.globalAlpha = effect.opacity;
            else if (isTransformEffect(effect)) {
                // Transform: translate to origin, apply matrix, translate back.
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            } else if (isClipEffect(effect)) {
                // Clip (overflow / border-radius): build path via callback then clip.
                this.pathCallback.path(effect.path);
                this.ctx.clip();
            } else if (isClipPathEffect(effect)) // Clip-path: delegate shape drawing (beginPath … clip()) to the effect.
            effect.applyClip(this.ctx);
            this.activeEffects.push(effect);
        }
        /**
         * Remove the most recent effect
         * Restores the canvas state before the effect was applied
         */ popEffect() {
            this.activeEffects.pop();
            this.ctx.restore();
        }
        /**
         * Get the current number of active effects
         *
         * @returns Number of active effects
         */ getActiveEffectCount() {
            return this.activeEffects.length;
        }
        /**
         * Check if there are any active effects
         *
         * @returns True if there are active effects
         */ hasActiveEffects() {
            return this.activeEffects.length > 0;
        }
    }
    /**
     * Text Renderer
     *
     * Handles rendering of text content including:
     * - Text with letter spacing
     * - Text decorations (underline, overline, line-through)
     * - Text shadows
     * - Webkit line clamp
     * - Text overflow ellipsis
     * - Paint order (fill/stroke)
     * - Font styles
     */ // iOS font fix - see https://github.com/niklasvh/html2canvas/pull/2645
    const iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    /**
     * Detect CJK (Chinese, Japanese, Korean) characters in a string.
     * CJK characters use the ideographic baseline in browsers, which differs
     * from the alphabetic baseline used for Latin script.
     *
     * Covers:
     *   U+2E80–U+2FFF  CJK Radicals Supplement, Kangxi Radicals
     *   U+3000–U+30FF  CJK Symbols & Punctuation (。、「」…), Hiragana, Katakana
     *   U+3400–U+4DBF  CJK Extension A
     *   U+4E00–U+9FFF  CJK Unified Ideographs (most common Chinese/Japanese/Korean)
     *   U+AC00–U+D7AF  Hangul Syllables
     *   U+F900–U+FAFF  CJK Compatibility Ideographs
     *   U+FF01–U+FFEF  Halfwidth and Fullwidth Forms (Ａ Ｂ １ ２ ！ ？ etc.)
     */ const CJK_CHAR_REGEX = /[\u2E80-\u2FFF\u3000-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uAC00-\uD7AF\uF900-\uFAFF\uFF01-\uFFEF]/;
    const hasCJKCharacters = (text)=>CJK_CHAR_REGEX.test(text);
    /**
     * Detect iOS version from user agent
     * Returns null if not iOS or version cannot be determined
     */ const getIOSVersion = ()=>{
        if (typeof navigator === 'undefined') return null;
        const userAgent = navigator.userAgent;
        // Check if it's iOS or iPadOS
        // iPadOS 13+ may identify as Macintosh, check for touch support
        const isIOS = /iPhone|iPad|iPod/.test(userAgent);
        const isIPadOS = /Macintosh/.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
        if (!isIOS && !isIPadOS) return null;
        // Extract version number from various iOS user agent formats:
        // - "iPhone OS 15_0" or "iPhone OS 15_0_1"
        // - "CPU OS 15_0 like Mac OS X"
        // - "CPU iPhone OS 15_0 like Mac OS X"
        // - "Version/15.0" (for iPadOS)
        const patterns = [
            /(?:iPhone|CPU(?:\siPhone)?)\sOS\s(\d+)[\._](\d+)/,
            /Version\/(\d+)\.(\d+)/ // Version/15.0 (iPadOS)
        ];
        for (const pattern of patterns){
            const match = userAgent.match(pattern);
            if (match && match[1]) return parseInt(match[1], 10);
        }
        return null;
    };
    const fixIOSSystemFonts = (fontFamilies)=>{
        const iosVersion = getIOSVersion();
        // On iOS 15.0 and 15.1, system fonts have rendering issues
        // Fixed in iOS 17+
        if (iosVersion !== null && iosVersion >= 15 && iosVersion < 17) return fontFamilies.map((fontFamily)=>iOSBrokenFonts.indexOf(fontFamily) !== -1 ? `-apple-system, "Helvetica Neue", Arial, sans-serif` : fontFamily);
        return fontFamilies;
    };
    /**
     * Text Renderer
     *
     * Specialized renderer for text content.
     * Extracted from CanvasRenderer to improve code organization and maintainability.
     */ class TextRenderer {
        constructor(deps){
            this.ctx = deps.ctx;
            // context stored but not used directly in this renderer
            this.options = deps.options;
        }
        /**
         * Iterate grapheme clusters one-by-one, applying correct letter-spacing and
         * per-script baseline for each character.
         *
         * Issue #73: When letter-spacing is non-zero, text must be rendered character by
         * character. This helper centralises two fixes applied during that iteration:
         *   1. Add `letterSpacing` to each character's advance width (was previously
         *      omitted, causing characters to render without any spacing).
         *   2. Switch to the ideographic baseline for CJK glyphs so their vertical
         *      position matches how browsers lay them out in the DOM.
         *
         * The `renderFn` callback receives (letter, x, y) and performs the actual draw
         * call (fillText or strokeText), allowing fill and stroke paths to share one
         * implementation.
         */ iterateLettersWithLetterSpacing(text, letterSpacing, baseline, renderFn) {
            const letters = segmentGraphemes(text.text);
            const y = text.bounds.top + baseline;
            let left = text.bounds.left;
            for (const letter of letters){
                if (hasCJKCharacters(letter)) {
                    const savedBaseline = this.ctx.textBaseline;
                    this.ctx.textBaseline = 'ideographic';
                    renderFn(letter, left, y);
                    this.ctx.textBaseline = savedBaseline;
                } else renderFn(letter, left, y);
                left += this.ctx.measureText(letter).width + letterSpacing;
            }
        }
        /**
         * Render text with letter-spacing applied (fill pass).
         * When letterSpacing is 0 the whole string is drawn in one call; otherwise each
         * grapheme is drawn individually so spacing and CJK baseline are applied correctly.
         */ renderTextWithLetterSpacing(text, letterSpacing, baseline) {
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else this.iterateLettersWithLetterSpacing(text, letterSpacing, baseline, (letter, x, y)=>{
                this.ctx.fillText(letter, x, y);
            });
        }
        /**
         * Helper method to render text with paint order support
         * Reduces code duplication in line-clamp and normal rendering
         */ renderTextBoundWithPaintOrder(textBound, styles, paintOrderLayers) {
            paintOrderLayers.forEach((paintOrderLayer)=>{
                switch(paintOrderLayer){
                    case 0 /* PAINT_ORDER_LAYER.FILL */ :
                        this.ctx.fillStyle = asString(styles.color);
                        this.renderTextWithLetterSpacing(textBound, styles.letterSpacing, styles.fontSize.number);
                        break;
                    case 1 /* PAINT_ORDER_LAYER.STROKE */ :
                        if (styles.webkitTextStrokeWidth && textBound.text.trim().length) {
                            this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                            this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                            this.ctx.lineJoin = typeof window !== 'undefined' && !!window.chrome ? 'miter' : 'round';
                            if (styles.letterSpacing === 0) this.ctx.strokeText(textBound.text, textBound.bounds.left, textBound.bounds.top + styles.fontSize.number);
                            else this.iterateLettersWithLetterSpacing(textBound, styles.letterSpacing, styles.fontSize.number, (letter, x, y)=>this.ctx.strokeText(letter, x, y));
                            this.ctx.strokeStyle = '';
                            this.ctx.lineWidth = 0;
                            this.ctx.lineJoin = 'miter';
                        }
                        break;
                }
            });
        }
        renderTextDecoration(bounds, styles) {
            this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
            // Calculate decoration line thickness
            let thickness = 1; // default
            if (typeof styles.textDecorationThickness === 'number') thickness = styles.textDecorationThickness;
            else if (styles.textDecorationThickness === 'from-font') // Use a reasonable default based on font size
            thickness = Math.max(1, Math.floor(styles.fontSize.number * 0.05));
            // 'auto' uses default thickness of 1
            // Calculate underline offset
            let underlineOffset = 0;
            if (typeof styles.textUnderlineOffset === 'number') // It's a pixel value
            underlineOffset = styles.textUnderlineOffset;
            // 'auto' uses default offset of 0
            const decorationStyle = styles.textDecorationStyle;
            styles.textDecorationLine.forEach((textDecorationLine)=>{
                let y = 0;
                switch(textDecorationLine){
                    case 1 /* TEXT_DECORATION_LINE.UNDERLINE */ :
                        y = bounds.top + bounds.height - thickness + underlineOffset;
                        break;
                    case 2 /* TEXT_DECORATION_LINE.OVERLINE */ :
                        y = bounds.top;
                        break;
                    case 3 /* TEXT_DECORATION_LINE.LINE_THROUGH */ :
                        y = bounds.top + (bounds.height / 2 - thickness / 2);
                        break;
                    default:
                        return;
                }
                this.drawDecorationLine(bounds.left, y, bounds.width, thickness, decorationStyle);
            });
        }
        drawDecorationLine(x, y, width, thickness, style) {
            switch(style){
                case 0 /* TEXT_DECORATION_STYLE.SOLID */ :
                    // Solid line (default)
                    this.ctx.fillRect(x, y, width, thickness);
                    break;
                case 1 /* TEXT_DECORATION_STYLE.DOUBLE */ :
                    // Double line
                    const gap = Math.max(1, thickness);
                    this.ctx.fillRect(x, y, width, thickness);
                    this.ctx.fillRect(x, y + thickness + gap, width, thickness);
                    break;
                case 2 /* TEXT_DECORATION_STYLE.DOTTED */ :
                    // Dotted line
                    this.ctx.save();
                    this.ctx.beginPath();
                    this.ctx.setLineDash([
                        thickness,
                        thickness * 2
                    ]);
                    this.ctx.lineWidth = thickness;
                    this.ctx.strokeStyle = this.ctx.fillStyle;
                    this.ctx.moveTo(x, y + thickness / 2);
                    this.ctx.lineTo(x + width, y + thickness / 2);
                    this.ctx.stroke();
                    this.ctx.restore();
                    break;
                case 3 /* TEXT_DECORATION_STYLE.DASHED */ :
                    // Dashed line
                    this.ctx.save();
                    this.ctx.beginPath();
                    this.ctx.setLineDash([
                        thickness * 3,
                        thickness * 2
                    ]);
                    this.ctx.lineWidth = thickness;
                    this.ctx.strokeStyle = this.ctx.fillStyle;
                    this.ctx.moveTo(x, y + thickness / 2);
                    this.ctx.lineTo(x + width, y + thickness / 2);
                    this.ctx.stroke();
                    this.ctx.restore();
                    break;
                case 4 /* TEXT_DECORATION_STYLE.WAVY */ :
                    // Wavy line (approximation using quadratic curves)
                    this.ctx.save();
                    this.ctx.beginPath();
                    this.ctx.lineWidth = thickness;
                    this.ctx.strokeStyle = this.ctx.fillStyle;
                    const amplitude = thickness * 2;
                    const wavelength = thickness * 4;
                    let currentX = x;
                    this.ctx.moveTo(currentX, y + thickness / 2);
                    while(currentX < x + width){
                        const nextX = Math.min(currentX + wavelength / 2, x + width);
                        this.ctx.quadraticCurveTo(currentX + wavelength / 4, y + thickness / 2 - amplitude, nextX, y + thickness / 2);
                        currentX = nextX;
                        if (currentX < x + width) {
                            const nextX2 = Math.min(currentX + wavelength / 2, x + width);
                            this.ctx.quadraticCurveTo(currentX + wavelength / 4, y + thickness / 2 + amplitude, nextX2, y + thickness / 2);
                            currentX = nextX2;
                        }
                    }
                    this.ctx.stroke();
                    this.ctx.restore();
                    break;
                default:
                    // Fallback to solid
                    this.ctx.fillRect(x, y, width, thickness);
            }
        }
        // Helper method to truncate text and add ellipsis if needed
        truncateTextWithEllipsis(text, maxWidth, letterSpacing) {
            // Use the Unicode ellipsis character (U+2026) whose width the browser measures
            // as a single glyph, matching native text-overflow behaviour more closely.
            const ellipsis = '\u2026';
            const ellipsisWidth = this.ctx.measureText(ellipsis).width;
            // Segment into grapheme clusters so multi-byte characters (emoji, composed
            // sequences) are never split mid-character.
            const graphemes = segmentGraphemes(text);
            if (letterSpacing === 0) {
                // Measure the whole candidate string for accuracy: the browser applies
                // kerning and ligatures when rendering multiple glyphs together, so
                // measuring them as one string is more precise than summing individual widths.
                // Binary search reduces measurements from O(n) to O(log n).
                const fits = (n)=>this.ctx.measureText(graphemes.slice(0, n).join('')).width + ellipsisWidth <= maxWidth;
                let lo = 0;
                let hi = graphemes.length;
                while(lo < hi){
                    const mid = lo + hi + 1 >> 1;
                    if (fits(mid)) lo = mid;
                    else hi = mid - 1;
                }
                return graphemes.slice(0, lo).join('') + ellipsis;
            } else {
                let width = ellipsisWidth;
                const result = [];
                for (const letter of graphemes){
                    const glyphWidth = this.ctx.measureText(letter).width;
                    // Check against glyph width only (no trailing spacing): letter-spacing
                    // is applied *between* characters, not after the final glyph. Using
                    // `glyphWidth + letterSpacing` would incorrectly discard letters that
                    // fit as the last character before the ellipsis.
                    if (width + glyphWidth > maxWidth) break;
                    result.push(letter);
                    // Accumulate glyph + inter-character spacing for the *next* iteration.
                    width += glyphWidth + letterSpacing;
                }
                return result.join('') + ellipsis;
            }
        }
        /**
         * Create font style array
         * Public method used by list rendering
         */ createFontStyle(styles) {
            const fontVariant = styles.fontVariant.filter((variant)=>variant === 'normal' || variant === 'small-caps').join('');
            const fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            const fontSize = isDimensionToken(styles.fontSize) ? `${styles.fontSize.number}${styles.fontSize.unit}` : `${styles.fontSize.number}px`;
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        }
        async renderTextNode(text, styles, containerBounds) {
            const [font] = this.createFontStyle(styles);
            this.ctx.font = font;
            this.ctx.direction = styles.direction === 1 /* DIRECTION.RTL */  ? 'rtl' : 'ltr';
            this.ctx.textAlign = 'left';
            this.ctx.textBaseline = 'alphabetic';
            const paintOrder = styles.paintOrder;
            // Calculate line height for text layout detection (used by both line-clamp and ellipsis)
            const lineHeight = styles.fontSize.number * 1.5;
            // Check if we need to apply -webkit-line-clamp
            // This limits text to a specific number of lines with ellipsis
            const shouldApplyLineClamp = styles.webkitLineClamp > 0 && (styles.display & 2 /* DISPLAY.BLOCK */ ) !== 0 && styles.overflowY === 1 /* OVERFLOW.HIDDEN */  && text.textBounds.length > 0;
            if (shouldApplyLineClamp) {
                // Group text bounds by lines based on their Y position
                const lines = [];
                let currentLine = [];
                let currentLineTop = text.textBounds[0].bounds.top;
                text.textBounds.forEach((tb)=>{
                    // If this text bound is on a different line, start a new line
                    if (Math.abs(tb.bounds.top - currentLineTop) >= lineHeight * 0.5) {
                        if (currentLine.length > 0) lines.push(currentLine);
                        currentLine = [
                            tb
                        ];
                        currentLineTop = tb.bounds.top;
                    } else currentLine.push(tb);
                });
                // Don't forget the last line
                if (currentLine.length > 0) lines.push(currentLine);
                // Only render up to webkitLineClamp lines
                const maxLines = styles.webkitLineClamp;
                if (lines.length > maxLines) {
                    // Render only the first (maxLines - 1) complete lines
                    for(let i = 0; i < maxLines - 1; i++)lines[i].forEach((textBound)=>{
                        this.renderTextBoundWithPaintOrder(textBound, styles, paintOrder);
                    });
                    // For the last line, truncate with ellipsis
                    const lastLine = lines[maxLines - 1];
                    if (lastLine && lastLine.length > 0 && containerBounds) {
                        const lastLineText = lastLine.map((tb)=>tb.text).join('');
                        const firstBound = lastLine[0];
                        const availableWidth = containerBounds.width - (firstBound.bounds.left - containerBounds.left);
                        const truncatedText = this.truncateTextWithEllipsis(lastLineText, availableWidth, styles.letterSpacing);
                        // Build TextBounds once; reused for fill and stroke without re-allocating.
                        const truncatedBounds = new TextBounds(truncatedText, firstBound.bounds);
                        paintOrder.forEach((paintOrderLayer)=>{
                            switch(paintOrderLayer){
                                case 0 /* PAINT_ORDER_LAYER.FILL */ :
                                    this.ctx.fillStyle = asString(styles.color);
                                    if (styles.letterSpacing === 0) this.ctx.fillText(truncatedText, firstBound.bounds.left, firstBound.bounds.top + styles.fontSize.number);
                                    else this.iterateLettersWithLetterSpacing(truncatedBounds, styles.letterSpacing, styles.fontSize.number, (letter, x, y)=>this.ctx.fillText(letter, x, y));
                                    break;
                                case 1 /* PAINT_ORDER_LAYER.STROKE */ :
                                    if (styles.webkitTextStrokeWidth && truncatedText.trim().length) {
                                        this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        this.ctx.lineJoin = typeof window !== 'undefined' && !!window.chrome ? 'miter' : 'round';
                                        if (styles.letterSpacing === 0) this.ctx.strokeText(truncatedText, firstBound.bounds.left, firstBound.bounds.top + styles.fontSize.number);
                                        else this.iterateLettersWithLetterSpacing(truncatedBounds, styles.letterSpacing, styles.fontSize.number, (letter, x, y)=>this.ctx.strokeText(letter, x, y));
                                        this.ctx.strokeStyle = '';
                                        this.ctx.lineWidth = 0;
                                        this.ctx.lineJoin = 'miter';
                                    }
                                    break;
                            }
                        });
                    }
                    return; // Don't render anything else
                }
            // If lines.length <= maxLines, fall through to normal rendering
            }
            // Check if we need to apply text-overflow: ellipsis
            // Issue #203: Only apply ellipsis for single-line text overflow
            // Multi-line text truncation (like -webkit-line-clamp) should not be affected
            const shouldApplyEllipsis = styles.textOverflow === 1 /* TEXT_OVERFLOW.ELLIPSIS */  && containerBounds && styles.overflowX === 1 /* OVERFLOW.HIDDEN */  && text.textBounds.length > 0;
            // Calculate total text width if ellipsis might be needed
            let needsEllipsis = false;
            let truncatedText = '';
            if (shouldApplyEllipsis) {
                // Check if all text bounds are on approximately the same line (single-line scenario)
                // For multi-line text (like -webkit-line-clamp), textBounds will have different Y positions
                const firstTop = text.textBounds[0].bounds.top;
                const isSingleLine = text.textBounds.every((tb)=>Math.abs(tb.bounds.top - firstTop) < lineHeight * 0.5);
                if (isSingleLine) {
                    // Measure the full text content
                    // Note: text.textBounds may contain whitespace characters from HTML formatting
                    // We need to collapse them like the browser does for white-space: nowrap
                    let fullText = text.textBounds.map((tb)=>tb.text).join('');
                    // Collapse whitespace: replace sequences of whitespace (including newlines) with single spaces
                    // and trim leading/trailing whitespace
                    fullText = fullText.replace(/\s+/g, ' ').trim();
                    const fullTextWidth = this.ctx.measureText(fullText).width;
                    const availableWidth = containerBounds.width;
                    if (fullTextWidth > availableWidth) {
                        needsEllipsis = true;
                        truncatedText = this.truncateTextWithEllipsis(fullText, availableWidth, styles.letterSpacing);
                    }
                }
            }
            // If ellipsis is needed, render the truncated text once
            if (needsEllipsis) {
                const firstBound = text.textBounds[0];
                // Build TextBounds once; reused across paint layers and every shadow pass
                // to avoid repeated allocation inside forEach callbacks.
                const truncatedBounds = new TextBounds(truncatedText, firstBound.bounds);
                paintOrder.forEach((paintOrderLayer)=>{
                    switch(paintOrderLayer){
                        case 0 /* PAINT_ORDER_LAYER.FILL */ :
                            {
                                this.ctx.fillStyle = asString(styles.color);
                                if (styles.letterSpacing === 0) this.ctx.fillText(truncatedText, firstBound.bounds.left, firstBound.bounds.top + styles.fontSize.number);
                                else this.iterateLettersWithLetterSpacing(truncatedBounds, styles.letterSpacing, styles.fontSize.number, (letter, x, y)=>this.ctx.fillText(letter, x, y));
                                const textShadows = styles.textShadow;
                                if (textShadows.length && truncatedText.trim().length) {
                                    textShadows.slice(0).reverse().forEach((textShadow)=>{
                                        this.ctx.shadowColor = asString(textShadow.color);
                                        this.ctx.shadowOffsetX = textShadow.offsetX.number * this.options.scale;
                                        this.ctx.shadowOffsetY = textShadow.offsetY.number * this.options.scale;
                                        this.ctx.shadowBlur = textShadow.blur.number;
                                        if (styles.letterSpacing === 0) this.ctx.fillText(truncatedText, firstBound.bounds.left, firstBound.bounds.top + styles.fontSize.number);
                                        else this.iterateLettersWithLetterSpacing(truncatedBounds, styles.letterSpacing, styles.fontSize.number, (letter, x, y)=>this.ctx.fillText(letter, x, y));
                                    });
                                    this.ctx.shadowColor = '';
                                    this.ctx.shadowOffsetX = 0;
                                    this.ctx.shadowOffsetY = 0;
                                    this.ctx.shadowBlur = 0;
                                }
                                break;
                            }
                        case 1 /* PAINT_ORDER_LAYER.STROKE */ :
                            if (styles.webkitTextStrokeWidth && truncatedText.trim().length) {
                                this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                this.ctx.lineJoin = typeof window !== 'undefined' && !!window.chrome ? 'miter' : 'round';
                                if (styles.letterSpacing === 0) this.ctx.strokeText(truncatedText, firstBound.bounds.left, firstBound.bounds.top + styles.fontSize.number);
                                else this.iterateLettersWithLetterSpacing(truncatedBounds, styles.letterSpacing, styles.fontSize.number, (letter, x, y)=>this.ctx.strokeText(letter, x, y));
                                this.ctx.strokeStyle = '';
                                this.ctx.lineWidth = 0;
                                this.ctx.lineJoin = 'miter';
                            }
                            break;
                    }
                });
                return;
            }
            // Normal rendering (no ellipsis needed)
            text.textBounds.forEach((text)=>{
                paintOrder.forEach((paintOrderLayer)=>{
                    switch(paintOrderLayer){
                        case 0 /* PAINT_ORDER_LAYER.FILL */ :
                            {
                                this.ctx.fillStyle = asString(styles.color);
                                this.renderTextWithLetterSpacing(text, styles.letterSpacing, styles.fontSize.number);
                                const textShadows = styles.textShadow;
                                if (textShadows.length && text.text.trim().length) {
                                    textShadows.slice(0).reverse().forEach((textShadow)=>{
                                        this.ctx.shadowColor = asString(textShadow.color);
                                        this.ctx.shadowOffsetX = textShadow.offsetX.number * this.options.scale;
                                        this.ctx.shadowOffsetY = textShadow.offsetY.number * this.options.scale;
                                        this.ctx.shadowBlur = textShadow.blur.number;
                                        this.renderTextWithLetterSpacing(text, styles.letterSpacing, styles.fontSize.number);
                                    });
                                    this.ctx.shadowColor = '';
                                    this.ctx.shadowOffsetX = 0;
                                    this.ctx.shadowOffsetY = 0;
                                    this.ctx.shadowBlur = 0;
                                }
                                if (styles.textDecorationLine.length) this.renderTextDecoration(text.bounds, styles);
                                break;
                            }
                        case 1 /* PAINT_ORDER_LAYER.STROKE */ :
                            if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                this.ctx.lineJoin = typeof window !== 'undefined' && !!window.chrome ? 'miter' : 'round';
                                const baseline = styles.fontSize.number;
                                if (styles.letterSpacing === 0) this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                else this.iterateLettersWithLetterSpacing(text, styles.letterSpacing, baseline, (letter, x, y)=>this.ctx.strokeText(letter, x, y));
                                this.ctx.strokeStyle = '';
                                this.ctx.lineWidth = 0;
                                this.ctx.lineJoin = 'miter';
                            }
                            break;
                    }
                });
            });
        }
    }
    const MASK_OFFSET = 10000;
    class CanvasRenderer extends Renderer {
        constructor(context, options){
            super(context, options);
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = `${options.width}px`;
                this.canvas.style.height = `${options.height}px`;
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x, -options.y);
            this.ctx.textBaseline = 'bottom';
            // Set image smoothing options
            if (options.imageSmoothing !== undefined) this.ctx.imageSmoothingEnabled = options.imageSmoothing;
            if (options.imageSmoothingQuality) this.ctx.imageSmoothingQuality = options.imageSmoothingQuality;
            // Initialize specialized renderers
            this.backgroundRenderer = new BackgroundRenderer({
                ctx: this.ctx,
                context: this.context,
                canvas: this.canvas,
                options: {
                    width: options.width,
                    height: options.height,
                    scale: options.scale
                }
            });
            this.borderRenderer = new BorderRenderer({
                ctx: this.ctx
            }, {
                path: (paths)=>this.path(paths),
                formatPath: (paths)=>this.formatPath(paths)
            });
            this.effectsRenderer = new EffectsRenderer({
                ctx: this.ctx
            }, {
                path: (paths)=>this.path(paths)
            });
            this.textRenderer = new TextRenderer({
                ctx: this.ctx,
                context: this.context,
                options: {
                    scale: options.scale
                }
            });
            this.context.logger.debug(`Canvas renderer initialized (${options.width}x${options.height}) with scale ${options.scale}`);
        }
        async renderStack(stack) {
            const styles = stack.element.container.styles;
            if (styles.isVisible()) await this.renderStackContent(stack);
        }
        async renderNode(paint) {
            if (contains(paint.container.flags, 16 /* FLAGS.DEBUG_RENDER */ )) debugger;
            if (paint.container.styles.isVisible()) {
                await this.renderNodeBackgroundAndBorders(paint);
                await this.renderNodeContent(paint);
            }
        }
        /**
         * Helper method to render text with paint order support
         * Reduces code duplication in line-clamp and normal rendering
         */ // Helper method to truncate text and add ellipsis if needed
        renderReplacedElement(container, curves, image) {
            const intrinsicWidth = image.naturalWidth || container.intrinsicWidth;
            const intrinsicHeight = image.naturalHeight || container.intrinsicHeight;
            if (image && intrinsicWidth > 0 && intrinsicHeight > 0) {
                const box = contentBox(container);
                const path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                let sx = 0, sy = 0, sw = intrinsicWidth, sh = intrinsicHeight, dx = box.left, dy = box.top, dw = box.width, dh = box.height;
                const { objectFit: objectFit } = container.styles;
                const boxRatio = dw / dh;
                const imgRatio = sw / sh;
                if (objectFit === 2 /* OBJECT_FIT.CONTAIN */ ) {
                    if (imgRatio > boxRatio) {
                        dh = dw / imgRatio;
                        dy += (box.height - dh) / 2;
                    } else {
                        dw = dh * imgRatio;
                        dx += (box.width - dw) / 2;
                    }
                } else if (objectFit === 4 /* OBJECT_FIT.COVER */ ) {
                    if (imgRatio > boxRatio) {
                        sw = sh * boxRatio;
                        sx += (intrinsicWidth - sw) / 2;
                    } else {
                        sh = sw / boxRatio;
                        sy += (intrinsicHeight - sh) / 2;
                    }
                } else if (objectFit === 8 /* OBJECT_FIT.NONE */ ) {
                    if (sw > dw) {
                        sx += (sw - dw) / 2;
                        sw = dw;
                    } else {
                        dx += (dw - sw) / 2;
                        dw = sw;
                    }
                    if (sh > dh) {
                        sy += (sh - dh) / 2;
                        sh = dh;
                    } else {
                        dy += (dh - sh) / 2;
                        dh = sh;
                    }
                } else if (objectFit === 16 /* OBJECT_FIT.SCALE_DOWN */ ) {
                    const containW = imgRatio > boxRatio ? dw : dh * imgRatio;
                    const noneW = sw > dw ? sw : dw;
                    if (containW < noneW) {
                        if (imgRatio > boxRatio) {
                            dh = dw / imgRatio;
                            dy += (box.height - dh) / 2;
                        } else {
                            dw = dh * imgRatio;
                            dx += (box.width - dw) / 2;
                        }
                    } else {
                        if (sw > dw) {
                            sx += (sw - dw) / 2;
                            sw = dw;
                        } else {
                            dx += (dw - sw) / 2;
                            dw = sw;
                        }
                        if (sh > dh) {
                            sy += (sh - dh) / 2;
                            sh = dh;
                        } else {
                            dy += (dh - sh) / 2;
                            dh = sh;
                        }
                    }
                }
                this.ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh);
                this.ctx.restore();
            }
        }
        async renderNodeContent(paint) {
            this.effectsRenderer.applyEffects(paint.getEffects(4 /* EffectTarget.CONTENT */ ));
            const container = paint.container;
            const curves = paint.curves;
            const styles = container.styles;
            // Use content box for text overflow calculation (excludes padding and border)
            // This matches browser behavior where text-overflow uses the content width
            const textBounds = contentBox(container);
            for (const child of container.textNodes)await this.textRenderer.renderTextNode(child, styles, textBounds);
            if (container instanceof ImageElementContainer) try {
                const image = await this.context.cache.match(container.src);
                // Apply image smoothing based on CSS image-rendering property and global options
                const prevSmoothing = this.ctx.imageSmoothingEnabled;
                // CSS image-rendering property overrides global settings
                if (styles.imageRendering === exports1.IMAGE_RENDERING.PIXELATED || styles.imageRendering === exports1.IMAGE_RENDERING.CRISP_EDGES) {
                    this.context.logger.debug(`Disabling image smoothing for ${container.src} due to CSS image-rendering: ${styles.imageRendering === exports1.IMAGE_RENDERING.PIXELATED ? 'pixelated' : 'crisp-edges'}`);
                    this.ctx.imageSmoothingEnabled = false;
                } else if (styles.imageRendering === exports1.IMAGE_RENDERING.SMOOTH) {
                    this.context.logger.debug(`Enabling image smoothing for ${container.src} due to CSS image-rendering: smooth`);
                    this.ctx.imageSmoothingEnabled = true;
                }
                // IMAGE_RENDERING.AUTO: keep current global setting
                this.renderReplacedElement(container, curves, image);
                // Restore previous smoothing state
                this.ctx.imageSmoothingEnabled = prevSmoothing;
            } catch (e) {
                this.context.logger.error(`Error loading image ${container.src}`);
            }
            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
            if (container instanceof SVGElementContainer) try {
                const image = await this.context.cache.match(container.svg);
                this.renderReplacedElement(container, curves, image);
            } catch (e) {
                this.context.logger.error(`Error loading svg ${container.svg.substring(0, 255)}`);
            }
            if (container instanceof IFrameElementContainer && container.tree) {
                const iframeRenderer = new CanvasRenderer(this.context, {
                    scale: this.options.scale,
                    backgroundColor: container.backgroundColor,
                    x: 0,
                    y: 0,
                    width: container.width,
                    height: container.height
                });
                const canvas = await iframeRenderer.render(container.tree);
                if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
            }
            if (container instanceof InputElementContainer) {
                const size = Math.min(container.bounds.width, container.bounds.height);
                if (container.type === CHECKBOX) {
                    if (container.checked) {
                        this.ctx.save();
                        this.path([
                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                        ]);
                        this.ctx.fillStyle = asString(INPUT_COLOR);
                        this.ctx.fill();
                        this.ctx.restore();
                    }
                } else if (container.type === RADIO) {
                    if (container.checked) {
                        this.ctx.save();
                        this.ctx.beginPath();
                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                        this.ctx.fillStyle = asString(INPUT_COLOR);
                        this.ctx.fill();
                        this.ctx.restore();
                    }
                }
            }
            if (isTextInputElement(container) && container.value.length) {
                const [font, fontFamily, fontSize] = this.textRenderer.createFontStyle(styles);
                const { baseline: baseline } = this.fontMetrics.getMetrics(fontFamily, fontSize);
                this.ctx.font = font;
                // Fix for Issue #92: Use placeholder color when rendering placeholder text
                const isPlaceholder = container instanceof InputElementContainer && container.isPlaceholder;
                this.ctx.fillStyle = isPlaceholder ? asString(PLACEHOLDER_COLOR) : asString(styles.color);
                this.ctx.textBaseline = 'alphabetic';
                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                const bounds = contentBox(container);
                let x = 0;
                switch(container.styles.textAlign){
                    case 1 /* TEXT_ALIGN.CENTER */ :
                        x += bounds.width / 2;
                        break;
                    case 2 /* TEXT_ALIGN.RIGHT */ :
                        x += bounds.width;
                        break;
                }
                // Fix for Issue #92: Position text vertically centered in single-line input
                // Only apply vertical centering for InputElementContainer, not for textarea or select
                let verticalOffset = 0;
                if (container instanceof InputElementContainer) {
                    const fontSizeValue = getAbsoluteValue(styles.fontSize, 0);
                    verticalOffset = (bounds.height - fontSizeValue) / 2;
                }
                // Create text bounds with horizontal and vertical offsets
                // Height is not modified as it doesn't affect text rendering position
                const textBounds = bounds.add(x, verticalOffset, 0, 0);
                this.ctx.save();
                this.path([
                    new Vector(bounds.left, bounds.top),
                    new Vector(bounds.left + bounds.width, bounds.top),
                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                    new Vector(bounds.left, bounds.top + bounds.height)
                ]);
                this.ctx.clip();
                this.textRenderer.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                this.ctx.restore();
                this.ctx.textBaseline = 'alphabetic';
                this.ctx.textAlign = 'left';
            }
            if (contains(container.styles.display, 2048 /* DISPLAY.LIST_ITEM */ )) {
                if (container.styles.listStyleImage !== null) {
                    const img = container.styles.listStyleImage;
                    if (img.type === 0 /* CSSImageType.URL */ ) {
                        let image;
                        const url = img.url;
                        try {
                            image = await this.context.cache.match(url);
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                        } catch (e) {
                            this.context.logger.error(`Error loading list-style-image ${url}`);
                        }
                    }
                } else if (paint.listValue && container.styles.listStyleType !== -1 /* LIST_STYLE_TYPE.NONE */ ) {
                    const [font] = this.textRenderer.createFontStyle(styles);
                    this.ctx.font = font;
                    this.ctx.fillStyle = asString(styles.color);
                    this.ctx.textBaseline = 'middle';
                    this.ctx.textAlign = 'right';
                    const bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                    this.textRenderer.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                    this.ctx.textBaseline = 'bottom';
                    this.ctx.textAlign = 'left';
                }
            }
        }
        async renderStackContent(stack) {
            if (contains(stack.element.container.flags, 16 /* FLAGS.DEBUG_RENDER */ )) debugger;
            // https://www.w3.org/TR/css-position-3/#painting-order
            // 1. the background and borders of the element forming the stacking context.
            await this.renderNodeBackgroundAndBorders(stack.element);
            // 2. the child stacking contexts with negative stack levels (most negative first).
            for (const child of stack.negativeZIndex)await this.renderStack(child);
            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
            await this.renderNodeContent(stack.element);
            for (const child of stack.nonInlineLevel)await this.renderNode(child);
            // 4. All non-positioned floating descendants, in tree order. For each one of these,
            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
            // which actually create a new stacking context should be considered part of the parent stacking context,
            // not this new one.
            for (const child of stack.nonPositionedFloats)await this.renderStack(child);
            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
            for (const child of stack.nonPositionedInlineLevel)await this.renderStack(child);
            for (const child of stack.inlineLevel)await this.renderNode(child);
            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
            //  but any positioned descendants and descendants which actually create a new stacking context should be
            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
            //  treat the stacking context generated atomically.
            //
            //  All opacity descendants with opacity less than 1
            //
            //  All transform descendants with transform other than none
            for (const child of stack.zeroOrAutoZIndexOrTransformedOrOpacity)await this.renderStack(child);
            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
            // order (smallest first) then tree order.
            for (const child of stack.positiveZIndex)await this.renderStack(child);
        }
        mask(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            // Use logical dimensions (options.width/height) instead of canvas pixel dimensions
            // because context has already been scaled by this.options.scale
            // Fix for Issue #126: Using canvas pixel dimensions causes broken output
            this.ctx.lineTo(this.options.width, 0);
            this.ctx.lineTo(this.options.width, this.options.height);
            this.ctx.lineTo(0, this.options.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        }
        path(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        }
        formatPath(paths) {
            paths.forEach((point, index)=>{
                const start = isBezierCurve(point) ? point.start : point;
                if (index === 0) this.ctx.moveTo(start.x, start.y);
                else this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        }
        async renderNodeBackgroundAndBorders(paint) {
            this.effectsRenderer.applyEffects(paint.getEffects(2 /* EffectTarget.BACKGROUND_BORDERS */ ));
            const styles = paint.container.styles;
            const hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
            const borders = [
                {
                    style: styles.borderTopStyle,
                    color: styles.borderTopColor,
                    width: styles.borderTopWidth
                },
                {
                    style: styles.borderRightStyle,
                    color: styles.borderRightColor,
                    width: styles.borderRightWidth
                },
                {
                    style: styles.borderBottomStyle,
                    color: styles.borderBottomColor,
                    width: styles.borderBottomWidth
                },
                {
                    style: styles.borderLeftStyle,
                    color: styles.borderLeftColor,
                    width: styles.borderLeftWidth
                }
            ];
            const backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
            if (hasBackground || styles.boxShadow.length) {
                this.ctx.save();
                this.path(backgroundPaintingArea);
                this.ctx.clip();
                if (!isTransparent(styles.backgroundColor)) {
                    this.ctx.fillStyle = asString(styles.backgroundColor);
                    this.ctx.fill();
                }
                await this.backgroundRenderer.renderBackgroundImage(paint.container);
                this.ctx.restore();
                styles.boxShadow.slice(0).reverse().forEach((shadow)=>{
                    this.ctx.save();
                    const borderBoxArea = calculateBorderBoxPath(paint.curves);
                    const maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                    const shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                    if (shadow.inset) {
                        this.path(borderBoxArea);
                        this.ctx.clip();
                        this.mask(shadowPaintingArea);
                    } else {
                        this.mask(borderBoxArea);
                        this.ctx.clip();
                        this.path(shadowPaintingArea);
                    }
                    this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                    this.ctx.shadowOffsetY = shadow.offsetY.number;
                    this.ctx.shadowColor = asString(shadow.color);
                    this.ctx.shadowBlur = shadow.blur.number;
                    this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                    this.ctx.fill();
                    this.ctx.restore();
                });
            }
            let side = 0;
            for (const border of borders){
                if (border.style !== 0 /* BORDER_STYLE.NONE */  && !isTransparent(border.color) && border.width > 0) {
                    if (border.style === 2 /* BORDER_STYLE.DASHED */ ) await this.borderRenderer.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* BORDER_STYLE.DASHED */ );
                    else if (border.style === 3 /* BORDER_STYLE.DOTTED */ ) await this.borderRenderer.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* BORDER_STYLE.DOTTED */ );
                    else if (border.style === 4 /* BORDER_STYLE.DOUBLE */ ) await this.borderRenderer.renderDoubleBorder(border.color, border.width, side, paint.curves);
                    else await this.borderRenderer.renderSolidBorder(border.color, side, paint.curves);
                }
                side++;
            }
        }
        async render(element) {
            if (this.options.backgroundColor) {
                this.ctx.fillStyle = asString(this.options.backgroundColor);
                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
            }
            const stack = parseStackingContexts(element);
            await this.renderStack(stack);
            this.effectsRenderer.applyEffects([]);
            return this.canvas;
        }
    }
    const isTextInputElement = (container)=>{
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    const calculateBackgroundCurvedPaintingArea = (clip, curves)=>{
        switch(clip){
            case 0 /* BACKGROUND_CLIP.BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* BACKGROUND_CLIP.CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* BACKGROUND_CLIP.PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    const canvasTextAlign = (textAlign)=>{
        switch(textAlign){
            case 1 /* TEXT_ALIGN.CENTER */ :
                return 'center';
            case 2 /* TEXT_ALIGN.RIGHT */ :
                return 'right';
            case 0 /* TEXT_ALIGN.LEFT */ :
            default:
                return 'left';
        }
    };
    class ForeignObjectRenderer extends Renderer {
        constructor(context, options){
            super(context, options);
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = `${options.width}px`;
            this.canvas.style.height = `${options.height}px`;
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x, -options.y);
            this.context.logger.debug(`EXPERIMENTAL ForeignObject renderer initialized (${options.width}x${options.height} at ${options.x},${options.y}) with scale ${options.scale}`);
        }
        async render(element) {
            const svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
            const img = await loadSerializedSVG(svg);
            if (this.options.backgroundColor) {
                this.ctx.fillStyle = asString(this.options.backgroundColor);
                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
            }
            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
            return this.canvas;
        }
    }
    const loadSerializedSVG = (svg)=>new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(img);
            };
            img.onerror = reject;
            img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(svg))}`;
        });
    class Logger {
        constructor({ id: id, enabled: enabled }){
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        debug(...args) {
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug(this.id, `${this.getTime()}ms`, ...args);
                else this.info(...args);
            }
        }
        getTime() {
            return Date.now() - this.start;
        }
        info(...args) {
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info(this.id, `${this.getTime()}ms`, ...args);
            }
        }
        warn(...args) {
            if (this.enabled) {
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') console.warn(this.id, `${this.getTime()}ms`, ...args);
                else this.info(...args);
            }
        }
        error(...args) {
            if (this.enabled) {
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') console.error(this.id, `${this.getTime()}ms`, ...args);
                else this.info(...args);
            }
        }
    }
    Logger.instances = {};
    class Cache {
        constructor(context, _options){
            this.context = context;
            this._options = _options;
            this._cache = new Map();
            this._pendingOperations = new Map();
            // Default cache size: 100 items
            this.maxSize = _options.maxCacheSize ?? 100;
            if (this.maxSize < 1) throw new Error('Cache maxSize must be at least 1');
            if (this.maxSize > 10000) this.context.logger.warn(`Cache maxSize ${this.maxSize} is very large and may cause memory issues. ` + `Consider using a smaller value (recommended: 100-1000).`);
        }
        addImage(src) {
            // Wait for any pending operations on this key
            const pending = this._pendingOperations.get(src);
            if (pending) return pending;
            if (this.has(src)) {
                // Update last accessed time
                const entry = this._cache.get(src);
                if (entry) entry.lastAccessed = Date.now();
                return Promise.resolve();
            }
            if (isBlobImage(src) || isRenderable(src)) {
                // Create a pending operation to ensure atomicity
                const operation = this._addImageInternal(src);
                this._pendingOperations.set(src, operation);
                operation.finally(()=>{
                    this._pendingOperations.delete(src);
                });
                return operation;
            }
            return Promise.resolve();
        }
        async _addImageInternal(src) {
            // Create image load promise with timeout protection
            const timeoutMs = this._options.imageTimeout ?? 15000;
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject(new Error(`Image load timeout after ${timeoutMs}ms: ${src}`));
                }, timeoutMs);
            });
            // Race between image load and timeout
            const imageWithTimeout = Promise.race([
                this.loadImage(src),
                timeoutPromise
            ]);
            // Handle errors to prevent unhandled rejections
            imageWithTimeout.catch((error)=>{
                this.context.logger.error(`Failed to load image ${src}: ${error instanceof Error ? error.message : 'Unknown error'}`);
            });
            // Store the promise with timeout in cache
            this.set(src, imageWithTimeout);
        }
        match(src) {
            const entry = this._cache.get(src);
            if (entry) {
                // Update last accessed time on access
                entry.lastAccessed = Date.now();
                return entry.value;
            }
            return undefined;
        }
        /**
         * Set a value in cache with LRU eviction
         */ set(key, value) {
            // If key already exists, update it without eviction
            if (this._cache.has(key)) {
                const entry = this._cache.get(key);
                entry.value = value;
                entry.lastAccessed = Date.now();
                return;
            }
            // For new keys, check if we need to evict
            if (this._cache.size >= this.maxSize) this.evictLRU();
            this._cache.set(key, {
                value: value,
                lastAccessed: Date.now()
            });
        }
        /**
         * Evict least recently used entry
         */ evictLRU() {
            let oldestKey = null;
            let oldestTime = Infinity;
            for (const [key, entry] of this._cache.entries())if (entry.lastAccessed < oldestTime) {
                oldestTime = entry.lastAccessed;
                oldestKey = key;
            }
            if (oldestKey) {
                this._cache.delete(oldestKey);
                this.context.logger.debug(`Cache: Evicted LRU entry: ${oldestKey}`);
            }
        }
        /**
         * Get cache size
         */ size() {
            return this._cache.size;
        }
        /**
         * Get max cache size
         */ getMaxSize() {
            return this.maxSize;
        }
        /**
         * Clear all cache entries
         */ clear() {
            this._cache.clear();
        }
        async loadImage(key) {
            const originChecker = this.context.originChecker;
            const defaultIsSameOrigin = (src)=>originChecker.isSameOrigin(src);
            const isSameOrigin = typeof this._options.customIsSameOrigin === 'function' ? await this._options.customIsSameOrigin(key, defaultIsSameOrigin) : defaultIsSameOrigin(key);
            const useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
            const useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return;
            let src = key;
            if (useProxy) src = await this.proxy(src);
            this.context.logger.debug(`Added image ${key.substring(0, 256)}`);
            return await new Promise((resolve, reject)=>{
                const img = new Image();
                img.onload = ()=>resolve(img);
                img.onerror = reject;
                //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                img.src = src;
                if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                setTimeout(()=>resolve(img), 500);
                if (this._options.imageTimeout > 0) setTimeout(()=>reject(`Timed out (${this._options.imageTimeout}ms) loading image`), this._options.imageTimeout);
            });
        }
        has(key) {
            return this._cache.has(key);
        }
        keys() {
            return Promise.resolve(Object.keys(this._cache));
        }
        proxy(src) {
            const proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            const key = src.substring(0, 256);
            return new Promise((resolve, reject)=>{
                const responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                const xhr = new XMLHttpRequest();
                xhr.onload = ()=>{
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            const reader = new FileReader();
                            reader.addEventListener('load', ()=>resolve(reader.result), false);
                            reader.addEventListener('error', (e)=>reject(e), false);
                            reader.readAsDataURL(xhr.response);
                        }
                    } else reject(`Failed to proxy resource ${key} with status code ${xhr.status}`);
                };
                xhr.onerror = reject;
                const queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', `${proxy}${queryString}url=${encodeURIComponent(src)}&responseType=${responseType}`);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (this._options.imageTimeout) {
                    const timeout = this._options.imageTimeout;
                    xhr.timeout = timeout;
                    xhr.ontimeout = ()=>reject(`Timed out (${timeout}ms) proxying ${key}`);
                }
                xhr.send();
            });
        }
    }
    const INLINE_SVG = /^data:image\/svg\+xml/i;
    const INLINE_BASE64 = /^data:image\/.*;base64,/i;
    const INLINE_IMG = /^data:image\/.*/i;
    const isRenderable = (src)=>FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    const isInlineImage = (src)=>INLINE_IMG.test(src);
    const isInlineBase64Image = (src)=>INLINE_BASE64.test(src);
    const isBlobImage = (src)=>src.substr(0, 4) === 'blob';
    const isSVG = (src)=>src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    /**
     * Origin Checker
     *
     * Provides origin checking functionality without global static state.
     * Each instance maintains its own anchor element and origin reference.
     *
     * Replaces the static methods in CacheStorage with instance-based approach.
     */ class OriginChecker {
        constructor(window1){
            if (!window1 || !window1.document) throw new Error('Valid window object required for OriginChecker');
            if (!window1.location || !window1.location.href) throw new Error('Window object must have valid location');
            this.link = window1.document.createElement('a');
            this.origin = this.getOrigin(window1.location.href);
        }
        /**
         * Get the origin (protocol + hostname + port) of a URL
         *
         * @param url - URL to parse
         * @returns Origin string (e.g., "https://example.com:8080")
         */ getOrigin(url) {
            this.link.href = url;
            // IE9 hack: accessing href twice to ensure it's properly parsed
            this.link.href = this.link.href;
            return this.link.protocol + this.link.hostname + this.link.port;
        }
        /**
         * Check if a URL is from the same origin as the context
         *
         * @param src - URL to check
         * @returns true if same origin, false otherwise
         */ isSameOrigin(src) {
            return this.getOrigin(src) === this.origin;
        }
        /**
         * Get the current context origin
         *
         * @returns The origin of the context window
         */ getContextOrigin() {
            return this.origin;
        }
    }
    class Context {
        constructor(options, windowBounds, config){
            this.windowBounds = windowBounds;
            this.instanceName = `#${Context.instanceCount++}`;
            this.config = config;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.originChecker = new OriginChecker(config.window);
            this.cache = options.cache ?? config.cache ?? new Cache(this, options);
        }
    }
    Context.instanceCount = 1;
    /**
     * Html2Canvas Configuration
     *
     * Manages configuration state for html2canvas rendering.
     * Eliminates the need for global static variables.
     */ class Html2CanvasConfig {
        constructor(options = {}){
            // Try to get window from options first, then fall back to global window
            this.window = options.window || (typeof window !== 'undefined' ? window : null);
            if (!this.window) throw new Error('Window object is required but not available');
            this.cspNonce = options.cspNonce;
            this.cache = options.cache;
        }
        /**
         * Create configuration from an element
         * Extracts window from element's owner document
         */ static fromElement(element, options = {}) {
            const ownerDocument = element.ownerDocument;
            if (!ownerDocument) throw new Error('Element is not attached to a document');
            const defaultView = ownerDocument.defaultView;
            if (!defaultView) throw new Error('Document is not attached to a window');
            return new Html2CanvasConfig({
                window: defaultView,
                ...options
            });
        }
        /**
         * Clone configuration with override options
         */ clone(options = {}) {
            return new Html2CanvasConfig({
                window: options.window || this.window,
                cspNonce: options.cspNonce ?? this.cspNonce,
                cache: options.cache ?? this.cache
            });
        }
    }
    /**
     * Set default configuration
     * @deprecated Pass configuration directly to html2canvas instead
     */ function setDefaultConfig(config) {
        console.warn('[html2canvas-pro] setDefaultConfig is deprecated. Pass configuration to html2canvas directly.');
    }
    /**
     * Input Validator
     *
     * Provides validation and sanitization for user inputs to prevent security vulnerabilities
     * including SSRF, XSS, and injection attacks.
     */ /**
     * Input Validator
     *
     * Validates and sanitizes user inputs for security and correctness.
     */ class Validator {
        constructor(config = {}){
            this.config = {
                maxImageTimeout: 300000,
                allowDataUrls: true,
                ...config
            };
        }
        /**
         * Validate a URL
         *
         * @param url - URL to validate
         * @param context - Context for validation (e.g., 'proxy', 'image')
         * @returns Validation result
         */ validateUrl(url, context = 'general') {
            if (!url || typeof url !== 'string') return {
                valid: false,
                error: 'URL must be a non-empty string'
            };
            // Check for data URLs
            if (url.startsWith('data:')) {
                if (!this.config.allowDataUrls) return {
                    valid: false,
                    error: 'Data URLs are not allowed'
                };
                return {
                    valid: true,
                    sanitized: url
                };
            }
            // Check for blob URLs
            if (url.startsWith('blob:')) return {
                valid: true,
                sanitized: url
            };
            // Validate URL format
            try {
                const parsedUrl = new URL(url);
                // Only allow http and https protocols
                if (![
                    'http:',
                    'https:'
                ].includes(parsedUrl.protocol)) return {
                    valid: false,
                    error: `Protocol ${parsedUrl.protocol} is not allowed. Only http and https are permitted.`
                };
                // For proxy URLs, check domain whitelist
                if (context === 'proxy' && this.config.allowedProxyDomains && this.config.allowedProxyDomains.length > 0) {
                    const hostname = parsedUrl.hostname.toLowerCase();
                    const isAllowed = this.config.allowedProxyDomains.some((domain)=>{
                        const normalizedDomain = domain.toLowerCase();
                        return hostname === normalizedDomain || hostname.endsWith('.' + normalizedDomain);
                    });
                    if (!isAllowed) return {
                        valid: false,
                        error: `Proxy domain ${parsedUrl.hostname} is not in the allowed list`
                    };
                }
                // Check for localhost/private IPs to prevent SSRF (skip when allowLocalhostProxy for dev/test)
                if (context === 'proxy') {
                    if (!this.config.allowLocalhostProxy) {
                        const hostname = parsedUrl.hostname.toLowerCase();
                        // Check for localhost
                        if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') return {
                            valid: false,
                            error: 'Localhost is not allowed for proxy URLs'
                        };
                        // For private IP ranges (simplified check)
                        if (this.isPrivateIP(hostname)) return {
                            valid: false,
                            error: 'Private IP addresses are not allowed for proxy URLs'
                        };
                        // For link-local addresses
                        if (hostname.startsWith('169.254.') || hostname.startsWith('fe80:')) return {
                            valid: false,
                            error: 'Link-local addresses are not allowed for proxy URLs'
                        };
                    }
                    // For proxy URLs, mark that runtime validation is recommended
                    // to prevent DNS rebinding attacks
                    return {
                        valid: true,
                        sanitized: url,
                        requiresRuntimeCheck: true
                    };
                }
                return {
                    valid: true,
                    sanitized: url
                };
            } catch (e) {
                return {
                    valid: false,
                    error: `Invalid URL format: ${e instanceof Error ? e.message : 'Unknown error'}`
                };
            }
        }
        /**
         * Check if a hostname is a private IP address
         */ isPrivateIP(hostname) {
            // IPv4 private ranges
            const privateIPv4Patterns = [
                /^0\./,
                /^10\./,
                /^100\.(6[4-9]|[7-9][0-9]|1[0-1][0-9]|12[0-7])\./,
                /^127\./,
                /^169\.254\./,
                /^172\.(1[6-9]|2[0-9]|3[0-1])\./,
                /^192\.0\.0\./,
                /^192\.0\.2\./,
                /^192\.168\./,
                /^198\.(1[8-9])\./,
                /^198\.51\.100\./,
                /^203\.0\.113\./,
                /^2(2[4-9]|3[0-9])\./,
                /^24[0-9]\./,
                /^255\.255\.255\.255$/ // 255.255.255.255/32 (Broadcast)
            ];
            // Check IPv4
            if (privateIPv4Patterns.some((pattern)=>pattern.test(hostname))) return true;
            // IPv6 private ranges and special addresses
            if (hostname.includes(':')) return this.isPrivateIPv6(hostname);
            return false;
        }
        /**
         * Check if an IPv6 address is private or special
         * Handles compressed IPv6 addresses (e.g., ::1, fc00::1)
         */ isPrivateIPv6(hostname) {
            const normalizedHost = hostname.toLowerCase().trim();
            // Remove square brackets if present (e.g., [::1])
            const addr = normalizedHost.replace(/^\[|\]$/g, '');
            // Remove zone ID if present (e.g., fe80::1%eth0)
            const addrWithoutZone = addr.split('%')[0];
            // Loopback ::1 (also matches 0:0:0:0:0:0:0:1)
            if (/^(0:){7}1$/.test(addrWithoutZone) || addrWithoutZone === '::1') return true;
            // Unspecified address :: (also matches 0:0:0:0:0:0:0:0)
            if (/^(0:){7}0$/.test(addrWithoutZone) || addrWithoutZone === '::') return true;
            // Expand :: compression to check prefixes
            // This handles cases like fc00::1, fe80::, etc.
            const expandedAddr = this.expandIPv6(addrWithoutZone);
            if (!expandedAddr) // If we can't expand it, fall back to prefix matching
            return this.isPrivateIPv6Prefix(addrWithoutZone);
            // fc00::/7 (Unique Local Address)
            // Check if first byte is in range fc00-fdff
            const firstByte = parseInt(expandedAddr.substring(0, 2), 16);
            if (firstByte >= 0xfc && firstByte <= 0xfd) return true;
            // fe80::/10 (Link-local)
            // First 10 bits should be 1111 1110 10
            if (firstByte === 0xfe) {
                const secondByte = parseInt(expandedAddr.substring(2, 4), 16);
                // Check if bits 11-12 are 10 (0x80-0xbf)
                if (secondByte >= 0x80 && secondByte <= 0xbf) return true;
            }
            // ff00::/8 (Multicast)
            if (firstByte === 0xff) return true;
            return false;
        }
        /**
         * Expand compressed IPv6 address to full form
         * e.g., "::1" -> "0000:0000:0000:0000:0000:0000:0000:0001"
         */ expandIPv6(addr) {
            try {
                // Handle :: compression
                if (addr.includes('::')) {
                    const parts = addr.split('::');
                    if (parts.length > 2) return null; // Invalid: more than one ::
                    const leftParts = parts[0] ? parts[0].split(':') : [];
                    const rightParts = parts[1] ? parts[1].split(':') : [];
                    const missingParts = 8 - leftParts.length - rightParts.length;
                    if (missingParts < 0) return null; // Invalid
                    const middleParts = Array(missingParts).fill('0000');
                    const allParts = [
                        ...leftParts,
                        ...middleParts,
                        ...rightParts
                    ];
                    return allParts.map((p)=>p.padStart(4, '0')).join(':');
                } else {
                    // No compression, just normalize
                    const parts = addr.split(':');
                    if (parts.length !== 8) return null; // Invalid
                    return parts.map((p)=>p.padStart(4, '0')).join(':');
                }
            } catch  {
                return null;
            }
        }
        /**
         * Fallback prefix matching for IPv6 when expansion fails
         */ isPrivateIPv6Prefix(addr) {
            // fc00::/7 (Unique Local Address)
            if (/^fc[0-9a-f]{0,2}:?/i.test(addr) || /^fd[0-9a-f]{0,2}:?/i.test(addr)) return true;
            // fe80::/10 (Link-local)
            if (/^fe[89ab][0-9a-f]:?/i.test(addr)) return true;
            // ff00::/8 (Multicast)
            if (/^ff[0-9a-f]{0,2}:?/i.test(addr)) return true;
            return false;
        }
        /**
         * Validate CSP nonce
         *
         * @param nonce - CSP nonce to validate
         * @returns Validation result
         */ validateCspNonce(nonce) {
            if (!nonce || typeof nonce !== 'string') return {
                valid: false,
                error: 'CSP nonce must be a non-empty string'
            };
            // Basic format validation - nonce should be base64-like
            // Typical format: base64 string, often 32+ characters
            if (nonce.length < 16) return {
                valid: false,
                error: 'CSP nonce is too short (minimum 16 characters recommended)'
            };
            // Check for suspicious characters
            if (!/^[A-Za-z0-9+/=_-]+$/.test(nonce)) return {
                valid: false,
                error: 'CSP nonce contains invalid characters'
            };
            return {
                valid: true,
                sanitized: nonce
            };
        }
        /**
         * Validate image timeout
         *
         * @param timeout - Timeout in milliseconds
         * @returns Validation result
         */ validateImageTimeout(timeout) {
            if (typeof timeout !== 'number' || isNaN(timeout)) return {
                valid: false,
                error: 'Image timeout must be a number'
            };
            if (timeout < 0) return {
                valid: false,
                error: 'Image timeout cannot be negative'
            };
            if (this.config.maxImageTimeout && timeout > this.config.maxImageTimeout) return {
                valid: false,
                error: `Image timeout ${timeout}ms exceeds maximum allowed ${this.config.maxImageTimeout}ms`
            };
            return {
                valid: true,
                sanitized: timeout
            };
        }
        /**
         * Validate window dimensions
         *
         * @param width - Window width
         * @param height - Window height
         * @returns Validation result
         */ validateDimensions(width, height) {
            if (typeof width !== 'number' || typeof height !== 'number') return {
                valid: false,
                error: 'Dimensions must be numbers'
            };
            if (isNaN(width) || isNaN(height)) return {
                valid: false,
                error: 'Dimensions cannot be NaN'
            };
            if (width <= 0 || height <= 0) return {
                valid: false,
                error: 'Dimensions must be positive'
            };
            // Reasonable maximum to prevent memory issues
            const MAX_DIMENSION = 32767; // Common canvas limit
            if (width > MAX_DIMENSION || height > MAX_DIMENSION) return {
                valid: false,
                error: `Dimensions exceed maximum allowed (${MAX_DIMENSION}px)`
            };
            return {
                valid: true,
                sanitized: {
                    width: width,
                    height: height
                }
            };
        }
        /**
         * Validate scale factor
         *
         * @param scale - Scale factor
         * @returns Validation result
         */ validateScale(scale) {
            if (typeof scale !== 'number' || isNaN(scale)) return {
                valid: false,
                error: 'Scale must be a number'
            };
            if (scale <= 0) return {
                valid: false,
                error: 'Scale must be positive'
            };
            // Reasonable scale limits
            if (scale > 10) return {
                valid: false,
                error: 'Scale factor too large (maximum 10x)'
            };
            return {
                valid: true,
                sanitized: scale
            };
        }
        /**
         * Validate HTML element
         *
         * @param element - Element to validate
         * @returns Validation result
         */ validateElement(element) {
            if (!element) return {
                valid: false,
                error: 'Element is required'
            };
            if (typeof element !== 'object') return {
                valid: false,
                error: 'Element must be an object'
            };
            // Accept real HTMLElement, or any element-like object with the minimal shape
            // required by the implementation (ownerDocument + defaultView) for backward
            // compatibility and test environments.
            if (typeof HTMLElement !== 'undefined' && element instanceof HTMLElement) {
                // Real DOM element
                if (!element.ownerDocument) return {
                    valid: false,
                    error: 'Element must be attached to a document'
                };
                return {
                    valid: true
                };
            }
            // Duck-typing: accept object with ownerDocument and defaultView (minimal contract)
            if (!element.ownerDocument) return {
                valid: false,
                error: 'Element must be attached to a document (ownerDocument required)'
            };
            if (!element.ownerDocument.defaultView) return {
                valid: false,
                error: 'Document must be attached to a window (ownerDocument.defaultView required)'
            };
            return {
                valid: true
            };
        }
        /**
         * Validate entire options object
         *
         * @param options - Options to validate
         * @returns Validation result with all errors
         */ validateOptions(options) {
            const errors = [];
            // Validate proxy URL only when a non-empty string (allow null/undefined to mean "no proxy")
            const proxyUrl = options.proxy;
            if (proxyUrl !== undefined && proxyUrl !== null && typeof proxyUrl === 'string' && proxyUrl.length > 0) {
                const proxyResult = this.validateUrl(proxyUrl, 'proxy');
                if (!proxyResult.valid) errors.push(`Proxy: ${proxyResult.error}`);
            // Note: Proxy URLs are marked with requiresRuntimeCheck to prevent DNS rebinding
            // Consider implementing runtime IP validation in production environments
            }
            // Validate image timeout
            if (options.imageTimeout !== undefined) {
                const timeoutResult = this.validateImageTimeout(options.imageTimeout);
                if (!timeoutResult.valid) errors.push(`Image timeout: ${timeoutResult.error}`);
            }
            // Validate dimensions
            if (options.width !== undefined || options.height !== undefined) {
                const width = options.width ?? 800;
                const height = options.height ?? 600;
                const dimensionsResult = this.validateDimensions(width, height);
                if (!dimensionsResult.valid) errors.push(`Dimensions: ${dimensionsResult.error}`);
            }
            // Validate scale
            if (options.scale !== undefined) {
                const scaleResult = this.validateScale(options.scale);
                if (!scaleResult.valid) errors.push(`Scale: ${scaleResult.error}`);
            }
            // Validate CSP nonce
            if (options.cspNonce !== undefined) {
                const nonceResult = this.validateCspNonce(options.cspNonce);
                if (!nonceResult.valid) errors.push(`CSP nonce: ${nonceResult.error}`);
            }
            // Custom validation
            if (this.config.customValidator) {
                const customResult = this.config.customValidator(options, 'options');
                if (!customResult.valid) errors.push(`Custom validation: ${customResult.error}`);
            }
            if (errors.length > 0) return {
                valid: false,
                error: errors.join('; ')
            };
            return {
                valid: true
            };
        }
    }
    /**
     * Create a default validator instance
     */ function createDefaultValidator(config = {}) {
        return new Validator({
            allowDataUrls: true,
            maxImageTimeout: 300000,
            ...config
        });
    }
    /**
     * Performance Monitor
     *
     * Tracks performance metrics throughout the rendering pipeline.
     * Provides insights into where time is spent during rendering.
     *
     * Usage:
     * ```typescript
     * const monitor = new PerformanceMonitor(context);
     *
     * monitor.start('clone');
     * await cloneDocument();
     * monitor.end('clone');
     *
     * const summary = monitor.getSummary();
     * ```
     */ class PerformanceMonitor {
        constructor(context, enabled = true){
            this.context = context;
            this.activeMetrics = new Map();
            this.completedMetrics = [];
            this.enabled = enabled;
            // Fallback for environments without performance.now()
            this.getTime = typeof performance !== 'undefined' && typeof performance.now === 'function' ? ()=>performance.now() : ()=>Date.now();
        }
        /**
         * Start measuring a performance metric
         *
         * @param name - Unique name for this metric
         * @param metadata - Optional metadata to attach
         */ start(name, metadata) {
            if (!this.enabled) return;
            if (this.activeMetrics.has(name)) this.context?.logger.warn(`Performance metric '${name}' already started. Overwriting.`);
            this.activeMetrics.set(name, {
                name: name,
                startTime: this.getTime(),
                metadata: metadata
            });
        }
        /**
         * End measuring a performance metric
         *
         * @param name - Name of the metric to end
         * @returns The completed metric, or undefined if not found
         */ end(name) {
            if (!this.enabled) return undefined;
            const metric = this.activeMetrics.get(name);
            if (!metric) {
                this.context?.logger.warn(`Performance metric '${name}' not found. Was start() called?`);
                return undefined;
            }
            metric.endTime = this.getTime();
            metric.duration = metric.endTime - metric.startTime;
            this.completedMetrics.push(metric);
            this.activeMetrics.delete(name);
            this.context?.logger.debug(`\u{23F1}\u{FE0F}  ${name}: ${metric.duration.toFixed(2)}ms`, metric.metadata);
            return metric;
        }
        /**
         * Measure a synchronous function
         *
         * @param name - Name for this measurement
         * @param fn - Function to measure
         * @param metadata - Optional metadata
         * @returns The function's return value
         */ measure(name, fn, metadata) {
            this.start(name, metadata);
            try {
                const result = fn();
                this.end(name);
                return result;
            } catch (error) {
                this.end(name);
                throw error;
            }
        }
        /**
         * Measure an asynchronous function
         *
         * @param name - Name for this measurement
         * @param fn - Async function to measure
         * @param metadata - Optional metadata
         * @returns Promise resolving to the function's return value
         */ async measureAsync(name, fn, metadata) {
            this.start(name, metadata);
            try {
                const result = await fn();
                this.end(name);
                return result;
            } catch (error) {
                this.end(name);
                throw error;
            }
        }
        /**
         * Get all completed metrics
         *
         * @returns Array of completed performance metrics
         */ getMetrics() {
            return [
                ...this.completedMetrics
            ];
        }
        /**
         * Get a specific metric by name
         *
         * @param name - Metric name
         * @returns The metric, or undefined if not found
         */ getMetric(name) {
            return this.completedMetrics.find((m)=>m.name === name);
        }
        /**
         * Get performance summary
         *
         * @returns Aggregated performance data
         */ getSummary() {
            const totalDuration = this.completedMetrics.reduce((sum, metric)=>sum + (metric.duration || 0), 0);
            const breakdown = this.completedMetrics.map((metric)=>({
                    name: metric.name,
                    duration: metric.duration || 0,
                    percentage: totalDuration > 0 ? ((metric.duration || 0) / totalDuration * 100).toFixed(1) + '%' : '0%'
                }));
            return {
                totalDuration: totalDuration,
                metrics: this.getMetrics(),
                breakdown: breakdown
            };
        }
        /**
         * Log performance summary to console
         */ logSummary() {
            if (!this.enabled || this.completedMetrics.length === 0 || !this.context) return;
            const summary = this.getSummary();
            this.context.logger.info(`
\u{1F4CA} Performance Summary (Total: ${summary.totalDuration.toFixed(2)}ms):`);
            summary.breakdown.sort((a, b)=>b.duration - a.duration).forEach((item)=>{
                this.context.logger.info(`  ${item.name.padEnd(20)} ${item.duration.toFixed(2).padStart(8)}ms  ${item.percentage.padStart(6)}`);
            });
        }
        /**
         * Clear all metrics
         */ clear() {
            this.activeMetrics.clear();
            this.completedMetrics.splice(0);
        }
        /**
         * Check if monitoring is enabled
         */ isEnabled() {
            return this.enabled;
        }
        /**
         * Get active (uncompleted) metrics
         * Useful for debugging leaked measurements
         */ getActiveMetrics() {
            return Array.from(this.activeMetrics.keys());
        }
    }
    /**
     * Main html2canvas function with improved configuration management
     *
     * @param element - Element to render
     * @param options - Rendering options
     * @param config - Optional configuration (for advanced use cases)
     * @returns Promise resolving to rendered canvas
     */ const html2canvas = (element, options = {}, config)=>{
        // Create configuration from element if not provided
        const finalConfig = config || Html2CanvasConfig.fromElement(element, {
            cspNonce: options.cspNonce,
            cache: options.cache
        });
        return renderElement(element, options, finalConfig);
    };
    /**
     * Set CSP nonce for inline styles
     * @deprecated Use options.cspNonce instead
     */ const setCspNonce = (nonce)=>{
        console.warn('[html2canvas-pro] setCspNonce is deprecated. Pass cspNonce in options instead: html2canvas(element, { cspNonce: "..." })');
        // For backward compatibility, set default config
        if (typeof window !== 'undefined') setDefaultConfig(new Html2CanvasConfig({
            window: window,
            cspNonce: nonce
        }));
    };
    html2canvas.setCspNonce = setCspNonce;
    /**
     * Coerce number-like option values for backward compatibility (e.g. string "2" from form/query).
     * Mutates opts in place; callers should avoid reusing the same options object if they rely on original types.
     */ const coerceNumberOptions = (opts)=>{
        const numKeys = [
            'scale',
            'width',
            'height',
            'imageTimeout',
            'x',
            'y',
            'windowWidth',
            'windowHeight',
            'scrollX',
            'scrollY'
        ];
        numKeys.forEach((key)=>{
            const v = opts[key];
            if (v !== undefined && v !== null && typeof v !== 'number') {
                const n = Number(v);
                if (!Number.isNaN(n)) opts[key] = n;
            }
        });
    };
    const renderElement = async (element, opts, config)=>{
        coerceNumberOptions(opts);
        // Input validation (unless explicitly skipped)
        if (!opts.skipValidation) {
            const validator = opts.validator || createDefaultValidator();
            // Validate element
            const elementValidation = validator.validateElement(element);
            if (!elementValidation.valid) throw new Error(elementValidation.error);
            // Validate options
            const optionsValidation = validator.validateOptions(opts);
            if (!optionsValidation.valid) throw new Error(`Invalid options: ${optionsValidation.error}`);
        }
        if (!element || typeof element !== 'object') throw new Error('Invalid element provided as first argument');
        const ownerDocument = element.ownerDocument;
        if (!ownerDocument) throw new Error(`Element is not attached to a Document`);
        const defaultView = ownerDocument.defaultView;
        if (!defaultView) throw new Error(`Document is not attached to a Window`);
        const resourceOptions = {
            allowTaint: opts.allowTaint ?? false,
            imageTimeout: opts.imageTimeout ?? 15000,
            proxy: opts.proxy,
            useCORS: opts.useCORS ?? false,
            customIsSameOrigin: opts.customIsSameOrigin
        };
        const contextOptions = {
            logging: opts.logging ?? true,
            cache: opts.cache ?? config.cache,
            ...resourceOptions
        };
        // Fallbacks for minimal window (e.g. element-like mocks) so we don't get NaN
        const DEFAULT_WINDOW_WIDTH = 800;
        const DEFAULT_WINDOW_HEIGHT = 600;
        const DEFAULT_SCROLL = 0;
        const win = defaultView;
        const windowOptions = {
            windowWidth: opts.windowWidth ?? win.innerWidth ?? DEFAULT_WINDOW_WIDTH,
            windowHeight: opts.windowHeight ?? win.innerHeight ?? DEFAULT_WINDOW_HEIGHT,
            scrollX: opts.scrollX ?? win.pageXOffset ?? DEFAULT_SCROLL,
            scrollY: opts.scrollY ?? win.pageYOffset ?? DEFAULT_SCROLL
        };
        const windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
        const context = new Context(contextOptions, windowBounds, config);
        // Initialize performance monitoring if enabled
        const performanceMonitoring = opts.enablePerformanceMonitoring ?? opts.logging ?? false;
        const perfMonitor = new PerformanceMonitor(context, performanceMonitoring);
        perfMonitor.start('total', {
            width: windowOptions.windowWidth,
            height: windowOptions.windowHeight
        });
        const foreignObjectRendering = opts.foreignObjectRendering ?? false;
        const cloneOptions = {
            allowTaint: opts.allowTaint ?? false,
            onclone: opts.onclone,
            ignoreElements: opts.ignoreElements,
            iframeContainer: opts.iframeContainer,
            inlineImages: foreignObjectRendering,
            copyStyles: foreignObjectRendering,
            cspNonce: opts.cspNonce ?? config.cspNonce
        };
        context.logger.debug(`Starting document clone with size ${windowBounds.width}x${windowBounds.height} scrolled to ${-windowBounds.left},${-windowBounds.top}`);
        perfMonitor.start('clone');
        const documentCloner = new DocumentCloner(context, element, cloneOptions);
        const clonedElement = documentCloner.clonedReferenceElement;
        if (!clonedElement) throw new Error('Unable to find element in cloned iframe');
        const container = await documentCloner.toIFrame(ownerDocument, windowBounds);
        perfMonitor.end('clone');
        const { width: width, height: height, left: left, top: top } = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement);
        const backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
        const renderOptions = {
            canvas: opts.canvas,
            backgroundColor: backgroundColor,
            scale: opts.scale ?? defaultView.devicePixelRatio ?? 1,
            x: (opts.x ?? 0) + left,
            y: (opts.y ?? 0) + top,
            width: opts.width ?? Math.ceil(width),
            height: opts.height ?? Math.ceil(height),
            imageSmoothing: opts.imageSmoothing,
            imageSmoothingQuality: opts.imageSmoothingQuality
        };
        let canvas;
        let root;
        try {
            if (foreignObjectRendering) {
                context.logger.debug(`Document cloned, using foreign object rendering`);
                perfMonitor.start('render-foreignobject');
                const renderer = new ForeignObjectRenderer(context, renderOptions);
                canvas = await renderer.render(clonedElement);
                perfMonitor.end('render-foreignobject');
            } else {
                context.logger.debug(`Document cloned, element located at ${left},${top} with size ${width}x${height} using computed rendering`);
                context.logger.debug(`Starting DOM parsing`);
                perfMonitor.start('parse');
                root = parseTree(context, clonedElement);
                perfMonitor.end('parse');
                if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                context.logger.debug(`Starting renderer for element at ${renderOptions.x},${renderOptions.y} with size ${renderOptions.width}x${renderOptions.height}`);
                perfMonitor.start('render');
                const renderer = new CanvasRenderer(context, renderOptions);
                canvas = await renderer.render(root);
                perfMonitor.end('render');
            }
            perfMonitor.start('cleanup');
            if (opts.removeContainer ?? true) {
                if (!DocumentCloner.destroy(container)) context.logger.error(`Cannot detach cloned iframe as it is not in the DOM anymore`);
            }
            perfMonitor.end('cleanup');
            perfMonitor.end('total');
            context.logger.debug(`Finished rendering`);
            // Log performance summary if monitoring is enabled
            if (performanceMonitoring) perfMonitor.logSummary();
            return canvas;
        } finally{
            // Restore DOM modifications (animations, transforms) in cloned document
            if (root) root.restoreTree();
        }
    };
    const parseBackgroundColor = (context, element, backgroundColorOverride)=>{
        const ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        const documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        const bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        const defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    exports1.Html2CanvasConfig = Html2CanvasConfig;
    exports1.PerformanceMonitor = PerformanceMonitor;
    exports1.Validator = Validator;
    exports1.createDefaultValidator = createDefaultValidator;
    exports1.default = html2canvas;
    exports1.html2canvas = html2canvas;
    exports1.setCspNonce = setCspNonce;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});
if (typeof window !== "undefined" && window.html2canvas && window.html2canvas.default) window.html2canvas = window.html2canvas.default;

});


parcelRegister("k36Cq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31e6ac276601d94$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $64MiS = parcelRequire("64MiS");
var $jUdJW = parcelRequire("jUdJW");
var $ktcBP = parcelRequire("ktcBP");

var $499od = parcelRequire("499od");
function $e31e6ac276601d94$export$2e2bcd8739ae039({ worksheetUrl: worksheetUrl, shareableGridRef: shareableGridRef }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "share-controls p-4 mt-8 bg-gray-50 rounded-lg",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                className: "text-lg font-medium mb-4",
                children: Drupal.t('Share word grid')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("label", {
                className: "block text-sm font-medium text-gray-700 mb-2",
                htmlFor: "worksheetUrl",
                children: [
                    Drupal.t('Shareable link'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "flex flex-col sm:flex-row justify-end gap-2",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "flex-1 flex flex-col sm:flex-row gap-2 sm:gap-0",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                type: "text",
                                readOnly: true,
                                value: worksheetUrl,
                                id: "worksheetUrl",
                                className: "flex-1 px-3 py-2 border border-gray-300 rounded-md sm:rounded-r-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("button", {
                                onClick: ()=>(0, $499od.copyToClipboard)(worksheetUrl),
                                className: "bg-primary text-white px-4 py-2 rounded-md sm:rounded-l-none cursor-pointer hover:bg-primary-lighter keep-in-pure-printable",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jUdJW.default), {
                                        className: "size-5 inline mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "align-middle",
                                        children: Drupal.t('Copy')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("button", {
                        onClick: ()=>(0, $499od.saveGridImage)(shareableGridRef.current),
                        className: "bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter keep-in-pure-printable",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $64MiS.default), {
                                className: "size-5 inline mr-2"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                className: "align-middle",
                                children: Drupal.t('Save')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("button", {
                        onClick: ()=>window.print(),
                        className: "bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter keep-in-pure-printable",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ktcBP.default), {
                                className: "size-5 inline mr-2"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                className: "align-middle",
                                children: Drupal.t('Print')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("64MiS", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c895e104c08175$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $46c895e104c08175$var$ArrowDownTrayIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    }));
}
const $46c895e104c08175$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($46c895e104c08175$var$ArrowDownTrayIcon);
var $46c895e104c08175$export$2e2bcd8739ae039 = $46c895e104c08175$var$ForwardRef;

});

parcelRegister("jUdJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7dde7bdcea1ba71$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $e7dde7bdcea1ba71$var$ClipboardIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
    }));
}
const $e7dde7bdcea1ba71$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($e7dde7bdcea1ba71$var$ClipboardIcon);
var $e7dde7bdcea1ba71$export$2e2bcd8739ae039 = $e7dde7bdcea1ba71$var$ForwardRef;

});

parcelRegister("ktcBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee704bfedc28dfe0$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $ee704bfedc28dfe0$var$PrinterIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
    }));
}
const $ee704bfedc28dfe0$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($ee704bfedc28dfe0$var$PrinterIcon);
var $ee704bfedc28dfe0$export$2e2bcd8739ae039 = $ee704bfedc28dfe0$var$ForwardRef;

});



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $6T1J1 = parcelRequire("6T1J1");

var $1IdZj = parcelRequire("1IdZj");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
function $1dc70cbea8676fb7$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        fillRule: "evenodd",
        d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
        clipRule: "evenodd"
    }));
}
const $1dc70cbea8676fb7$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($1dc70cbea8676fb7$var$CheckIcon);
var $1dc70cbea8676fb7$export$2e2bcd8739ae039 = $1dc70cbea8676fb7$var$ForwardRef;


function $34af7efc396727e6$export$2e2bcd8739ae039({ steps: steps, changeCurrentStep: changeCurrentStep }) {
    const padStepId = (id)=>id.toString().padStart(2, '0');
    const handleStepChange = (event, id)=>{
        event.preventDefault();
        changeCurrentStep(id);
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("nav", {
        className: "mb-8",
        "aria-label": Drupal.t('Progress'),
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("ol", {
            role: "list",
            className: "divide-y divide-gray-300 rounded-md border border-gray-300 md:flex md:divide-y-0",
            children: steps.map((step, stepIdx)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                    className: "relative md:flex md:flex-1",
                    children: [
                        step.status === 'complete' ? /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            href: step.href,
                            className: "group flex w-full items-center",
                            onClick: (event)=>handleStepChange(event, step.id),
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                                className: "flex items-center px-6 py-4 text-sm font-medium",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "flex size-10 shrink-0 items-center justify-center rounded-full bg-indigo-600 group-hover:bg-indigo-800",
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1dc70cbea8676fb7$export$2e2bcd8739ae039), {
                                            "aria-hidden": "true",
                                            className: "size-6 text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "ml-4 text-sm font-medium text-gray-900",
                                        children: step.name
                                    })
                                ]
                            })
                        }) : step.status === 'current' ? /*#__PURE__*/ (0, $1IdZj.jsxs)("a", {
                            href: step.href,
                            "aria-current": "step",
                            className: "flex items-center px-6 py-4 text-sm font-medium",
                            onClick: (event)=>handleStepChange(event, step.id),
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                    className: "flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-indigo-600",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "text-indigo-600",
                                        children: padStepId(step.id)
                                    })
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                    className: "ml-4 text-sm font-medium text-indigo-600",
                                    children: step.name
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                            href: step.href,
                            className: "group flex items-center",
                            onClick: (event)=>handleStepChange(event, step.id),
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                                className: "flex items-center px-6 py-4 text-sm font-medium",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-gray-400",
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                            className: "text-gray-500 group-hover:text-gray-900",
                                            children: padStepId(step.id)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                        className: "ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900",
                                        children: step.name
                                    })
                                ]
                            })
                        }),
                        stepIdx !== steps.length - 1 ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                "aria-hidden": "true",
                                className: "absolute top-0 right-0 hidden h-full w-5 md:block",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
                                    fill: "none",
                                    viewBox: "0 0 22 80",
                                    preserveAspectRatio: "none",
                                    className: "size-full text-gray-300",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                                        d: "M0 -2L20 40L0 82",
                                        stroke: "currentcolor",
                                        vectorEffect: "non-scaling-stroke",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        }) : null
                    ]
                }, step.name))
        })
    });
}



var $bfBMW = parcelRequire("bfBMW");

var $8NFma = parcelRequire("8NFma");

var $cltGd = parcelRequire("cltGd");

var $1IdZj = parcelRequire("1IdZj");

var $1IdZj = parcelRequire("1IdZj");

var $lmhZG = parcelRequire("lmhZG");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
const $a4297f3c09e7c9d1$var$AlphabetContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
function $a4297f3c09e7c9d1$export$3a64ed71c950704a({ children: children }) {
    const [currentLetter, setCurrentLetter] = (0, $8NFma.useState)(null);
    const contextValue = {
        currentLetter: currentLetter,
        setCurrentLetter: setCurrentLetter
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a4297f3c09e7c9d1$var$AlphabetContext, {
        value: contextValue,
        children: children
    });
}
function $a4297f3c09e7c9d1$export$9be34d74b5c50f4b() {
    return (0, $8NFma.useContext)($a4297f3c09e7c9d1$var$AlphabetContext);
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
const $0b1683ffd1cf01f1$var$SearchContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
function $0b1683ffd1cf01f1$export$a14e94a710e3b3ab({ children: children }) {
    const [searchText, setSearchText] = (0, $8NFma.useState)('');
    const [domain, setDomain] = (0, $8NFma.useState)('');
    const contextValue = {
        searchText: searchText,
        setSearchText: setSearchText,
        domain: domain,
        setDomain: setDomain
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)($0b1683ffd1cf01f1$var$SearchContext, {
        value: contextValue,
        children: children
    });
}
function $0b1683ffd1cf01f1$export$bd221a7c56b93941() {
    return (0, $8NFma.useContext)($0b1683ffd1cf01f1$var$SearchContext);
}


function $6c7457c1844444b1$export$2e2bcd8739ae039({ alphabet: alphabet, makeSearchApiCall: makeSearchApiCall }) {
    const { currentLetter: currentLetter, setCurrentLetter: setCurrentLetter } = (0, $a4297f3c09e7c9d1$export$9be34d74b5c50f4b)();
    const { setSearchText: setSearchText, setDomain: setDomain } = (0, $0b1683ffd1cf01f1$export$bd221a7c56b93941)();
    const letterClicked = (event, letter)=>{
        event.preventDefault();
        setCurrentLetter(letter);
        setSearchText('');
        setDomain('');
        makeSearchApiCall({
            starts_with: letter
        });
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "alphabet",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                href: "#",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))('alphabet-letter', {
                    'alphabet-letter--empty': alphabet.active.length === 0,
                    'alphabet-letter--current': currentLetter === ''
                }),
                onClick: (event)=>letterClicked(event, ''),
                children: Drupal.t('All')
            }),
            alphabet.letters.map((letter, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                    href: "#",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))('alphabet-letter', {
                        'alphabet-letter--empty': !alphabet.active.includes(letter),
                        'alphabet-letter--current': currentLetter === letter
                    }),
                    onClick: (event)=>letterClicked(event, letter),
                    children: letter
                }, index))
        ]
    });
}





var $8NFma = parcelRequire("8NFma");
function $4d4ff3ba4af691e9$var$CogIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $8NFma.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $8NFma.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $8NFma.createElement("path", {
        d: "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z"
    }), /*#__PURE__*/ $8NFma.createElement("path", {
        fillRule: "evenodd",
        d: "M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z",
        clipRule: "evenodd"
    }));
}
const $4d4ff3ba4af691e9$var$ForwardRef = /*#__PURE__*/ $8NFma.forwardRef($4d4ff3ba4af691e9$var$CogIcon);
var $4d4ff3ba4af691e9$export$2e2bcd8739ae039 = $4d4ff3ba4af691e9$var$ForwardRef;



var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
function $2e419f86bad4d057$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "select-wrapper",
            children: [
                children,
                /*#__PURE__*/ (0, $1IdZj.jsx)("svg", {
                    viewBox: "0 0 16 16",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                        d: "M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z",
                        clipRule: "evenodd",
                        fillRule: "evenodd"
                    })
                })
            ]
        })
    });
}


const $d6744e12d571bea0$var$debounce = (func, delay)=>{
    let timeoutId;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>func(...args), delay);
    };
};
function $d6744e12d571bea0$export$2e2bcd8739ae039({ domainLabel: domainLabel, domainOptions: domainOptions, tokens: tokens, setTokens: setTokens, children: children, alphabet: alphabet }) {
    const { setCurrentLetter: setCurrentLetter } = (0, $a4297f3c09e7c9d1$export$9be34d74b5c50f4b)();
    const { searchText: searchText, setSearchText: setSearchText, domain: domain, setDomain: setDomain } = (0, $0b1683ffd1cf01f1$export$bd221a7c56b93941)();
    const [isLoading, setIsLoading] = (0, $8NFma.useState)(false);
    const [displayNoResults, setDisplayNoResults] = (0, $8NFma.useState)(null);
    const [autocomplete, setAutocomplete] = (0, $8NFma.useState)([]);
    const makeSearchApiCall = (data)=>{
        const params = new URLSearchParams(data);
        const timer = setTimeout(()=>setIsLoading(true), 500);
        const clearLoader = ()=>{
            clearTimeout(timer);
            setIsLoading(false);
        };
        setTokens([]);
        setDisplayNoResults(false);
        fetch(Drupal.url('token-search') + '?' + params, {}).then((res)=>res.json()).then((data)=>{
            clearLoader();
            setTokens(data);
            if (data.length === 0) setDisplayNoResults(true);
        }).catch((error)=>{
            clearLoader();
            console.error('token-search fetch error', error);
        });
    };
    const makeAutocompleteApiCall = (q)=>{
        const params = new URLSearchParams({
            q: q.trim()
        });
        if (!q.trim()) {
            closeAutocomplete();
            return;
        }
        fetch(Drupal.url('token-autocomplete') + '?' + params, {}).then((res)=>res.json()).then((data)=>{
            setAutocomplete(data);
        }).catch((error)=>{
            console.error('autocomplete error', error);
        });
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        setCurrentLetter(null);
        closeAutocomplete();
        makeSearchApiCall({
            search: searchText,
            domain: domain
        });
    };
    const closeAutocomplete = ()=>setAutocomplete([]);
    const closeAutocompleteOnEscape = (e)=>{
        if (e.key === 'Escape') closeAutocomplete();
    };
    const handleAutocomplete = (0, $8NFma.useCallback)($d6744e12d571bea0$var$debounce((q)=>{
        makeAutocompleteApiCall(q);
    }, 150), []);
    const handleKeyUp = (e)=>{
        // Pressing enter to submit the form passes empty value to the autocomplete handler and is will trigger closing
        // of autocomplete
        handleAutocomplete(e.key === 'Enter' ? '' : e.target.value);
    };
    const setSearchTextAndCloseAutocomplete = (text)=>{
        setSearchText(text);
        closeAutocomplete();
    };
    (0, $8NFma.useEffect)(()=>{
        document.addEventListener('keyup', closeAutocompleteOnEscape);
        return ()=>{
            document.removeEventListener('keyup', closeAutocompleteOnEscape);
        };
    }, []);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("form", {
                className: "grid grid-cols-1 sm:grid-cols-12 gap-4",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "sm:col-span-5",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                                htmlFor: "search",
                                className: "block text-sm/6 font-medium text-gray-900 mb-2",
                                children: Drupal.t('Search')
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                type: "text",
                                name: "search",
                                id: "search",
                                value: searchText,
                                autoComplete: "off",
                                placeholder: Drupal.t('Search for tokens...'),
                                onChange: (e)=>setSearchText(e.target.value),
                                onKeyUp: handleKeyUp,
                                onBlur: ()=>setTimeout(()=>closeAutocomplete(), 150)
                            }),
                            autocomplete.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                                    className: "absolute w-full bg-white border-x border-b border-gray-300 rounded-b max-h-60 overflow-y-auto",
                                    children: autocomplete.map((text, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                            className: "cursor-pointer not-last:border-b not-last:border-b-gray-300 p-2 text-sm/6 font-medium text-gray-900 truncate hover:text-primary",
                                            title: text,
                                            onClick: ()=>setSearchTextAndCloseAutocomplete(text),
                                            children: text
                                        }, index))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "sm:col-span-5",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                                htmlFor: "domain",
                                className: "block text-sm/6 font-medium text-gray-900 mb-2",
                                children: domainLabel
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2e419f86bad4d057$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("select", {
                                    id: "domain",
                                    name: "domain",
                                    value: domain,
                                    onChange: (e)=>setDomain(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                            value: "",
                                            children: Drupal.t('- All -')
                                        }),
                                        Object.entries(domainOptions).map(([value, text])=>/*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                value: value,
                                                children: text
                                            }, value))
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "sm:col-span-2 flex items-end",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                            className: "button form-submit grow",
                            children: Drupal.t('Search', {}, {
                                context: 'Action'
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6c7457c1844444b1$export$2e2bcd8739ae039), {
                alphabet: alphabet,
                makeSearchApiCall: makeSearchApiCall
            }),
            isLoading && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "flex items-center justify-center gap-2 text-gray-600 mb-4",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4d4ff3ba4af691e9$export$2e2bcd8739ae039), {
                        className: "size-6 animate-spin"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                        children: Drupal.t('Loading...')
                    })
                ]
            }),
            displayNoResults && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "text-center text-sm text-gray-400 mb-4",
                children: Drupal.t('No results')
            }),
            displayNoResults === false && tokens.length !== 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "text-sm text-gray-400 mb-2",
                children: Drupal.formatPlural(tokens.length, 'Shows 1 result.', 'Shows @count results.')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                children: children
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $lmhZG = parcelRequire("lmhZG");
function $45d7833cba911ec6$export$2e2bcd8739ae039({ isInGrid: isInGrid, addTokenToGrid: addTokenToGrid, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))('inline-flex items-center rounded-md px-2 py-1 text-sm font-medium ring-1 ring-inset cursor-pointer', {
            'bg-gray-50 text-gray-600 ring-gray-500/10': !isInGrid,
            'bg-indigo-50 text-indigo-700 ring-indigo-700/10': isInGrid
        }),
        onClick: addTokenToGrid,
        children: children
    });
}



var $499od = parcelRequire("499od");

var $1DKzi = parcelRequire("1DKzi");

var $k36Cq = parcelRequire("k36Cq");

const $34ea82c4cc465c49$var$initialSteps = [
    {
        id: 1,
        name: Drupal.t('Grid layout'),
        href: '#',
        status: 'current'
    },
    {
        id: 2,
        name: Drupal.t('Words'),
        href: '#',
        status: 'upcoming'
    },
    {
        id: 3,
        name: Drupal.t('Sharing'),
        href: '#',
        status: 'upcoming'
    }
];
function $34ea82c4cc465c49$export$2e2bcd8739ae039() {
    const [steps, setSteps] = (0, $8NFma.useState)($34ea82c4cc465c49$var$initialSteps);
    const currentStepId = (0, $8NFma.useMemo)(()=>steps.find((step)=>step.status === 'current').id, [
        steps
    ]);
    const [grid, setGrid] = (0, $8NFma.useState)((0, $499od.createArrayWithEmptyCells));
    const [tokens, setTokens] = (0, $8NFma.useState)([]);
    const [domainLabel, setDomainLabel] = (0, $8NFma.useState)('');
    const [domainOptions, setDomainOptions] = (0, $8NFma.useState)({});
    const [alphabet, setAlphabet] = (0, $8NFma.useState)({
        letters: [],
        active: []
    });
    const worksheetUrl = (0, $8NFma.useMemo)(()=>(0, $499od.buildWorksheetUrl)(grid), [
        grid
    ]);
    const shareableGridRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        setDomainLabel(drupalSettings.worksheets.domain.label);
        setDomainOptions(drupalSettings.worksheets.domain.options);
        setAlphabet(drupalSettings.worksheets.alphabet);
    }, []);
    const changeCurrentStep = (id)=>{
        let found = false;
        setSteps(steps.map((step)=>{
            if (!found) step.status = 'complete';
            if (step.id === id) {
                step.status = 'current';
                found = true;
                return step;
            }
            if (found) step.status = 'upcoming';
            return step;
        }));
    };
    const resetGrid = (count)=>{
        setGrid((0, $499od.createArrayWithEmptyCells)(count));
    };
    const addTokenToGrid = (token)=>{
        const index = grid.findIndex((c)=>c === null);
        if (index !== -1 && token) setGrid(grid.map((c, i)=>{
            if (i === index) return token;
            return c;
        }));
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $34af7efc396727e6$export$2e2bcd8739ae039), {
                steps: steps,
                changeCurrentStep: changeCurrentStep
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    currentStepId === 1 && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "max-w-3xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                                className: "text-xl font-semibold mb-4",
                                children: Drupal.t('Choose grid layout')
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                                        htmlFor: "cells",
                                        className: "block text-sm/6 font-medium text-gray-900",
                                        children: Drupal.t('Grid')
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        className: "mt-2 grid grid-cols-1 mb-8",
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2e419f86bad4d057$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("select", {
                                                id: "cells",
                                                name: "cells",
                                                value: grid.length,
                                                onChange: (e)=>resetGrid(parseInt(e.target.value)),
                                                className: "block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600",
                                                children: (0, $1DKzi.gridCellOptions).map((item, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                        value: item.count,
                                                        children: item.text
                                                    }, index))
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bfBMW.default), {
                                grid: grid,
                                setGrid: setGrid
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                className: "flex flex-row justify-end gap-2 mt-8",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                    className: "bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter",
                                    onClick: ()=>changeCurrentStep(currentStepId + 1),
                                    children: Drupal.t('Next')
                                })
                            })
                        ]
                    }),
                    currentStepId === 2 && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "max-w-3xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                                className: "text-xl font-semibold mb-4",
                                children: Drupal.t('Add words to the grid')
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $d6744e12d571bea0$export$2e2bcd8739ae039), {
                                domainLabel: domainLabel,
                                domainOptions: domainOptions,
                                tokens: tokens,
                                setTokens: setTokens,
                                alphabet: alphabet,
                                children: tokens.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "flex flex-wrap justify-start gap-2 mb-4",
                                    children: tokens.map((token, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $45d7833cba911ec6$export$2e2bcd8739ae039), {
                                            isInGrid: grid.findIndex((current)=>current && current.id === token.id) !== -1,
                                            addTokenToGrid: ()=>addTokenToGrid(token),
                                            children: token.title
                                        }, index))
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bfBMW.default), {
                                grid: grid,
                                setGrid: setGrid,
                                displayActions: true
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                className: "flex flex-row justify-end gap-2 mt-8",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                                    className: "bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter",
                                    onClick: ()=>changeCurrentStep(currentStepId + 1),
                                    children: Drupal.t('Next')
                                })
                            })
                        ]
                    }),
                    currentStepId === 3 && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "max-w-3xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                                className: "text-xl font-semibold mb-4",
                                children: Drupal.t('Share word grid')
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bfBMW.default), {
                                grid: grid,
                                setGrid: setGrid,
                                ref: shareableGridRef
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $k36Cq.default), {
                                worksheetUrl: worksheetUrl,
                                shareableGridRef: shareableGridRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cltGd.default), {})
                ]
            })
        ]
    });
}



var $3hUXe = parcelRequire("3hUXe");


const $c59fbb2ebdb91678$var$root = (0, $6T1J1.createRoot)(document.getElementById('token-worksheets'));
$c59fbb2ebdb91678$var$root.render(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $8NFma.StrictMode), {
    children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3hUXe.VideoModalProvider), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $0b1683ffd1cf01f1$export$a14e94a710e3b3ab), {
            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a4297f3c09e7c9d1$export$3a64ed71c950704a), {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $34ea82c4cc465c49$export$2e2bcd8739ae039), {})
            })
        })
    })
}));

})();
//# sourceMappingURL=worksheets.js.map
